var _path, _g, _g2, _g3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _g4, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _g5, _g6, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLicensecard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 123,
    viewBox: "0 0 198 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M197.298 113.157C197.298 118.33 193.102 122.525 187.928 122.525H9.38518C4.21066 122.525 0.014328 118.33 0.014328 113.157V9.38349C0.014328 4.21008 4.21066 0.0146484 9.38518 0.0146484H187.935C193.109 0.0146484 197.305 4.21008 197.305 9.38349V113.157H197.298Z",
    fill: "url(#paint0_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M165.599 117.359C167.428 115.601 169.314 113.78 169.314 110.187C169.314 106.594 167.428 104.772 165.599 103.015C163.728 101.208 161.956 99.5068 161.956 96.0059C161.956 92.512 163.728 90.8041 165.599 88.9969C167.428 87.2394 169.314 85.4181 169.314 81.825C169.314 78.232 167.428 76.4106 165.599 74.6531C163.728 72.846 161.956 71.138 161.956 67.6442C161.956 64.1504 163.728 62.4424 165.599 60.6353C167.428 58.8777 169.314 57.0564 169.314 53.4634C169.314 49.8703 167.428 48.049 165.599 46.2914C163.728 44.4843 161.956 42.7764 161.956 39.2825C161.956 35.7816 163.728 34.0808 165.599 32.2736C167.428 30.5161 169.314 28.6947 169.314 25.1017C169.314 21.5087 167.428 19.6873 165.599 17.9298C163.728 16.1226 161.956 14.4147 161.956 10.9209C161.956 7.41995 163.728 5.71911 165.599 3.91195C166.769 2.78514 167.96 1.62998 168.668 0H168.435C167.754 1.52368 166.62 2.61506 165.443 3.74896C163.622 5.5065 161.729 7.32783 161.729 10.9209C161.729 14.5139 163.614 16.3352 165.443 18.0928C167.315 19.8999 169.087 21.6079 169.087 25.1017C169.087 28.5955 167.315 30.3035 165.443 32.1106C163.622 33.8682 161.729 35.6895 161.729 39.2825C161.729 42.8756 163.614 44.6969 165.443 46.4544C167.315 48.2616 169.087 49.9695 169.087 53.4634C169.087 56.9572 167.315 58.6651 165.443 60.4723C163.622 62.2298 161.729 64.0511 161.729 67.6442C161.729 71.2372 163.614 73.0586 165.443 74.8161C167.315 76.6233 169.087 78.3312 169.087 81.825C169.087 85.3188 167.315 87.0268 165.443 88.8339C163.622 90.5915 161.729 92.4128 161.729 96.0059C161.729 99.5989 163.614 101.413 165.443 103.178C167.315 104.985 169.087 106.686 169.087 110.187C169.087 113.681 167.315 115.388 165.443 117.196C163.962 118.627 162.438 120.094 161.92 122.518H162.147C162.65 120.208 164.089 118.818 165.599 117.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M163.6 117.359C165.422 115.601 167.314 113.78 167.314 110.187C167.314 106.594 165.429 104.772 163.6 103.015C161.729 101.208 159.956 99.5068 159.956 96.0059C159.956 92.512 161.729 90.8041 163.6 88.9969C165.422 87.2394 167.314 85.4181 167.314 81.825C167.314 78.232 165.429 76.4106 163.6 74.6531C161.729 72.846 159.956 71.138 159.956 67.6442C159.956 64.1504 161.729 62.4424 163.6 60.6353C165.422 58.8777 167.314 57.0564 167.314 53.4634C167.314 49.8703 165.429 48.049 163.6 46.2914C161.729 44.4843 159.956 42.7764 159.956 39.2825C159.956 35.7816 161.729 34.0808 163.6 32.2736C165.422 30.5161 167.314 28.6947 167.314 25.1017C167.314 21.5087 165.429 19.6873 163.6 17.9298C161.729 16.1226 159.956 14.4147 159.956 10.9209C159.956 7.41995 161.729 5.71911 163.6 3.91195C164.769 2.78514 165.96 1.62998 166.669 0H166.435C165.755 1.52368 164.621 2.61506 163.444 3.74896C161.622 5.5065 159.73 7.32783 159.73 10.9209C159.73 14.5139 161.615 16.3352 163.444 18.0928C165.315 19.8999 167.087 21.6079 167.087 25.1017C167.087 28.5955 165.315 30.3035 163.444 32.1106C161.622 33.8682 159.73 35.6895 159.73 39.2825C159.73 42.8756 161.615 44.6969 163.444 46.4544C165.315 48.2616 167.087 49.9695 167.087 53.4634C167.087 56.9572 165.315 58.6651 163.444 60.4723C161.622 62.2298 159.73 64.0511 159.73 67.6442C159.73 71.2372 161.615 73.0586 163.444 74.8161C165.315 76.6233 167.087 78.3312 167.087 81.825C167.087 85.3188 165.315 87.0268 163.444 88.8339C161.622 90.5915 159.73 92.4128 159.73 96.0059C159.73 99.5989 161.615 101.413 163.444 103.178C165.315 104.985 167.087 106.686 167.087 110.187C167.087 113.681 165.315 115.388 163.444 117.196C161.962 118.627 160.438 120.094 159.921 122.518H160.148C160.651 120.208 162.09 118.818 163.6 117.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M161.606 117.359C163.428 115.601 165.321 113.78 165.321 110.187C165.321 106.594 163.435 104.772 161.606 103.015C159.735 101.208 157.963 99.5068 157.963 96.0059C157.963 92.512 159.735 90.8041 161.606 88.9969C163.428 87.2394 165.321 85.4181 165.321 81.825C165.321 78.232 163.435 76.4106 161.606 74.6531C159.735 72.846 157.963 71.138 157.963 67.6442C157.963 64.1504 159.735 62.4424 161.606 60.6353C163.428 58.8777 165.321 57.0564 165.321 53.4634C165.321 49.8703 163.435 48.049 161.606 46.2914C159.735 44.4843 157.963 42.7764 157.963 39.2825C157.963 35.7816 159.735 34.0808 161.606 32.2736C163.428 30.5161 165.321 28.6947 165.321 25.1017C165.321 21.5087 163.435 19.6873 161.606 17.9298C159.735 16.1226 157.963 14.4147 157.963 10.9209C157.963 7.41995 159.735 5.71911 161.606 3.91195C162.776 2.78514 163.967 1.62998 164.676 0H164.442C163.761 1.52368 162.627 2.61506 161.45 3.74896C159.622 5.5065 157.736 7.32783 157.736 10.9209C157.736 14.5139 159.622 16.3352 161.45 18.0928C163.322 19.8999 165.094 21.6079 165.094 25.1017C165.094 28.5955 163.322 30.3035 161.45 32.1106C159.622 33.8682 157.736 35.6895 157.736 39.2825C157.736 42.8756 159.622 44.6969 161.45 46.4544C163.322 48.2616 165.094 49.9695 165.094 53.4634C165.094 56.9572 163.322 58.6651 161.45 60.4723C159.622 62.2298 157.736 64.0511 157.736 67.6442C157.736 71.2372 159.622 73.0586 161.45 74.8161C163.322 76.6233 165.094 78.3312 165.094 81.825C165.094 85.3188 163.322 87.0268 161.45 88.8339C159.622 90.5915 157.736 92.4128 157.736 96.0059C157.736 99.5989 159.622 101.413 161.45 103.178C163.322 104.985 165.094 106.686 165.094 110.187C165.094 113.681 163.322 115.388 161.45 117.196C159.969 118.627 158.445 120.094 157.927 122.518H158.154C158.65 120.208 160.097 118.818 161.606 117.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M159.609 117.359C161.431 115.601 163.323 113.78 163.323 110.187C163.323 106.594 161.438 104.772 159.609 103.015C157.738 101.208 155.966 99.5068 155.966 96.0059C155.966 92.512 157.738 90.8041 159.609 88.9969C161.431 87.2394 163.323 85.4181 163.323 81.825C163.323 78.232 161.438 76.4106 159.609 74.6531C157.738 72.846 155.966 71.138 155.966 67.6442C155.966 64.1504 157.738 62.4424 159.609 60.6353C161.431 58.8777 163.323 57.0564 163.323 53.4634C163.323 49.8703 161.438 48.049 159.609 46.2914C157.738 44.4843 155.966 42.7764 155.966 39.2825C155.966 35.7816 157.738 34.0808 159.609 32.2736C161.431 30.5161 163.323 28.6947 163.323 25.1017C163.323 21.5087 161.438 19.6873 159.609 17.9298C157.738 16.1226 155.966 14.4147 155.966 10.9209C155.966 7.41995 157.738 5.71911 159.609 3.91195C160.779 2.78514 161.969 1.62998 162.678 0H162.444C161.764 1.52368 160.63 2.61506 159.453 3.74896C157.624 5.5065 155.739 7.32783 155.739 10.9209C155.739 14.5139 157.624 16.3352 159.453 18.0928C161.324 19.8999 163.096 21.6079 163.096 25.1017C163.096 28.5955 161.324 30.3035 159.453 32.1106C157.624 33.8682 155.739 35.6895 155.739 39.2825C155.739 42.8756 157.624 44.6969 159.453 46.4544C161.324 48.2616 163.096 49.9695 163.096 53.4634C163.096 56.9572 161.324 58.6651 159.453 60.4723C157.624 62.2298 155.739 64.0511 155.739 67.6442C155.739 71.2372 157.624 73.0586 159.453 74.8161C161.324 76.6233 163.096 78.3312 163.096 81.825C163.096 85.3188 161.324 87.0268 159.453 88.8339C157.624 90.5915 155.739 92.4128 155.739 96.0059C155.739 99.5989 157.624 101.413 159.453 103.178C161.324 104.985 163.096 106.686 163.096 110.187C163.096 113.681 161.324 115.388 159.453 117.196C157.972 118.627 156.448 120.094 155.93 122.518H156.157C156.66 120.208 158.099 118.818 159.609 117.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M157.61 117.359C159.431 115.601 161.324 113.78 161.324 110.187C161.324 106.594 159.438 104.772 157.61 103.015C155.738 101.208 153.966 99.5068 153.966 96.0059C153.966 92.512 155.738 90.8041 157.61 88.9969C159.431 87.2394 161.324 85.4181 161.324 81.825C161.324 78.232 159.438 76.4106 157.61 74.6531C155.738 72.846 153.966 71.138 153.966 67.6442C153.966 64.1504 155.738 62.4424 157.61 60.6353C159.431 58.8777 161.324 57.0564 161.324 53.4634C161.324 49.8703 159.438 48.049 157.61 46.2914C155.738 44.4843 153.966 42.7764 153.966 39.2825C153.966 35.7816 155.738 34.0808 157.61 32.2736C159.431 30.5161 161.324 28.6947 161.324 25.1017C161.324 21.5087 159.438 19.6873 157.61 17.9298C155.738 16.1226 153.966 14.4218 153.966 10.9209C153.966 7.41995 155.738 5.71911 157.61 3.91195C158.779 2.78514 159.97 1.62998 160.679 0H160.445C159.764 1.52368 158.63 2.61506 157.454 3.74896C155.632 5.5065 153.739 7.32783 153.739 10.9209C153.739 14.5139 155.625 16.3352 157.454 18.0928C159.325 19.8999 161.097 21.6079 161.097 25.1017C161.097 28.5955 159.325 30.3035 157.454 32.1106C155.632 33.8682 153.739 35.6895 153.739 39.2825C153.739 42.8756 155.625 44.6969 157.454 46.4544C159.325 48.2616 161.097 49.9695 161.097 53.4634C161.097 56.9572 159.325 58.6651 157.454 60.4723C155.632 62.2298 153.739 64.0511 153.739 67.6442C153.739 71.2372 155.625 73.0586 157.454 74.8161C159.325 76.6233 161.097 78.3312 161.097 81.825C161.097 85.3188 159.325 87.0268 157.454 88.8339C155.632 90.5915 153.739 92.4128 153.739 96.0059C153.739 99.5989 155.625 101.413 157.454 103.178C159.325 104.985 161.097 106.686 161.097 110.187C161.097 113.681 159.325 115.388 157.454 117.196C155.972 118.627 154.448 120.094 153.931 122.518H154.158C154.661 120.208 156.1 118.818 157.61 117.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M155.61 117.359C157.439 115.601 159.325 113.78 159.325 110.187C159.325 106.594 157.439 104.772 155.61 103.015C153.739 101.208 151.967 99.5068 151.967 96.0059C151.967 92.512 153.739 90.8041 155.61 88.9969C157.439 87.2394 159.325 85.4181 159.325 81.825C159.325 78.232 157.439 76.4106 155.61 74.6531C153.739 72.846 151.967 71.138 151.967 67.6442C151.967 64.1504 153.739 62.4424 155.61 60.6353C157.439 58.8777 159.325 57.0564 159.325 53.4634C159.325 49.8703 157.439 48.049 155.61 46.2914C153.739 44.4843 151.967 42.7764 151.967 39.2825C151.967 35.7816 153.739 34.0808 155.61 32.2736C157.439 30.5161 159.325 28.6947 159.325 25.1017C159.325 21.5087 157.439 19.6873 155.61 17.9298C153.739 16.1226 151.967 14.4147 151.967 10.9209C151.967 7.41995 153.739 5.71911 155.61 3.91195C156.78 2.78514 157.971 1.62998 158.68 0H158.446C157.765 1.52368 156.631 2.61506 155.454 3.74896C153.633 5.5065 151.74 7.32783 151.74 10.9209C151.74 14.5139 153.626 16.3352 155.454 18.0928C157.326 19.8999 159.098 21.6008 159.098 25.1017C159.098 28.6026 157.326 30.3035 155.454 32.1106C153.633 33.8682 151.74 35.6895 151.74 39.2825C151.74 42.8756 153.626 44.6969 155.454 46.4544C157.326 48.2616 159.098 49.9695 159.098 53.4634C159.098 56.9572 157.326 58.6651 155.454 60.4723C153.633 62.2298 151.74 64.0511 151.74 67.6442C151.74 71.2372 153.626 73.0586 155.454 74.8161C157.326 76.6233 159.098 78.3312 159.098 81.825C159.098 85.3188 157.326 87.0268 155.454 88.8339C153.633 90.5915 151.74 92.4128 151.74 96.0059C151.74 99.5989 153.626 101.413 155.454 103.178C157.326 104.985 159.098 106.686 159.098 110.187C159.098 113.681 157.326 115.388 155.454 117.196C153.973 118.627 152.449 120.094 151.931 122.518H152.158C152.661 120.208 154.1 118.818 155.61 117.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M153.619 117.359C155.44 115.601 157.333 113.78 157.333 110.187C157.333 106.594 155.447 104.772 153.619 103.015C151.747 101.208 149.975 99.5068 149.975 96.0059C149.975 92.512 151.747 90.8041 153.619 88.9969C155.44 87.2394 157.333 85.4181 157.333 81.825C157.333 78.232 155.447 76.4106 153.619 74.6531C151.747 72.846 149.975 71.138 149.975 67.6442C149.975 64.1504 151.747 62.4424 153.619 60.6353C155.44 58.8777 157.333 57.0564 157.333 53.4634C157.333 49.8703 155.447 48.049 153.619 46.2914C151.747 44.4843 149.975 42.7764 149.975 39.2825C149.975 35.7816 151.747 34.0808 153.619 32.2736C155.44 30.5161 157.333 28.6947 157.333 25.1017C157.333 21.5087 155.447 19.6873 153.619 17.9298C151.747 16.1226 149.975 14.4147 149.975 10.9209C149.975 7.41995 151.747 5.71911 153.619 3.91195C154.788 2.78514 155.979 1.62998 156.688 0H156.454C155.774 1.52368 154.639 2.61506 153.463 3.74896C151.641 5.5065 149.748 7.32783 149.748 10.9209C149.748 14.5139 151.634 16.3352 153.463 18.0928C155.334 19.8999 157.106 21.6008 157.106 25.1017C157.106 28.6026 155.334 30.3035 153.463 32.1106C151.641 33.8682 149.748 35.6895 149.748 39.2825C149.748 42.8756 151.634 44.6969 153.463 46.4544C155.334 48.2616 157.106 49.9695 157.106 53.4634C157.106 56.9572 155.334 58.6651 153.463 60.4723C151.641 62.2298 149.748 64.0511 149.748 67.6442C149.748 71.2372 151.634 73.0586 153.463 74.8161C155.334 76.6233 157.106 78.3312 157.106 81.825C157.106 85.3188 155.334 87.0268 153.463 88.8339C151.641 90.5915 149.748 92.4128 149.748 96.0059C149.748 99.5989 151.634 101.413 153.463 103.178C155.334 104.985 157.106 106.686 157.106 110.187C157.106 113.681 155.334 115.388 153.463 117.196C151.981 118.627 150.457 120.094 149.94 122.518H150.167C150.67 120.208 152.109 118.818 153.619 117.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M151.619 117.359C153.448 115.601 155.334 113.78 155.334 110.187C155.334 106.594 153.448 104.772 151.619 103.015C149.748 101.208 147.976 99.5068 147.976 96.0059C147.976 92.512 149.748 90.8041 151.619 88.9969C153.448 87.2394 155.334 85.4181 155.334 81.825C155.334 78.232 153.448 76.4106 151.619 74.6531C149.748 72.846 147.976 71.138 147.976 67.6442C147.976 64.1504 149.748 62.4424 151.619 60.6353C153.448 58.8777 155.334 57.0564 155.334 53.4634C155.334 49.8703 153.448 48.049 151.619 46.2914C149.748 44.4843 147.976 42.7764 147.976 39.2825C147.976 35.7816 149.748 34.0808 151.619 32.2736C153.448 30.5161 155.334 28.6947 155.334 25.1017C155.334 21.5087 153.448 19.6873 151.619 17.9298C149.748 16.1226 147.976 14.4147 147.976 10.9209C147.976 7.41995 149.748 5.71911 151.619 3.91195C152.789 2.78514 153.98 1.62998 154.689 0H154.455C153.774 1.52368 152.64 2.61506 151.463 3.74896C149.635 5.5065 147.749 7.32783 147.749 10.9209C147.749 14.5139 149.635 16.3352 151.463 18.0928C153.335 19.8999 155.107 21.6008 155.107 25.1017C155.107 28.6026 153.335 30.3035 151.463 32.1106C149.635 33.8682 147.749 35.6895 147.749 39.2825C147.749 42.8756 149.635 44.6969 151.463 46.4544C153.335 48.2616 155.107 49.9695 155.107 53.4634C155.107 56.9572 153.335 58.6651 151.463 60.4723C149.635 62.2298 147.749 64.0511 147.749 67.6442C147.749 71.2372 149.635 73.0586 151.463 74.8161C153.335 76.6233 155.107 78.3312 155.107 81.825C155.107 85.3188 153.335 87.0268 151.463 88.8339C149.635 90.5915 147.749 92.4128 147.749 96.0059C147.749 99.5989 149.635 101.413 151.463 103.178C153.335 104.985 155.107 106.686 155.107 110.187C155.107 113.681 153.335 115.388 151.463 117.196C149.982 118.627 148.458 120.094 147.94 122.518H148.167C148.671 120.208 150.109 118.818 151.619 117.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M149.62 117.359C151.442 115.601 153.334 113.78 153.334 110.187C153.334 106.594 151.449 104.779 149.62 103.015C147.749 101.208 145.977 99.5068 145.977 96.0059C145.977 92.512 147.749 90.8041 149.62 88.9969C151.442 87.2394 153.334 85.4181 153.334 81.825C153.334 78.232 151.449 76.4106 149.62 74.6531C147.749 72.846 145.977 71.1451 145.977 67.6442C145.977 64.1504 147.749 62.4424 149.62 60.6353C151.442 58.8777 153.334 57.0564 153.334 53.4634C153.334 49.8703 151.449 48.049 149.62 46.2914C147.749 44.4843 145.977 42.7764 145.977 39.2825C145.977 35.7816 147.749 34.0808 149.62 32.2736C151.442 30.5161 153.334 28.6947 153.334 25.1017C153.334 21.5087 151.449 19.6873 149.62 17.9298C147.749 16.1226 145.977 14.4147 145.977 10.9209C145.977 7.41995 147.749 5.71911 149.62 3.91195C150.79 2.78514 151.98 1.62998 152.689 0H152.455C151.775 1.52368 150.641 2.61506 149.464 3.74896C147.635 5.5065 145.75 7.32783 145.75 10.9209C145.75 14.5139 147.635 16.3352 149.464 18.0928C151.335 19.8999 153.107 21.6008 153.107 25.1017C153.107 28.6026 151.335 30.3035 149.464 32.1106C147.635 33.8682 145.75 35.6895 145.75 39.2825C145.75 42.8756 147.635 44.6969 149.464 46.4544C151.335 48.2616 153.107 49.9624 153.107 53.4634C153.107 56.9572 151.335 58.6651 149.464 60.4723C147.635 62.2298 145.75 64.0511 145.75 67.6442C145.75 71.2372 147.635 73.0586 149.464 74.8161C151.335 76.6233 153.107 78.3241 153.107 81.825C153.107 85.3188 151.335 87.0268 149.464 88.8339C147.635 90.5915 145.75 92.4128 145.75 96.0059C145.75 99.5989 147.635 101.42 149.464 103.178C151.335 104.985 153.107 106.686 153.107 110.187C153.107 113.681 151.335 115.388 149.464 117.196C147.983 118.627 146.459 120.094 145.941 122.518H146.168C146.671 120.208 148.11 118.818 149.62 117.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M147.63 117.359C149.452 115.601 151.345 113.78 151.345 110.187C151.345 106.594 149.459 104.779 147.63 103.015C145.759 101.208 143.987 99.5068 143.987 96.0059C143.987 92.512 145.759 90.8041 147.63 88.9969C149.452 87.2394 151.345 85.4181 151.345 81.825C151.345 78.232 149.459 76.4106 147.63 74.6531C145.759 72.846 143.987 71.1451 143.987 67.6442C143.987 64.1504 145.759 62.4424 147.63 60.6353C149.452 58.8777 151.345 57.0564 151.345 53.4634C151.345 49.8703 149.459 48.049 147.63 46.2914C145.759 44.4843 143.987 42.7764 143.987 39.2825C143.987 35.7887 145.759 34.0808 147.63 32.2736C149.452 30.5161 151.345 28.6947 151.345 25.1017C151.345 21.5087 149.459 19.6873 147.63 17.9298C145.759 16.1226 143.987 14.4147 143.987 10.9209C143.987 7.41995 145.759 5.71911 147.63 3.91195C148.8 2.78514 149.991 1.62998 150.7 0H150.466C149.785 1.52368 148.651 2.61506 147.474 3.74896C145.653 5.5065 143.76 7.32783 143.76 10.9209C143.76 14.5139 145.646 16.3352 147.474 18.0928C149.346 19.8999 151.118 21.6008 151.118 25.1017C151.118 28.5955 149.346 30.3035 147.474 32.1106C145.653 33.8682 143.76 35.6895 143.76 39.2825C143.76 42.8756 145.646 44.6969 147.474 46.4544C149.346 48.2616 151.118 49.9624 151.118 53.4634C151.118 56.9572 149.346 58.6651 147.474 60.4723C145.653 62.2298 143.76 64.0511 143.76 67.6442C143.76 71.2372 145.646 73.0586 147.474 74.8161C149.346 76.6233 151.118 78.3241 151.118 81.825C151.118 85.3188 149.346 87.0268 147.474 88.8339C145.653 90.5915 143.76 92.4128 143.76 96.0059C143.76 99.5989 145.646 101.42 147.474 103.178C149.346 104.985 151.118 106.686 151.118 110.187C151.118 113.681 149.346 115.388 147.474 117.196C145.993 118.627 144.469 120.094 143.951 122.518H144.178C144.674 120.208 146.121 118.818 147.63 117.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M145.631 117.359C147.453 115.601 149.338 113.78 149.338 110.187C149.338 106.594 147.453 104.779 145.624 103.015C143.753 101.208 141.98 99.5068 141.98 96.0059C141.98 92.512 143.753 90.8041 145.624 88.9969C147.453 87.2394 149.338 85.4181 149.338 81.825C149.338 78.232 147.453 76.4106 145.624 74.6531C143.753 72.846 141.98 71.1451 141.98 67.6442C141.98 64.1504 143.753 62.4424 145.624 60.6353C147.446 58.8777 149.331 57.0564 149.331 53.4634C149.331 49.8703 147.446 48.049 145.624 46.2914C143.753 44.4843 141.98 42.7764 141.98 39.2825C141.98 35.7887 143.753 34.0808 145.624 32.2736C147.446 30.5161 149.331 28.6947 149.331 25.1017C149.331 21.5087 147.446 19.6873 145.624 17.9298C143.753 16.1226 141.98 14.4147 141.98 10.9209C141.98 7.41995 143.753 5.71911 145.624 3.91195C146.793 2.78514 147.984 1.62998 148.693 0H148.459C147.779 1.52368 146.645 2.61506 145.468 3.74896C143.646 5.5065 141.761 7.32783 141.761 10.9209C141.761 14.5139 143.646 16.3352 145.475 18.0928C147.346 19.8999 149.118 21.6008 149.118 25.1017C149.118 28.5955 147.346 30.3035 145.475 32.1106C143.653 33.8682 141.768 35.6895 141.768 39.2825C141.768 42.8756 143.653 44.6969 145.475 46.4544C147.346 48.2616 149.118 49.9624 149.118 53.4634C149.118 56.9572 147.346 58.6651 145.475 60.4723C143.653 62.2298 141.768 64.0511 141.768 67.6442C141.768 71.2372 143.653 73.0586 145.475 74.8161C147.346 76.6233 149.118 78.3241 149.118 81.825C149.118 85.3188 147.346 87.0268 145.475 88.8339C143.653 90.5915 141.768 92.4128 141.768 96.0059C141.768 99.5989 143.653 101.42 145.475 103.178C147.346 104.985 149.118 106.686 149.118 110.187C149.118 113.681 147.346 115.388 145.475 117.196C143.994 118.627 142.47 120.094 141.952 122.518H142.179C142.682 120.208 144.121 118.818 145.631 117.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M143.632 117.359C145.46 115.601 147.346 113.78 147.346 110.187C147.346 106.594 145.46 104.779 143.632 103.015C141.76 101.208 139.988 99.5068 139.988 96.0059C139.988 92.512 141.76 90.8041 143.632 88.9969C145.46 87.2394 147.346 85.4181 147.346 81.825C147.346 78.232 145.46 76.4106 143.632 74.6531C141.76 72.846 139.988 71.1451 139.988 67.6442C139.988 64.1504 141.76 62.4424 143.632 60.6353C145.46 58.8777 147.346 57.0564 147.346 53.4634C147.346 49.8703 145.46 48.049 143.632 46.2914C141.76 44.4843 139.988 42.7764 139.988 39.2825C139.988 35.7887 141.76 34.0808 143.632 32.2736C145.46 30.5161 147.346 28.6947 147.346 25.1017C147.346 21.5087 145.46 19.6873 143.632 17.9298C141.76 16.1226 139.988 14.4147 139.988 10.9209C139.988 7.41995 141.76 5.71911 143.632 3.91195C144.801 2.78514 145.992 1.62998 146.701 0H146.467C145.787 1.52368 144.652 2.61506 143.476 3.74896C141.654 5.5065 139.761 7.32783 139.761 10.9209C139.761 14.5139 141.647 16.3352 143.476 18.0928C145.347 19.8999 147.119 21.6008 147.119 25.1017C147.119 28.5955 145.347 30.3035 143.476 32.1106C141.654 33.8682 139.761 35.6895 139.761 39.2825C139.761 42.8756 141.647 44.6969 143.476 46.4544C145.347 48.2616 147.119 49.9624 147.119 53.4634C147.119 56.9572 145.347 58.6651 143.476 60.4723C141.654 62.2298 139.761 64.0511 139.761 67.6442C139.761 71.2372 141.647 73.0586 143.476 74.8161C145.347 76.6233 147.119 78.3241 147.119 81.825C147.119 85.3188 145.347 87.0268 143.476 88.8339C141.654 90.5915 139.761 92.4128 139.761 96.0059C139.761 99.5989 141.647 101.42 143.476 103.178C145.347 104.985 147.119 106.686 147.119 110.187C147.119 113.681 145.347 115.388 143.476 117.196C141.994 118.627 140.47 120.094 139.953 122.518H140.18C140.683 120.208 142.122 118.818 143.632 117.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M141.632 117.359C143.461 115.601 145.347 113.78 145.347 110.187C145.347 106.594 143.461 104.779 141.632 103.015C139.761 101.208 137.989 99.5068 137.989 96.0059C137.989 92.512 139.761 90.8041 141.632 88.9969C143.461 87.2394 145.347 85.4181 145.347 81.825C145.347 78.232 143.461 76.4106 141.632 74.6531C139.761 72.846 137.989 71.1451 137.989 67.6442C137.989 64.1504 139.761 62.4424 141.632 60.6353C143.461 58.8777 145.347 57.0564 145.347 53.4634C145.347 49.8703 143.461 48.049 141.632 46.2914C139.761 44.4843 137.989 42.7764 137.989 39.2825C137.989 35.7887 139.761 34.0808 141.632 32.2736C143.461 30.5161 145.347 28.6947 145.347 25.1017C145.347 21.5087 143.461 19.6873 141.632 17.9298C139.761 16.1226 137.989 14.4147 137.989 10.9209C137.989 7.41995 139.761 5.71911 141.632 3.91195C142.802 2.78514 143.993 1.62998 144.702 0H144.468C143.787 1.52368 142.653 2.61506 141.476 3.74896C139.655 5.5065 137.762 7.32783 137.762 10.9209C137.762 14.5139 139.648 16.3352 141.476 18.0928C143.348 19.8999 145.12 21.6008 145.12 25.1017C145.12 28.5955 143.348 30.3035 141.476 32.1106C139.655 33.8682 137.762 35.6895 137.762 39.2825C137.762 42.8756 139.648 44.6969 141.476 46.4544C143.348 48.2616 145.12 49.9624 145.12 53.4634C145.12 56.9572 143.348 58.6651 141.476 60.4723C139.655 62.2298 137.762 64.0511 137.762 67.6442C137.762 71.2372 139.648 73.0586 141.476 74.8161C143.348 76.6233 145.12 78.3241 145.12 81.825C145.12 85.3188 143.348 87.0268 141.476 88.8339C139.655 90.5915 137.762 92.4128 137.762 96.0059C137.762 99.5989 139.648 101.42 141.476 103.178C143.348 104.985 145.12 106.686 145.12 110.187C145.12 113.681 143.348 115.388 141.476 117.196C139.995 118.627 138.471 120.094 137.953 122.518H138.18C138.684 120.208 140.13 118.818 141.632 117.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M139.641 117.359C141.47 115.601 143.355 113.78 143.355 110.187C143.355 106.594 141.47 104.779 139.641 103.015C137.769 101.208 135.997 99.5068 135.997 96.0059C135.997 92.512 137.769 90.8041 139.641 88.9969C141.47 87.2394 143.355 85.4181 143.355 81.825C143.355 78.232 141.47 76.4106 139.641 74.6531C137.769 72.846 135.997 71.1451 135.997 67.6442C135.997 64.1504 137.769 62.4424 139.641 60.6353C141.47 58.8777 143.355 57.0564 143.355 53.4634C143.355 49.8703 141.47 48.049 139.641 46.2914C137.769 44.4843 135.997 42.7764 135.997 39.2825C135.997 35.7887 137.769 34.0808 139.641 32.2736C141.47 30.5161 143.355 28.6947 143.355 25.1017C143.355 21.5087 141.47 19.6873 139.641 17.9298C137.769 16.1226 135.997 14.4218 135.997 10.9209C135.997 7.41995 137.769 5.71911 139.641 3.91195C140.81 2.78514 142.001 1.62998 142.71 0H142.476C141.796 1.52368 140.661 2.61506 139.485 3.74896C137.656 5.5065 135.77 7.32783 135.77 10.9209C135.77 14.5139 137.656 16.3352 139.485 18.0928C141.356 19.8999 143.128 21.6079 143.128 25.1017C143.128 28.5955 141.356 30.3035 139.485 32.1106C137.656 33.8682 135.77 35.6895 135.77 39.2825C135.77 42.8756 137.656 44.6969 139.485 46.4544C141.356 48.2616 143.128 49.9624 143.128 53.4634C143.128 56.9572 141.356 58.6651 139.485 60.4723C137.656 62.2298 135.77 64.0511 135.77 67.6442C135.77 71.2372 137.656 73.0586 139.485 74.8161C141.356 76.6233 143.128 78.3241 143.128 81.825C143.128 85.3188 141.356 87.0268 139.485 88.8339C137.656 90.5915 135.77 92.4128 135.77 96.0059C135.77 99.5989 137.656 101.42 139.485 103.178C141.356 104.985 143.128 106.686 143.128 110.187C143.128 113.681 141.356 115.388 139.485 117.196C138.003 118.627 136.479 120.094 135.962 122.518H136.189C136.692 120.208 138.131 118.818 139.641 117.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M137.641 117.359C139.463 115.601 141.356 113.78 141.356 110.187C141.356 106.594 139.47 104.779 137.641 103.015C135.77 101.208 133.998 99.5068 133.998 96.0059C133.998 92.512 135.77 90.8041 137.641 88.9969C139.463 87.2394 141.356 85.4181 141.356 81.825C141.356 78.232 139.47 76.4106 137.641 74.6531C135.77 72.846 133.998 71.1451 133.998 67.6442C133.998 64.1504 135.77 62.4424 137.641 60.6353C139.463 58.8777 141.356 57.0564 141.356 53.4634C141.356 49.8703 139.47 48.049 137.641 46.2914C135.77 44.4843 133.998 42.7764 133.998 39.2825C133.998 35.7887 135.77 34.0808 137.641 32.2736C139.463 30.5161 141.356 28.6947 141.356 25.1017C141.356 21.5087 139.47 19.6873 137.641 17.9298C135.77 16.1226 133.998 14.4218 133.998 10.9209C133.998 7.41995 135.77 5.71911 137.641 3.91195C138.811 2.78514 140.002 1.62998 140.711 0H140.477C139.796 1.52368 138.662 2.61506 137.485 3.74896C135.657 5.5065 133.771 7.32783 133.771 10.9209C133.771 14.5139 135.657 16.3352 137.485 18.0928C139.357 19.8999 141.129 21.6079 141.129 25.1017C141.129 28.5955 139.357 30.3035 137.485 32.1106C135.657 33.8682 133.771 35.6895 133.771 39.2825C133.771 42.8756 135.657 44.6969 137.485 46.4544C139.357 48.2616 141.129 49.9624 141.129 53.4634C141.129 56.9572 139.357 58.6651 137.485 60.4723C135.657 62.2298 133.771 64.0511 133.771 67.6442C133.771 71.2372 135.657 73.0586 137.485 74.8161C139.357 76.6233 141.129 78.3241 141.129 81.825C141.129 85.3188 139.357 87.0268 137.485 88.8339C135.657 90.5915 133.771 92.4128 133.771 96.0059C133.771 99.5989 135.657 101.42 137.485 103.178C139.357 104.985 141.129 106.686 141.129 110.187C141.129 113.681 139.357 115.388 137.485 117.196C136.004 118.627 134.48 120.094 133.962 122.518H134.189C134.693 120.208 136.132 118.818 137.641 117.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M135.642 117.359C137.464 115.601 139.349 113.78 139.349 110.187C139.349 106.594 137.464 104.779 135.642 103.015C133.771 101.208 131.999 99.5068 131.999 96.0059C131.999 92.512 133.771 90.8041 135.642 88.9969C137.464 87.2394 139.349 85.4181 139.349 81.825C139.349 78.232 137.464 76.4106 135.642 74.6531C133.771 72.846 131.999 71.1451 131.999 67.6442C131.999 64.1504 133.771 62.4424 135.642 60.6353C137.464 58.8777 139.349 57.0564 139.349 53.4634C139.349 49.8703 137.464 48.049 135.642 46.2914C133.771 44.4843 131.999 42.7764 131.999 39.2825C131.999 35.7887 133.771 34.0808 135.642 32.2736C137.464 30.5161 139.349 28.6947 139.349 25.1017C139.349 21.5087 137.464 19.6873 135.642 17.9298C133.771 16.1226 131.999 14.4218 131.999 10.9209C131.999 7.41995 133.771 5.71911 135.642 3.91195C136.812 2.78514 138.002 1.62998 138.711 0H138.477C137.797 1.52368 136.663 2.61506 135.486 3.74896C133.657 5.5065 131.772 7.32783 131.772 10.9209C131.772 14.5139 133.657 16.3352 135.486 18.0928C137.357 19.8999 139.13 21.6079 139.13 25.1017C139.13 28.5955 137.357 30.3035 135.486 32.1106C133.657 33.8682 131.772 35.6895 131.772 39.2825C131.772 42.8756 133.657 44.6969 135.486 46.4544C137.357 48.2616 139.13 49.9624 139.13 53.4634C139.13 56.9572 137.357 58.6651 135.486 60.4723C133.657 62.2298 131.772 64.0511 131.772 67.6442C131.772 71.2372 133.657 73.0586 135.486 74.8161C137.357 76.6233 139.13 78.3241 139.13 81.825C139.13 85.3188 137.357 87.0268 135.486 88.8339C133.657 90.5915 131.772 92.4128 131.772 96.0059C131.772 99.5989 133.657 101.42 135.486 103.178C137.357 104.985 139.13 106.686 139.13 110.187C139.13 113.681 137.357 115.388 135.486 117.196C134.005 118.627 132.481 120.094 131.963 122.518H132.19C132.693 120.208 134.132 118.818 135.642 117.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M133.652 117.359C135.474 115.601 137.359 113.78 137.359 110.187C137.359 106.594 135.474 104.779 133.645 103.015C131.774 101.208 130.002 99.5068 130.002 96.0059C130.002 92.512 131.774 90.8041 133.645 88.9969C135.474 87.2394 137.359 85.4181 137.359 81.825C137.359 78.232 135.474 76.4106 133.645 74.6531C131.774 72.846 130.002 71.1451 130.002 67.6442C130.002 64.1504 131.774 62.4424 133.645 60.6353C135.467 58.8777 137.352 57.0564 137.352 53.4634C137.352 49.8703 135.467 48.049 133.645 46.2914C131.774 44.4843 130.002 42.7764 130.002 39.2825C130.002 35.7887 131.774 34.0808 133.645 32.2736C135.467 30.5161 137.352 28.6947 137.352 25.1017C137.352 21.5087 135.467 19.6873 133.645 17.9298C131.774 16.1226 130.002 14.4218 130.002 10.9209C130.002 7.41995 131.774 5.71911 133.645 3.91195C134.815 2.78514 136.005 1.62998 136.714 0H136.48C135.8 1.52368 134.666 2.61506 133.489 3.74896C131.667 5.5065 129.775 7.32783 129.775 10.9209C129.775 14.5139 131.66 16.3352 133.489 18.0928C135.36 19.8999 137.132 21.6079 137.132 25.1017C137.132 28.5955 135.36 30.3035 133.489 32.1106C131.667 33.8682 129.775 35.6895 129.775 39.2825C129.775 42.8756 131.66 44.6969 133.489 46.4544C135.36 48.2616 137.132 49.9624 137.132 53.4634C137.132 56.9572 135.36 58.6651 133.489 60.4723C131.667 62.2298 129.775 64.0511 129.775 67.6442C129.775 71.2372 131.66 73.0586 133.489 74.8161C135.36 76.6233 137.132 78.3241 137.132 81.825C137.132 85.3188 135.36 87.0268 133.489 88.8339C131.667 90.5915 129.775 92.4128 129.775 96.0059C129.775 99.5989 131.66 101.42 133.489 103.178C135.36 104.985 137.132 106.686 137.132 110.187C137.132 113.681 135.36 115.388 133.489 117.196C132.008 118.627 130.484 120.094 129.966 122.518H130.193C130.696 120.208 132.142 118.818 133.652 117.359Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M127.483 117.359C129.304 115.601 131.197 113.78 131.197 110.187C131.197 106.594 129.311 104.772 127.483 103.015C125.611 101.208 123.839 99.5068 123.839 96.0059C123.839 92.512 125.611 90.8041 127.483 88.9969C129.304 87.2394 131.197 85.4181 131.197 81.825C131.197 78.232 129.311 76.4106 127.483 74.6531C125.611 72.846 123.839 71.138 123.839 67.6442C123.839 64.1504 125.611 62.4424 127.483 60.6353C129.304 58.8777 131.197 57.0564 131.197 53.4634C131.197 49.8703 129.311 48.049 127.483 46.2914C125.611 44.4843 123.839 42.7764 123.839 39.2825C123.839 35.7816 125.611 34.0808 127.483 32.2736C129.304 30.5161 131.197 28.6947 131.197 25.1017C131.197 21.5087 129.311 19.6873 127.483 17.9298C125.611 16.1226 123.839 14.4147 123.839 10.9209C123.839 7.41995 125.611 5.71911 127.483 3.91195C128.652 2.78514 129.843 1.62998 130.552 0H130.318C129.637 1.52368 128.503 2.61506 127.327 3.74896C125.498 5.5065 123.612 7.32783 123.612 10.9209C123.612 14.5139 125.498 16.3352 127.327 18.0928C129.198 19.8999 130.97 21.6079 130.97 25.1017C130.97 28.5955 129.198 30.3035 127.327 32.1106C125.498 33.8682 123.612 35.6895 123.612 39.2825C123.612 42.8756 125.498 44.6969 127.327 46.4544C129.198 48.2616 130.97 49.9695 130.97 53.4634C130.97 56.9572 129.198 58.6651 127.327 60.4723C125.498 62.2298 123.612 64.0511 123.612 67.6442C123.612 71.2372 125.498 73.0586 127.327 74.8161C129.198 76.6233 130.97 78.3312 130.97 81.825C130.97 85.3188 129.198 87.0268 127.327 88.8339C125.498 90.5915 123.612 92.4128 123.612 96.0059C123.612 99.5989 125.498 101.413 127.327 103.178C129.198 104.985 130.97 106.686 130.97 110.187C130.97 113.681 129.198 115.388 127.327 117.196C125.845 118.627 124.321 120.094 123.804 122.518H124.031C124.534 120.208 125.973 118.818 127.483 117.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M125.483 117.359C127.305 115.601 129.198 113.78 129.198 110.187C129.198 106.594 127.312 104.772 125.483 103.015C123.612 101.208 121.84 99.5068 121.84 96.0059C121.84 92.512 123.612 90.8041 125.483 88.9969C127.305 87.2394 129.198 85.4181 129.198 81.825C129.198 78.232 127.312 76.4106 125.483 74.6531C123.612 72.846 121.84 71.138 121.84 67.6442C121.84 64.1504 123.612 62.4424 125.483 60.6353C127.305 58.8777 129.198 57.0564 129.198 53.4634C129.198 49.8703 127.312 48.049 125.483 46.2914C123.612 44.4843 121.84 42.7764 121.84 39.2825C121.84 35.7816 123.612 34.0808 125.483 32.2736C127.305 30.5161 129.198 28.6947 129.198 25.1017C129.198 21.5087 127.312 19.6873 125.483 17.9298C123.612 16.1226 121.84 14.4147 121.84 10.9209C121.84 7.41995 123.612 5.71911 125.483 3.91195C126.653 2.78514 127.844 1.62998 128.553 0H128.319C127.638 1.52368 126.504 2.61506 125.327 3.74896C123.499 5.5065 121.613 7.32783 121.613 10.9209C121.613 14.5139 123.499 16.3352 125.327 18.0928C127.199 19.8999 128.971 21.6079 128.971 25.1017C128.971 28.5955 127.199 30.3035 125.327 32.1106C123.499 33.8682 121.613 35.6895 121.613 39.2825C121.613 42.8756 123.499 44.6969 125.327 46.4544C127.199 48.2616 128.971 49.9695 128.971 53.4634C128.971 56.9572 127.199 58.6651 125.327 60.4723C123.499 62.2298 121.613 64.0511 121.613 67.6442C121.613 71.2372 123.499 73.0586 125.327 74.8161C127.199 76.6233 128.971 78.3312 128.971 81.825C128.971 85.3188 127.199 87.0268 125.327 88.8339C123.499 90.5915 121.613 92.4128 121.613 96.0059C121.613 99.5989 123.499 101.413 125.327 103.178C127.199 104.985 128.971 106.686 128.971 110.187C128.971 113.681 127.199 115.388 125.327 117.196C123.846 118.627 122.322 120.094 121.804 122.518H122.031C122.535 120.208 123.973 118.818 125.483 117.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M123.486 117.359C125.308 115.601 127.2 113.78 127.2 110.187C127.2 106.594 125.315 104.772 123.486 103.015C121.615 101.208 119.842 99.5068 119.842 96.0059C119.842 92.512 121.615 90.8041 123.486 88.9969C125.308 87.2394 127.2 85.4181 127.2 81.825C127.2 78.232 125.315 76.4106 123.486 74.6531C121.615 72.846 119.842 71.138 119.842 67.6442C119.842 64.1504 121.615 62.4424 123.486 60.6353C125.308 58.8777 127.2 57.0564 127.2 53.4634C127.2 49.8703 125.315 48.049 123.486 46.2914C121.615 44.4843 119.842 42.7764 119.842 39.2825C119.842 35.7816 121.615 34.0808 123.486 32.2736C125.308 30.5161 127.2 28.6947 127.2 25.1017C127.2 21.5087 125.315 19.6873 123.486 17.9298C121.615 16.1226 119.842 14.4147 119.842 10.9209C119.842 7.41995 121.615 5.71911 123.486 3.91195C124.655 2.78514 125.846 1.62998 126.555 0H126.321C125.641 1.52368 124.507 2.61506 123.33 3.74896C121.508 5.5065 119.616 7.32783 119.616 10.9209C119.616 14.5139 121.501 16.3352 123.33 18.0928C125.201 19.8999 126.973 21.6079 126.973 25.1017C126.973 28.5955 125.201 30.3035 123.33 32.1106C121.508 33.8682 119.616 35.6895 119.616 39.2825C119.616 42.8756 121.501 44.6969 123.33 46.4544C125.201 48.2616 126.973 49.9695 126.973 53.4634C126.973 56.9572 125.201 58.6651 123.33 60.4723C121.508 62.2298 119.616 64.0511 119.616 67.6442C119.616 71.2372 121.501 73.0586 123.33 74.8161C125.201 76.6233 126.973 78.3312 126.973 81.825C126.973 85.3188 125.201 87.0268 123.33 88.8339C121.508 90.5915 119.616 92.4128 119.616 96.0059C119.616 99.5989 121.501 101.413 123.33 103.178C125.201 104.985 126.973 106.686 126.973 110.187C126.973 113.681 125.201 115.388 123.33 117.196C121.848 118.627 120.324 120.094 119.807 122.518H120.034C120.537 120.208 121.976 118.818 123.486 117.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M121.494 117.359C123.323 115.601 125.209 113.78 125.209 110.187C125.209 106.594 123.323 104.772 121.494 103.015C119.623 101.208 117.851 99.5068 117.851 96.0059C117.851 92.512 119.623 90.8041 121.494 88.9969C123.323 87.2394 125.209 85.4181 125.209 81.825C125.209 78.232 123.323 76.4106 121.494 74.6531C119.623 72.846 117.851 71.138 117.851 67.6442C117.851 64.1504 119.623 62.4424 121.494 60.6353C123.323 58.8777 125.209 57.0564 125.209 53.4634C125.209 49.8703 123.323 48.049 121.494 46.2914C119.623 44.4843 117.851 42.7764 117.851 39.2825C117.851 35.7816 119.623 34.0808 121.494 32.2736C123.323 30.5161 125.209 28.6947 125.209 25.1017C125.209 21.5087 123.323 19.6873 121.494 17.9298C119.623 16.1226 117.851 14.4147 117.851 10.9209C117.851 7.41995 119.623 5.71911 121.494 3.91195C122.664 2.78514 123.855 1.62998 124.564 0H124.33C123.649 1.52368 122.515 2.61506 121.338 3.74896C119.517 5.5065 117.624 7.32783 117.624 10.9209C117.624 14.5139 119.51 16.3352 121.338 18.0928C123.21 19.8999 124.982 21.6079 124.982 25.1017C124.982 28.5955 123.21 30.3035 121.338 32.1106C119.517 33.8682 117.624 35.6895 117.624 39.2825C117.624 42.8756 119.51 44.6969 121.338 46.4544C123.21 48.2616 124.982 49.9695 124.982 53.4634C124.982 56.9572 123.21 58.6651 121.338 60.4723C119.517 62.2298 117.624 64.0511 117.624 67.6442C117.624 71.2372 119.51 73.0586 121.338 74.8161C123.21 76.6233 124.982 78.3312 124.982 81.825C124.982 85.3188 123.21 87.0268 121.338 88.8339C119.517 90.5915 117.624 92.4128 117.624 96.0059C117.624 99.5989 119.51 101.413 121.338 103.178C123.21 104.985 124.982 106.686 124.982 110.187C124.982 113.681 123.21 115.388 121.338 117.196C119.857 118.627 118.333 120.094 117.815 122.518H118.042C118.546 120.208 119.984 118.818 121.494 117.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M119.495 117.359C121.324 115.601 123.209 113.78 123.209 110.187C123.209 106.594 121.324 104.779 119.495 103.015C117.624 101.208 115.851 99.5068 115.851 96.0059C115.851 92.512 117.624 90.8041 119.495 88.9969C121.324 87.2394 123.209 85.4181 123.209 81.825C123.209 78.232 121.324 76.4106 119.495 74.6531C117.624 72.846 115.851 71.138 115.851 67.6442C115.851 64.1504 117.624 62.4424 119.495 60.6353C121.324 58.8777 123.209 57.0564 123.209 53.4634C123.209 49.8703 121.324 48.049 119.495 46.2914C117.624 44.4843 115.851 42.7764 115.851 39.2825C115.851 35.7816 117.624 34.0808 119.495 32.2736C121.324 30.5161 123.209 28.6947 123.209 25.1017C123.209 21.5087 121.324 19.6873 119.495 17.9298C117.624 16.1226 115.851 14.4218 115.851 10.9209C115.851 7.41995 117.624 5.71911 119.495 3.91195C120.664 2.78514 121.855 1.62998 122.564 0H122.33C121.65 1.52368 120.516 2.61506 119.339 3.74896C117.51 5.5065 115.625 7.32783 115.625 10.9209C115.625 14.5139 117.51 16.3352 119.339 18.0928C121.21 19.8999 122.982 21.6079 122.982 25.1017C122.982 28.5955 121.21 30.3035 119.339 32.1106C117.51 33.8682 115.625 35.6895 115.625 39.2825C115.625 42.8756 117.51 44.6969 119.339 46.4544C121.21 48.2616 122.982 49.9695 122.982 53.4634C122.982 56.9572 121.21 58.6651 119.339 60.4723C117.51 62.2298 115.625 64.0511 115.625 67.6442C115.625 71.2372 117.51 73.0586 119.339 74.8161C121.21 76.6233 122.982 78.3312 122.982 81.825C122.982 85.3188 121.21 87.0268 119.339 88.8339C117.51 90.5915 115.625 92.4128 115.625 96.0059C115.625 99.5989 117.51 101.42 119.339 103.178C121.21 104.985 122.982 106.686 122.982 110.187C122.982 113.681 121.21 115.388 119.339 117.196C117.857 118.627 116.333 120.094 115.816 122.518H116.043C116.546 120.208 117.985 118.818 119.495 117.359Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M61.1216 117.359C62.9433 115.601 64.8359 113.78 64.8359 110.187C64.8359 106.594 62.9504 104.779 61.1216 103.015C59.2503 101.208 57.4782 99.5068 57.4782 96.0059C57.4782 92.512 59.2503 90.8041 61.1216 88.9969C62.9433 87.2394 64.8359 85.4181 64.8359 81.825C64.8359 78.232 62.9504 76.4106 61.1216 74.6531C59.2503 72.846 57.4782 71.1451 57.4782 67.6442C57.4782 64.1504 59.2503 62.4424 61.1216 60.6353C62.9433 58.8777 64.8359 57.0564 64.8359 53.4634C64.8359 49.8703 62.9504 48.049 61.1216 46.2914C59.2503 44.4843 57.4782 42.7764 57.4782 39.2825C57.4782 35.7887 59.2503 34.0808 61.1216 32.2736C62.9433 30.5161 64.8359 28.6947 64.8359 25.1017C64.8359 21.5087 62.9504 19.6873 61.1216 17.9298C59.2503 16.1226 57.4782 14.4218 57.4782 10.9209C57.4782 7.41995 59.2503 5.71911 61.1216 3.91195C62.2912 2.78514 63.4821 1.62998 64.1909 0H63.957C63.2765 1.52368 62.1424 2.61506 60.9657 3.74896C59.144 5.5065 57.2514 7.32783 57.2514 10.9209C57.2514 14.5139 59.1369 16.3352 60.9657 18.0928C62.837 19.8999 64.6091 21.6079 64.6091 25.1017C64.6091 28.5955 62.837 30.3035 60.9657 32.1106C59.144 33.8682 57.2514 35.6895 57.2514 39.2825C57.2514 42.8756 59.1369 44.6969 60.9657 46.4544C62.837 48.2616 64.6091 49.9624 64.6091 53.4634C64.6091 56.9572 62.837 58.6651 60.9657 60.4723C59.144 62.2298 57.2514 64.0511 57.2514 67.6442C57.2514 71.2372 59.1369 73.0586 60.9657 74.8161C62.837 76.6233 64.6091 78.3241 64.6091 81.825C64.6091 85.3188 62.837 87.0268 60.9657 88.8339C59.144 90.5915 57.2514 92.4128 57.2514 96.0059C57.2514 99.5989 59.1369 101.42 60.9657 103.178C62.837 104.985 64.6091 106.686 64.6091 110.187C64.6091 113.681 62.837 115.388 60.9657 117.196C59.4842 118.627 57.9602 120.094 57.4428 122.518H57.6696C58.1729 120.208 59.6118 118.818 61.1216 117.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M58.4359 117.359C60.2576 115.601 62.1502 113.78 62.1502 110.187C62.1502 106.594 60.2647 104.779 58.4359 103.015C56.5645 101.208 54.7924 99.5068 54.7924 96.0059C54.7924 92.512 56.5645 90.8041 58.4359 88.9969C60.2576 87.2394 62.1502 85.4181 62.1502 81.825C62.1502 78.232 60.2647 76.4106 58.4359 74.6531C56.5645 72.846 54.7924 71.1451 54.7924 67.6442C54.7924 64.1504 56.5645 62.4424 58.4359 60.6353C60.2576 58.8777 62.1502 57.0564 62.1502 53.4634C62.1502 49.8703 60.2647 48.049 58.4359 46.2914C56.5645 44.4843 54.7924 42.7764 54.7924 39.2825C54.7924 35.7887 56.5645 34.0808 58.4359 32.2736C60.2576 30.5161 62.1502 28.6947 62.1502 25.1017C62.1502 21.5087 60.2647 19.6873 58.4359 17.9298C56.5645 16.1226 54.7924 14.4218 54.7924 10.9209C54.7924 7.41995 56.5645 5.71911 58.4359 3.91195C59.6055 2.78514 60.7963 1.62998 61.5051 0H61.2712C60.5907 1.52368 59.4566 2.61506 58.2799 3.74896C56.4582 5.5065 54.5656 7.32783 54.5656 10.9209C54.5656 14.5139 56.4511 16.3352 58.2799 18.0928C60.1513 19.8999 61.9234 21.6079 61.9234 25.1017C61.9234 28.5955 60.1513 30.3035 58.2799 32.1106C56.4582 33.8682 54.5656 35.6895 54.5656 39.2825C54.5656 42.8756 56.4511 44.6969 58.2799 46.4544C60.1513 48.2616 61.9234 49.9624 61.9234 53.4634C61.9234 56.9572 60.1513 58.6651 58.2799 60.4723C56.4582 62.2298 54.5656 64.0511 54.5656 67.6442C54.5656 71.2372 56.4511 73.0586 58.2799 74.8161C60.1513 76.6233 61.9234 78.3241 61.9234 81.825C61.9234 85.3188 60.1513 87.0268 58.2799 88.8339C56.4582 90.5915 54.5656 92.4128 54.5656 96.0059C54.5656 99.5989 56.4511 101.42 58.2799 103.178C60.1513 104.985 61.9234 106.686 61.9234 110.187C61.9234 113.681 60.1513 115.388 58.2799 117.196C56.7985 118.627 55.2745 120.094 54.757 122.518H54.9838C55.4871 120.208 56.926 118.818 58.4359 117.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M55.7501 117.359C57.5718 115.601 59.4644 113.78 59.4644 110.187C59.4644 106.594 57.5789 104.779 55.7501 103.015C53.8788 101.208 52.1067 99.5068 52.1067 96.0059C52.1067 92.512 53.8788 90.8041 55.7501 88.9969C57.5718 87.2394 59.4644 85.4181 59.4644 81.825C59.4644 78.232 57.5789 76.4106 55.7501 74.6531C53.8788 72.846 52.1067 71.1451 52.1067 67.6442C52.1067 64.1504 53.8788 62.4424 55.7501 60.6353C57.5718 58.8777 59.4644 57.0564 59.4644 53.4634C59.4644 49.8703 57.5789 48.049 55.7501 46.2914C53.8788 44.4843 52.1067 42.7764 52.1067 39.2825C52.1067 35.7887 53.8788 34.0808 55.7501 32.2736C57.5718 30.5161 59.4644 28.6947 59.4644 25.1017C59.4644 21.5087 57.5789 19.6873 55.7501 17.9298C53.8788 16.1226 52.1067 14.4218 52.1067 10.9209C52.1067 7.41995 53.8788 5.71911 55.7501 3.91195C56.9197 2.78514 58.1105 1.62998 58.8194 0H58.5855C57.905 1.52368 56.7708 2.61506 55.5942 3.74896C53.7725 5.5065 51.8799 7.32783 51.8799 10.9209C51.8799 14.5139 53.7654 16.3352 55.5942 18.0928C57.4655 19.8999 59.2376 21.6079 59.2376 25.1017C59.2376 28.5955 57.4655 30.3035 55.5942 32.1106C53.7725 33.8682 51.8799 35.6895 51.8799 39.2825C51.8799 42.8756 53.7654 44.6969 55.5942 46.4544C57.4655 48.2616 59.2376 49.9624 59.2376 53.4634C59.2376 56.9572 57.4655 58.6651 55.5942 60.4723C53.7725 62.2298 51.8799 64.0511 51.8799 67.6442C51.8799 71.2372 53.7654 73.0586 55.5942 74.8161C57.4655 76.6233 59.2376 78.3241 59.2376 81.825C59.2376 85.3188 57.4655 87.0268 55.5942 88.8339C53.7725 90.5915 51.8799 92.4128 51.8799 96.0059C51.8799 99.5989 53.7654 101.42 55.5942 103.178C57.4655 104.985 59.2376 106.686 59.2376 110.187C59.2376 113.681 57.4655 115.388 55.5942 117.196C54.1127 118.627 52.5887 120.094 52.0712 122.518H52.2981C52.8013 120.208 54.2403 118.818 55.7501 117.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M53.1494 117.195C54.1843 116.196 55.1909 115.225 55.8855 113.964C56.4243 112.943 56.7716 111.724 56.7716 110.186C56.7716 108.641 56.4242 107.43 55.8784 106.402C55.1909 105.148 54.1843 104.177 53.1494 103.178C52.1074 102.171 51.0513 101.151 50.3282 99.7971C49.7683 98.7837 49.4138 97.5789 49.4138 96.0127C49.4138 94.4536 49.7683 93.2488 50.3282 92.2354C51.0513 90.8747 52.1074 89.8471 53.1494 88.8408C54.1843 87.8415 55.1909 86.8706 55.8784 85.6092C56.4172 84.5886 56.7645 83.3697 56.7645 81.8319C56.7645 80.2869 56.4172 79.0751 55.8714 78.0475C55.1767 76.786 54.1772 75.8222 53.1423 74.8229C52.1003 73.8237 51.0442 72.7961 50.3211 71.4425C49.7612 70.4291 49.4067 69.2172 49.4067 67.6581C49.4067 66.0919 49.7612 64.8942 50.3211 63.8737C51.0371 62.513 52.1003 61.4925 53.1423 60.4862C54.1772 59.4869 55.1838 58.516 55.8714 57.2617C56.4101 56.2341 56.7645 55.0222 56.7645 53.4773C56.7645 51.9323 56.4101 50.7134 55.8714 49.6858C55.1838 48.4314 54.1772 47.4676 53.1494 46.4684C52.1074 45.4691 51.0513 44.4415 50.3353 43.0879C49.7753 42.0674 49.4209 40.8626 49.4209 39.2964C49.4209 37.7302 49.7753 36.5326 50.3353 35.5121C51.0513 34.1514 52.1145 33.1309 53.1565 32.1245C54.1914 31.1253 55.198 30.1544 55.8855 28.9C56.4243 27.8724 56.7787 26.6606 56.7787 25.1156C56.7787 23.5636 56.4242 22.3517 55.8784 21.3241C55.1838 20.0698 54.1843 19.1059 53.1565 18.1067C52.1216 17.1075 51.0583 16.0869 50.3424 14.7263C49.7824 13.7058 49.4209 12.501 49.4209 10.9348C49.4209 9.36859 49.7753 8.16382 50.3353 7.1504C51.0583 5.78972 52.1145 4.76212 53.1565 3.76287C54.1914 2.76362 55.198 1.79272 55.8855 0.538345C55.9777 0.36826 56.0557 0.198175 56.1336 0.013916H55.8997C55.2192 1.53759 54.0851 2.62897 52.9084 3.76287C51.0867 5.52042 49.1941 7.34174 49.1941 10.9348C49.1941 14.5278 51.0796 16.3492 52.9084 18.1067C54.7797 19.9139 56.5518 21.6218 56.5518 25.1156C56.5518 28.6094 54.7797 30.3174 52.9084 32.1245C51.0867 33.8821 49.1941 35.7034 49.1941 39.2964C49.1941 42.8895 51.0796 44.7108 52.9084 46.4684C54.7797 48.2755 56.5518 49.9764 56.5518 53.4773C56.5518 56.9711 54.7797 58.679 52.9084 60.4862C51.0867 62.2437 49.1941 64.0651 49.1941 67.6581C49.1941 71.2512 51.0796 73.0725 52.9084 74.83C54.7797 76.6372 56.5518 78.338 56.5518 81.8389C56.5518 85.3328 54.7797 87.0407 52.9084 88.8479C51.0867 90.6054 49.1941 92.4267 49.1941 96.0198C49.1941 99.6128 51.0796 101.434 52.9084 103.192C54.7797 104.999 56.5518 106.7 56.5518 110.201C56.5518 113.694 54.7797 115.402 52.9084 117.21C51.4269 118.641 49.9029 120.108 49.3855 122.532H49.6123C49.7683 121.809 50.0163 121.178 50.3353 120.604C51.0513 119.229 52.1074 118.202 53.1494 117.195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M50.3696 117.359C52.1913 115.601 54.0839 113.78 54.0839 110.187C54.0839 106.594 52.1984 104.779 50.3696 103.015C48.4982 101.208 46.7261 99.5068 46.7261 96.0059C46.7261 92.512 48.4982 90.8041 50.3696 88.9969C52.1913 87.2394 54.0839 85.4181 54.0839 81.825C54.0839 78.232 52.1984 76.4106 50.3696 74.6531C48.4982 72.846 46.7261 71.1451 46.7261 67.6442C46.7261 64.1504 48.4982 62.4424 50.3696 60.6353C52.1913 58.8777 54.0839 57.0564 54.0839 53.4634C54.0839 49.8703 52.1984 48.049 50.3696 46.2914C48.4982 44.4843 46.7261 42.7764 46.7261 39.2825C46.7261 35.7887 48.4982 34.0808 50.3696 32.2736C52.1913 30.5161 54.0839 28.6947 54.0839 25.1017C54.0839 21.5087 52.1984 19.6873 50.3696 17.9298C48.4982 16.1226 46.7261 14.4218 46.7261 10.9209C46.7261 7.41995 48.4982 5.71911 50.3696 3.91195C51.5392 2.78514 52.73 1.62998 53.4389 0H53.2049C52.645 1.24729 51.7802 2.2111 50.8374 3.13948C50.5751 3.4017 50.3129 3.65683 50.0506 3.91195C49.838 4.11747 49.6324 4.31591 49.4268 4.52142C47.8816 6.07345 46.5064 7.84517 46.5064 10.9209C46.5064 13.9541 47.8532 15.7187 49.363 17.2565C49.5899 17.4833 49.8238 17.703 50.0577 17.9298C50.3412 18.2062 50.6319 18.4826 50.9083 18.766C52.5032 20.3535 53.8571 22.0402 53.8571 25.1017C53.8571 28.2058 52.4607 29.8995 50.8445 31.5011C50.5822 31.7634 50.32 32.0185 50.0577 32.2736C49.845 32.4791 49.6395 32.6776 49.4268 32.8831C47.8886 34.4351 46.5064 36.2068 46.5064 39.2825C46.5064 42.3299 47.8674 44.1016 49.3914 45.6395C49.6111 45.8591 49.8309 46.0718 50.0577 46.2914C50.3341 46.5607 50.6106 46.8301 50.887 47.1064C52.4961 48.701 53.8642 50.3877 53.8642 53.4634C53.8642 56.5674 52.4677 58.2612 50.8516 59.8628C50.5893 60.125 50.327 60.3801 50.0648 60.6353C49.8521 60.8408 49.6395 61.0463 49.4339 61.2518C47.8957 62.8039 46.5135 64.5756 46.5135 67.6442C46.5135 70.7057 47.8816 72.4774 49.4126 74.0224C49.6253 74.235 49.845 74.4405 50.0648 74.6531C50.3341 74.9153 50.6035 75.1775 50.8729 75.4397C52.489 77.0414 53.8712 78.7281 53.8712 81.8179C53.8712 84.922 52.4748 86.6157 50.8516 88.2174C50.5893 88.4796 50.327 88.7347 50.0648 88.9898C49.8521 89.1954 49.6466 89.4009 49.4339 89.5993C47.8957 91.1513 46.5135 92.9231 46.5135 95.9988C46.5135 99.0461 47.8674 100.811 49.3985 102.356C49.6182 102.575 49.845 102.788 50.0648 103.008C50.3412 103.277 50.6177 103.546 50.8941 103.823C52.4961 105.41 53.8712 107.104 53.8712 110.18C53.8712 113.284 52.4819 114.977 50.8587 116.579C50.5964 116.841 50.3341 117.096 50.0719 117.352C49.8592 117.557 49.6466 117.755 49.441 117.961C48.236 119.173 47.1373 120.519 46.7049 122.511H46.9317C47.4208 120.208 48.8668 118.818 50.3696 117.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M46.8053 117.359C48.627 115.601 50.5196 113.78 50.5196 110.187C50.5196 106.594 48.6341 104.772 46.8053 103.015C44.934 101.208 43.1619 99.5068 43.1619 96.0059C43.1619 92.512 44.934 90.8041 46.8053 88.9969C48.627 87.2394 50.5196 85.4181 50.5196 81.825C50.5196 78.232 48.6341 76.4106 46.8053 74.6531C44.934 72.846 43.1619 71.138 43.1619 67.6442C43.1619 64.1504 44.934 62.4424 46.8053 60.6353C48.627 58.8777 50.5196 57.0564 50.5196 53.4634C50.5196 49.8703 48.6341 48.049 46.8053 46.2914C44.934 44.4843 43.1619 42.7764 43.1619 39.2825C43.1619 35.7816 44.934 34.0808 46.8053 32.2736C48.627 30.5161 50.5196 28.6947 50.5196 25.1017C50.5196 21.5087 48.6341 19.6873 46.8053 17.9298C44.934 16.1226 43.1619 14.4218 43.1619 10.9209C43.1619 7.41995 44.934 5.71911 46.8053 3.91195C47.9749 2.78514 49.1658 1.62998 49.8746 0H49.6407C48.9602 1.52368 47.826 2.61506 46.6494 3.74896C44.8277 5.5065 42.9351 7.32783 42.9351 10.9209C42.9351 14.5139 44.8206 16.3352 46.6494 18.0928C48.5207 19.8999 50.2928 21.6079 50.2928 25.1017C50.2928 28.5955 48.5207 30.3035 46.6494 32.1106C44.8277 33.8682 42.9351 35.6895 42.9351 39.2825C42.9351 42.8756 44.8206 44.6969 46.6494 46.4544C48.5207 48.2616 50.2928 49.9695 50.2928 53.4634C50.2928 56.9572 48.5207 58.6651 46.6494 60.4723C44.8277 62.2298 42.9351 64.0511 42.9351 67.6442C42.9351 71.2372 44.8206 73.0586 46.6494 74.8161C48.5207 76.6233 50.2928 78.3312 50.2928 81.825C50.2928 85.3188 48.5207 87.0268 46.6494 88.8339C44.8277 90.5915 42.9351 92.4128 42.9351 96.0059C42.9351 99.5989 44.8206 101.413 46.6494 103.178C48.5207 104.985 50.2928 106.686 50.2928 110.187C50.2928 113.681 48.5207 115.388 46.6494 117.196C45.1679 118.627 43.6439 120.094 43.1264 122.518H43.3533C43.8565 120.208 45.2955 118.818 46.8053 117.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M43.5511 117.359C45.3728 115.601 47.2654 113.78 47.2654 110.187C47.2654 106.594 45.3799 104.772 43.5511 103.015C41.6797 101.208 39.9076 99.5068 39.9076 96.0059C39.9076 92.512 41.6797 90.8041 43.5511 88.9969C45.3728 87.2394 47.2654 85.4181 47.2654 81.825C47.2654 78.232 45.3799 76.4106 43.5511 74.6531C41.6797 72.846 39.9076 71.138 39.9076 67.6442C39.9076 64.1504 41.6797 62.4424 43.5511 60.6353C45.3728 58.8777 47.2654 57.0564 47.2654 53.4634C47.2654 49.8703 45.3799 48.049 43.5511 46.2914C41.6797 44.4843 39.9076 42.7764 39.9076 39.2825C39.9076 35.7816 41.6797 34.0808 43.5511 32.2736C45.3728 30.5161 47.2654 28.6947 47.2654 25.1017C47.2654 21.5087 45.3799 19.6873 43.5511 17.9298C41.6797 16.1226 39.9076 14.4147 39.9076 10.9209C39.9076 7.41995 41.6797 5.71911 43.5511 3.91195C44.7207 2.78514 45.9115 1.62998 46.6204 0H46.3864C45.7059 1.52368 44.5718 2.61506 43.3951 3.74896C41.5734 5.5065 39.6808 7.32783 39.6808 10.9209C39.6808 14.5139 41.5663 16.3352 43.3951 18.0928C45.2665 19.8999 47.0386 21.6008 47.0386 25.1017C47.0386 28.6026 45.2665 30.3035 43.3951 32.1106C41.5734 33.8682 39.6808 35.6895 39.6808 39.2825C39.6808 42.8756 41.5663 44.6969 43.3951 46.4544C45.2665 48.2616 47.0386 49.9695 47.0386 53.4634C47.0386 56.9572 45.2665 58.6651 43.3951 60.4723C41.5734 62.2298 39.6808 64.0511 39.6808 67.6442C39.6808 71.2372 41.5663 73.0586 43.3951 74.8161C45.2665 76.6233 47.0386 78.3312 47.0386 81.825C47.0386 85.3188 45.2665 87.0268 43.3951 88.8339C41.5734 90.5915 39.6808 92.4128 39.6808 96.0059C39.6808 99.5989 41.5663 101.413 43.3951 103.178C45.2665 104.985 47.0386 106.686 47.0386 110.187C47.0386 113.681 45.2665 115.388 43.3951 117.196C41.9137 118.627 40.3897 120.094 39.8722 122.518H40.099C40.6023 120.208 42.0412 118.818 43.5511 117.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M40.2968 117.359C42.1186 115.601 44.0111 113.78 44.0111 110.187C44.0111 106.594 42.1256 104.772 40.2968 103.015C38.4255 101.208 36.6534 99.5068 36.6534 96.0059C36.6534 92.512 38.4255 90.8041 40.2968 88.9969C42.1186 87.2394 44.0111 85.4181 44.0111 81.825C44.0111 78.232 42.1256 76.4106 40.2968 74.6531C38.4255 72.846 36.6534 71.138 36.6534 67.6442C36.6534 64.1504 38.4255 62.4424 40.2968 60.6353C42.1186 58.8777 44.0111 57.0564 44.0111 53.4634C44.0111 49.8703 42.1256 48.049 40.2968 46.2914C38.4255 44.4843 36.6534 42.7764 36.6534 39.2825C36.6534 35.7816 38.4255 34.0808 40.2968 32.2736C42.1186 30.5161 44.0111 28.6947 44.0111 25.1017C44.0111 21.5087 42.1256 19.6873 40.2968 17.9298C38.4255 16.1226 36.6534 14.4147 36.6534 10.9209C36.6534 7.41995 38.4255 5.71911 40.2968 3.91195C41.4664 2.78514 42.6573 1.62998 43.3661 0H43.1322C42.4517 1.52368 41.3176 2.61506 40.1409 3.74896C38.3192 5.5065 36.4266 7.32783 36.4266 10.9209C36.4266 14.5139 38.3121 16.3352 40.1409 18.0928C42.0122 19.8999 43.7843 21.6008 43.7843 25.1017C43.7843 28.6026 42.0122 30.3035 40.1409 32.1106C38.3192 33.8682 36.4266 35.6895 36.4266 39.2825C36.4266 42.8756 38.3121 44.6969 40.1409 46.4544C42.0122 48.2616 43.7843 49.9695 43.7843 53.4634C43.7843 56.9572 42.0122 58.6651 40.1409 60.4723C38.3192 62.2298 36.4266 64.0511 36.4266 67.6442C36.4266 71.2372 38.3121 73.0586 40.1409 74.8161C42.0122 76.6233 43.7843 78.3312 43.7843 81.825C43.7843 85.3188 42.0122 87.0268 40.1409 88.8339C38.3192 90.5915 36.4266 92.4128 36.4266 96.0059C36.4266 99.5989 38.3121 101.413 40.1409 103.178C42.0122 104.985 43.7843 106.686 43.7843 110.187C43.7843 113.681 42.0122 115.388 40.1409 117.196C38.6594 118.627 37.1354 120.094 36.618 122.518H36.8448C37.3481 120.208 38.787 118.818 40.2968 117.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M37.0426 117.359C38.8643 115.601 40.7569 113.78 40.7569 110.187C40.7569 106.594 38.8714 104.772 37.0426 103.015C35.1713 101.208 33.3992 99.5068 33.3992 96.0059C33.3992 92.512 35.1713 90.8041 37.0426 88.9969C38.8643 87.2394 40.7569 85.4181 40.7569 81.825C40.7569 78.232 38.8714 76.4106 37.0426 74.6531C35.1713 72.846 33.3992 71.138 33.3992 67.6442C33.3992 64.1504 35.1713 62.4424 37.0426 60.6353C38.8643 58.8777 40.7569 57.0564 40.7569 53.4634C40.7569 49.8703 38.8714 48.049 37.0426 46.2914C35.1713 44.4843 33.3992 42.7764 33.3992 39.2825C33.3992 35.7816 35.1713 34.0808 37.0426 32.2736C38.8643 30.5161 40.7569 28.6947 40.7569 25.1017C40.7569 21.5087 38.8714 19.6873 37.0426 17.9298C35.1713 16.1226 33.3992 14.4147 33.3992 10.9209C33.3992 7.41995 35.1713 5.71911 37.0426 3.91195C38.2122 2.78514 39.403 1.62998 40.1119 0H39.8779C39.1975 1.52368 38.0633 2.61506 36.8866 3.74896C35.0649 5.5065 33.1723 7.32783 33.1723 10.9209C33.1723 14.5139 35.0578 16.3352 36.8866 18.0928C38.758 19.8999 40.5301 21.6008 40.5301 25.1017C40.5301 28.6026 38.758 30.3035 36.8866 32.1106C35.0649 33.8682 33.1723 35.6895 33.1723 39.2825C33.1723 42.8756 35.0578 44.6969 36.8866 46.4544C38.758 48.2616 40.5301 49.9695 40.5301 53.4634C40.5301 56.9572 38.758 58.6651 36.8866 60.4723C35.0649 62.2298 33.1723 64.0511 33.1723 67.6442C33.1723 71.2372 35.0578 73.0586 36.8866 74.8161C38.758 76.6233 40.5301 78.3312 40.5301 81.825C40.5301 85.3188 38.758 87.0268 36.8866 88.8339C35.0649 90.5915 33.1723 92.4128 33.1723 96.0059C33.1723 99.5989 35.0578 101.413 36.8866 103.178C38.758 104.985 40.5301 106.686 40.5301 110.187C40.5301 113.681 38.758 115.388 36.8866 117.196C35.4052 118.627 33.8812 120.094 33.3637 122.518H33.5905C34.0938 120.208 35.5328 118.818 37.0426 117.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M33.798 117.359C35.6197 115.601 37.5123 113.78 37.5123 110.187C37.5123 106.594 35.6268 104.772 33.798 103.015C31.9267 101.208 30.1546 99.5068 30.1546 96.0059C30.1546 92.512 31.9267 90.8041 33.798 88.9969C35.6197 87.2394 37.5123 85.4181 37.5123 81.825C37.5123 78.232 35.6268 76.4106 33.798 74.6531C31.9267 72.846 30.1546 71.1451 30.1546 67.6442C30.1546 64.1504 31.9267 62.4424 33.798 60.6353C35.6197 58.8777 37.5123 57.0564 37.5123 53.4634C37.5123 49.8703 35.6268 48.049 33.798 46.2914C31.9267 44.4843 30.1546 42.7764 30.1546 39.2825C30.1546 35.7816 31.9267 34.0808 33.798 32.2736C35.6197 30.5161 37.5123 28.6947 37.5123 25.1017C37.5123 21.5087 35.6268 19.6873 33.798 17.9298C31.9267 16.1226 30.1546 14.4147 30.1546 10.9209C30.1546 7.41995 31.9267 5.71911 33.798 3.91195C34.9676 2.78514 36.1585 1.62998 36.8673 0H36.6334C35.9529 1.52368 34.8188 2.61506 33.6421 3.74896C31.8133 5.5065 29.9278 7.32783 29.9278 10.9209C29.9278 14.5139 31.8133 16.3352 33.6421 18.0928C35.5134 19.8999 37.2855 21.6008 37.2855 25.1017C37.2855 28.6026 35.5134 30.3035 33.6421 32.1106C31.8133 33.8682 29.9278 35.6895 29.9278 39.2825C29.9278 42.8756 31.8133 44.6969 33.6421 46.4544C35.5134 48.2616 37.2855 49.9624 37.2855 53.4634C37.2855 56.9572 35.5134 58.6651 33.6421 60.4723C31.8133 62.2298 29.9278 64.0511 29.9278 67.6442C29.9278 71.2372 31.8133 73.0586 33.6421 74.8161C35.5134 76.6233 37.2855 78.3241 37.2855 81.825C37.2855 85.3188 35.5134 87.0268 33.6421 88.8339C31.8204 90.5915 29.9278 92.4128 29.9278 96.0059C29.9278 99.5989 31.8133 101.42 33.6421 103.178C35.5134 104.985 37.2855 106.686 37.2855 110.187C37.2855 113.681 35.5134 115.388 33.6421 117.196C32.1606 118.627 30.6366 120.094 30.1192 122.518H30.346C30.8422 120.208 32.2882 118.818 33.798 117.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M30.5419 117.359C32.3636 115.601 34.2562 113.78 34.2562 110.187C34.2562 106.594 32.3707 104.772 30.5419 103.015C28.6705 101.208 26.8984 99.5068 26.8984 96.0059C26.8984 92.512 28.6705 90.8041 30.5419 88.9969C32.3636 87.2394 34.2562 85.4181 34.2562 81.825C34.2562 78.232 32.3707 76.4106 30.5419 74.6531C28.6705 72.846 26.8984 71.1451 26.8984 67.6442C26.8984 64.1504 28.6705 62.4424 30.5419 60.6353C32.3636 58.8777 34.2562 57.0564 34.2562 53.4634C34.2562 49.8703 32.3707 48.049 30.5419 46.2914C28.6705 44.4843 26.8984 42.7764 26.8984 39.2825C26.8984 35.7887 28.6705 34.0808 30.5419 32.2736C32.3636 30.5161 34.2562 28.6947 34.2562 25.1017C34.2562 21.5087 32.3707 19.6873 30.5419 17.9298C28.6705 16.1226 26.8984 14.4147 26.8984 10.9209C26.8984 7.41995 28.6705 5.71911 30.5419 3.91195C31.7114 2.78514 32.9023 1.62998 33.6111 0H33.3772C32.6967 1.52368 31.5626 2.61506 30.3859 3.74896C28.5642 5.5065 26.6716 7.32783 26.6716 10.9209C26.6716 14.5139 28.5571 16.3352 30.3859 18.0928C32.2573 19.8999 34.0293 21.6008 34.0293 25.1017C34.0293 28.5955 32.2573 30.3035 30.3859 32.1106C28.5642 33.8682 26.6716 35.6895 26.6716 39.2825C26.6716 42.8756 28.5571 44.6969 30.3859 46.4544C32.2573 48.2616 34.0293 49.9624 34.0293 53.4634C34.0293 56.9572 32.2573 58.6651 30.3859 60.4723C28.5642 62.2298 26.6716 64.0511 26.6716 67.6442C26.6716 71.2372 28.5571 73.0586 30.3859 74.8161C32.2573 76.6233 34.0293 78.3241 34.0293 81.825C34.0293 85.3188 32.2573 87.0268 30.3859 88.8339C28.5642 90.5915 26.6716 92.4128 26.6716 96.0059C26.6716 99.5989 28.5571 101.42 30.3859 103.178C32.2573 104.985 34.0293 106.686 34.0293 110.187C34.0293 113.681 32.2573 115.388 30.3859 117.196C28.9044 118.627 27.3804 120.094 26.863 122.518H27.0898C27.5931 120.208 29.032 118.818 30.5419 117.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M27.2896 117.359C29.1113 115.601 31.0039 113.78 31.0039 110.187C31.0039 106.594 29.1184 104.772 27.2896 103.015C25.4182 101.208 23.6461 99.5068 23.6461 96.0059C23.6461 92.512 25.4182 90.8041 27.2896 88.9969C29.1113 87.2394 31.0039 85.4181 31.0039 81.825C31.0039 78.232 29.1184 76.4106 27.2896 74.6531C25.4182 72.846 23.6461 71.1451 23.6461 67.6442C23.6461 64.1504 25.4182 62.4424 27.2896 60.6353C29.1113 58.8777 31.0039 57.0564 31.0039 53.4634C31.0039 49.8703 29.1184 48.049 27.2896 46.2914C25.4182 44.4843 23.6461 42.7764 23.6461 39.2825C23.6461 35.7887 25.4182 34.0808 27.2896 32.2736C29.1113 30.5161 31.0039 28.6947 31.0039 25.1017C31.0039 21.5087 29.1184 19.6873 27.2896 17.9298C25.4182 16.1226 23.6461 14.4147 23.6461 10.9209C23.6461 7.41995 25.4182 5.71911 27.2896 3.91195C28.4591 2.78514 29.65 1.62998 30.3588 0H30.1249C29.4444 1.52368 28.3103 2.61506 27.1336 3.74896C25.3119 5.5065 23.4193 7.32783 23.4193 10.9209C23.4193 14.5139 25.3048 16.3352 27.1336 18.0928C29.0049 19.8999 30.777 21.6008 30.777 25.1017C30.777 28.5955 29.0049 30.3035 27.1336 32.1106C25.3119 33.8682 23.4193 35.6895 23.4193 39.2825C23.4193 42.8756 25.3048 44.6969 27.1336 46.4544C29.0049 48.2616 30.777 49.9624 30.777 53.4634C30.777 56.9572 29.0049 58.6651 27.1336 60.4723C25.3119 62.2298 23.4193 64.0511 23.4193 67.6442C23.4193 71.2372 25.3048 73.0586 27.1336 74.8161C29.0049 76.6233 30.777 78.3241 30.777 81.825C30.777 85.3188 29.0049 87.0268 27.1336 88.8339C25.3119 90.5915 23.4193 92.4128 23.4193 96.0059C23.4193 99.5989 25.3048 101.42 27.1336 103.178C29.0049 104.985 30.777 106.686 30.777 110.187C30.777 113.681 29.0049 115.388 27.1336 117.196C25.6521 118.627 24.1281 120.094 23.6107 122.518H23.8375C24.3408 120.208 25.7797 118.818 27.2896 117.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M24.0353 117.359C25.857 115.601 27.7496 113.78 27.7496 110.187C27.7496 106.594 25.8641 104.772 24.0353 103.015C22.164 101.208 20.3919 99.5068 20.3919 96.0059C20.3919 92.512 22.164 90.8041 24.0353 88.9969C25.857 87.2394 27.7496 85.4181 27.7496 81.825C27.7496 78.232 25.8641 76.4106 24.0353 74.6531C22.164 72.846 20.3919 71.1451 20.3919 67.6442C20.3919 64.1504 22.164 62.4424 24.0353 60.6353C25.857 58.8777 27.7496 57.0564 27.7496 53.4634C27.7496 49.8703 25.8641 48.049 24.0353 46.2914C22.164 44.4843 20.3919 42.7764 20.3919 39.2825C20.3919 35.7887 22.164 34.0808 24.0353 32.2736C25.857 30.5161 27.7496 28.6947 27.7496 25.1017C27.7496 21.5087 25.8641 19.6873 24.0353 17.9298C22.164 16.1226 20.3919 14.4147 20.3919 10.9209C20.3919 7.41995 22.164 5.71911 24.0353 3.91195C25.2049 2.78514 26.3957 1.62998 27.1046 0H26.8707C26.1902 1.52368 25.056 2.61506 23.8794 3.74896C22.0577 5.5065 20.1651 7.32783 20.1651 10.9209C20.1651 14.5139 22.0506 16.3352 23.8794 18.0928C25.7507 19.8999 27.5228 21.6008 27.5228 25.1017C27.5228 28.5955 25.7507 30.3035 23.8794 32.1106C22.0577 33.8682 20.1651 35.6895 20.1651 39.2825C20.1651 42.8756 22.0506 44.6969 23.8794 46.4544C25.7507 48.2616 27.5228 49.9624 27.5228 53.4634C27.5228 56.9572 25.7507 58.6651 23.8794 60.4723C22.0577 62.2298 20.1651 64.0511 20.1651 67.6442C20.1651 71.2372 22.0506 73.0586 23.8794 74.8161C25.7507 76.6233 27.5228 78.3241 27.5228 81.825C27.5228 85.3188 25.7507 87.0268 23.8794 88.8339C22.0577 90.5915 20.1651 92.4128 20.1651 96.0059C20.1651 99.5989 22.0506 101.42 23.8794 103.178C25.7507 104.985 27.5228 106.686 27.5228 110.187C27.5228 113.681 25.7507 115.388 23.8794 117.196C22.3979 118.627 20.8739 120.094 20.3564 122.518H20.5833C21.0865 120.208 22.5255 118.818 24.0353 117.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M20.783 117.359C22.6047 115.601 24.4973 113.78 24.4973 110.187C24.4973 106.594 22.6118 104.772 20.783 103.015C18.9117 101.208 17.1396 99.5068 17.1396 96.0059C17.1396 92.512 18.9117 90.8041 20.783 88.9969C22.6047 87.2394 24.4973 85.4181 24.4973 81.825C24.4973 78.232 22.6118 76.4106 20.783 74.6531C18.9117 72.846 17.1396 71.1451 17.1396 67.6442C17.1396 64.1504 18.9117 62.4424 20.783 60.6353C22.6047 58.8777 24.4973 57.0564 24.4973 53.4634C24.4973 49.8703 22.6118 48.049 20.783 46.2914C18.9117 44.4843 17.1396 42.7764 17.1396 39.2825C17.1396 35.7887 18.9117 34.0808 20.783 32.2736C22.6047 30.5161 24.4973 28.6947 24.4973 25.1017C24.4973 21.5087 22.6118 19.6873 20.783 17.9298C18.9117 16.1226 17.1396 14.4147 17.1396 10.9209C17.1396 7.41995 18.9117 5.71911 20.783 3.91195C21.9526 2.78514 23.1434 1.62998 23.8523 0H23.6184C22.9379 1.52368 21.8037 2.61506 20.6271 3.74896C18.8054 5.5065 16.9128 7.32783 16.9128 10.9209C16.9128 14.5139 18.7983 16.3352 20.6271 18.0928C22.4984 19.8999 24.2705 21.6008 24.2705 25.1017C24.2705 28.5955 22.4984 30.3035 20.6271 32.1106C18.8054 33.8682 16.9128 35.6895 16.9128 39.2825C16.9128 42.8756 18.7983 44.6969 20.6271 46.4544C22.4984 48.2616 24.2705 49.9624 24.2705 53.4634C24.2705 56.9572 22.4984 58.6651 20.6271 60.4723C18.8054 62.2298 16.9128 64.0511 16.9128 67.6442C16.9128 71.2372 18.7983 73.0586 20.6271 74.8161C22.4984 76.6233 24.2705 78.3241 24.2705 81.825C24.2705 85.3188 22.4984 87.0268 20.6271 88.8339C18.8054 90.5915 16.9128 92.4128 16.9128 96.0059C16.9128 99.5989 18.7983 101.42 20.6271 103.178C22.4984 104.985 24.2705 106.686 24.2705 110.187C24.2705 113.681 22.4984 115.388 20.6271 117.196C19.1456 118.627 17.6216 120.094 17.1041 122.518H17.331C17.8342 120.208 19.2732 118.818 20.783 117.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M17.5288 117.359C19.3505 115.601 21.2431 113.78 21.2431 110.187C21.2431 106.594 19.3576 104.772 17.5288 103.015C15.6574 101.208 13.8853 99.5068 13.8853 96.0059C13.8853 92.512 15.6574 90.8041 17.5288 88.9969C19.3505 87.2394 21.2431 85.4181 21.2431 81.825C21.2431 78.232 19.3576 76.4106 17.5288 74.6531C15.6574 72.846 13.8853 71.1451 13.8853 67.6442C13.8853 64.1504 15.6574 62.4424 17.5288 60.6353C19.3505 58.8777 21.2431 57.0564 21.2431 53.4634C21.2431 49.8703 19.3576 48.049 17.5288 46.2914C15.6574 44.4843 13.8853 42.7764 13.8853 39.2825C13.8853 35.7887 15.6574 34.0808 17.5288 32.2736C19.3505 30.5161 21.2431 28.6947 21.2431 25.1017C21.2431 21.5087 19.3576 19.6873 17.5288 17.9298C15.6574 16.1226 13.8853 14.4218 13.8853 10.9209C13.8853 7.41995 15.6574 5.71911 17.5288 3.91195C18.6984 2.78514 19.8892 1.62998 20.598 0H20.3641C19.6836 1.52368 18.5495 2.61506 17.3728 3.74896C15.5511 5.5065 13.6585 7.32783 13.6585 10.9209C13.6585 14.5139 15.544 16.3352 17.3728 18.0928C19.2442 19.8999 21.0163 21.6079 21.0163 25.1017C21.0163 28.5955 19.2442 30.3035 17.3728 32.1106C15.5511 33.8682 13.6585 35.6895 13.6585 39.2825C13.6585 42.8756 15.544 44.6969 17.3728 46.4544C19.2442 48.2616 21.0163 49.9624 21.0163 53.4634C21.0163 56.9572 19.2442 58.6651 17.3728 60.4723C15.5511 62.2298 13.6585 64.0511 13.6585 67.6442C13.6585 71.2372 15.544 73.0586 17.3728 74.8161C19.2442 76.6233 21.0163 78.3241 21.0163 81.825C21.0163 85.3188 19.2442 87.0268 17.3728 88.8339C15.5511 90.5915 13.6585 92.4128 13.6585 96.0059C13.6585 99.5989 15.544 101.42 17.3728 103.178C19.2442 104.985 21.0163 106.686 21.0163 110.187C21.0163 113.681 19.2442 115.388 17.3728 117.196C15.8914 118.627 14.3673 120.094 13.8499 122.518H14.0767C14.58 120.208 16.0189 118.818 17.5288 117.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M14.2823 117.359C16.104 115.601 17.9966 113.78 17.9966 110.187C17.9966 106.594 16.1111 104.772 14.2823 103.015C12.4109 101.208 10.6388 99.5068 10.6388 96.0059C10.6388 92.512 12.4109 90.8041 14.2823 88.9969C16.104 87.2394 17.9966 85.4181 17.9966 81.825C17.9966 78.232 16.1111 76.4106 14.2823 74.6531C12.4109 72.846 10.6388 71.1451 10.6388 67.6442C10.6388 64.1504 12.4109 62.4424 14.2823 60.6353C16.104 58.8777 17.9966 57.0564 17.9966 53.4634C17.9966 49.8703 16.1111 48.049 14.2823 46.2914C12.4109 44.4843 10.6388 42.7764 10.6388 39.2825C10.6388 35.7887 12.4109 34.0808 14.2823 32.2736C16.104 30.5161 17.9966 28.6947 17.9966 25.1017C17.9966 21.5087 16.1111 19.6873 14.2823 17.9298C12.4109 16.1226 10.6388 14.4218 10.6388 10.9209C10.6388 7.41995 12.4109 5.71911 14.2823 3.91195C15.4518 2.78514 16.6427 1.62998 17.3515 0H17.1176C16.4371 1.52368 15.303 2.61506 14.1263 3.74896C12.3046 5.5065 10.412 7.32783 10.412 10.9209C10.412 14.5139 12.2975 16.3352 14.1263 18.0928C15.9977 19.8999 17.7698 21.6079 17.7698 25.1017C17.7698 28.5955 15.9977 30.3035 14.1263 32.1106C12.3046 33.8682 10.412 35.6895 10.412 39.2825C10.412 42.8756 12.2975 44.6969 14.1263 46.4544C15.9977 48.2616 17.7698 49.9624 17.7698 53.4634C17.7698 56.9572 15.9977 58.6651 14.1263 60.4723C12.3046 62.2298 10.412 64.0511 10.412 67.6442C10.412 71.2372 12.2975 73.0586 14.1263 74.8161C15.9977 76.6233 17.7698 78.3241 17.7698 81.825C17.7698 85.3188 15.9977 87.0268 14.1263 88.8339C12.3046 90.5915 10.412 92.4128 10.412 96.0059C10.412 99.5989 12.2975 101.42 14.1263 103.178C15.9977 104.985 17.7698 106.686 17.7698 110.187C17.7698 113.681 15.9977 115.388 14.1263 117.196C12.6448 118.627 11.1208 120.094 10.6034 122.518H10.8302C11.3335 120.208 12.7724 118.818 14.2823 117.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M11.028 117.359C12.8497 115.601 14.7423 113.78 14.7423 110.187C14.7423 106.594 12.8568 104.772 11.028 103.015C9.15669 101.208 7.38459 99.5068 7.38459 96.0058C7.38459 92.512 9.15669 90.8041 11.028 88.9969C12.8497 87.2394 14.7423 85.4181 14.7423 81.825C14.7423 78.232 12.8568 76.4106 11.028 74.6531C9.15669 72.8459 7.38459 71.1451 7.38459 67.6442C7.38459 64.1504 9.15669 62.4424 11.028 60.6353C12.8497 58.8777 14.7423 57.0564 14.7423 53.4634C14.7423 49.8703 12.8568 48.049 11.028 46.2914C9.15669 44.4843 7.38459 42.7764 7.38459 39.2825C7.38459 35.7887 9.15669 34.0808 11.028 32.2736C12.8497 30.5161 14.7423 28.6947 14.7423 25.1017C14.7423 21.5087 12.8568 19.6873 11.028 17.9298C9.15669 16.1226 7.38459 14.4218 7.38459 10.9209C7.38459 7.41995 9.15669 5.7191 11.028 3.91195C12.1976 2.78514 13.3885 1.62998 14.0973 0H13.8634C13.1829 1.52368 12.0487 2.61506 10.8721 3.74895C9.05036 5.5065 7.15776 7.32782 7.15776 10.9209C7.15776 14.5139 9.04327 16.3352 10.8721 18.0928C12.7434 19.8999 14.5155 21.6079 14.5155 25.1017C14.5155 28.5955 12.7434 30.3035 10.8721 32.1106C9.05036 33.8682 7.15776 35.6895 7.15776 39.2825C7.15776 42.8756 9.04327 44.6969 10.8721 46.4544C12.7434 48.2616 14.5155 49.9624 14.5155 53.4634C14.5155 56.9572 12.7434 58.6651 10.8721 60.4723C9.05036 62.2298 7.15776 64.0511 7.15776 67.6442C7.15776 71.2372 9.04327 73.0586 10.8721 74.8161C12.7434 76.6233 14.5155 78.3241 14.5155 81.825C14.5155 85.3188 12.7434 87.0268 10.8721 88.8339C9.05036 90.5915 7.15776 92.4128 7.15776 96.0058C7.15776 99.5989 9.04327 101.42 10.8721 103.178C12.7434 104.985 14.5155 106.686 14.5155 110.187C14.5155 113.681 12.7434 115.388 10.8721 117.196C9.3906 118.627 7.83825 119.882 7.32079 122.305H7.54762C8.0509 119.995 9.51819 118.818 11.028 117.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M4.52254 121.157C5.22429 119.499 6.43641 118.337 7.62017 117.196C9.4915 115.388 11.2636 113.688 11.2636 110.187C11.2636 106.693 9.4915 104.985 7.62017 103.178C5.79845 101.42 3.90585 99.5989 3.90585 96.0059C3.90585 92.4128 5.79136 90.5986 7.62017 88.8339C9.4915 87.0268 11.2636 85.3188 11.2636 81.825C11.2636 78.3241 9.4915 76.6233 7.62017 74.8161C5.79845 73.0586 3.90585 71.2372 3.90585 67.6442C3.90585 64.0511 5.79136 62.2298 7.62017 60.4723C9.4915 58.6651 11.2636 56.9572 11.2636 53.4634C11.2636 49.9624 9.4915 48.2616 7.62017 46.4544C5.79845 44.6969 3.90585 42.8756 3.90585 39.2825C3.90585 35.6895 5.79136 33.8682 7.62017 32.1106C9.4915 30.3035 11.2636 28.6026 11.2636 25.1017C11.2636 21.6008 9.4915 19.8999 7.62017 18.0928C5.79845 16.3352 3.90585 14.5139 3.90585 10.9209C3.90585 7.32783 5.79136 5.5065 7.62017 3.74896C8.79684 2.61506 9.93098 1.52368 10.6115 0H10.8454C10.1365 1.62998 8.9457 2.78514 7.77611 3.91195C5.90478 5.71911 4.13268 7.42704 4.13268 10.9209C4.13268 14.4218 5.90478 16.1226 7.77611 17.9298C9.59783 19.7086 11.4833 21.5228 11.4833 25.1159C11.4833 28.7089 9.59783 30.5302 7.76903 32.2878C5.89769 34.0949 4.12559 35.8029 4.12559 39.2967C4.12559 42.7905 5.89769 44.4985 7.76903 46.3056C9.59783 48.0632 11.4833 49.8845 11.4833 53.4775C11.4833 57.0706 9.59783 58.8919 7.76903 60.6494C5.89769 62.4566 4.12559 64.1645 4.12559 67.6584C4.12559 71.1522 5.89769 72.8601 7.76903 74.6673C9.59074 76.4248 11.4833 78.2461 11.4833 81.8392C11.4833 85.4322 9.59783 87.2536 7.76903 89.0111C5.89769 90.8183 4.12559 92.5262 4.12559 96.02C4.12559 99.5139 5.89769 101.222 7.76903 103.029C9.59074 104.786 11.4833 106.608 11.4833 110.201C11.4833 113.794 9.59783 115.615 7.76903 117.373C6.54982 118.549 5.37315 119.683 4.69975 121.299L4.52254 121.157Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M191.4 121.851C191.485 121.815 191.571 121.787 191.648 121.752C192.208 120.894 192.91 120.023 193.81 119.13C194.732 118.208 195.625 117.492 196.504 116.918C196.539 116.84 196.575 116.755 196.61 116.67C195.668 117.259 194.696 118.024 193.704 119.016C192.733 119.98 191.989 120.93 191.4 121.851Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M189.346 122.404C189.409 122.397 189.466 122.39 189.53 122.376C190.182 120.966 191.153 119.506 192.67 117.982C194.222 116.43 195.711 115.452 197.15 114.8C197.157 114.736 197.164 114.68 197.178 114.616C195.697 115.268 194.166 116.267 192.564 117.869C190.99 119.442 189.998 120.945 189.346 122.404Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M187.707 122.517H187.87C188.487 120.703 189.536 118.825 191.528 116.834C193.555 114.807 195.462 113.758 197.305 113.149V112.986C195.433 113.602 193.484 114.665 191.421 116.727C189.387 118.761 188.324 120.675 187.707 122.517Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M186.227 122.518H186.39C186.935 120.349 187.97 118.103 190.38 115.693C192.826 113.248 195.108 112.221 197.299 111.675V111.519C195.073 112.065 192.755 113.099 190.267 115.587C187.821 118.039 186.779 120.321 186.227 122.518Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M184.836 122.518H184.992C185.467 120.002 186.402 117.387 189.238 114.545C192.109 111.675 194.76 110.754 197.304 110.279V110.123C194.731 110.598 192.045 111.519 189.131 114.432C186.247 117.323 185.311 119.974 184.836 122.518Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M183.496 122.517H183.652C184.077 119.654 184.822 116.671 188.089 113.404C191.393 110.094 194.398 109.378 197.297 108.953V108.797C194.37 109.222 191.329 109.945 187.983 113.297C184.673 116.614 183.928 119.619 183.496 122.517Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M186.842 112.157C183.092 115.906 182.632 119.272 182.199 122.525H182.355C182.788 119.307 183.241 115.976 186.948 112.27C190.67 108.549 194.016 108.103 197.248 107.663C197.269 107.663 197.283 107.656 197.298 107.656V107.5C197.276 107.508 197.248 107.508 197.227 107.508C193.973 107.947 190.599 108.393 186.842 112.157Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M185.7 111.008C181.937 114.771 181.49 118.137 181.05 121.39C181.001 121.766 180.951 122.142 180.895 122.517H181.05C181.107 122.149 181.157 121.78 181.206 121.412C181.639 118.18 182.085 114.835 185.807 111.114C189.528 107.394 192.874 106.947 196.106 106.515C196.503 106.458 196.9 106.409 197.304 106.352V106.196C196.9 106.26 196.489 106.309 196.092 106.366C192.824 106.798 189.457 107.252 185.7 111.008Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M184.553 109.868C180.789 113.631 180.342 116.997 179.91 120.25C179.811 121.001 179.704 121.752 179.562 122.518H179.718C179.86 121.759 179.959 121.008 180.059 120.271C180.491 117.04 180.938 113.695 184.659 109.974C188.38 106.253 191.726 105.807 194.958 105.375C195.731 105.268 196.511 105.169 197.298 105.02V104.864C196.504 105.013 195.717 105.119 194.937 105.226C191.684 105.658 188.317 106.112 184.553 109.868Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M183.412 108.728C179.648 112.491 179.202 115.857 178.769 119.11C178.62 120.23 178.464 121.364 178.174 122.519H178.337C178.62 121.371 178.776 120.244 178.925 119.131C179.358 115.9 179.804 112.555 183.526 108.834C187.247 105.113 190.593 104.667 193.825 104.235C194.966 104.079 196.129 103.923 197.305 103.625V103.462C196.115 103.767 194.952 103.923 193.804 104.079C190.543 104.518 187.176 104.965 183.412 108.728Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M182.271 107.58C178.507 111.336 178.06 114.709 177.628 117.962C177.429 119.45 177.224 120.96 176.699 122.519H176.862C177.373 120.967 177.578 119.465 177.777 117.983C178.209 114.752 178.656 111.407 182.377 107.686C186.098 103.966 189.444 103.519 192.676 103.087C194.186 102.888 195.717 102.676 197.305 102.137V101.974C195.71 102.52 194.172 102.725 192.655 102.931C189.395 103.37 186.028 103.824 182.271 107.58Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M181.12 106.437C177.363 110.193 176.91 113.566 176.477 116.819C176.229 118.662 175.974 120.547 175.109 122.517H175.279C176.13 120.554 176.378 118.683 176.626 116.84C177.059 113.609 177.505 110.264 181.227 106.543C184.948 102.823 188.294 102.376 191.526 101.944C193.397 101.696 195.304 101.434 197.296 100.555V100.385C195.297 101.285 193.383 101.54 191.505 101.795C188.251 102.227 184.884 102.681 181.12 106.437Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M179.982 105.298C176.225 109.054 175.772 112.427 175.339 115.68C175.042 117.884 174.744 120.13 173.404 122.519H173.582C174.9 120.138 175.198 117.891 175.495 115.701C175.928 112.47 176.374 109.125 180.096 105.404C183.817 101.683 187.163 101.237 190.395 100.805C192.621 100.507 194.889 100.202 197.306 98.8415V98.6643C194.882 100.046 192.6 100.351 190.374 100.649C187.113 101.088 183.739 101.534 179.982 105.298Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M178.841 104.149C175.077 107.905 174.631 111.279 174.191 114.531C173.851 117.083 173.497 119.698 171.533 122.518H171.717C173.646 119.705 174 117.097 174.34 114.553C174.773 111.321 175.219 107.976 178.941 104.255C182.662 100.535 186.008 100.088 189.24 99.6561C191.813 99.3088 194.45 98.9545 197.3 96.9701V96.7859C194.45 98.7986 191.799 99.16 189.226 99.5072C185.965 99.9395 182.598 100.393 178.841 104.149Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M177.691 103.007C173.927 106.763 173.481 110.136 173.041 113.389C172.651 116.28 172.247 119.257 169.504 122.517H169.709C172.403 119.264 172.807 116.295 173.197 113.41C173.629 110.179 174.076 106.834 177.797 103.113C181.519 99.3924 184.864 98.9459 188.097 98.5136C191.01 98.1239 194.008 97.7128 197.297 94.9489V94.7434C194.001 97.5569 190.996 97.9679 188.075 98.3577C184.822 98.7971 181.455 99.2507 177.691 103.007Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M192.28 87.6648C188.558 91.3854 185.213 91.8318 181.98 92.2641C178.72 92.6964 175.353 93.15 171.596 96.9131C167.839 100.669 167.385 104.043 166.953 107.295C166.52 110.527 166.074 113.865 162.353 117.593C158.631 121.313 155.285 121.76 152.053 122.192C151.337 122.291 150.607 122.39 149.877 122.518H150.82C151.238 122.454 151.663 122.398 152.081 122.341C155.342 121.909 158.709 121.455 162.466 117.692C166.223 113.936 166.676 110.562 167.116 107.31C167.548 104.078 167.995 100.74 171.716 97.0123C175.438 93.2917 178.783 92.8453 182.016 92.413C185.276 91.9807 188.643 91.5271 192.4 87.764C196.164 84.0079 196.611 80.6346 197.05 77.3817C197.135 76.7793 197.213 76.1698 197.32 75.5604V74.7241C197.135 75.6171 197.022 76.4958 196.901 77.3675C196.448 80.5991 196.001 83.9371 192.28 87.6648Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M191.138 86.517C187.416 90.2376 184.071 90.6841 180.838 91.1164C177.578 91.5557 174.211 92.0022 170.454 95.7653C166.69 99.5214 166.243 102.895 165.804 106.148C165.372 109.379 164.925 112.717 161.204 116.445C157.482 120.165 154.136 120.612 150.904 121.044C148.983 121.299 147.02 121.569 144.957 122.518H145.326C147.261 121.689 149.104 121.441 150.918 121.2C154.179 120.768 157.546 120.314 161.303 116.551C165.06 112.795 165.513 109.422 165.953 106.169C166.385 102.937 166.832 99.5993 170.553 95.8716C174.275 92.151 177.62 91.7046 180.853 91.2723C184.113 90.8329 187.48 90.3864 191.237 86.6233C195.001 82.8672 195.448 79.4939 195.887 76.241C196.142 74.363 196.397 72.4566 197.298 70.451V70.0825C196.277 72.2086 196.001 74.2354 195.738 76.2197C195.306 79.4584 194.859 82.7964 191.138 86.517Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M189.991 85.3748C186.269 89.0954 182.924 89.5419 179.691 89.9742C176.431 90.4136 173.064 90.86 169.307 94.6232C165.543 98.3792 165.096 101.753 164.657 105.005C164.225 108.237 163.778 111.575 160.057 115.303C156.335 119.023 152.989 119.47 149.757 119.902C147.22 120.242 144.611 120.597 141.797 122.517H142.073C144.781 120.724 147.312 120.384 149.778 120.051C153.039 119.619 156.406 119.165 160.163 115.409C163.92 111.653 164.373 108.28 164.806 105.027C165.238 101.795 165.685 98.4572 169.406 94.7295C173.128 91.0089 176.473 90.5624 179.706 90.1301C182.966 89.6907 186.333 89.2442 190.09 85.4811C193.847 81.7251 194.301 78.3517 194.74 75.0988C195.073 72.5972 195.428 70.0246 197.292 67.2678V66.9915C195.293 69.8475 194.931 72.498 194.584 75.0776C194.166 78.3092 193.719 81.6542 189.991 85.3748Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M188.848 84.2338C185.126 87.9545 181.78 88.4009 178.548 88.8332C175.287 89.2726 171.92 89.7191 168.164 93.4822C164.4 97.2383 163.953 100.612 163.521 103.864C163.088 107.096 162.642 110.434 158.92 114.162C155.199 117.882 151.853 118.329 148.621 118.761C145.644 119.158 142.567 119.576 139.193 122.517H139.427C142.723 119.711 145.729 119.3 148.642 118.91C151.903 118.478 155.27 118.024 159.027 114.268C162.784 110.512 163.237 107.139 163.67 103.886C164.102 100.654 164.549 97.3162 168.27 93.5885C171.991 89.8679 175.337 89.4214 178.569 88.9891C181.83 88.5568 185.197 88.1033 188.954 84.3401C192.711 80.5841 193.164 77.2108 193.604 73.9579C194.001 71.0097 194.412 67.9766 197.297 64.6457V64.4119C194.27 67.8277 193.852 70.9318 193.448 73.9437C193.015 77.1682 192.569 80.5062 188.848 84.2338Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M192.307 72.7971C191.875 76.0288 191.428 79.3667 187.707 83.0944C183.985 86.815 180.64 87.2614 177.407 87.6937C174.147 88.1331 170.78 88.5796 167.023 92.3427C163.259 96.1059 162.812 99.4721 162.373 102.725C161.941 105.957 161.494 109.295 157.773 113.022C154.051 116.743 150.705 117.189 147.473 117.622C144.212 118.054 140.846 118.507 137.089 122.264C137.004 122.349 136.926 122.434 136.848 122.519H137.06C137.11 122.469 137.152 122.419 137.202 122.37C140.923 118.649 144.269 118.203 147.502 117.77C150.762 117.338 154.129 116.885 157.886 113.121C161.643 109.365 162.096 105.992 162.529 102.739C162.961 99.5076 163.408 96.1626 167.129 92.4419C170.851 88.7213 174.196 88.2749 177.429 87.8426C180.689 87.4032 184.056 86.9567 187.813 83.1936C191.577 79.4305 192.024 76.0642 192.463 72.8113C192.896 69.5797 193.342 66.2418 197.071 62.5141C197.149 62.4361 197.227 62.3653 197.305 62.2873V62.0747C197.191 62.181 197.078 62.2873 196.957 62.4007C193.193 66.1709 192.747 69.5372 192.307 72.7971Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M191.168 71.6482C190.736 74.8798 190.289 78.2248 186.561 81.9454C182.839 85.666 179.494 86.1125 176.261 86.5448C173.001 86.9842 169.634 87.4307 165.877 91.1938C162.113 94.9498 161.666 98.3232 161.227 101.576C160.795 104.808 160.348 108.146 156.627 111.873C152.905 115.594 149.559 116.04 146.327 116.473C143.066 116.905 139.7 117.359 135.943 121.122C135.468 121.596 135.05 122.057 134.674 122.518H134.879C135.227 122.093 135.617 121.66 136.056 121.228C139.777 117.507 143.123 117.061 146.356 116.629C149.616 116.196 152.983 115.743 156.74 111.98C160.497 108.224 160.95 104.85 161.383 101.597C161.815 98.3657 162.262 95.0207 165.983 91.3001C169.705 87.5795 173.05 87.133 176.283 86.7007C179.543 86.2613 182.91 85.8149 186.667 82.0517C190.431 78.2957 190.878 74.9223 191.317 71.6695C191.75 68.4378 192.196 65.0928 195.925 61.3722C196.392 60.9045 196.846 60.4935 197.307 60.1249V59.9265C196.818 60.3163 196.322 60.7557 195.818 61.2588C192.054 65.022 191.601 68.3953 191.168 71.6482Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M190.026 70.5066C189.594 73.7383 189.147 77.0833 185.419 80.8039C181.697 84.5245 178.352 84.9709 175.119 85.4032C171.859 85.8355 168.492 86.2891 164.735 90.0522C160.978 93.8083 160.524 97.1816 160.085 100.435C159.652 103.666 159.206 107.004 155.484 110.732C151.763 114.452 148.417 114.899 145.185 115.331C141.924 115.763 138.557 116.217 134.801 119.98C133.936 120.845 133.248 121.695 132.695 122.524H132.88C133.418 121.731 134.078 120.923 134.907 120.093C138.628 116.373 141.974 115.926 145.206 115.494C148.467 115.062 151.834 114.608 155.591 110.852C159.348 107.089 159.801 103.723 160.234 100.47C160.666 97.2383 161.113 93.8933 164.834 90.1727C168.555 86.4521 171.901 86.0056 175.133 85.5733C178.394 85.141 181.761 84.6875 185.518 80.9243C189.282 77.1683 189.728 73.795 190.168 70.5421C190.6 67.3105 191.047 63.9655 194.775 60.2449C195.633 59.3873 196.477 58.707 197.299 58.1542V57.97C196.441 58.5369 195.562 59.2385 194.669 60.1386C190.912 63.8804 190.459 67.2467 190.026 70.5066Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M188.877 69.3669C188.445 72.5986 187.998 75.9436 184.27 79.6642C180.548 83.3848 177.203 83.8312 173.97 84.2635C170.71 84.7029 167.343 85.1494 163.586 88.9125C159.829 92.6686 159.375 96.0419 158.936 99.2948C158.503 102.526 158.057 105.864 154.335 109.592C150.614 113.313 147.268 113.759 144.036 114.191C140.775 114.624 137.408 115.077 133.651 118.833C132.383 120.102 131.497 121.328 130.852 122.518H131.029C131.66 121.363 132.532 120.173 133.758 118.94C137.479 115.219 140.825 114.773 144.057 114.34C147.318 113.908 150.685 113.454 154.442 109.691C158.199 105.935 158.652 102.562 159.092 99.309C159.524 96.0774 159.971 92.7324 163.692 89.0117C167.413 85.2911 170.759 84.8447 173.992 84.4124C177.252 83.973 180.619 83.5265 184.376 79.7634C188.14 76.0073 188.586 72.634 189.026 69.3811C189.458 66.1495 189.905 62.8045 193.633 59.0839C194.895 57.8224 196.114 56.9437 197.298 56.3058V56.1287C196.079 56.7736 194.824 57.6736 193.52 58.9776C189.763 62.7407 189.317 66.107 188.877 69.3669Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M187.737 68.2183C187.305 71.4499 186.858 74.7949 183.13 78.5155C179.409 82.2361 176.063 82.6826 172.83 83.1149C169.57 83.5543 166.203 84.0007 162.446 87.7639C158.689 91.5199 158.236 94.8933 157.796 98.1461C157.364 101.378 156.917 104.716 153.196 108.443C149.474 112.164 146.129 112.61 142.896 113.043C139.636 113.475 136.269 113.929 132.512 117.685C130.832 119.364 129.818 120.966 129.166 122.511H129.336C129.981 120.994 130.988 119.428 132.625 117.791C136.347 114.07 139.692 113.624 142.925 113.192C146.185 112.759 149.552 112.306 153.309 108.543C157.066 104.787 157.52 101.413 157.952 98.1603C158.384 94.9287 158.831 91.5908 162.552 87.8631C166.274 84.1425 169.619 83.696 172.852 83.2637C176.112 82.8243 179.479 82.3779 183.236 78.6147C187 74.8587 187.447 71.4853 187.886 68.2325C188.319 65.0008 188.765 61.6558 192.494 57.9352C194.167 56.2627 195.761 55.2564 197.307 54.6115V54.4414C195.733 55.0934 194.103 56.1139 192.387 57.8289C188.623 61.5921 188.17 64.9654 187.737 68.2183Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M186.595 67.0764C186.163 70.308 185.716 73.653 181.988 77.3736C178.266 81.0942 174.92 81.5407 171.688 81.973C168.428 82.4123 165.061 82.8588 161.304 86.6219C157.547 90.378 157.093 93.7513 156.661 97.0042C156.228 100.236 155.782 103.574 152.06 107.301C148.339 111.022 144.993 111.469 141.761 111.901C138.5 112.333 135.133 112.787 131.376 116.543C129.278 118.64 128.215 120.618 127.605 122.517H127.768C128.378 120.646 129.427 118.711 131.49 116.649C135.211 112.928 138.557 112.482 141.789 112.05C145.05 111.617 148.417 111.164 152.174 107.401C155.931 103.645 156.384 100.271 156.817 97.0184C157.249 93.7868 157.696 90.4489 161.417 86.7212C165.138 83.0006 168.484 82.5541 171.717 82.1218C174.977 81.6895 178.344 81.2359 182.101 77.4728C185.858 73.7168 186.312 70.3434 186.751 67.0905C187.183 63.8589 187.63 60.5139 191.351 56.7933C193.442 54.7027 195.406 53.6467 197.306 53.0443V52.8813C195.378 53.4837 193.372 54.5538 191.245 56.6799C187.481 60.4501 187.027 63.8164 186.595 67.0764Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M185.447 65.9353C185.015 69.1669 184.568 72.5119 180.84 76.2325C177.118 79.9531 173.773 80.3996 170.54 80.8319C167.28 81.2642 163.913 81.7178 160.156 85.4809C156.399 89.2369 155.945 92.6103 155.513 95.8632C155.081 99.0948 154.634 102.433 150.913 106.16C147.191 109.881 143.845 110.327 140.613 110.76C137.353 111.192 133.986 111.646 130.229 115.402C127.705 117.925 126.677 120.263 126.139 122.517H126.302C126.84 120.299 127.861 117.988 130.342 115.508C134.063 111.787 137.409 111.341 140.642 110.909C143.902 110.476 147.269 110.023 151.026 106.26C154.783 102.504 155.237 99.1302 155.669 95.8773C156.101 92.6457 156.548 89.3078 160.269 85.5801C163.991 81.8595 167.336 81.413 170.569 80.9807C173.829 80.5484 177.196 80.0949 180.953 76.3317C184.71 72.5757 185.164 69.2023 185.603 65.9495C186.036 62.7179 186.482 59.3728 190.211 55.6522C192.72 53.1435 195.059 52.123 197.306 51.5915V51.4285C195.024 51.96 192.656 52.9876 190.097 55.5388C186.333 59.3091 185.887 62.6753 185.447 65.9353Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M184.305 64.788C183.873 68.0197 183.426 71.3647 179.705 75.0853C175.983 78.8059 172.637 79.2523 169.405 79.6846C166.144 80.124 162.777 80.5705 159.021 84.3336C155.264 88.0897 154.81 91.463 154.378 94.7159C153.945 97.9475 153.499 101.285 149.777 105.013C146.056 108.734 142.71 109.18 139.478 109.612C136.217 110.045 132.85 110.498 129.093 114.254C126.145 117.203 125.23 119.91 124.77 122.518H124.925C125.393 119.945 126.301 117.273 129.207 114.368C132.928 110.647 136.274 110.201 139.506 109.768C142.767 109.336 146.134 108.883 149.891 105.119C153.648 101.363 154.101 97.99 154.534 94.7372C154.966 91.5055 155.413 88.1676 159.134 84.4399C162.855 80.7193 166.201 80.2729 169.433 79.8406C172.694 79.4012 176.061 78.9547 179.818 75.1916C183.575 71.4355 184.028 68.0622 184.468 64.8093C184.9 61.5777 185.347 58.2327 189.075 54.5121C192.017 51.571 194.718 50.6781 197.312 50.2174V50.0615C194.682 50.5222 191.946 51.4222 188.962 54.4058C185.191 58.1618 184.737 61.5352 184.305 64.788Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M183.164 63.6476C182.732 66.8792 182.285 70.2242 178.557 73.9448C174.835 77.6654 171.49 78.1119 168.257 78.5442C164.997 78.9765 161.63 79.4301 157.873 83.1932C154.116 86.9492 153.662 90.3226 153.23 93.5755C152.798 96.8071 152.351 100.145 148.63 103.873C144.908 107.593 141.563 108.04 138.33 108.472C135.07 108.904 131.703 109.358 127.946 113.114C124.565 116.494 123.863 119.563 123.438 122.518H123.593C124.012 119.598 124.713 116.565 128.059 113.22C131.781 109.5 135.126 109.053 138.359 108.621C141.619 108.189 144.986 107.735 148.743 103.979C152.5 100.216 152.954 96.8496 153.386 93.5967C153.818 90.3651 154.265 87.0272 157.986 83.2995C161.708 79.5789 165.053 79.1324 168.286 78.693C171.546 78.2607 174.913 77.8072 178.67 74.044C182.434 70.288 182.881 66.9146 183.32 63.6618C183.753 60.4302 184.199 57.0852 187.928 53.3646C191.302 49.9912 194.364 49.3109 197.313 48.8856V48.7297C194.328 49.1549 191.238 49.8353 187.821 53.2512C184.05 57.0214 183.597 60.3876 183.164 63.6476Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M186.666 52.1175C182.902 55.8736 182.455 59.2469 182.016 62.4998C181.583 65.7314 181.137 69.0764 177.408 72.797C173.687 76.5176 170.341 76.9641 167.109 77.3964C163.848 77.8287 160.481 78.2823 156.724 82.0454C152.967 85.8014 152.514 89.1748 152.081 92.4276C151.649 95.6593 151.202 98.9972 147.481 102.725C143.759 106.445 140.414 106.892 137.181 107.324C133.921 107.757 130.554 108.21 126.797 111.966C123.04 115.722 122.586 119.096 122.154 122.348C122.147 122.405 122.14 122.455 122.133 122.511H122.289C122.296 122.462 122.303 122.419 122.31 122.37C122.742 119.138 123.189 115.8 126.91 112.072C130.632 108.352 133.978 107.905 137.21 107.473C140.47 107.041 143.837 106.587 147.594 102.824C151.351 99.0681 151.805 95.6947 152.237 92.4418C152.67 89.2102 153.116 85.8652 156.838 82.1446C160.559 78.424 163.905 77.9775 167.137 77.5452C170.398 77.1129 173.765 76.6594 177.521 72.8962C181.285 69.1402 181.732 65.7668 182.171 62.514C182.604 59.2824 183.05 55.9374 186.779 52.2167C190.5 48.4961 193.846 48.0497 197.078 47.6174C197.156 47.6103 197.227 47.5961 197.305 47.589V47.4331C197.22 47.4473 197.135 47.4544 197.057 47.4685C193.796 47.9079 190.422 48.3615 186.666 52.1175Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M185.523 50.9763C181.759 54.7324 181.313 58.1057 180.873 61.3586C180.441 64.5902 179.994 67.9352 176.266 71.6558C172.544 75.3764 169.199 75.8229 165.966 76.2552C162.706 76.6946 159.339 77.1411 155.582 80.9042C151.818 84.6602 151.371 88.0336 150.932 91.2865C150.499 94.5181 150.053 97.856 146.331 101.584C142.61 105.304 139.264 105.751 136.032 106.183C132.771 106.615 129.404 107.069 125.648 110.832C121.891 114.588 121.437 117.954 121.005 121.214C120.948 121.647 120.891 122.086 120.82 122.518H120.976C121.04 122.086 121.097 121.661 121.153 121.228C121.586 117.997 122.032 114.659 125.754 110.931C129.475 107.211 132.821 106.764 136.053 106.332C139.314 105.9 142.681 105.446 146.438 101.683C150.195 97.9269 150.648 94.5535 151.081 91.3006C151.513 88.069 151.96 84.724 155.681 81.0034C159.402 77.2828 162.748 76.8363 165.98 76.404C169.241 75.9646 172.608 75.5182 176.365 71.755C180.129 67.999 180.575 64.6256 181.015 61.3728C181.447 58.1412 181.894 54.7962 185.622 51.0755C189.344 47.3549 192.69 46.9085 195.922 46.4762C196.375 46.4124 196.836 46.3557 197.297 46.2848V46.1289C196.829 46.1998 196.368 46.2636 195.908 46.3273C192.647 46.7667 189.28 47.2132 185.523 50.9763Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M184.377 49.8347C180.62 53.5907 180.166 56.964 179.727 60.2169C179.294 63.4485 178.848 66.7935 175.119 70.5141C171.398 74.2348 168.052 74.6812 164.82 75.1135C161.559 75.5529 158.192 75.9994 154.435 79.7625C150.671 83.5186 150.225 86.8919 149.785 90.1448C149.353 93.3764 148.906 96.7143 145.185 100.442C141.464 104.163 138.118 104.609 134.885 105.041C131.625 105.474 128.258 105.927 124.501 109.69C120.744 113.446 120.29 116.82 119.858 120.073C119.752 120.881 119.638 121.696 119.482 122.525H119.638C119.794 121.703 119.908 120.895 120.014 120.094C120.446 116.862 120.893 113.524 124.614 109.797C128.336 106.076 131.682 105.63 134.914 105.197C138.175 104.765 141.541 104.311 145.298 100.555C149.055 96.7993 149.509 93.426 149.941 90.1731C150.374 86.9415 150.82 83.5965 154.542 79.8759C158.263 76.1553 161.609 75.7088 164.841 75.2765C168.102 74.8371 171.469 74.3907 175.226 70.6275C178.982 66.8715 179.436 63.4981 179.876 60.2453C180.308 57.0137 180.754 53.6687 184.476 49.948C188.197 46.2274 191.543 45.781 194.775 45.3487C195.605 45.2353 196.441 45.1219 197.292 44.9589V44.803C196.434 44.9731 195.59 45.0865 194.754 45.1998C191.508 45.618 188.141 46.0715 184.377 49.8347Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M183.233 48.6875C179.477 52.4435 179.023 55.8169 178.583 59.0697C178.151 62.3013 177.704 65.6463 173.976 69.367C170.255 73.0876 166.909 73.534 163.677 73.9663C160.416 74.4057 157.049 74.8522 153.292 78.6153C149.528 82.3714 149.082 85.7447 148.649 88.9976C148.217 92.2292 147.77 95.5671 144.049 99.2948C140.327 103.015 136.982 103.462 133.749 103.894C130.489 104.326 127.122 104.78 123.365 108.536C119.608 112.292 119.154 115.665 118.722 118.918C118.566 120.095 118.403 121.292 118.084 122.511H118.24C118.552 121.3 118.715 120.109 118.871 118.94C119.303 115.708 119.75 112.37 123.471 108.642C127.193 104.922 130.538 104.475 133.771 104.043C137.031 103.611 140.398 103.157 144.155 99.4011C147.912 95.6451 148.366 92.2717 148.798 89.0188C149.23 85.7872 149.677 82.4422 153.398 78.7216C157.12 75.001 160.465 74.5545 163.698 74.1222C166.958 73.6899 170.325 73.2364 174.082 69.4733C177.839 65.7172 178.293 62.3439 178.732 59.091C179.165 55.8594 179.611 52.5144 183.34 48.7938C187.061 45.0732 190.407 44.6267 193.639 44.1944C194.837 44.0314 196.056 43.8684 197.297 43.5424V43.3794C196.042 43.7125 194.823 43.8755 193.618 44.0385C190.364 44.4779 186.99 44.9314 183.233 48.6875Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M177.139 42.5919C173.375 46.3479 172.929 49.7213 172.489 52.9742C172.057 56.2058 171.61 59.5508 167.882 63.2714C164.16 66.992 160.815 67.4385 157.582 67.8708C154.322 68.3031 150.955 68.7566 147.198 72.5197C143.434 76.2758 142.987 79.6491 142.555 82.902C142.123 86.1336 141.676 89.4715 137.955 93.1992C134.233 96.9199 130.887 97.3663 127.655 97.7986C124.394 98.2309 121.028 98.6845 117.271 102.441C113.514 106.197 113.06 109.57 112.628 112.823C112.217 115.877 111.791 119.031 108.602 122.511H108.814C111.954 119.038 112.373 115.891 112.784 112.837C113.216 109.605 113.663 106.267 117.384 102.54C121.105 98.8191 124.451 98.3727 127.684 97.9404C130.944 97.5081 134.311 97.0545 138.068 93.2985C141.825 89.5424 142.279 86.1691 142.711 82.9162C143.143 79.6846 143.59 76.3396 147.311 72.619C151.033 68.8984 154.378 68.4519 157.611 68.0196C160.871 67.5873 164.238 67.1337 167.995 63.3706C171.759 59.6146 172.206 56.2412 172.645 52.9883C173.078 49.7567 173.524 46.4117 177.253 42.6911C180.974 38.9705 184.32 38.524 187.552 38.0917C190.628 37.6807 193.804 37.2555 197.313 34.0451V33.8325C193.797 37.0925 190.614 37.5248 187.538 37.9358C184.263 38.3823 180.896 38.8288 177.139 42.5919Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M186.382 36.8017C183.121 37.234 179.754 37.6875 175.997 41.4507C172.233 45.2067 171.787 48.5801 171.347 51.8329C170.915 55.0645 170.468 58.4096 166.74 62.1302C163.018 65.8508 159.673 66.2972 156.44 66.7295C153.18 67.1618 149.813 67.6154 146.056 71.3785C142.292 75.1346 141.845 78.5079 141.413 81.7608C140.981 84.9924 140.534 88.3303 136.813 92.058C133.091 95.7786 129.745 96.2251 126.513 96.6574C123.253 97.0897 119.886 97.5433 116.129 101.299C112.372 105.055 111.918 108.429 111.486 111.682C111.053 114.913 110.607 118.251 106.885 121.979C106.694 122.17 106.51 122.347 106.318 122.517H106.545C106.694 122.376 106.85 122.241 106.999 122.085C110.756 118.329 111.209 114.963 111.642 111.703C112.074 108.471 112.521 105.133 116.242 101.406C119.964 97.685 123.309 97.2385 126.542 96.8062C129.802 96.3739 133.169 95.9204 136.926 92.1572C140.69 88.4012 141.137 85.0278 141.569 81.775C142.001 78.5434 142.448 75.1984 146.169 71.4777C149.891 67.7571 153.236 67.3107 156.469 66.8784C159.729 66.439 163.096 65.9925 166.853 62.2294C170.617 58.4733 171.064 55.1 171.503 51.8471C171.936 48.6155 172.382 45.2705 176.111 41.5499C179.832 37.8293 183.178 37.3828 186.41 36.9505C189.671 36.5182 193.038 36.0646 196.795 32.3015C196.979 32.1173 197.142 31.9401 197.312 31.7629V31.5361C197.114 31.7558 196.908 31.9684 196.688 32.1881C192.953 35.9229 189.614 36.3694 186.382 36.8017Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M185.232 35.6609C181.972 36.1003 178.605 36.5468 174.848 40.3099C171.084 44.0659 170.637 47.4393 170.198 50.6922C169.765 53.9238 169.319 57.2688 165.597 60.9894C161.876 64.71 158.53 65.1565 155.298 65.5888C152.037 66.0282 148.67 66.4746 144.913 70.2378C141.157 73.9938 140.703 77.3671 140.271 80.62C139.838 83.8516 139.392 87.1896 135.67 90.9173C131.949 94.6379 128.603 95.0843 125.371 95.5166C122.11 95.9489 118.743 96.4025 114.986 100.166C111.229 103.922 110.776 107.295 110.343 110.548C109.911 113.779 109.464 117.117 105.743 120.845C105.084 121.504 104.439 122.057 103.801 122.532H104.056C104.644 122.078 105.247 121.568 105.856 120.958C109.613 117.202 110.067 113.829 110.499 110.576C110.932 107.345 111.378 104.007 115.1 100.279C118.821 96.5584 122.167 96.1119 125.399 95.6796C128.66 95.2473 132.027 94.7938 135.784 91.0306C139.548 87.2746 139.994 83.9012 140.434 80.6484C140.866 77.4168 141.313 74.0718 145.034 70.3511C148.755 66.6305 152.101 66.1841 155.333 65.7518C158.594 65.3124 161.961 64.8659 165.718 61.1028C169.482 57.3467 169.928 53.9734 170.368 50.7205C170.8 47.4889 171.247 44.1439 174.968 40.4233C178.69 36.7027 182.035 36.2562 185.268 35.8239C188.528 35.3845 191.895 34.9381 195.652 31.1749C196.297 30.53 196.843 29.8922 197.311 29.2686V29.0134C196.822 29.6867 196.24 30.367 195.546 31.0615C191.81 34.7751 188.464 35.2286 185.232 35.6609Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M184.091 34.5135C180.83 34.9529 177.463 35.3994 173.707 39.1625C169.95 42.9186 169.496 46.2919 169.057 49.5448C168.624 52.7764 168.178 56.1214 164.456 59.842C160.735 63.5626 157.389 64.0091 154.157 64.4414C150.896 64.8808 147.529 65.3272 143.772 69.0904C140.015 72.8464 139.562 76.2198 139.122 79.4726C138.69 82.7043 138.243 86.0422 134.522 89.7699C130.801 93.4905 127.455 93.937 124.222 94.3693C120.962 94.8016 117.595 95.2551 113.838 99.0182C110.081 102.774 109.627 106.148 109.195 109.401C108.763 112.632 108.316 115.97 104.595 119.698C103.298 120.995 102.05 121.888 100.838 122.525H101.171C102.312 121.888 103.489 121.023 104.708 119.804C108.465 116.048 108.919 112.682 109.351 109.422C109.783 106.19 110.23 102.852 113.951 99.1245C117.673 95.4039 121.019 94.9575 124.251 94.5252C127.511 94.0929 130.878 93.6393 134.635 89.8833C138.392 86.1272 138.846 82.7539 139.285 79.501C139.718 76.2694 140.164 72.9315 143.886 69.2038C147.607 65.4832 150.953 65.0367 154.185 64.5973C157.446 64.165 160.813 63.7114 164.57 59.9483C168.334 56.1923 168.78 52.8189 169.22 49.566C169.652 46.3344 170.099 42.9894 173.82 39.2688C177.541 35.5482 180.887 35.1017 184.119 34.6694C187.38 34.2301 190.747 33.7836 194.504 30.0205C195.78 28.7519 196.666 27.5188 197.304 26.3282V26.0022C196.659 27.2637 195.744 28.5676 194.39 29.9142C190.662 33.6348 187.323 34.0812 184.091 34.5135Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M182.952 33.3725C179.692 33.8048 176.325 34.2584 172.568 38.0215C168.811 41.7775 168.357 45.1509 167.918 48.4038C167.486 51.6354 167.039 54.9804 163.318 58.701C159.596 62.4216 156.25 62.8681 153.018 63.3004C149.757 63.7398 146.391 64.1862 142.634 67.9494C138.87 71.7125 138.423 75.0788 137.991 78.3316C137.558 81.5632 137.112 84.9012 133.39 88.6289C129.669 92.3495 126.323 92.7959 123.091 93.2282C119.83 93.6605 116.463 94.1141 112.706 97.8701C108.95 101.626 108.496 105 108.064 108.252C107.631 111.484 107.185 114.822 103.463 118.55C101.089 120.924 98.8699 121.965 96.7363 122.518H97.3105C99.3023 121.923 101.372 120.86 103.577 118.656C107.333 114.9 107.787 111.534 108.22 108.274C108.652 105.042 109.098 101.704 112.82 97.9764C116.541 94.2558 119.887 93.8094 123.119 93.3771C126.38 92.9448 129.747 92.4912 133.504 88.7281C137.261 84.972 137.714 81.5987 138.147 78.3458C138.579 75.1142 139.026 71.7692 142.747 68.0486C146.468 64.328 149.814 63.8815 153.046 63.4492C156.307 63.0098 159.674 62.5633 163.431 58.8002C167.188 55.0442 167.641 51.6708 168.081 48.4179C168.513 45.1863 168.96 41.8413 172.681 38.1207C176.403 34.4001 179.748 33.9536 182.981 33.5213C186.241 33.089 189.608 32.6355 193.365 28.8724C195.676 26.562 196.732 24.4005 197.313 22.3241V21.7004C196.782 23.9399 195.761 26.2644 193.259 28.766C189.523 32.4937 186.185 32.9402 182.952 33.3725Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M192.103 27.6242C188.382 31.3448 185.036 31.7913 181.804 32.2236C178.543 32.663 175.176 33.1095 171.419 36.8726C167.655 40.6286 167.209 44.002 166.769 47.2549C166.337 50.4865 165.89 53.8315 162.169 57.5521C158.447 61.2727 155.102 61.7192 151.869 62.1515C148.609 62.5909 145.242 63.0373 141.485 66.8005C137.721 70.5565 137.274 73.9298 136.842 77.1827C136.41 80.4143 135.963 83.7522 132.242 87.4799C128.52 91.2005 125.175 91.647 121.942 92.0793C118.682 92.5116 115.315 92.9652 111.558 96.7283C107.801 100.484 107.347 103.858 106.915 107.111C106.483 110.342 106.036 113.687 102.315 117.408C98.5931 121.128 95.2474 121.575 92.0151 122.007C91.0015 122.142 89.9736 122.284 88.9316 122.517H89.6972C90.484 122.369 91.2637 122.262 92.0364 122.163C95.297 121.724 98.664 121.277 102.421 117.514C106.178 113.758 106.631 110.392 107.064 107.132C107.496 103.9 107.943 100.562 111.664 96.8346C115.386 93.114 118.731 92.6675 121.964 92.2352C125.224 91.8029 128.591 91.3494 132.348 87.5862C136.105 83.8302 136.559 80.4569 136.991 77.204C137.423 73.9724 137.87 70.6274 141.591 66.9068C145.313 63.1861 148.658 62.7397 151.891 62.3074C155.151 61.868 158.518 61.4215 162.275 57.6584C166.039 53.9023 166.486 50.529 166.925 47.2761C167.358 44.0445 167.804 40.6995 171.533 36.9789C175.254 33.2583 178.6 32.8118 181.832 32.3795C185.093 31.9401 188.46 31.4937 192.217 27.7305C195.981 23.9674 196.427 20.6011 196.867 17.3483C196.987 16.4411 197.115 15.5269 197.306 14.6056V13.9111C197.015 15.0734 196.859 16.2073 196.711 17.327C196.278 20.5586 195.825 23.9036 192.103 27.6242Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M190.961 26.4834C187.24 30.204 183.894 30.6504 180.662 31.0827C177.401 31.5221 174.034 31.9686 170.278 35.7317C166.514 39.4878 166.067 42.8611 165.628 46.114C165.195 49.3456 164.749 52.6906 161.02 56.4112C157.299 60.1318 153.953 60.5783 150.721 61.0106C147.46 61.45 144.093 61.8965 140.336 65.6596C136.572 69.4156 136.126 72.789 135.693 76.0419C135.261 79.2735 134.814 82.6114 131.093 86.3391C127.372 90.0597 124.026 90.5062 120.794 90.9385C117.533 91.3708 114.166 91.8243 110.409 95.5874C106.652 99.3435 106.198 102.717 105.766 105.97C105.334 109.201 104.887 112.546 101.166 116.267C97.4443 119.988 94.0986 120.434 90.8663 120.866C88.8178 121.143 86.7338 121.419 84.5293 122.525H84.8979C86.9748 121.554 88.9525 121.284 90.8876 121.022C94.1482 120.583 97.5152 120.136 101.272 116.373C105.029 112.617 105.483 109.244 105.915 105.991C106.347 102.759 106.794 99.4214 110.515 95.6937C114.237 91.9731 117.582 91.5267 120.815 91.0944C124.075 90.6621 127.442 90.2085 131.199 86.4525C134.963 82.6964 135.41 79.3231 135.842 76.0702C136.275 72.8386 136.721 69.4936 140.443 65.773C144.164 62.0524 147.51 61.6059 150.742 61.1736C154.003 60.7342 157.37 60.2877 161.126 56.5246C164.89 52.7686 165.337 49.3952 165.776 46.1423C166.209 42.9107 166.655 39.5657 170.384 35.8451C174.105 32.1245 177.451 31.678 180.683 31.2457C183.944 30.8064 187.311 30.3599 191.068 26.5968C194.832 22.8336 195.278 19.4674 195.718 16.2145C195.987 14.2231 196.264 12.1891 197.306 10.0489V9.70874C196.136 11.9695 195.845 14.1097 195.569 16.2003C195.129 19.4178 194.683 22.7628 190.961 26.4834Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M189.814 25.3419C186.092 29.0625 182.747 29.509 179.514 29.9413C176.254 30.3807 172.887 30.8272 169.13 34.5903C165.366 38.3463 164.919 41.7197 164.48 44.9726C164.047 48.2042 163.601 51.5492 159.872 55.2698C156.151 58.9904 152.805 59.4369 149.573 59.8692C146.312 60.3015 142.945 60.755 139.188 64.5182C135.432 68.2742 134.978 71.6475 134.546 74.9004C134.113 78.132 133.667 81.47 129.945 85.1976C126.224 88.9183 122.878 89.3647 119.646 89.797C116.385 90.2293 113.018 90.6829 109.261 94.4389C105.504 98.195 105.051 101.568 104.618 104.821C104.186 108.053 103.739 111.391 100.018 115.118C96.2966 118.839 92.9509 119.285 89.7186 119.718C87.0959 120.072 84.4094 120.434 81.4961 122.517H81.7725C84.5866 120.568 87.1952 120.214 89.7399 119.874C93.0005 119.434 96.3675 118.988 100.124 115.225C103.881 111.469 104.335 108.095 104.767 104.842C105.2 101.611 105.646 98.2729 109.368 94.5452C113.089 90.8246 116.435 90.3781 119.667 89.9458C122.928 89.5135 126.295 89.06 130.052 85.3039C133.815 81.5479 134.262 78.1746 134.694 74.9217C135.127 71.6901 135.573 68.3451 139.295 64.6245C143.016 60.9038 146.362 60.4574 149.594 60.0251C152.855 59.5928 156.222 59.1392 159.979 55.3761C163.743 51.62 164.189 48.2467 164.629 44.9938C165.061 41.7622 165.508 38.4172 169.236 34.6966C172.958 30.976 176.303 30.5295 179.536 30.0972C182.796 29.6649 186.163 29.2114 189.92 25.4482C193.684 21.6851 194.131 18.3188 194.57 15.066C194.903 12.5926 195.251 10.0485 197.065 7.32001C197.051 7.25623 197.03 7.18536 197.016 7.12158C195.116 9.91381 194.761 12.5147 194.421 15.0447C193.989 18.2763 193.542 21.6142 189.814 25.3419Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M188.671 24.1939C184.949 27.9145 181.604 28.361 178.371 28.8004C175.111 29.2327 171.744 29.6862 167.987 33.4493C164.223 37.2054 163.776 40.5787 163.337 43.8316C162.905 47.0632 162.458 50.4082 158.737 54.1288C155.015 57.8494 151.67 58.2959 148.437 58.7353C145.177 59.1747 141.81 59.6212 138.053 63.3843C134.296 67.1403 133.842 70.5137 133.403 73.7665C132.97 76.9982 132.524 80.3361 128.802 84.0638C125.081 87.7844 121.735 88.2309 118.503 88.6632C115.242 89.0955 111.875 89.549 108.118 93.3051C104.362 97.0611 103.908 100.434 103.476 103.687C103.043 106.919 102.597 110.257 98.8752 113.985C95.1538 117.705 91.8081 118.152 88.5757 118.584C85.5348 118.995 82.3947 119.413 78.9355 122.524H79.1695C82.5435 119.555 85.6199 119.137 88.597 118.74C91.8577 118.3 95.2247 117.854 98.9815 114.091C102.738 110.335 103.192 106.961 103.624 103.709C104.057 100.477 104.503 97.1391 108.225 93.4114C111.946 89.6908 115.292 89.2443 118.524 88.812C121.785 88.3797 125.152 87.9261 128.909 84.163C132.666 80.4069 133.119 77.0336 133.559 73.7807C133.991 70.5491 134.438 67.2112 138.159 63.4835C141.88 59.7629 145.226 59.3164 148.458 58.8841C151.719 58.4518 155.086 57.9983 158.843 54.2351C162.607 50.4791 163.053 47.1057 163.493 43.8529C163.925 40.6213 164.372 37.2762 168.093 33.5556C171.815 29.835 175.16 29.3886 178.393 28.9563C181.653 28.524 185.02 28.0704 188.777 24.3073C192.541 20.5441 192.988 17.1779 193.427 13.925C193.789 11.232 194.164 8.46812 196.433 5.46328C196.411 5.41368 196.383 5.35698 196.355 5.30737C194.023 8.36181 193.64 11.1682 193.271 13.9037C192.846 17.1283 192.399 20.4733 188.671 24.1939Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M187.531 23.0528C183.809 26.7735 180.464 27.2199 177.231 27.6522C173.971 28.0916 170.604 28.5381 166.847 32.3012C163.09 36.0573 162.636 39.4306 162.197 42.6835C161.764 45.9151 161.318 49.2601 157.596 52.9807C153.875 56.7013 150.529 57.1478 147.297 57.5801C144.036 58.0195 140.669 58.4659 136.912 62.2291C133.156 65.9851 132.702 69.3585 132.262 72.6113C131.83 75.843 131.384 79.1809 127.662 82.9086C123.941 86.6292 120.595 87.0756 117.363 87.5079C114.102 87.9402 110.735 88.3938 106.978 92.1569C103.221 95.913 102.768 99.2863 102.335 102.539C101.903 105.771 101.456 109.109 97.7349 112.836C94.0135 116.557 90.6678 117.004 87.4355 117.436C84.1749 117.868 80.8079 118.322 77.051 122.085C76.9022 122.234 76.7746 122.375 76.6328 122.524H76.8455C76.9518 122.411 77.051 122.304 77.1574 122.191C80.8788 118.47 84.2245 118.024 87.4568 117.592C90.7174 117.159 94.0844 116.706 97.8413 112.943C101.598 109.187 102.052 105.813 102.484 102.56C102.917 99.3288 103.363 95.9909 107.085 92.2632C110.806 88.5426 114.152 88.0962 117.384 87.6639C120.645 87.2316 124.012 86.778 127.768 83.022C131.525 79.2659 131.979 75.8926 132.418 72.6397C132.851 69.4081 133.297 66.0702 137.019 62.3425C140.74 58.6219 144.086 58.1754 147.318 57.736C150.579 57.3037 153.946 56.8501 157.703 53.087C161.467 49.331 161.913 45.9576 162.353 42.7047C162.785 39.4731 163.232 36.1281 166.953 32.4075C170.674 28.6869 174.02 28.2404 177.252 27.8081C180.513 27.3688 183.88 26.9223 187.637 23.1591C191.401 19.396 191.847 16.0298 192.287 12.7769C192.663 9.97757 193.053 7.1003 195.562 3.96082C195.533 3.91829 195.498 3.87577 195.47 3.83325C192.911 7.01526 192.514 9.92796 192.138 12.7556C191.699 15.9872 191.252 19.3252 187.531 23.0528Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M186.388 21.9057C182.667 25.6263 179.321 26.0728 176.089 26.5051C172.828 26.9374 169.461 27.391 165.704 31.1541C161.948 34.9101 161.494 38.2835 161.054 41.5363C160.622 44.768 160.176 48.113 156.454 51.8336C152.733 55.5542 149.387 56.0006 146.155 56.4329C142.894 56.8723 139.527 57.3188 135.77 61.0819C132.006 64.838 131.56 68.2113 131.127 71.4642C130.695 74.6958 130.248 78.0337 126.527 81.7614C122.806 85.482 119.46 85.9285 116.228 86.3608C112.967 86.7931 109.6 87.2467 105.843 91.0027C102.086 94.7587 101.633 98.1321 101.2 101.385C100.768 104.617 100.321 107.955 96.5998 111.682C92.8784 115.403 89.5326 115.849 86.3003 116.282C83.0397 116.714 79.6727 117.167 75.9158 120.931C75.3842 121.469 74.9164 121.994 74.5052 122.511H74.7037C75.0936 122.029 75.526 121.533 76.0222 121.037C79.7436 117.316 83.0893 116.87 86.3216 116.437C89.5823 116.005 92.9492 115.552 96.7061 111.796C100.463 108.04 100.917 104.666 101.349 101.413C101.781 98.1817 102.228 94.8438 105.949 91.1161C109.671 87.3955 113.016 86.949 116.249 86.5167C119.509 86.0844 122.876 85.6309 126.633 81.8748C130.39 78.1188 130.844 74.7454 131.276 71.4925C131.709 68.2609 132.155 64.923 135.877 61.1953C139.598 57.4747 142.944 57.0282 146.176 56.5889C149.437 56.1566 152.804 55.703 156.56 51.9399C160.317 48.1838 160.771 44.8105 161.21 41.5576C161.643 38.326 162.089 34.981 165.811 31.2604C169.532 27.5398 172.878 27.0933 176.11 26.661C179.371 26.2287 182.738 25.7751 186.495 22.012C190.259 18.2489 190.705 14.8826 191.145 11.6297C191.527 8.80209 191.917 5.8823 194.505 2.70738C194.469 2.67194 194.427 2.63651 194.391 2.60107C191.768 5.81143 191.372 8.75248 190.996 11.6085C190.556 14.8472 190.11 18.1851 186.388 21.9057Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M185.24 20.7647C181.519 24.4853 178.173 24.9318 174.941 25.3641C171.68 25.8035 168.313 26.25 164.556 30.0131C160.792 33.7691 160.346 37.1425 159.906 40.3953C159.474 43.627 159.027 46.972 155.306 50.6926C151.585 54.4132 148.239 54.8597 145.007 55.299C141.746 55.7313 138.379 56.1849 134.622 59.948C130.858 63.7041 130.412 67.0774 129.979 70.3303C129.547 73.5619 129.1 76.8998 125.379 80.6275C121.657 84.3481 118.312 84.7946 115.079 85.2269C111.819 85.6592 108.452 86.1128 104.695 89.8688C100.938 93.6248 100.484 96.9982 100.052 100.251C99.6197 103.483 99.1731 106.821 95.4517 110.548C91.7303 114.269 88.3845 114.715 85.1522 115.148C81.8916 115.58 78.5246 116.034 74.7678 119.79C73.8392 120.718 73.1091 121.625 72.5349 122.518H72.7263C73.2863 121.668 73.988 120.796 74.8812 119.903C78.6026 116.182 81.9483 115.736 85.1806 115.304C88.4413 114.871 91.8082 114.418 95.5651 110.655C99.3219 106.899 99.7756 103.525 100.208 100.272C100.64 97.0407 101.087 93.7028 104.808 89.9751C108.53 86.2545 111.875 85.808 115.108 85.3757C118.368 84.9434 121.735 84.4899 125.492 80.7267C129.249 76.9707 129.703 73.5973 130.135 70.3445C130.568 67.1128 131.014 63.7749 134.736 60.0472C138.457 56.3266 141.803 55.8802 145.035 55.4479C148.296 55.0085 151.663 54.562 155.419 50.7989C159.176 47.0428 159.63 43.6695 160.069 40.4166C160.502 37.185 160.948 33.84 164.67 30.1194C168.391 26.3988 171.737 25.9523 174.969 25.52C178.23 25.0806 181.597 24.6341 185.354 20.871C189.118 17.1079 189.564 13.7416 190.004 10.4887C190.379 7.69652 190.769 4.81925 193.271 1.68686C193.229 1.65851 193.186 1.62307 193.144 1.59473C190.62 4.75547 190.231 7.654 189.848 10.4675C189.415 13.6991 188.962 17.0441 185.24 20.7647Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M184.099 19.624C180.377 23.3446 177.032 23.7911 173.799 24.2234C170.539 24.6628 167.172 25.1092 163.415 28.8724C159.651 32.6284 159.204 36.0018 158.765 39.2546C158.332 42.4862 157.886 45.8312 154.157 49.5518C150.436 53.2725 147.09 53.7189 143.858 54.1583C140.597 54.5906 137.23 55.0442 133.473 58.8073C129.709 62.5633 129.263 65.9367 128.831 69.1896C128.398 72.4212 127.952 75.7591 124.23 79.4868C120.509 83.2074 117.163 83.6539 113.931 84.0862C110.67 84.5185 107.303 84.972 103.546 88.7352C99.7894 92.4912 99.3357 95.8646 98.9033 99.1174C98.4709 102.349 98.0244 105.687 94.303 109.415C90.5816 113.135 87.2358 113.582 84.0035 114.014C80.7429 114.446 77.3759 114.9 73.6191 118.656C72.2864 119.988 71.372 121.278 70.727 122.525H70.9042C71.5422 121.306 72.4353 120.059 73.7325 118.762C77.4539 115.042 80.7996 114.595 84.0319 114.163C87.2926 113.731 90.6595 113.277 94.4164 109.514C98.1732 105.758 98.6269 102.384 99.0593 99.1316C99.4917 95.9 99.9382 92.5621 103.66 88.8344C107.381 85.1138 110.727 84.6673 113.959 84.235C117.22 83.8027 120.587 83.3491 124.344 79.586C128.108 75.8229 128.554 72.4566 128.986 69.2037C129.419 65.9721 129.865 62.6342 133.587 58.9065C137.308 55.1859 140.654 54.7394 143.886 54.3001C147.147 53.8607 150.514 53.4142 154.271 49.6511C158.035 45.895 158.481 42.5217 158.921 39.2688C159.353 36.0372 159.8 32.6922 163.528 28.9716C167.25 25.251 170.595 24.8045 173.828 24.3722C177.088 23.9328 180.455 23.4863 184.212 19.7232C187.976 15.9601 188.423 12.5938 188.862 9.34094C189.224 6.64793 189.599 3.88405 191.868 0.879218C191.818 0.857958 191.775 0.82961 191.726 0.80835C189.458 3.82736 189.075 6.6125 188.713 9.31968C188.267 12.5584 187.82 15.9034 184.099 19.624Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M182.958 18.4828C179.236 22.2034 175.891 22.6498 172.658 23.0821C169.398 23.5215 166.031 23.968 162.274 27.7311C158.51 31.4872 158.063 34.8605 157.624 38.1134C157.191 41.345 156.745 44.69 153.016 48.4106C149.295 52.1312 145.949 52.5777 142.717 53.01C139.456 53.4423 136.089 53.8959 132.332 57.659C128.576 61.415 128.122 64.7884 127.69 68.0413C127.257 71.2729 126.811 74.6108 123.089 78.3385C119.368 82.0591 116.022 82.5056 112.79 82.9379C109.529 83.3702 106.162 83.8237 102.405 87.5868C98.6485 91.3429 98.1948 94.7162 97.7624 97.9691C97.33 101.201 96.8835 104.539 93.1621 108.266C89.4406 111.987 86.0949 112.433 82.8626 112.866C79.602 113.298 76.235 113.752 72.4781 117.515C70.7344 119.258 69.7066 120.923 69.0544 122.525H69.2246C69.8696 120.952 70.8832 119.329 72.5845 117.621C76.3059 113.9 79.6516 113.454 82.8839 113.022C86.1445 112.589 89.5115 112.136 93.2684 108.373C97.0252 104.617 97.4789 101.243 97.9113 97.9904C98.3437 94.7588 98.7902 91.4208 102.512 87.6931C106.233 83.9725 109.579 83.5261 112.811 83.0938C116.072 82.6615 119.439 82.2079 123.196 78.4519C126.959 74.6958 127.406 71.3225 127.846 68.0696C128.278 64.838 128.725 61.493 132.446 57.7724C136.167 54.0518 139.513 53.6053 142.745 53.173C146.006 52.7407 149.373 52.2871 153.13 48.524C156.894 44.768 157.34 41.3946 157.78 38.1417C158.212 34.9101 158.659 31.5651 162.387 27.8445C166.109 24.1239 169.454 23.6774 172.687 23.2451C175.947 22.8128 179.314 22.3593 183.071 18.5962C186.828 14.833 187.282 11.4668 187.721 8.21389C188.054 5.69805 188.409 3.11843 190.301 0.340373C190.252 0.326199 190.195 0.312025 190.138 0.297852C188.253 3.08299 187.898 5.6697 187.565 8.19263C187.126 11.4172 186.679 14.7551 182.958 18.4828Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M181.81 17.3342C178.089 21.0548 174.743 21.5013 171.511 21.9336C168.25 22.3659 164.883 22.8194 161.127 26.5826C157.363 30.3386 156.916 33.712 156.477 36.9648C156.044 40.1964 155.598 43.5414 151.869 47.262C148.148 50.9827 144.802 51.4291 141.57 51.8685C138.309 52.3008 134.942 52.7544 131.185 56.5175C127.428 60.2735 126.975 63.6469 126.535 66.8998C126.103 70.1314 125.656 73.4693 121.935 77.197C118.213 80.9176 114.868 81.3641 111.635 81.7964C108.375 82.2287 105.008 82.6822 101.251 86.4383C97.494 90.1943 97.0404 93.5677 96.608 96.8205C96.1756 100.052 95.729 103.39 92.0076 107.118C88.2862 110.838 84.9405 111.285 81.7082 111.717C78.4475 112.149 75.0805 112.603 71.3237 116.366C69.1617 118.528 68.0914 120.562 67.496 122.525H67.659C68.2544 120.597 69.3106 118.598 71.4371 116.48C75.1585 112.759 78.5042 112.312 81.7365 111.88C84.9972 111.448 88.3642 110.994 92.121 107.231C95.8779 103.475 96.3315 100.102 96.7639 96.8489C97.1963 93.6173 97.6429 90.2794 101.364 86.5517C105.086 82.8311 108.431 82.3846 111.664 81.9523C114.924 81.52 118.291 81.0664 122.048 77.3033C125.805 73.5473 126.259 70.1739 126.698 66.921C127.131 63.6894 127.577 60.3515 131.299 56.6238C135.02 52.9032 138.366 52.4567 141.598 52.0244C144.859 51.585 148.226 51.1386 151.982 47.3754C155.746 43.6194 156.193 40.246 156.632 36.9932C157.065 33.7616 157.511 30.4166 161.24 26.696C164.961 22.9753 168.307 22.5289 171.539 22.0966C174.8 21.6572 178.167 21.2107 181.924 17.4476C185.688 13.6845 186.134 10.3182 186.574 7.06532C186.879 4.81169 187.191 2.50846 188.608 0.0564033C188.551 0.0493164 188.488 0.0493164 188.431 0.0493164C187.027 2.49429 186.723 4.79752 186.418 7.05115C185.978 10.2686 185.532 13.6136 181.81 17.3342Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M180.668 16.1933C176.946 19.9139 173.6 20.3603 170.368 20.7926C167.108 21.232 163.741 21.6785 159.984 25.4416C156.227 29.1977 155.773 32.571 155.334 35.8239C154.901 39.0555 154.455 42.4005 150.733 46.1211C147.012 49.8417 143.666 50.2882 140.434 50.7276C137.173 51.167 133.806 51.6134 130.049 55.3766C126.293 59.1326 125.839 62.506 125.399 65.7588C124.967 68.9904 124.52 72.3284 120.799 76.0561C117.078 79.7767 113.732 80.2231 110.5 80.6554C107.239 81.0877 103.872 81.5413 100.115 85.2973C96.3583 89.0534 95.9046 92.4267 95.4722 95.6796C95.0398 98.9112 94.5933 102.249 90.8719 105.977C87.1505 109.697 83.8047 110.144 80.5724 110.576C77.3118 111.008 73.9448 111.462 70.188 115.218C67.6007 117.805 66.58 120.207 66.0554 122.518H66.2185C66.743 120.243 67.7566 117.876 70.3014 115.331C74.0228 111.611 77.3685 111.164 80.6008 110.732C83.8615 110.3 87.2284 109.846 90.9853 106.083C94.7421 102.327 95.1958 98.9537 95.6282 95.7009C96.0606 92.4692 96.5071 89.1313 100.229 85.4036C103.95 81.683 107.296 81.2366 110.528 80.8043C113.789 80.372 117.156 79.9184 120.912 76.1553C124.669 72.3992 125.123 69.0259 125.555 65.773C125.988 62.5414 126.434 59.2035 130.156 55.4758C133.877 51.7552 137.223 51.3087 140.455 50.8693C143.716 50.4299 147.083 49.9835 150.84 46.2203C154.604 42.4643 155.05 39.0909 155.49 35.8381C155.922 32.6064 156.369 29.2614 160.09 25.5408C163.811 21.8202 167.157 21.3738 170.389 20.9415C173.65 20.5021 177.017 20.0556 180.774 16.2925C184.538 12.5293 184.984 9.16307 185.424 5.9102C185.679 4.00383 185.948 2.05494 186.884 0.00683594H186.714C185.792 2.04077 185.53 3.98257 185.275 5.88894C184.836 9.12764 184.389 12.4656 180.668 16.1933Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M179.52 15.0525C175.799 18.7731 172.453 19.2196 169.221 19.6519C165.96 20.0913 162.593 20.5377 158.836 24.3009C155.08 28.0569 154.626 31.4303 154.186 34.6831C153.754 37.9147 153.307 41.2597 149.586 44.9804C145.865 48.701 142.519 49.1474 139.287 49.5797C136.026 50.0191 132.659 50.4656 128.902 54.2287C125.138 57.9848 124.692 61.3581 124.259 64.611C123.827 67.8426 123.38 71.1805 119.659 74.9082C115.937 78.6288 112.592 79.0753 109.359 79.5076C106.099 79.9399 102.732 80.3934 98.9749 84.1566C95.2181 87.9126 94.7644 91.286 94.332 94.5388C93.8996 97.7705 93.4531 101.108 89.7317 104.836C86.0103 108.557 82.6645 109.003 79.4322 109.435C76.1716 109.875 72.8046 110.321 69.0477 114.084C66.0281 117.103 65.142 119.867 64.6884 122.525H64.8443C65.298 119.896 66.184 117.167 69.1541 114.191C72.8755 110.47 76.2212 110.024 79.4535 109.591C82.7142 109.152 86.0811 108.706 89.838 104.942C93.5948 101.186 94.0485 97.813 94.4809 94.5601C94.9133 91.3285 95.3599 87.9906 99.0813 84.2629C102.803 80.5423 106.148 80.0958 109.381 79.6635C112.641 79.2312 116.008 78.7776 119.765 75.0216C123.522 71.2656 123.976 67.8922 124.408 64.6393C124.84 61.4077 125.287 58.0698 129.008 54.3421C132.73 50.6215 136.076 50.175 139.308 49.7356C142.569 49.3033 145.936 48.8498 149.692 45.0867C153.449 41.3306 153.903 37.9573 154.342 34.7044C154.775 31.4728 155.221 28.1278 158.943 24.4072C162.664 20.6866 166.01 20.2401 169.242 19.8078C172.503 19.3684 175.87 18.9219 179.627 15.1588C183.391 11.3957 183.837 8.0294 184.277 4.77653C184.482 3.22451 184.702 1.65122 185.276 0.0212402H185.113C184.546 1.64413 184.333 3.21742 184.128 4.75527C183.695 7.98688 183.249 11.3248 179.52 15.0525Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M163.125 13.5569C159.865 13.9963 156.498 14.4428 152.741 18.2059C148.977 21.9691 148.53 25.3353 148.091 28.5882C147.658 31.8198 147.212 35.1648 143.49 38.8854C139.769 42.606 136.423 43.0525 133.191 43.4848C129.93 43.9242 126.563 44.3707 122.799 48.1338C119.043 51.8898 118.589 55.2632 118.157 58.516C117.724 61.7477 117.278 65.0856 113.556 68.8133C109.835 72.5339 106.489 72.9804 103.257 73.4126C99.9961 73.8449 96.6291 74.2985 92.8723 78.0546C89.1154 81.8106 88.6618 85.1839 88.2294 88.4368C87.797 91.6684 87.3504 95.0063 83.629 98.734C79.9076 102.455 76.5619 102.901 73.3296 103.333C70.0689 103.766 66.702 104.219 62.9451 107.982C59.1883 111.738 58.7346 115.112 58.3022 118.365C58.1179 119.725 57.9336 121.1 57.5012 122.518H57.6643C58.0825 121.107 58.2739 119.732 58.4511 118.386C58.8835 115.154 59.33 111.816 63.0514 108.089C66.7728 104.368 70.1186 103.922 73.3509 103.489C76.6115 103.057 79.9785 102.603 83.7353 98.8403C87.4922 95.0843 87.9459 91.711 88.3782 88.4581C88.8106 85.2265 89.2572 81.8886 92.9786 78.1609C96.7 74.4402 100.046 73.9938 103.278 73.5615C106.539 73.1292 109.906 72.6756 113.663 68.9125C117.426 65.1564 117.873 61.7831 118.305 58.5302C118.738 55.2986 119.184 51.9607 122.906 48.233C126.627 44.5124 129.973 44.0659 133.205 43.6336C136.466 43.1942 139.833 42.7478 143.59 38.9846C147.354 35.2215 147.8 31.8552 148.24 28.6024C148.672 25.3707 149.119 22.0257 152.84 18.3051C156.561 14.5845 159.907 14.1381 163.139 13.7058C166.4 13.2664 169.767 12.8199 173.524 9.05677C176.77 5.81098 177.55 2.85576 177.983 0.00683594H177.827C177.394 2.82032 176.615 5.74012 173.411 8.94338C169.703 12.6782 166.358 13.1246 163.125 13.5569Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M161.983 12.4089C158.722 12.8482 155.355 13.2947 151.599 17.0578C147.835 20.821 147.388 24.1872 146.949 27.4401C146.516 30.6717 146.07 34.0167 142.348 37.7373C138.627 41.4579 135.281 41.9044 132.049 42.3367C128.788 42.7761 125.421 43.2226 121.657 46.9857C117.9 50.7417 117.447 54.1151 117.014 57.368C116.582 60.5996 116.135 63.9375 112.414 67.6652C108.693 71.3858 105.347 71.8323 102.115 72.2646C98.8539 72.6969 95.4869 73.1504 91.7301 76.9136C87.9732 80.6696 87.5196 84.043 87.0872 87.2958C86.6548 90.5274 86.2082 93.8654 82.4868 97.593C78.7654 101.314 75.4197 101.76 72.1874 102.192C68.9267 102.632 65.5597 103.078 61.8029 106.841C58.0461 110.597 57.5924 113.971 57.16 117.224C56.9332 118.946 56.6922 120.696 55.9621 122.518H56.1322C56.8481 120.703 57.0891 118.953 57.316 117.238C57.7483 114.006 58.1949 110.668 61.9163 106.941C65.6377 103.22 68.9834 102.774 72.2157 102.341C75.4764 101.902 78.8434 101.455 82.6002 97.6923C86.3571 93.9362 86.8107 90.5629 87.2431 87.31C87.6755 84.0784 88.1221 80.7405 91.8435 77.0128C95.5649 73.2922 98.9106 72.8457 102.143 72.4134C105.404 71.9811 108.771 71.5275 112.527 67.7715C116.291 64.0155 116.738 60.6421 117.177 57.3892C117.61 54.1576 118.056 50.8197 121.778 47.092C125.499 43.3714 128.845 42.9249 132.077 42.4926C135.338 42.0532 138.705 41.6068 142.462 37.8436C146.226 34.0805 146.672 30.7142 147.112 27.4614C147.544 24.2298 147.991 20.8848 151.712 17.1641C155.433 13.4435 158.779 12.9971 162.011 12.5648C165.272 12.1254 168.639 11.6789 172.396 7.91578C175.21 5.10229 176.174 2.50849 176.656 0.013916H176.5C176.018 2.47306 175.061 5.03851 172.29 7.80947C168.554 11.5301 165.215 11.9766 161.983 12.4089Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M160.842 11.2679C157.582 11.7002 154.215 12.1537 150.458 15.9169C146.694 19.68 146.247 23.0462 145.808 26.2991C145.375 29.5307 144.929 32.8687 141.2 36.5963C137.479 40.317 134.133 40.7634 130.901 41.1957C127.64 41.6351 124.273 42.0816 120.516 45.8447C116.76 49.6078 116.306 52.9741 115.866 56.227C115.434 59.4586 114.987 62.7965 111.266 66.5242C107.545 70.2448 104.199 70.6913 100.967 71.1236C97.7059 71.5559 94.3389 72.0094 90.5821 75.7655C86.8252 79.5215 86.3716 82.8949 85.9392 86.1478C85.5068 89.3794 85.0602 92.7173 81.3388 96.445C77.6174 100.166 74.2717 100.612 71.0394 101.044C67.7787 101.477 64.4117 101.93 60.6549 105.693C56.898 109.449 56.4444 112.823 56.012 116.076C55.7356 118.152 55.4449 120.278 54.2895 122.518H54.4667C55.6009 120.285 55.8915 118.166 56.1679 116.097C56.6003 112.865 57.0469 109.52 60.7683 105.8C64.4897 102.079 67.8354 101.633 71.0677 101.2C74.3284 100.768 77.6954 100.314 81.4522 96.5584C85.2091 92.8023 85.6627 89.429 86.0951 86.1761C86.5275 82.9445 86.9741 79.6066 90.6955 75.8789C94.4169 72.1583 97.7626 71.7118 100.995 71.2795C104.256 70.8472 107.623 70.3936 111.379 66.6305C115.143 62.8745 115.59 59.5011 116.029 56.2482C116.462 53.0166 116.908 49.6787 120.63 45.951C124.351 42.2304 127.697 41.7839 130.929 41.3516C134.19 40.9123 137.557 40.4658 141.314 36.7026C145.078 32.9395 145.524 29.5733 145.964 26.3204C146.396 23.0888 146.843 19.7438 150.564 16.0232C154.285 12.3026 157.631 11.8561 160.863 11.4238C164.124 10.9915 167.491 10.5379 171.248 6.77479C173.637 4.38652 174.686 2.16124 175.253 0.013916H175.09C174.53 2.1258 173.488 4.32273 171.135 6.6614C167.413 10.3891 164.075 10.8356 160.842 11.2679Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M159.694 10.1269C156.433 10.5663 153.066 11.0127 149.31 14.7759C145.546 18.539 145.099 21.9053 144.66 25.1581C144.227 28.3897 143.781 31.7348 140.052 35.4554C136.331 39.176 132.985 39.6224 129.753 40.0547C126.492 40.4941 123.125 40.9406 119.368 44.7037C115.611 48.4598 115.158 51.8331 114.725 55.086C114.293 58.3176 113.846 61.6555 110.125 65.3832C106.404 69.1038 103.058 69.5503 99.8256 69.9826C96.5649 70.4149 93.1979 70.8685 89.4411 74.6245C85.6842 78.3805 85.2306 81.7539 84.7982 85.0068C84.3658 88.2384 83.9192 91.5763 80.1978 95.304C76.4764 99.0246 73.1307 99.4711 69.8984 99.9034C66.6377 100.336 63.2708 100.789 59.5139 104.552C55.7571 108.308 55.3034 111.682 54.871 114.935C54.545 117.365 54.2118 119.853 52.4893 122.518H52.6736C54.3677 119.86 54.7009 117.373 55.027 114.956C55.4594 111.724 55.9059 108.386 59.6273 104.659C63.3487 100.938 66.6945 100.492 69.9268 100.059C73.1874 99.6199 76.5544 99.1734 80.3113 95.4103C84.0681 91.6542 84.5217 88.2809 84.9541 85.028C85.3865 81.7964 85.8331 78.4585 89.5545 74.7308C93.2759 71.0102 96.6216 70.5637 99.8539 70.1314C103.115 69.6991 106.482 69.2456 110.238 65.4824C113.995 61.7264 114.449 58.353 114.881 55.1002C115.314 51.8686 115.76 48.5306 119.482 44.8029C123.203 41.0823 126.549 40.6359 129.781 40.2036C133.042 39.7642 136.409 39.3177 140.166 35.5546C143.93 31.7914 144.376 28.4252 144.816 25.1723C145.248 21.9407 145.695 18.5957 149.416 14.8751C153.137 11.1545 156.483 10.708 159.715 10.2757C162.976 9.83632 166.343 9.38985 170.1 5.62672C172.063 3.66365 173.127 1.79981 173.75 0.013916H173.587C172.964 1.77146 171.914 3.59279 169.994 5.52042C166.272 9.24811 162.926 9.69458 159.694 10.1269Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M158.553 8.97905C155.293 9.41843 151.926 9.86491 148.169 13.628C144.412 17.3912 143.958 20.7574 143.519 24.0103C143.086 27.2419 142.64 30.5869 138.911 34.3075C135.19 38.0281 131.844 38.4746 128.612 38.9069C125.351 39.3463 121.984 39.7928 118.227 43.5559C114.463 47.3119 114.017 50.6853 113.584 53.9382C113.152 57.1698 112.705 60.5077 108.984 64.2354C105.263 67.956 101.917 68.4025 98.6846 68.8348C95.424 69.2671 92.057 69.7206 88.3001 73.4837C84.5433 77.2398 84.0896 80.6131 83.6572 83.866C83.2248 87.0976 82.7783 90.4356 79.0569 94.1632C75.3355 97.8839 71.9897 98.3303 68.7574 98.7626C65.4968 99.202 62.1298 99.6485 58.3729 103.412C54.6161 107.168 54.1624 110.541 53.7301 113.794C53.3615 116.565 52.9716 119.414 50.519 122.525H50.7175C53.1275 119.428 53.5103 116.579 53.8789 113.815C54.3113 110.584 54.7579 107.246 58.4793 103.518C62.2007 99.7973 65.5464 99.3508 68.7787 98.9185C72.0394 98.4791 75.4064 98.0327 79.1632 94.2695C82.92 90.5135 83.3737 87.1401 83.8061 83.8873C84.2385 80.6557 84.6851 77.3177 88.4065 73.59C92.1279 69.8694 95.4736 69.423 98.7059 68.9907C101.967 68.5584 105.334 68.1048 109.09 64.3488C112.847 60.5927 113.301 57.2194 113.733 53.9665C114.166 50.7349 114.612 47.397 118.334 43.6693C122.055 39.9487 125.401 39.5022 128.633 39.0699C131.894 38.6305 135.261 38.184 139.025 34.4209C142.781 30.6578 143.235 27.2915 143.675 24.0386C144.107 20.807 144.554 17.462 148.282 13.7414C152.004 10.0208 155.349 9.57434 158.582 9.14204C161.842 8.70266 165.209 8.25618 168.966 4.49306C170.518 2.94103 171.504 1.45988 172.156 0.0212402H171.986C171.334 1.42444 170.37 2.87016 168.86 4.38675C165.131 8.10027 161.785 8.54675 158.553 8.97905Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M157.412 7.83806C154.151 8.27036 150.784 8.72392 147.028 12.487C143.271 16.2502 142.817 19.6164 142.378 22.8693C141.945 26.1009 141.499 29.4459 137.777 33.1665C134.056 36.8871 130.71 37.3336 127.478 37.7659C124.217 38.2053 120.85 38.6518 117.093 42.4149C113.329 46.1709 112.883 49.5443 112.45 52.7972C112.018 56.0288 111.572 59.3667 107.85 63.0944C104.129 66.815 100.783 67.2615 97.5507 67.6938C94.29 68.1261 90.923 68.5796 87.1662 72.3428C83.4093 76.0988 82.9557 79.4722 82.5233 82.725C82.0909 85.9566 81.6443 89.2946 77.9229 93.0223C74.2015 96.7429 70.8558 97.1893 67.6235 97.6216C64.3628 98.061 60.9958 98.5075 57.239 102.271C53.4822 106.027 53.0285 109.4 52.5961 112.653C52.1779 115.764 51.7455 118.974 48.3998 122.525H48.6124C51.9014 118.981 52.3338 115.778 52.7521 112.674C53.1844 109.443 53.631 106.105 57.3524 102.377C61.0738 98.6563 64.4195 98.2098 67.6518 97.7775C70.9125 97.3382 74.2795 96.8917 78.0363 93.1286C81.7932 89.3725 82.2468 85.9992 82.6792 82.7463C83.1116 79.5147 83.5582 76.1768 87.2796 72.4491C91.001 68.7285 94.3467 68.282 97.579 67.8497C100.84 67.4174 104.207 66.9638 107.964 63.2078C111.72 59.4517 112.174 56.0784 112.606 52.8255C113.039 49.5939 113.485 46.256 117.207 42.5283C120.928 38.8077 124.274 38.3612 127.506 37.9289C130.767 37.4966 134.134 37.0431 137.898 33.2799C141.655 29.5168 142.108 26.1505 142.541 22.8977C142.973 19.666 143.42 16.321 147.148 12.6004C150.87 8.87983 154.215 8.43336 157.448 8.00106C160.708 7.56876 164.075 7.1152 167.832 3.35207C168.98 2.21108 169.81 1.09844 170.433 0.0212402H170.249C169.632 1.06301 168.824 2.14021 167.719 3.23868C163.983 6.95929 160.644 7.40576 157.412 7.83806Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M156.263 6.69684C153.003 7.13622 149.636 7.5827 145.879 11.3458C142.115 15.1019 141.668 18.4752 141.229 21.7281C140.796 24.9597 140.35 28.3047 136.629 32.0253C132.907 35.7459 129.561 36.1924 126.329 36.6318C123.068 37.0641 119.701 37.5176 115.945 41.2808C112.188 45.0368 111.734 48.4102 111.302 51.663C110.869 54.8947 110.423 58.2326 106.701 61.9603C102.98 65.6809 99.6342 66.1273 96.4019 66.5596C93.1412 66.9919 89.7743 67.4455 86.0174 71.2015C82.2606 74.9576 81.8069 78.3238 81.3745 81.5838C80.9421 84.8154 80.4956 88.1533 76.7741 91.881C73.0527 95.6016 69.707 96.0481 66.4747 96.4804C63.2141 96.9198 59.8471 97.3663 56.0902 101.129C52.3334 104.885 51.8797 108.252 51.4473 111.512C51.0149 114.743 50.5684 118.081 46.847 121.809C46.5918 122.064 46.3366 122.305 46.0814 122.525H46.3153C46.528 122.333 46.7406 122.128 46.9533 121.915C50.7101 118.159 51.1638 114.786 51.5962 111.533C52.0286 108.301 52.4752 104.963 56.1966 101.236C59.918 97.5151 63.2637 97.0686 66.496 96.6363C69.7566 96.1969 73.1236 95.7505 76.8805 91.9873C80.6373 88.2313 81.091 84.865 81.5234 81.6051C81.9558 78.3735 82.4023 75.0355 86.1237 71.3078C89.8451 67.5872 93.1909 67.1408 96.4232 66.7085C99.6838 66.2762 103.051 65.8226 106.808 62.0595C110.564 58.2963 111.018 54.9301 111.451 51.6772C111.883 48.4456 112.33 45.1077 116.051 41.38C119.772 37.6594 123.118 37.2129 126.35 36.7806C129.611 36.3483 132.978 35.8947 136.735 32.1316C140.499 28.3756 140.945 25.0022 141.385 21.7494C141.817 18.5177 142.264 15.1727 145.992 11.4521C149.714 7.73152 153.059 7.28505 156.292 6.85275C159.552 6.41336 162.919 5.96689 166.676 2.20376C167.42 1.45964 168.03 0.72969 168.54 0.013916H168.356C167.867 0.694256 167.279 1.38877 166.57 2.09037C162.841 5.81806 159.496 6.26454 156.263 6.69684Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M155.122 5.54876C151.862 5.98815 148.495 6.43462 144.738 10.1977C140.974 13.9538 140.527 17.3271 140.095 20.58C139.662 23.8116 139.216 27.1566 135.487 30.8772C131.766 34.5978 128.42 35.0443 125.188 35.4766C121.927 35.916 118.56 36.3625 114.803 40.1256C111.047 43.8817 110.593 47.255 110.161 50.5079C109.728 53.7395 109.282 57.0774 105.56 60.8051C101.839 64.5257 98.4931 64.9722 95.2608 65.4045C92.0001 65.8368 88.6331 66.2903 84.8763 70.0535C81.1194 73.8095 80.6658 77.1829 80.2334 80.4357C79.801 83.6673 79.3544 87.0053 75.633 90.733C71.9116 94.4536 68.5659 94.9 65.3336 95.3323C62.0729 95.7717 58.706 96.2182 54.9491 99.9813C51.1923 103.737 50.7386 107.111 50.3062 110.364C49.8738 113.595 49.4272 116.933 45.7058 120.661C44.9616 121.405 44.2315 122.014 43.5155 122.525H43.7849C44.4512 122.036 45.1246 121.462 45.8193 120.767C49.5761 117.011 50.0298 113.645 50.4622 110.385C50.8945 107.153 51.3411 103.815 55.0625 100.088C58.7839 96.367 62.1296 95.9205 65.3619 95.4882C68.6226 95.0489 71.9896 94.6024 75.7464 90.8393C79.5033 87.0832 79.9569 83.7099 80.3893 80.457C80.8217 77.2254 81.2683 73.8875 84.9897 70.1598C88.7111 66.4392 92.0568 65.9927 95.2891 65.5604C98.5498 65.1281 101.917 64.6745 105.674 60.9185C109.43 57.1624 109.884 53.7891 110.317 50.5362C110.749 47.3046 111.195 43.9667 114.917 40.239C118.638 36.5184 121.984 36.0719 125.216 35.6396C128.477 35.2002 131.844 34.7538 135.601 30.9906C139.365 27.2346 139.811 23.8612 140.251 20.6084C140.683 17.3768 141.13 14.0317 144.858 10.3111C148.58 6.59053 151.925 6.14406 155.158 5.70467C158.418 5.26529 161.785 4.81881 165.542 1.05569C165.897 0.701343 166.208 0.361173 166.506 0.013916H166.301C166.031 0.325738 165.748 0.630474 165.436 0.949383C161.693 4.66999 158.355 5.11646 155.122 5.54876Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M143.59 9.05724C139.826 12.8204 139.38 16.1866 138.94 19.4395C138.508 22.6711 138.061 26.0161 134.34 29.7367C130.618 33.4573 127.273 33.9038 124.04 34.3361C120.78 34.7684 117.413 35.222 113.649 38.9851C109.892 42.7411 109.438 46.1145 109.006 49.3674C108.573 52.599 108.127 55.9369 104.405 59.6646C100.684 63.3852 97.3383 63.8317 94.106 64.264C90.8453 64.6963 87.4784 65.1498 83.7215 68.913C79.9647 72.669 79.511 76.0423 79.0786 79.2952C78.6462 82.5268 78.1997 85.8647 74.4783 89.5924C70.7569 93.313 67.4111 93.7595 64.1788 94.1918C60.9182 94.6312 57.5512 95.0777 53.7943 98.8408C50.0375 102.597 49.5838 105.97 49.1514 109.223C48.719 112.455 48.2725 115.793 44.5511 119.52C43.1334 120.938 41.7724 121.88 40.4469 122.525H40.7871C42.0347 121.88 43.3248 120.966 44.6574 119.627C48.4143 115.871 48.8679 112.504 49.3003 109.244C49.7327 106.013 50.1793 102.675 53.9007 98.9471C57.6221 95.2265 60.9678 94.78 64.2001 94.3477C67.4608 93.9083 70.8277 93.4619 74.5846 89.6987C78.3414 85.9427 78.7951 82.5694 79.2275 79.3165C79.6599 76.0849 80.1064 72.7469 83.8278 69.0193C87.5492 65.2986 90.895 64.8522 94.1273 64.4199C97.3879 63.9876 100.755 63.534 104.512 59.778C108.276 56.0219 108.722 52.6486 109.155 49.3957C109.587 46.1641 110.034 42.8262 113.755 39.0985C117.476 35.3779 120.822 34.9314 124.054 34.4991C127.315 34.0668 130.682 33.6132 134.439 29.8501C138.203 26.087 138.649 22.7207 139.089 19.4679C139.521 16.2362 139.968 12.8983 143.689 9.17063C147.411 5.45002 150.756 5.00355 153.989 4.57125C157.214 4.13895 160.553 3.68539 164.267 0.0285645H164.047C160.411 3.55074 157.136 3.99721 153.967 4.42242C150.721 4.84764 147.354 5.29411 143.59 9.05724Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M142.449 7.90869C138.685 11.6718 138.239 15.0381 137.799 18.291C137.367 21.5226 136.92 24.8676 133.199 28.5882C129.477 32.3088 126.132 32.7553 122.899 33.1876C119.639 33.6269 116.272 34.0734 112.508 37.8365C108.751 41.5926 108.297 44.9659 107.865 48.2188C107.433 51.4504 106.986 54.7883 103.265 58.516C99.5432 62.2366 96.1975 62.6831 92.9652 63.1154C89.7045 63.5477 86.3375 64.0013 82.5807 67.7573C78.8238 71.5134 78.3702 74.8867 77.9378 78.1396C77.5054 81.3712 77.0588 84.7091 73.3374 88.4368C69.616 92.1574 66.2703 92.6039 63.038 93.0362C59.7773 93.4685 56.4103 93.9221 52.6535 97.6852C48.8966 101.441 48.443 104.815 48.0106 108.067C47.5782 111.299 47.1316 114.637 43.4102 118.365C40.7521 121.022 38.2853 122.007 35.9107 122.518H36.5983C38.7886 121.965 41.0711 120.923 43.5236 118.478C47.2805 114.722 47.7341 111.349 48.1665 108.096C48.5989 104.864 49.0455 101.526 52.7669 97.7986C56.4883 94.078 59.834 93.6315 63.0663 93.1992C66.327 92.7669 69.694 92.3133 73.4508 88.5502C77.2077 84.7942 77.6613 81.4208 78.0937 78.1679C78.5261 74.9363 78.9727 71.5984 82.6941 67.8707C86.4155 64.1501 89.7612 63.7036 92.9935 63.2713C96.2542 62.839 99.6211 62.3855 103.378 58.6223C107.142 54.8663 107.588 51.493 108.028 48.2401C108.46 45.0085 108.907 41.6705 112.628 37.9429C116.35 34.2222 119.695 33.7758 122.928 33.3435C126.188 32.9041 129.555 32.4576 133.312 28.6945C137.076 24.9314 137.523 21.5651 137.962 18.3122C138.395 15.0806 138.841 11.7356 142.563 8.01499C146.284 4.29439 149.63 3.84791 152.862 3.41561C155.719 3.03292 158.66 2.63606 161.878 0.013916H161.63C158.504 2.50141 155.634 2.89119 152.848 3.26679C149.58 3.69909 146.206 4.15265 142.449 7.90869Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M141.306 6.7677C137.55 10.5308 137.096 13.8971 136.656 17.15C136.224 20.3816 135.777 23.7195 132.056 27.4472C128.335 31.1678 124.989 31.6143 121.757 32.0466C118.496 32.486 115.129 32.9324 111.365 36.6956C107.608 40.4587 107.155 43.825 106.722 47.0778C106.29 50.3094 105.843 53.6474 102.122 57.3751C98.4004 61.0957 95.0546 61.5421 91.8223 61.9744C88.5617 62.4067 85.1947 62.8603 81.4378 66.6234C77.681 70.3795 77.2273 73.7528 76.7949 77.0057C76.3626 80.2373 75.916 83.5752 72.1946 87.3029C68.4732 91.0235 65.1275 91.47 61.8952 91.9023C58.6345 92.3346 55.2675 92.7882 51.5107 96.5442C47.7538 100.3 47.3002 103.674 46.8678 106.926C46.4354 110.158 45.9888 113.496 42.2674 117.224C38.546 120.944 35.2003 121.391 31.968 121.823C30.7204 121.986 29.4587 122.163 28.1686 122.518H28.7995C29.8769 122.262 30.9402 122.121 31.9892 121.979C35.2499 121.547 38.6169 121.093 42.3737 117.337C46.1306 113.581 46.5842 110.215 47.0166 106.955C47.449 103.723 47.8956 100.385 51.617 96.6576C55.3384 92.937 58.6841 92.4905 61.9164 92.0582C65.1771 91.6259 68.5441 91.1723 72.3009 87.4092C76.0578 83.6532 76.5114 80.2798 76.9438 77.0269C77.3762 73.7953 77.8228 70.4574 81.5442 66.7297C85.2656 63.0091 88.6113 62.5626 91.8436 62.1303C95.1043 61.698 98.4712 61.2445 102.228 57.4884C105.992 53.7324 106.439 50.3591 106.878 47.1062C107.31 43.8746 107.757 40.5366 111.478 36.809C115.2 33.0883 118.546 32.6419 121.778 32.2096C125.039 31.7702 128.406 31.3237 132.162 27.5606C135.919 23.7975 136.373 20.4312 136.812 17.1783C137.245 13.9467 137.691 10.6017 141.413 6.88109C145.134 3.16049 148.48 2.71401 151.712 2.27463C154.087 1.95572 156.518 1.62264 159.119 0.013916H158.822C156.327 1.49507 153.98 1.81398 151.691 2.11872C148.43 2.5581 145.063 3.00458 141.306 6.7677Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M140.159 5.62696C136.402 9.383 135.949 12.7563 135.509 16.0092C135.077 19.2408 134.63 22.5858 130.909 26.3064C127.187 30.0271 123.842 30.4735 120.609 30.9058C117.349 31.3381 113.982 31.7917 110.225 35.5548C106.468 39.3109 106.014 42.6842 105.582 45.9371C105.15 49.1687 104.703 52.5066 100.982 56.2343C97.2602 59.9549 93.9145 60.4014 90.6822 60.8337C87.4216 61.266 84.0546 61.7195 80.2977 65.4827C76.5409 69.2387 76.0872 72.6121 75.6548 75.8649C75.2224 79.0965 74.7759 82.4345 71.0545 86.1622C67.3331 89.8828 63.9873 90.3292 60.755 90.7615C57.4944 91.2009 54.1274 91.6474 50.3705 95.4105C46.6137 99.1666 46.16 102.54 45.7276 105.793C45.2953 109.024 44.8487 112.362 41.1273 116.09C37.4059 119.811 34.0602 120.257 30.8279 120.689C28.6801 120.973 26.4756 121.278 24.1506 122.525H24.4837C26.6953 121.398 28.7935 121.115 30.8491 120.845C34.1098 120.413 37.4768 119.959 41.2336 116.196C44.9905 112.44 45.4441 109.067 45.8765 105.814C46.3089 102.582 46.7555 99.2445 50.4769 95.5168C54.1983 91.7962 57.544 91.3498 60.7763 90.9175C64.037 90.4781 67.4039 90.0316 71.1608 86.2685C74.9176 82.5124 75.3713 79.1391 75.8037 75.8862C76.2361 72.6546 76.6826 69.3167 80.4041 65.589C84.1255 61.8684 87.4712 61.4219 90.7035 60.9896C93.9641 60.5573 97.3311 60.1037 101.088 56.3477C104.852 52.5916 105.298 49.2183 105.731 45.9654C106.163 42.7338 106.61 39.3959 110.331 35.6682C114.053 31.9476 117.398 31.5011 120.631 31.0688C123.891 30.6365 127.258 30.183 131.015 26.4198C134.772 22.6638 135.226 19.2904 135.658 16.0376C136.09 12.806 136.537 9.46095 140.266 5.74035C143.987 2.01974 147.333 1.57327 150.565 1.13388C152.224 0.914186 153.911 0.680319 155.669 0.0212402H155.208C153.613 0.566929 152.068 0.779536 150.544 0.985055C147.29 1.41735 143.923 1.86383 140.159 5.62696Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M134.367 14.8683C133.935 18.0999 133.488 21.4449 129.76 25.1655C126.038 28.8861 122.693 29.3326 119.46 29.7649C116.2 30.1972 112.833 30.6507 109.076 34.4139C105.319 38.1699 104.865 41.5432 104.433 44.7961C104.001 48.0277 103.554 51.3656 99.8327 55.0933C96.1113 58.8139 92.7656 59.2604 89.5333 59.6927C86.2726 60.125 82.9056 60.5786 79.1488 64.3346C75.392 68.0907 74.9383 71.464 74.5059 74.7169C74.0735 77.9485 73.6269 81.2864 69.9055 85.0141C66.1841 88.7347 62.8384 89.1812 59.6061 89.6135C56.3455 90.0458 52.9785 90.4994 49.2216 94.2625C45.4648 98.0185 45.0111 101.392 44.5787 104.645C44.1463 107.876 43.6998 111.214 39.9784 114.942C36.257 118.663 32.9112 119.109 29.6789 119.541C26.9853 119.903 24.2138 120.278 21.2154 122.518H21.4706C24.3839 120.406 27.0775 120.045 29.7002 119.69C32.9609 119.258 36.3278 118.804 40.0847 115.041C43.8415 111.285 44.2952 107.912 44.7276 104.659C45.16 101.427 45.6065 98.0894 49.3279 94.3617C53.0493 90.6411 56.3951 90.1946 59.6274 89.7623C62.888 89.33 66.255 88.8765 70.0119 85.1133C73.7687 81.3573 74.2224 77.9839 74.6548 74.7311C75.0872 71.4994 75.5337 68.1615 79.2551 64.4338C82.9765 60.7132 86.3223 60.2668 89.5546 59.8345C92.8152 59.4022 96.1822 58.9486 99.939 55.1855C103.703 51.4294 104.15 48.0561 104.589 44.8032C105.021 41.5716 105.468 38.2337 109.189 34.506C112.911 30.7854 116.257 30.3389 119.489 29.9066C122.749 29.4672 126.116 29.0207 129.873 25.2576C133.63 21.5016 134.084 18.1282 134.516 14.8753C134.949 11.6437 135.395 8.29873 139.124 4.57812C142.767 0.935467 146.049 0.425212 149.218 0H148.112C145.255 0.432299 142.278 1.19768 139.01 4.46473C135.253 8.24203 134.807 11.6083 134.367 14.8683Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M133.226 13.7204C132.794 16.952 132.347 20.297 128.619 24.0176C124.897 27.7382 121.552 28.1847 118.319 28.617C115.059 29.0564 111.692 29.5029 107.935 33.266C104.171 37.022 103.724 40.3954 103.285 43.6483C102.852 46.8799 102.406 50.2178 98.6845 53.9455C94.9631 57.6661 91.6174 58.1126 88.3851 58.5449C85.1244 58.9772 81.7575 59.4307 78.0006 63.1938C74.2438 66.9499 73.7901 70.3232 73.3577 73.5761C72.9253 76.8077 72.4788 80.1456 68.7573 83.8733C65.0359 87.5939 61.6902 88.0404 58.4579 88.4727C55.1973 88.9121 51.8303 89.3586 48.0734 93.1217C44.3166 96.8777 43.8629 100.251 43.4305 103.504C42.9981 106.736 42.5516 110.073 38.8302 113.801C35.1088 117.522 31.763 117.968 28.5307 118.401C25.4331 118.812 22.2362 119.251 18.692 122.525H18.9189C22.378 119.386 25.5111 118.96 28.552 118.556C31.8127 118.124 35.1796 117.671 38.9365 113.915C42.6933 110.159 43.147 106.785 43.5794 103.532C44.0118 100.301 44.4583 96.9628 48.1797 93.2351C51.9012 89.5145 55.2469 89.068 58.4792 88.6357C61.7398 88.1963 65.1068 87.7499 68.8637 83.9867C72.6205 80.2307 73.0742 76.8573 73.5066 73.6045C73.939 70.3728 74.3855 67.0349 78.1069 63.3072C81.8283 59.5866 85.1741 59.1402 88.4064 58.7079C91.667 58.2756 95.034 57.822 98.7909 54.066C102.548 50.3099 103.001 46.9366 103.441 43.6837C103.873 40.4521 104.32 37.1142 108.041 33.3865C111.763 29.6659 115.108 29.2194 118.341 28.7871C121.601 28.3477 124.968 27.9012 128.732 24.1381C132.489 20.3821 132.943 17.0087 133.375 13.7558C133.808 10.5242 134.254 7.17922 137.983 3.45861C139.748 1.68689 141.435 0.666383 143.058 0.0285645H142.64C141.109 0.680557 139.528 1.69398 137.876 3.35231C134.112 7.10126 133.659 10.4675 133.226 13.7204Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M132.085 12.5789C131.652 15.8106 131.206 19.1556 127.477 22.8762C123.756 26.5968 120.41 27.0432 117.178 27.4755C113.917 27.9078 110.55 28.3614 106.793 32.1245C103.029 35.8806 102.583 39.2539 102.143 42.5068C101.711 45.7384 101.264 49.0763 97.5428 52.804C93.8214 56.5246 90.4757 56.9711 87.2434 57.4034C83.9827 57.8357 80.6158 58.2893 76.8589 62.0524C73.1021 65.8084 72.6484 69.1747 72.216 72.4347C71.7836 75.6663 71.3371 79.0042 67.6157 82.7319C63.8942 86.4525 60.5485 86.899 57.3162 87.3313C54.0556 87.7707 50.6886 88.2171 46.9317 91.9803C43.1749 95.7363 42.7212 99.1096 42.2888 102.363C41.8564 105.594 41.4099 108.932 37.6885 112.66C33.9671 116.38 30.6213 116.827 27.389 117.259C24.1284 117.691 20.7614 118.145 17.0046 121.901C16.799 122.107 16.6005 122.312 16.4162 122.518H16.6289C16.7848 122.347 16.9408 122.177 17.118 122.007C20.8394 118.287 24.1851 117.84 27.4174 117.408C30.6781 116.976 34.045 116.522 37.8019 112.759C41.5587 109.003 42.0124 105.63 42.4448 102.377C42.8772 99.1451 43.3237 95.8072 47.0451 92.0795C50.7665 88.3589 54.1123 87.9124 57.3446 87.4801C60.6052 87.0407 63.9722 86.5942 67.7291 82.8311C71.4859 79.0751 71.9396 75.7088 72.372 72.4488C72.8044 69.2172 73.2509 65.8793 76.9723 62.1516C80.6937 58.431 84.0394 57.9845 87.2718 57.5522C90.5324 57.1199 93.8994 56.6664 97.6563 52.9103C101.413 49.1472 101.867 45.7809 102.306 42.5281C102.739 39.2965 103.185 35.9585 106.907 32.2308C110.628 28.5102 113.974 28.0638 117.206 27.6244C120.467 27.1921 123.834 26.7385 127.598 22.9754C131.354 19.2193 131.808 15.846 132.24 12.5931C132.673 9.36151 133.119 6.0165 136.848 2.2959C137.812 1.33208 138.755 0.587959 139.669 0.00683594H139.386C138.521 0.573786 137.642 1.28247 136.742 2.18959C132.971 5.95272 132.517 9.31898 132.085 12.5789Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M130.936 11.438C130.504 14.6696 130.058 18.0146 126.329 21.7352C122.608 25.4558 119.262 25.9023 116.03 26.3346C112.769 26.7739 109.402 27.2204 105.645 30.9835C101.881 34.7396 101.435 38.1129 101.002 41.3658C100.57 44.5974 100.123 47.9353 96.4018 51.663C92.6804 55.3836 89.3347 55.8301 86.1024 56.2624C82.8417 56.6947 79.4748 57.1483 75.7179 60.9043C71.9611 64.6604 71.5074 68.0337 71.075 71.2866C70.6426 74.5182 70.196 77.8561 66.4746 81.5838C62.7532 85.3044 59.4075 85.7509 56.1752 86.1832C52.9146 86.6155 49.5476 87.069 45.7907 90.8322C42.0339 94.5882 41.5802 97.9616 41.1478 101.214C40.7154 104.446 40.2689 107.784 36.5475 111.512C32.8261 115.232 29.4803 115.679 26.248 116.111C22.9874 116.543 19.6204 116.997 15.8635 120.76C15.2681 121.355 14.7577 121.944 14.3183 122.525H14.5167C14.942 121.979 15.417 121.433 15.977 120.866C19.6984 117.146 23.0441 116.699 26.2764 116.267C29.537 115.835 32.904 115.381 36.6609 111.625C40.4177 107.869 40.8714 104.496 41.3038 101.243C41.7362 98.0112 42.1827 94.6733 45.9041 90.9456C49.6255 87.225 52.9713 86.7785 56.2036 86.3462C59.4642 85.9139 62.8312 85.4603 66.5881 81.6972C70.3449 77.9412 70.7986 74.5678 71.231 71.3149C71.6633 68.0833 72.1099 64.7454 75.8313 61.0177C79.5527 57.2971 82.8984 56.8506 86.1307 56.4183C89.3914 55.986 92.7584 55.5325 96.5152 51.7693C100.272 48.0133 100.726 44.6399 101.158 41.3871C101.591 38.1555 102.037 34.8175 105.758 31.0898C109.48 27.3692 112.826 26.9228 116.058 26.4905C119.319 26.0511 122.686 25.6046 126.442 21.8415C130.206 18.0854 130.653 14.7121 131.092 11.4592C131.525 8.2276 131.971 4.8826 135.7 1.16199C136.125 0.736777 136.543 0.361173 136.954 0.013916H136.721C136.345 0.332825 135.969 0.665908 135.586 1.0486C131.823 4.81173 131.376 8.17799 130.936 11.438Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M125.188 20.5871C121.467 24.3077 118.121 24.7542 114.889 25.1865C111.628 25.6259 108.261 26.0723 104.504 29.8355C100.74 33.5915 100.294 36.9649 99.8541 40.2177C99.4217 43.4493 98.9751 46.7873 95.2537 50.515C91.5323 54.2356 88.1866 54.682 84.9543 55.1143C81.6936 55.5466 78.3267 56.0002 74.5698 59.7633C70.813 63.5194 70.3593 66.8927 69.9269 70.1456C69.4945 73.3772 69.048 76.7151 65.3266 80.4428C61.6052 84.1634 58.2594 84.6099 55.0271 85.0422C51.7665 85.4816 48.3995 85.9281 44.6426 89.6912C40.8858 93.4472 40.4321 96.8206 39.9997 100.073C39.5674 103.305 39.1208 106.643 35.3994 110.371C31.678 114.091 28.3323 114.538 25.0999 114.97C21.8393 115.402 18.4723 115.856 14.7155 119.619C13.7231 120.611 12.9646 121.582 12.3692 122.525H12.5535C13.1347 121.618 13.8719 120.682 14.8289 119.725C18.5503 116.005 21.896 115.558 25.1283 115.126C28.389 114.694 31.7559 114.24 35.5128 110.477C39.2696 106.721 39.7233 103.348 40.1557 100.095C40.5881 96.8631 41.0347 93.5252 44.7561 89.7975C48.4775 86.0769 51.8232 85.6304 55.0555 85.1981C58.3161 84.7587 61.6831 84.3122 65.44 80.5491C69.1968 76.7931 69.6505 73.4197 70.0829 70.1669C70.5153 66.9352 70.9618 63.5973 74.6832 59.8696C78.4046 56.149 81.7504 55.7026 84.9827 55.2703C88.2433 54.838 91.6103 54.3844 95.3672 50.6213C99.124 46.8652 99.5777 43.4919 100.01 40.239C100.442 37.0074 100.889 33.6695 104.61 29.9418C108.332 26.2212 111.678 25.7747 114.91 25.3424C118.171 24.903 121.537 24.4565 125.294 20.6934C129.051 16.9374 129.505 13.564 129.944 10.3111C130.377 7.07953 130.823 3.73452 134.545 0.013916H134.332C130.667 3.72744 130.221 7.06535 129.788 10.2899C129.363 13.5215 128.917 16.8665 125.188 20.5871Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M19.0191 109.024C22.2797 108.592 25.6467 108.138 29.4035 104.375C33.1604 100.619 33.614 97.2458 34.0464 93.9929C34.4788 90.7613 34.9254 87.4234 38.6468 83.6957C42.3682 79.9751 45.7139 79.5286 48.9462 79.0963C52.2069 78.664 55.5739 78.2105 59.3307 74.4473C63.0876 70.6913 63.5412 67.3179 63.9736 64.0651C64.406 60.8335 64.8526 57.4955 68.574 53.7678C72.2954 50.0472 75.6411 49.6008 78.8734 49.1685C82.1341 48.7362 85.5011 48.2826 89.2579 44.5195C93.0147 40.7634 93.4684 37.3901 93.9008 34.1372C94.3332 30.9056 94.7798 27.5677 98.5012 23.84C102.223 20.1194 105.568 19.6729 108.801 19.2406C112.061 18.8012 115.428 18.3547 119.185 14.5916C122.942 10.8285 123.396 7.46222 123.835 4.20935C124.019 2.8345 124.211 1.43838 124.65 0.00683594H124.487C124.055 1.4313 123.863 2.82032 123.686 4.18809C123.254 7.4197 122.807 10.7647 119.079 14.4853C115.357 18.2059 112.012 18.6524 108.779 19.0847C105.519 19.517 102.152 19.9706 98.3948 23.7337C94.638 27.4897 94.1843 30.8631 93.7519 34.1159C93.3195 37.3476 92.873 40.6855 89.1516 44.4132C85.4302 48.1338 82.0845 48.5803 78.8521 49.0126C75.5915 49.4449 72.2245 49.8984 68.4677 53.6545C64.7108 57.4105 64.2571 60.7838 63.8248 64.0367C63.3924 67.2683 62.9458 70.6063 59.2244 74.3339C55.503 78.0546 52.1573 78.501 48.925 78.9333C45.6643 79.3656 42.2973 79.8192 38.5405 83.5823C34.7836 87.3384 34.33 90.7117 33.8976 93.9646C33.4652 97.1962 33.0186 100.534 29.2972 104.262C25.5758 107.982 22.2301 108.429 18.9978 108.861C15.7371 109.293 12.3701 109.747 8.6133 113.503C5.9268 116.189 4.92733 118.684 4.42406 121.072C4.47368 121.1 4.51621 121.129 4.56582 121.157C5.0691 118.769 6.0473 116.288 8.72671 113.609C12.4481 109.903 15.7867 109.456 19.0191 109.024Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M17.8763 107.883C21.1369 107.451 24.5039 106.997 28.2608 103.241C32.0176 99.4852 32.4713 96.1119 32.9037 92.859C33.3361 89.6274 33.7826 86.2895 37.504 82.5618C41.2254 78.8412 44.5712 78.3947 47.8035 77.9624C51.0641 77.523 54.4311 77.0766 58.188 73.3134C61.9448 69.5574 62.3985 66.184 62.8309 62.9312C63.2632 59.6995 63.7098 56.3616 67.4312 52.6339C71.1526 48.9133 74.4983 48.4669 77.7306 48.0346C80.9913 47.6023 84.3583 47.1487 88.1151 43.3856C91.872 39.6295 92.3256 36.2562 92.758 33.0033C93.1904 29.7717 93.637 26.4338 97.3584 22.7061C101.08 18.9855 104.426 18.539 107.658 18.1067C110.918 17.6673 114.285 17.2208 118.042 13.4577C121.806 9.69458 122.253 6.32832 122.692 3.07544C122.827 2.06911 122.962 1.05569 123.196 0.013916H123.04C122.806 1.04151 122.671 2.05493 122.536 3.05418C122.104 6.2858 121.657 9.6308 117.929 13.3514C114.208 17.072 110.862 17.5185 107.629 17.9508C104.369 18.3902 101.002 18.8366 97.245 22.5998C93.4881 26.3558 93.0345 29.7292 92.6021 32.982C92.1697 36.2137 91.7231 39.5516 88.0017 43.2793C84.2803 46.9999 80.9346 47.4463 77.7023 47.8786C74.4416 48.3109 71.0746 48.7645 67.3178 52.5205C63.561 56.2766 63.1073 59.6499 62.6749 62.9028C62.2425 66.1344 61.7959 69.4723 58.0745 73.2C54.3531 76.9206 51.0074 77.3671 47.7751 77.7994C44.5145 78.2317 41.1475 78.6853 37.3906 82.4484C33.6338 86.2044 33.1801 89.5778 32.7477 92.8307C32.3153 96.0623 31.8688 99.4002 28.1474 103.128C24.426 106.849 21.0802 107.295 17.8479 107.727C14.5873 108.16 11.2203 108.613 7.46344 112.369C4.67771 115.154 3.71369 117.727 3.2175 120.193C3.26003 120.229 3.30256 120.278 3.35218 120.314C3.83419 117.84 4.78403 115.268 7.57686 112.475C11.2983 108.762 14.644 108.315 17.8763 107.883Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M16.7284 106.742C19.989 106.31 23.356 105.857 27.1129 102.093C30.8697 98.3374 31.3234 94.9641 31.7558 91.7112C32.1882 88.4796 32.6347 85.1417 36.3561 81.414C40.0775 77.6933 43.4233 77.2469 46.6556 76.8146C49.9162 76.3752 53.2832 75.9287 57.04 72.1656C60.7969 68.4095 61.2506 65.0362 61.6829 61.7833C62.1153 58.5517 62.5619 55.2138 66.2833 51.4861C70.0047 47.7655 73.3504 47.319 76.5827 46.8867C79.8434 46.4544 83.2104 46.0009 86.9672 42.2448C90.7241 38.4888 91.1777 35.1154 91.6101 31.8626C92.0425 28.6309 92.4891 25.293 96.2105 21.5653C99.9319 17.8447 103.278 17.3982 106.51 16.9659C109.771 16.5266 113.138 16.0801 116.894 12.317C120.658 8.55383 121.105 5.18757 121.537 1.9347C121.622 1.30396 121.707 0.666146 121.821 0.0212402H121.665C121.559 0.659059 121.474 1.28979 121.388 1.91343C120.956 5.14505 120.51 8.48296 116.781 12.2107C113.06 15.9313 109.714 16.3777 106.482 16.81C103.221 17.2494 99.8539 17.6959 96.0971 21.459C92.3402 25.2151 91.8866 28.5884 91.4542 31.8413C91.0218 35.0729 90.5752 38.4108 86.8538 42.1385C83.1324 45.8591 79.7867 46.3056 76.5544 46.7379C73.2937 47.1702 69.9267 47.6238 66.1699 51.3869C62.413 55.1429 61.9594 58.5163 61.527 61.7691C61.0946 65.0008 60.648 68.3387 56.9266 72.0664C53.2052 75.787 49.8595 76.2335 46.6272 76.6658C43.3665 77.1051 39.9996 77.5516 36.2427 81.3147C32.4859 85.0708 32.0322 88.4441 31.5998 91.697C31.1674 94.9286 30.7209 98.2665 26.9995 101.994C23.278 105.715 19.9323 106.161 16.7 106.594C13.4394 107.026 10.0724 107.479 6.31553 111.236C3.54397 114.006 2.57286 116.565 2.07668 119.024C2.11921 119.074 2.16174 119.13 2.20427 119.18C2.68628 116.707 3.63612 114.134 6.42895 111.342C10.1574 107.621 13.4961 107.175 16.7284 106.742Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M15.5889 105.594C18.8495 105.155 22.2165 104.708 25.9734 100.945C29.7302 97.1891 30.1839 93.8158 30.6163 90.5629C31.0487 87.3313 31.4952 83.9933 35.2166 80.2657C38.938 76.545 42.2837 76.0986 45.5161 75.6663C48.7767 75.234 52.1437 74.7804 55.9005 71.0173C59.6574 67.2612 60.111 63.8879 60.5434 60.635C60.9758 57.4034 61.4224 54.0655 65.1438 50.3378C68.8652 46.6172 72.2109 46.1707 75.4432 45.7384C78.7039 45.3061 82.0709 44.8526 85.8277 41.0894C89.5846 37.3334 90.0382 33.96 90.4706 30.7072C90.903 27.4755 91.3496 24.1376 95.071 20.4099C98.7924 16.6893 102.138 16.2429 105.37 15.8106C108.631 15.3712 111.998 14.9247 115.755 11.1616C119.519 7.39844 119.965 4.03218 120.398 0.779305C120.433 0.524177 120.469 0.26905 120.504 0.00683594H120.348C120.313 0.254876 120.277 0.510004 120.249 0.758044C119.817 3.98966 119.37 7.33466 115.642 11.0553C111.92 14.7759 108.574 15.2223 105.342 15.6546C102.081 16.0869 98.7144 16.5405 94.9576 20.3036C91.2007 24.0597 90.7471 27.433 90.3147 30.6859C89.8823 33.9175 89.4357 37.2554 85.7143 40.9831C81.9929 44.7037 78.6472 45.1502 75.4149 45.5825C72.1542 46.0148 68.7872 46.4684 65.0304 50.2244C61.2735 53.9804 60.8199 57.3538 60.3875 60.6067C59.9551 63.8383 59.5085 67.1762 55.7871 70.9039C52.0657 74.6245 48.72 75.071 45.4877 75.5033C42.227 75.9356 38.8601 76.3891 35.1032 80.1523C31.3464 83.9083 30.8927 87.2817 30.4603 90.5345C30.0279 93.7661 29.5814 97.1041 25.8599 100.832C22.1385 104.552 18.7928 104.999 15.5605 105.431C12.2999 105.871 8.93287 106.317 5.17603 110.08C2.58168 112.674 1.56095 115.083 1.03641 117.394C1.07185 117.472 1.10729 117.55 1.14982 117.621C1.66019 115.268 2.65256 112.823 5.28944 110.186C9.01793 106.473 12.3566 106.026 15.5889 105.594Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M14.4462 104.453C17.7068 104.021 21.0738 103.567 24.8307 99.8113C28.5875 96.0552 29.0412 92.6819 29.4736 89.429C29.906 86.1974 30.3525 82.8594 34.0739 79.1318C37.7953 75.4111 41.1411 74.9647 44.3734 74.5324C47.634 74.1001 51.001 73.6465 54.7579 69.8834C58.5147 66.1273 58.9684 62.754 59.4007 59.5011C59.8331 56.2695 60.2797 52.9316 64.0011 49.2039C67.7225 45.4833 71.0682 45.0368 74.3005 44.6045C77.5612 44.1722 80.9282 43.7187 84.685 39.9555C88.4419 36.1995 88.8955 32.8261 89.3279 29.5733C89.7603 26.3416 90.2069 23.0037 93.9283 19.276C97.6497 15.5554 100.995 15.109 104.228 14.6767C107.488 14.2373 110.855 13.7908 114.612 10.0277C118.227 6.41336 118.78 3.16049 119.205 0.013916H119.05C118.631 3.12505 118.071 6.34249 114.499 9.92136C110.777 13.642 107.432 14.0884 104.199 14.5207C100.939 14.9601 97.5717 15.4066 93.8149 19.1697C90.058 22.9258 89.6044 26.2991 89.172 29.552C88.7396 32.7836 88.293 36.1215 84.5716 39.8492C80.8502 43.5698 77.5045 44.0163 74.2722 44.4486C71.0115 44.8809 67.6445 45.3345 63.8877 49.0905C60.1308 52.8465 59.6772 56.2199 59.2448 59.4728C58.8124 62.7044 58.3658 66.0423 54.6444 69.77C50.923 73.4906 47.5773 73.9371 44.345 74.3694C41.0843 74.8017 37.7174 75.2552 33.9605 79.0113C30.2037 82.7673 29.75 86.1407 29.3176 89.3935C28.8852 92.6252 28.4387 95.9631 24.7173 99.6908C20.9958 103.411 17.6501 103.858 14.4178 104.29C11.1572 104.722 7.79018 105.176 4.03333 108.939C1.87846 111.094 0.808117 113.12 0.212692 115.076C0.233957 115.176 0.262311 115.268 0.290664 115.367C0.871912 113.361 1.92099 111.271 4.14675 109.045C7.86815 105.332 11.2139 104.885 14.4462 104.453Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M13.2971 103.305C16.5578 102.873 19.9247 102.419 23.6816 98.6561C27.4384 94.9 27.8921 91.5267 28.3245 88.2738C28.7569 85.0422 29.2035 81.7043 32.9249 77.9766C36.6463 74.256 39.992 73.8095 43.2243 73.3772C46.4849 72.9378 49.8519 72.4914 53.6088 68.7282C57.3656 64.9722 57.8193 61.5988 58.2517 58.346C58.6841 55.1143 59.1306 51.7764 62.852 48.0487C66.5734 44.3281 69.9192 43.8817 73.1515 43.4494C76.4121 43.0171 79.7791 42.5635 83.536 38.8075C87.2928 35.0514 87.7465 31.6781 88.1788 28.4252C88.6112 25.1936 89.0578 21.8557 92.7792 18.128C96.5006 14.4074 99.8463 13.9609 103.079 13.5286C106.339 13.0892 109.706 12.6427 113.47 8.8796C116.653 5.69759 117.461 2.79906 117.9 0.00683594H117.745C117.312 2.76363 116.497 5.63381 113.364 8.76621C109.642 12.4868 106.297 12.9333 103.064 13.3656C99.8038 13.805 96.4368 14.2514 92.68 18.0146C88.9231 21.7706 88.4695 25.144 88.0371 28.3968C87.6047 31.6285 87.1581 34.9664 83.4367 38.6941C79.7153 42.4147 76.3696 42.8611 73.1373 43.2934C69.8766 43.7257 66.5096 44.1793 62.7528 47.9424C58.996 51.6985 58.5423 55.0718 58.1099 58.3247C57.6775 61.5563 57.2309 64.8942 53.5095 68.6219C49.7881 72.3425 46.4424 72.789 43.2101 73.2213C39.9495 73.6607 36.5825 74.1072 32.8256 77.8703C29.0688 81.6263 28.6151 84.9997 28.1827 88.2526C27.7503 91.4842 27.3038 94.8221 23.5824 98.5498C19.861 102.27 16.5152 102.717 13.2829 103.149C10.0223 103.581 6.65529 104.035 2.89844 107.791C1.57291 109.116 0.665597 110.392 0.0205536 111.625V111.958C0.665597 110.647 1.60835 109.301 3.01185 107.897C6.72617 104.191 10.0648 103.737 13.2971 103.305Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M12.1567 102.164C15.4173 101.732 18.7843 101.278 22.5412 97.5153C26.298 93.7593 26.7517 90.386 27.1841 87.1331C27.6165 83.9015 28.063 80.5635 31.7844 76.8359C35.5058 73.1152 38.8516 72.6688 42.0839 72.2365C45.3445 71.7971 48.7115 71.3506 52.4683 67.5875C56.2252 63.8314 56.6789 60.4581 57.1112 57.2052C57.5436 53.9736 57.9902 50.6357 61.7116 46.908C65.433 43.1874 68.7787 42.7409 72.011 42.3086C75.2717 41.8763 78.6387 41.4228 82.3955 37.6596C86.1524 33.9036 86.606 30.5302 87.0384 27.2774C87.4708 24.0457 87.9174 20.7078 91.6388 16.9801C95.3602 13.2595 98.7059 12.8131 101.938 12.3808C105.199 11.9485 108.566 11.4949 112.323 7.73177C115.073 4.98206 116.051 2.44496 116.547 0.00708008H116.391C115.895 2.41662 114.917 4.91828 112.216 7.62547C108.495 11.3461 105.149 11.7925 101.917 12.2319C98.6563 12.6642 95.2893 13.1178 91.5325 16.8809C87.7756 20.637 87.322 24.0103 86.8896 27.2632C86.4572 30.4948 86.0106 33.8327 82.2892 37.5604C78.5678 41.281 75.2221 41.7275 71.9898 42.1598C68.7291 42.5921 65.3621 43.0456 61.6053 46.8088C57.8484 50.5648 57.3948 53.9382 56.9624 57.191C56.53 60.4227 56.0834 63.7606 52.362 67.4883C48.6406 71.2089 45.2949 71.6554 42.0626 72.0877C38.8019 72.527 35.435 72.9735 31.6781 76.7366C27.9213 80.4927 27.4676 83.866 27.0352 87.1189C26.6028 90.3505 26.1562 93.6884 22.4348 97.4161C18.7134 101.137 15.3677 101.583 12.1354 102.016C8.87475 102.448 5.50777 102.901 1.75092 106.657C1.07044 107.338 0.496277 108.004 0.014267 108.663V108.932C0.517543 108.224 1.12006 107.501 1.85725 106.771C5.58574 103.043 8.92437 102.597 12.1567 102.164Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M11.0146 101.023C14.2753 100.591 17.6423 100.137 21.3991 96.3812C25.156 92.6251 25.6096 89.2518 26.042 85.9989C26.4744 82.7673 26.921 79.4294 30.6424 75.7017C34.3638 71.9811 37.7095 71.5346 40.9418 71.1023C44.2025 70.67 47.5695 70.2165 51.3263 66.4533C55.0832 62.6973 55.5368 59.3239 55.9692 56.0711C56.4016 52.8395 56.8482 49.5015 60.5696 45.7739C64.291 42.0532 67.6367 41.6068 70.869 41.1745C74.1297 40.7422 77.4966 40.2886 81.2535 36.5255C85.0103 32.7694 85.464 29.3961 85.8964 26.1432C86.3288 22.9116 86.7754 19.5737 90.4968 15.846C94.2182 12.1254 97.5639 11.6789 100.796 11.2395C104.057 10.8001 107.424 10.3537 111.181 6.59054C113.506 4.26605 114.562 2.09746 115.136 0.00683594H114.973C114.399 2.06203 113.35 4.20226 111.074 6.48424C107.353 10.2048 104.007 10.6513 100.775 11.0907C97.5143 11.5301 94.1473 11.9766 90.3904 15.7397C86.6336 19.4957 86.1799 22.8691 85.7475 26.122C85.3152 29.3536 84.8686 32.6915 81.1472 36.4192C77.4258 40.1398 74.0801 40.5863 70.8477 41.0186C67.5871 41.4509 64.2201 41.9044 60.4633 45.6605C56.7064 49.4165 56.2528 52.7899 55.8204 56.0427C55.388 59.2743 54.9414 62.6123 51.22 66.34C47.4986 70.0606 44.1529 70.507 40.9206 70.9393C37.6599 71.3716 34.2929 71.8252 30.5361 75.5883C26.7792 79.3444 26.3256 82.7177 25.8932 85.9706C25.4608 89.2022 25.0142 92.5401 21.2928 96.2678C17.5714 99.9884 14.2257 100.435 10.9934 100.867C7.73272 101.299 4.36574 101.753 0.60889 105.516C0.403327 105.722 0.204852 105.934 0.0205536 106.14V106.367C0.240294 106.119 0.47421 105.878 0.722304 105.622C4.43662 101.902 7.78234 101.455 11.0146 101.023Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M20.2587 95.2334C24.0156 91.4773 24.4692 88.104 24.9016 84.8511C25.334 81.6195 25.7806 78.2816 29.502 74.5539C33.2234 70.8333 36.5691 70.3868 39.8014 69.9545C43.0621 69.5151 46.429 69.0686 50.1859 65.3055C53.9427 61.5495 54.3964 58.1761 54.8288 54.9232C55.2612 51.6916 55.7077 48.3537 59.4291 44.626C63.1506 40.9054 66.4963 40.4589 69.7286 40.0266C72.9892 39.5943 76.3562 39.1408 80.1131 35.3847C83.8699 31.6216 84.3236 28.2553 84.756 25.0025C85.1884 21.7709 85.6349 18.4329 89.3563 14.7053C93.0777 10.9846 96.4235 10.5382 99.6558 10.0988C102.916 9.6594 106.283 9.21293 110.04 5.4498C111.94 3.55052 112.996 1.75045 113.634 0.00708008H113.471C112.84 1.70793 111.798 3.47965 109.934 5.33641C106.213 9.05701 102.867 9.50349 99.6345 9.93579C96.3738 10.3681 93.0069 10.8216 89.25 14.5848C85.4932 18.3408 85.0395 21.7142 84.6 24.967C84.1676 28.1987 83.7211 31.5366 79.9997 35.2643C76.2783 38.9849 72.9325 39.4313 69.7002 39.8636C66.4396 40.2959 63.0726 40.7495 59.3157 44.5126C55.5589 48.2687 55.1052 51.6349 54.6728 54.8949C54.2404 58.1265 53.7939 61.4715 50.0725 65.1921C46.3511 68.9127 43.0054 69.3592 39.773 69.7915C36.5124 70.2309 33.1454 70.6774 29.3886 74.4405C25.6317 78.1965 25.178 81.5699 24.7457 84.8228C24.3133 88.0544 23.8667 91.3923 20.1453 95.12C16.4239 98.8406 13.0782 99.2871 9.84586 99.7194C6.74824 100.13 3.55137 100.57 0.014267 103.837V104.049C3.55846 100.719 6.7695 100.286 9.86713 99.8682C13.1278 99.443 16.4948 98.9894 20.2587 95.2334Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M19.1098 94.0921C22.8667 90.3361 23.3203 86.9627 23.7527 83.7099C24.1851 80.4782 24.6317 77.1403 28.3531 73.4126C32.0745 69.692 35.4202 69.2456 38.6525 68.8133C41.9132 68.381 45.2802 67.9274 49.037 64.1643C52.7939 60.4082 53.2475 57.0349 53.6799 53.782C54.1123 50.5504 54.5589 47.2125 58.2803 43.4848C62.0017 39.7642 65.3474 39.3177 68.5797 38.8854C71.8404 38.4531 75.2073 37.9995 78.9642 34.2435C82.721 30.4875 83.1747 27.1141 83.6071 23.8612C84.0395 20.6296 84.486 17.2917 88.2074 13.564C91.9289 9.8434 95.2746 9.39693 98.5069 8.96463C101.768 8.53233 105.135 8.07877 108.891 4.31564C110.38 2.8274 111.344 1.40294 112.003 0.0209961H111.833C111.181 1.3675 110.238 2.76362 108.785 4.20934C105.064 7.92994 101.718 8.37642 98.4856 8.80872C95.225 9.24102 91.858 9.69457 88.1011 13.4577C84.3443 17.2137 83.8906 20.5871 83.4582 23.84C83.0258 27.0716 82.5793 30.4095 78.8579 34.1372C75.1365 37.8578 71.7907 38.3043 68.5584 38.7366C65.2978 39.1689 61.9308 39.6224 58.1739 43.3785C54.4171 47.1345 53.9634 50.5079 53.531 53.7607C53.0987 56.9924 52.6521 60.3303 48.9307 64.058C45.2093 67.7786 41.8636 68.225 38.6313 68.6573C35.3706 69.0896 32.0036 69.5432 28.2468 73.3063C24.4899 77.0624 24.0363 80.4357 23.6039 83.6886C23.1715 86.9202 22.7249 90.2581 19.0035 93.9858C15.2821 97.7064 11.9364 98.1529 8.70407 98.5852C5.94668 98.9537 3.10424 99.3435 0.0137024 101.739V101.937C3.11133 99.4994 5.96086 99.1167 8.72533 98.7411C11.986 98.3017 15.353 97.8482 19.1098 94.0921Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M17.9692 92.9443C21.726 89.1883 22.1797 85.8149 22.6121 82.562C23.0444 79.3304 23.491 75.9925 27.2124 72.2648C30.9338 68.5442 34.2795 68.0977 37.5119 67.6654C40.7725 67.2331 44.1395 66.7796 47.8963 63.0165C51.6532 59.2604 52.1068 55.8871 52.5392 52.6342C52.9716 49.4026 53.4182 46.0647 57.1396 42.337C60.861 38.6164 64.2067 38.1699 67.439 37.7376C70.6997 37.3053 74.0667 36.8517 77.8235 33.0886C81.5804 29.3326 82.034 25.9592 82.4664 22.7063C82.8988 19.4747 83.3454 16.1368 87.0668 12.4091C90.7882 8.6885 94.1339 8.24202 97.3662 7.80973C100.627 7.37034 103.994 6.92387 107.758 3.16074C108.842 2.07645 109.643 1.02759 110.253 0.00708008H110.069C109.466 0.999242 108.686 2.00558 107.644 3.05443C103.923 6.77504 100.577 7.22152 97.3449 7.65381C94.0843 8.0932 90.7173 8.53967 86.9605 12.3028C83.2036 16.0588 82.7499 19.4322 82.3176 22.6851C81.8852 25.9167 81.4386 29.2546 77.7172 32.9823C73.9958 36.7029 70.6501 37.1494 67.4178 37.5817C64.1571 38.014 60.7901 38.4675 57.0333 42.2236C53.2764 45.9796 52.8228 49.353 52.3904 52.6058C51.958 55.8375 51.5114 59.1754 47.79 62.9031C44.0686 66.6237 40.7229 67.0701 37.4906 67.5024C34.2299 67.9347 30.8629 68.3883 27.1061 72.1514C23.3492 75.9075 22.8956 79.2808 22.4632 82.5337C22.0308 85.7653 21.5842 89.1032 17.8628 92.8309C14.1414 96.5515 10.7957 96.998 7.5634 97.4303C5.14626 97.7563 2.67241 98.0894 0.014267 99.769V99.9532C2.67241 98.2382 5.16044 97.9051 7.58467 97.5862C10.8382 97.1539 14.2123 96.7074 17.9692 92.9443Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M16.8279 91.8033C20.5848 88.0473 21.0384 84.6739 21.4708 81.4211C21.9032 78.1894 22.3498 74.8515 26.0712 71.1238C29.7926 67.4032 33.1383 66.9568 36.3706 66.5245C39.6313 66.0922 42.9983 65.6386 46.7551 61.8755C50.512 58.1194 50.9656 54.7461 51.398 51.4932C51.8304 48.2616 52.277 44.9237 55.9984 41.196C59.7198 37.4754 63.0655 37.0289 66.2978 36.5966C69.5585 36.1643 72.9254 35.7107 76.6823 31.9547C80.4391 28.1987 80.8928 24.8253 81.3252 21.5724C81.7576 18.3408 82.2041 15.0029 85.9255 11.2752C89.647 7.5546 92.9927 7.10812 96.225 6.66874C99.4856 6.23644 102.853 5.78288 106.609 2.01975C107.29 1.33941 107.864 0.666159 108.346 0.00708008H108.148C107.68 0.630725 107.141 1.26146 106.496 1.90636C102.775 5.62697 99.4289 6.07344 96.1966 6.50574C92.936 6.94513 89.569 7.3916 85.8121 11.1547C82.0553 14.9108 81.6016 18.2841 81.1692 21.537C80.7368 24.7686 80.2903 28.1065 76.5689 31.8342C72.8475 35.5548 69.5017 36.0013 66.2694 36.4336C63.0088 36.8659 59.6418 37.3195 55.885 41.0826C52.1281 44.8386 51.6744 48.212 51.2421 51.4649C50.8097 54.6965 50.3631 58.0344 46.6417 61.7621C42.9203 65.4827 39.5746 65.9292 36.3423 66.3615C33.0816 66.7938 29.7146 67.2473 25.9578 71.0104C22.2009 74.7665 21.7473 78.1398 21.3149 81.3927C20.8825 84.6243 20.4359 87.9622 16.7145 91.6899C12.9931 95.4105 9.64739 95.857 6.41508 96.2893C4.35236 96.5657 2.24002 96.8492 0.014267 97.9831V98.1602C2.24711 97.0122 4.36654 96.7216 6.43635 96.4452C9.69701 96.0129 13.064 95.5594 16.8279 91.8033Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M15.6795 90.6628C19.4364 86.9068 19.89 83.5334 20.3224 80.2806C20.7548 77.0489 21.2014 73.711 24.9228 69.9833C28.6442 66.2627 31.9899 65.8162 35.2222 65.3839C38.4829 64.9446 41.8498 64.4981 45.6067 60.735C49.3635 56.9789 49.8172 53.6056 50.2496 50.3527C50.682 47.1211 51.1286 43.7832 54.85 40.0555C58.5714 36.3349 61.9171 35.8884 65.1494 35.4561C68.41 35.0238 71.777 34.5702 75.5339 30.8142C79.2907 27.0582 79.7444 23.6848 80.1768 20.4319C80.6092 17.2003 81.0557 13.8624 84.7771 10.1347C88.4985 6.41409 91.8443 5.96762 95.0766 5.52823C98.3372 5.09594 101.704 4.64238 105.461 0.879247C105.752 0.588685 106.021 0.298123 106.269 0.0146484H106.064C105.837 0.262689 105.603 0.517816 105.348 0.772944C101.626 4.49355 98.2805 4.94002 95.0482 5.37232C91.7876 5.81171 88.4206 6.25818 84.6566 10.0213C80.8998 13.7774 80.4461 17.1507 80.0137 20.4036C79.5813 23.6352 79.1348 26.9731 75.4134 30.7008C71.692 34.4214 68.3463 34.8679 65.1139 35.3002C61.8533 35.7325 58.4863 36.186 54.7295 39.9492C50.9726 43.7052 50.5189 47.0786 50.0866 50.3314C49.6542 53.563 49.2076 56.901 45.4862 60.6287C41.7648 64.3493 38.4191 64.7957 35.1868 65.228C31.9261 65.6674 28.5591 66.1139 24.8023 69.877C21.0454 73.6331 20.5918 77.0064 20.1594 80.2593C19.727 83.4909 19.2804 86.8288 15.559 90.5565C11.8376 94.2771 8.49189 94.7236 5.25958 95.1559C3.55128 95.3827 1.80754 95.6236 0 96.3323V96.5024C1.81463 95.7795 3.56546 95.5386 5.28085 95.3118C8.55569 94.8724 11.9227 94.4189 15.6795 90.6628Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M14.5389 89.5148C18.2957 85.7587 18.7494 82.3854 19.1818 79.1325C19.6141 75.9009 20.0607 72.563 23.7821 68.8353C27.5035 65.1147 30.8492 64.6682 34.0816 64.2359C37.3422 63.8036 40.7092 63.35 44.466 59.5869C48.2229 55.8309 48.6765 52.4575 49.1089 49.2046C49.5413 45.973 49.9879 42.6351 53.7093 38.9074C57.4307 35.1868 60.7764 34.7403 64.0087 34.308C67.2694 33.8757 70.6364 33.4222 74.3932 29.659C78.1501 25.903 78.6037 22.5296 79.0361 19.2768C79.4685 16.0452 79.9151 12.7072 83.6365 8.97955C87.3579 5.25894 90.7036 4.81247 93.9359 4.38017C97.1115 3.95496 100.386 3.50848 104.037 0.00756836H103.81C100.252 3.36675 97.0335 3.80613 93.9146 4.22426C90.654 4.65656 87.287 5.11012 83.5231 8.87324C79.7662 12.6293 79.3126 16.0026 78.8802 19.2555C78.4478 22.4871 78.0012 25.825 74.2798 29.5527C70.5584 33.2733 67.2127 33.7198 63.9804 34.1521C60.7197 34.5844 57.3527 35.038 53.5959 38.794C49.839 42.5501 49.3854 45.9234 48.953 49.1763C48.5206 52.4079 48.074 55.7458 44.3526 59.4735C40.6312 63.1941 37.2855 63.6406 34.0532 64.0729C30.7925 64.5052 27.4256 64.9587 23.6687 68.7219C19.9119 72.4779 19.4582 75.8513 19.0258 79.1041C18.5934 82.3358 18.1469 85.6737 14.4254 89.4014C10.704 93.122 7.35832 93.5684 4.12601 94.0007C2.77922 94.1779 1.41116 94.3693 0.00765991 94.7874V94.9504C1.41825 94.5252 2.7934 94.3409 4.14728 94.1566C7.40794 93.7243 10.782 93.2779 14.5389 89.5148Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M13.3963 88.3733C17.1532 84.6172 17.6068 81.2439 18.0392 77.991C18.4716 74.7594 18.9182 71.4215 22.6396 67.6938C26.361 63.9732 29.7067 63.5267 32.939 63.0944C36.1997 62.6621 39.5667 62.2085 43.3235 58.4454C47.0804 54.6894 47.534 51.316 47.9664 48.0631C48.3988 44.8315 48.8454 41.4936 52.5668 37.7659C56.2882 34.0453 59.6339 33.5988 62.8662 33.1665C66.1269 32.7342 69.4939 32.2807 73.2507 28.5246C77.0075 24.7686 77.4612 21.3953 77.8936 18.1424C78.326 14.9108 78.7726 11.5728 82.494 7.84515C86.2154 4.12455 89.5611 3.67807 92.7934 3.23869C95.5791 2.86308 98.4499 2.4733 101.583 0.0141602H101.328C98.2869 2.33865 95.4941 2.72135 92.7721 3.08986C89.5115 3.52925 86.1445 3.97572 82.3876 7.73885C78.6308 11.4949 78.1771 14.8682 77.7447 18.1211C77.3124 21.3527 76.8658 24.6906 73.1444 28.4183C69.423 32.1389 66.0773 32.5854 62.8449 33.0177C59.5843 33.45 56.2173 33.9036 52.4605 37.6667C48.7036 41.4227 48.25 44.7961 47.8176 48.049C47.3852 51.2806 46.9386 54.6185 43.2172 58.3462C39.4958 62.0668 36.1501 62.5133 32.9178 62.9456C29.6571 63.3779 26.2901 63.8314 22.5333 67.5946C18.7764 71.3506 18.3228 74.724 17.8904 77.9768C17.458 81.2084 17.0114 84.5464 13.29 88.2741C9.56861 91.9947 6.22289 92.4411 2.99059 92.8734C2.01239 93.001 1.02002 93.1356 0.0205536 93.3624V93.5183C1.03419 93.2916 2.02657 93.1569 3.01185 93.0223C6.26542 92.5829 9.63241 92.1293 13.3963 88.3733Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M12.2488 87.2328C16.0057 83.4767 16.4593 80.1034 16.8917 76.8505C17.3241 73.6189 17.7707 70.2739 21.4921 66.5533C25.2135 62.8327 28.5592 62.3862 31.7915 61.9539C35.0522 61.5216 38.4192 61.0681 42.176 57.3049C45.9329 53.5489 46.3865 50.1755 46.8189 46.9227C47.2513 43.691 47.6979 40.3531 51.4193 36.6254C55.1407 32.9048 58.4864 32.4583 61.7187 32.0261C64.9794 31.5938 68.3463 31.1402 72.1032 27.3841C75.86 23.6281 76.3137 20.2548 76.7461 17.0019C77.1785 13.7703 77.625 10.4324 81.3464 6.70466C85.0679 2.98405 88.4136 2.53757 91.6459 2.09819C93.9283 1.79345 96.2746 1.47454 98.7626 0.0146484H98.4507C96.069 1.34698 93.8149 1.65172 91.6175 1.94228C88.3569 2.37458 84.9899 2.82814 81.233 6.59127C77.4762 10.3473 77.0225 13.7207 76.5901 16.9735C76.1577 20.2051 75.7112 23.5431 71.9898 27.2708C68.2684 30.9914 64.9227 31.4378 61.6903 31.8701C58.4297 32.3024 55.0627 32.756 51.3059 36.5191C47.549 40.2752 47.0953 43.6485 46.663 46.9014C46.2306 50.133 45.784 53.4709 42.0626 57.1986C38.3412 60.9192 34.9955 61.3657 31.7632 61.798C28.5025 62.2303 25.1355 62.6839 21.3787 66.447C17.6218 70.203 17.1682 73.5764 16.7358 76.8293C16.3034 80.0609 15.8568 83.3988 12.1354 87.1265C8.414 90.8471 5.06828 91.2936 1.83598 91.7259C1.23346 91.8038 0.623862 91.8889 0.00717163 91.9952V92.1511C0.63095 92.0448 1.24764 91.9668 1.85724 91.8818C5.12499 91.4424 8.49197 90.9888 12.2488 87.2328Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M11.1068 86.084C14.8636 82.3279 15.3173 78.9546 15.7497 75.7017C16.1821 72.4701 16.6287 69.1322 20.3501 65.4045C24.0715 61.6839 27.4172 61.2374 30.6495 60.8051C33.9101 60.3728 37.2771 59.9193 41.034 56.1561C44.7908 52.4001 45.2445 49.0267 45.6769 45.7739C46.1093 42.5422 46.5558 39.2043 50.2772 35.4766C53.9986 31.756 57.3444 31.3095 60.5767 30.8773C63.8373 30.445 67.2043 29.9914 70.9612 26.2283C74.718 22.4722 75.1717 19.0989 75.6041 15.846C76.0364 12.6144 76.483 9.27646 80.2044 5.54877C83.9258 1.82816 87.2715 1.38169 90.5038 0.94939C92.0066 0.750957 93.5306 0.538351 95.1113 0.00683594H94.6009C93.1974 0.424961 91.8294 0.616307 90.4897 0.793479C87.229 1.22578 83.862 1.67934 80.1052 5.44247C76.3483 9.19851 75.8947 12.5719 75.4623 15.8247C75.0299 19.0563 74.5833 22.3943 70.8619 26.122C67.1405 29.8426 63.7948 30.289 60.5625 30.7213C57.3018 31.1536 53.9348 31.6072 50.178 35.3632C46.4212 39.1193 45.9675 42.4926 45.5351 45.7455C45.1027 48.9771 44.6561 52.315 40.9347 56.0427C37.2133 59.7633 33.8676 60.2098 30.6353 60.6421C27.3747 61.0744 24.0077 61.528 20.2508 65.2911C16.494 69.0471 16.0403 72.4205 15.6079 75.6734C15.1755 78.905 14.729 82.2429 11.0076 85.9706C7.28615 89.6912 3.94043 90.1377 0.708128 90.57C0.481299 90.5983 0.25447 90.6338 0.0205536 90.6621V90.818C0.25447 90.7826 0.495476 90.7542 0.729393 90.7188C3.97588 90.2936 7.34995 89.8471 11.1068 86.084Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M9.65368 69.6072C10.0861 66.3756 10.5326 63.0377 14.254 59.31C17.9754 55.5894 21.3212 55.1429 24.5535 54.7106C27.8141 54.2783 31.1811 53.8248 34.938 50.0616C38.6948 46.3056 39.1485 42.9322 39.5809 39.6794C40.0132 36.4478 40.4598 33.1098 44.1812 29.3822C47.9026 25.6615 51.2483 25.2151 54.4807 24.7828C57.7413 24.3505 61.1083 23.8969 64.8651 20.1338C68.622 16.3777 69.0756 13.0044 69.508 9.75152C69.9192 6.68291 70.3516 3.51507 73.5839 0.0141602H73.3712C70.1956 3.50799 69.7703 6.66873 69.3592 9.73026C68.9268 12.9619 68.4802 16.2998 64.7588 20.0275C61.0374 23.7481 57.6917 24.1946 54.4594 24.6269C51.1987 25.0592 47.8317 25.5127 44.0749 29.2688C40.3181 33.0248 39.8644 36.3982 39.432 39.651C38.9996 42.8826 38.553 46.2206 34.8316 49.9483C31.1102 53.6689 27.7645 54.1153 24.5322 54.5476C21.2715 54.9799 17.9046 55.4335 14.1477 59.1966C10.3909 62.9527 9.93721 66.326 9.50482 69.5789C9.07243 72.8105 8.62586 76.1484 4.90445 79.8761C3.20324 81.577 1.58709 82.5904 0.0205536 83.2282V83.3983C1.62253 82.7463 3.27412 81.7258 5.01787 79.9824C8.76763 76.2264 9.22128 72.8601 9.65368 69.6072Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M8.51331 68.4597C8.9457 65.228 9.39227 61.8901 13.1137 58.1624C16.8351 54.4418 20.1808 53.9953 23.4131 53.563C26.6738 53.1237 30.0407 52.6772 33.7976 48.9141C37.5544 45.158 38.0081 41.7847 38.4405 38.5318C38.8729 35.3002 39.3194 31.9623 43.0408 28.2346C46.7623 24.514 50.108 24.0675 53.3403 23.6352C56.6009 23.2029 59.9679 22.7493 63.7248 18.9933C67.4816 15.2372 67.9353 11.8639 68.3677 8.61102C68.7363 5.88258 69.119 3.06909 71.4724 0.0146484H71.2739C68.956 3.062 68.5732 5.86132 68.2117 8.58976C67.7793 11.8214 67.3328 15.1593 63.6114 18.887C59.89 22.6076 56.5442 23.0541 53.3119 23.4864C50.0513 23.9187 46.6843 24.3722 42.9274 28.1354C39.1706 31.8914 38.7169 35.2647 38.2845 38.5176C37.8521 41.7492 37.4056 45.0942 33.6842 48.8148C29.9628 52.5355 26.6171 52.9819 23.3847 53.4142C20.1241 53.8536 16.7571 54.3001 13.0003 58.0632C9.24341 61.8193 8.78975 65.1926 8.35736 68.4455C7.92497 71.6771 7.4784 75.015 3.757 78.7427C2.46691 80.0325 1.22644 80.9184 0.014328 81.5633V81.7404C1.2548 81.0955 2.53779 80.1813 3.86332 78.8561C7.62726 75.0859 8.07383 71.7196 8.51331 68.4597Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M7.36499 67.3187C7.79738 64.0871 8.24395 60.7491 11.9654 57.0214C15.6868 53.3008 19.0325 52.8544 22.2648 52.4221C25.5254 51.9827 28.8924 51.5362 32.6493 47.7731C36.4061 44.017 36.8598 40.6437 37.2922 37.3908C37.7246 34.1592 38.1711 30.8213 41.8925 27.0936C45.6139 23.373 48.9597 22.9265 52.192 22.4942C55.4526 22.0619 58.8196 21.6083 62.5765 17.8523C66.3333 14.0963 66.787 10.7229 67.2193 7.47004C67.5383 5.08176 67.8715 2.63679 69.5231 0.0146484H69.3388C67.7155 2.62262 67.3824 5.06759 67.0634 7.44878C66.631 10.6804 66.1844 14.0183 62.463 17.746C58.7416 21.4666 55.3959 21.9131 52.1636 22.3454C48.9029 22.7777 45.536 23.2312 41.7791 26.9944C38.0223 30.7504 37.5686 34.1238 37.1362 37.3766C36.7038 40.6082 36.2573 43.9462 32.5359 47.6739C28.8145 51.3945 25.4687 51.8409 22.2364 52.2732C18.9758 52.7126 15.6088 53.1591 11.8519 56.9222C8.09509 60.6783 7.64143 64.0516 7.20904 67.3045C6.77665 70.5361 6.33008 73.874 2.60868 77.6017C1.72263 78.4876 0.857846 79.1821 0.014328 79.742V79.9333C0.893288 79.3593 1.79351 78.6364 2.72209 77.7151C6.47894 73.9449 6.9326 70.5786 7.36499 67.3187Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M6.22376 66.1777C6.65615 62.9461 7.10272 59.6082 10.8241 55.8805C14.5455 52.1598 17.8912 51.7134 21.1236 51.2811C24.3842 50.8488 27.7512 50.3952 31.508 46.6321C35.2649 42.876 35.7185 39.5027 36.1509 36.2498C36.5833 33.0182 37.0299 29.6803 40.7513 25.9526C44.4727 22.232 47.8184 21.7855 51.0507 21.3532C54.3114 20.9209 57.6784 20.4674 61.4352 16.7042C65.1921 12.9482 65.6457 9.57484 66.0781 6.32196C66.3475 4.28803 66.631 2.20449 67.7297 0.0146484H67.5525C66.468 2.1974 66.1915 4.27386 65.9222 6.30779C65.4898 9.5394 65.0432 12.8773 61.3218 16.605C57.6004 20.3256 54.2547 20.7721 51.0224 21.2044C47.7617 21.6367 44.3947 22.0903 40.6379 25.8463C36.881 29.6023 36.4274 32.9757 35.995 36.2286C35.5626 39.4602 35.116 42.7981 31.3946 46.5258C27.6732 50.2464 24.3275 50.6929 21.0952 51.1252C17.8345 51.5575 14.4676 52.011 10.7107 55.7742C6.95386 59.5302 6.5002 62.9035 6.06781 66.1564C5.63542 69.388 5.18885 72.7259 1.46745 76.4536C0.97835 76.9426 0.48925 77.3749 0.014328 77.7576V77.9561C0.53178 77.5521 1.04923 77.0915 1.58086 76.5599C5.33771 72.8039 5.79137 69.4306 6.22376 66.1777Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M5.08247 65.0291C5.51486 61.7975 5.96143 58.4596 9.68283 54.7319C13.4042 51.0113 16.75 50.5648 19.9823 50.1325C23.2429 49.6931 26.6099 49.2467 30.3668 45.4835C34.1236 41.7275 34.5773 38.3541 35.0096 35.1013C35.442 31.8697 35.8886 28.5317 39.61 24.804C43.3314 21.0834 46.6771 20.637 49.9094 20.2047C53.1701 19.7724 56.5371 19.3188 60.2939 15.5557C64.0508 11.7996 64.5044 8.42628 64.9368 5.17341C65.1637 3.49382 65.3976 1.78588 66.0851 0.00708008H65.915C65.2345 1.7788 65.0077 3.47965 64.7809 5.15215C64.3485 8.38376 63.9019 11.7217 60.1805 15.4494C56.4591 19.17 53.1134 19.6165 49.8811 20.0488C46.6204 20.4811 43.2534 20.9346 39.4966 24.6907C35.7397 28.4467 35.2861 31.82 34.8537 35.0729C34.4213 38.3045 33.9747 41.6425 30.2533 45.3701C26.5319 49.0908 23.1862 49.5372 19.9539 49.9695C16.6932 50.4018 13.3263 50.8554 9.56942 54.6185C5.81257 58.3746 5.35891 61.7479 4.92652 65.0008C4.49413 68.2324 4.04756 71.5703 0.326156 75.298C0.219831 75.4043 0.120593 75.4964 0.014267 75.5957V75.8083C0.156035 75.6736 0.290714 75.546 0.432482 75.4114C4.19642 71.6553 4.64298 68.2891 5.08247 65.0291Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M8.54166 53.5914C12.2631 49.8708 15.6088 49.4243 18.8411 48.992C22.1018 48.5526 25.4687 48.1062 29.2256 44.343C32.9824 40.587 33.4361 37.2136 33.8685 33.9608C34.3009 30.7291 34.7474 27.3912 38.4688 23.6635C42.1902 19.9429 45.536 19.4965 48.7683 19.0642C52.0289 18.6319 55.3959 18.1783 59.1528 14.4223C62.9096 10.6662 63.3633 7.29286 63.7957 4.03999C63.9729 2.72183 64.1572 1.3895 64.5541 0.0146484H64.3911C63.9941 1.37533 63.8169 2.70766 63.6397 4.01873C63.2073 7.25034 62.7607 10.5883 59.0393 14.316C55.3179 18.0366 51.9722 18.483 48.7399 18.9153C45.4793 19.3476 42.1123 19.8012 38.3554 23.5643C34.5986 27.3204 34.1449 30.6937 33.7125 33.9466C33.2801 37.1782 32.8336 40.5161 29.1122 44.2438C25.3908 47.9644 22.045 48.4109 18.8127 48.8432C15.5521 49.2826 12.1851 49.729 8.42825 53.4922C4.6714 57.2482 4.21774 60.6216 3.78535 63.8744C3.3884 66.8438 2.97019 69.9054 0.014328 73.2716V73.5055C3.11195 70.0542 3.53017 66.9218 3.93421 63.8886C4.3666 60.657 4.81317 57.3191 8.54166 53.5914Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M7.39248 52.4499C11.1139 48.7293 14.4596 48.2828 17.6919 47.8505C20.9526 47.4112 24.3196 46.9647 28.0764 43.2016C31.8332 39.4455 32.2869 36.0722 32.7193 32.8193C33.1517 29.5877 33.5983 26.2498 37.3197 22.5221C41.0411 18.8015 44.3868 18.355 47.6191 17.9227C50.8798 17.4904 54.2467 17.0368 58.0036 13.2737C61.7604 9.51765 62.2141 6.1443 62.6465 2.89143C62.7741 1.94179 62.9017 0.985062 63.1143 0.0141602H62.9584C62.7528 0.977975 62.6181 1.9347 62.4976 2.87726C62.0652 6.10887 61.6187 9.44679 57.8973 13.1745C54.1759 16.8951 50.8301 17.3416 47.5978 17.7739C44.3372 18.2062 40.9702 18.6597 37.2133 22.4228C33.4565 26.1789 33.0028 29.5522 32.5704 32.8051C32.138 36.0367 31.6915 39.3746 27.9701 43.1023C24.2487 46.8229 20.903 47.2694 17.6706 47.7017C14.41 48.1411 11.043 48.5876 7.28615 52.3507C3.52931 56.1067 3.07565 59.4801 2.64326 62.733C2.30302 65.2701 1.9486 67.871 0.0205536 70.6703V70.9467C2.08328 68.0481 2.45187 65.3622 2.7992 62.7542C3.22451 59.5155 3.67107 56.1705 7.39248 52.4499Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M6.25211 51.3094C9.97352 47.5888 13.3192 47.1423 16.5515 46.71C19.8122 46.2777 23.1792 45.8242 26.936 42.0611C30.6929 38.305 31.1465 34.9317 31.5789 31.6788C32.0113 28.4472 32.4579 25.1093 36.1793 21.3816C39.9007 17.661 43.2464 17.2145 46.4787 16.7822C49.7394 16.3499 53.1064 15.8963 56.8632 12.1332C60.6201 8.37716 61.0737 5.00381 61.5061 1.75093C61.5841 1.1769 61.662 0.595772 61.7542 0.0146484H61.5983C61.5061 0.588685 61.4281 1.16272 61.3502 1.72967C60.9178 4.96128 60.4712 8.2992 56.7498 12.0269C53.0284 15.7475 49.6827 16.194 46.4504 16.6263C43.1897 17.0586 39.8227 17.5121 36.0659 21.2682C32.309 25.0242 31.8554 28.3976 31.423 31.6504C30.9906 34.8821 30.544 38.22 26.8226 41.9477C23.1012 45.6683 19.7555 46.1147 16.5232 46.547C13.2625 46.9793 9.89554 47.4329 6.1387 51.196C2.38185 54.9521 1.92819 58.3254 1.4958 61.5783C1.24062 63.4988 0.971261 65.469 0.014328 67.5242V67.8927C1.09885 65.7029 1.3753 63.6264 1.65175 61.5925C2.08414 58.375 2.53071 55.03 6.25211 51.3094Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M5.11088 50.1614C8.83228 46.4407 12.178 45.9943 15.4103 45.562C18.671 45.1297 22.038 44.6761 25.7948 40.913C29.5516 37.1569 30.0053 33.7836 30.4377 30.5307C30.8701 27.2991 31.3167 23.9612 35.0381 20.2335C38.7595 16.5129 42.1052 16.0664 45.3375 15.6341C48.5982 15.2018 51.9651 14.7483 55.722 10.9922C59.4788 7.23617 59.9325 3.86282 60.3649 0.609946C60.3932 0.411513 60.4145 0.213081 60.4428 0.0146484H60.2869C60.2585 0.205994 60.2373 0.397339 60.2089 0.588685C59.7765 3.8203 59.33 7.15822 55.6086 10.8859C51.8872 14.6065 48.5414 15.053 45.3091 15.4853C42.0485 15.9176 38.6815 16.3711 34.9246 20.1343C31.1678 23.8903 30.7141 27.2637 30.2818 30.5165C29.8494 33.7482 29.4028 37.0861 25.6814 40.8138C21.96 44.5344 18.6143 44.9808 15.382 45.4131C12.1213 45.8454 8.75431 46.299 4.99747 50.0551C1.24062 53.8111 0.786963 57.1844 0.354571 60.4373C0.255334 61.1744 0.156096 61.9114 0.014328 62.6626V63.4422C0.241156 62.4287 0.375836 61.4366 0.503427 60.4515C0.935819 57.227 1.38239 53.8891 5.11088 50.1614Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M14.262 44.421C17.5226 43.9887 20.8896 43.5351 24.6465 39.772C28.4033 36.016 28.857 32.6426 29.2894 29.3897C29.7218 26.1581 30.1683 22.8202 33.8897 19.0925C37.6111 15.3719 40.9569 14.9254 44.1892 14.4931C47.4498 14.0608 50.8168 13.6073 54.5737 9.85123C58.1249 6.3007 58.7204 3.10452 59.1457 0.0146484H58.9897C58.5715 3.06909 57.969 6.23692 54.4673 9.73784C50.7459 13.4584 47.4002 13.9049 44.1679 14.3372C40.9072 14.7695 37.5403 15.2231 33.7834 18.9791C30.0266 22.7352 29.5729 26.1085 29.1405 29.3614C28.7081 32.593 28.2616 35.9309 24.5402 39.6586C20.8187 43.3792 17.473 43.8257 14.2407 44.258C10.9801 44.6974 7.61308 45.1438 3.85624 48.907C1.6801 51.0826 0.616841 53.1308 0.014328 55.1009V55.6608C0.574311 53.5489 1.6163 51.359 3.96256 49.0133C7.69105 45.2998 11.0297 44.8533 14.262 44.421Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M13.1199 43.2795C16.3806 42.8401 19.7475 42.3937 23.5044 38.6305C27.2612 34.8745 27.7149 31.5011 28.1473 28.2483C28.5797 25.0166 29.0262 21.6787 32.7476 17.951C36.4691 14.2304 39.8148 13.784 43.0471 13.3517C46.3077 12.9194 49.6747 12.4658 53.4316 8.70266C56.5434 5.59153 57.3869 2.74969 57.8335 0.0141602H57.6775C57.2309 2.71426 56.3945 5.52775 53.3252 8.59636C49.6038 12.317 46.2581 12.7634 43.0258 13.1957C39.7652 13.628 36.3982 14.0816 32.6413 17.8376C28.8845 21.5937 28.4308 24.967 27.9984 28.2199C27.566 31.4515 27.1195 34.7894 23.3981 38.5171C19.6767 42.2377 16.3309 42.6842 13.0986 43.1165C9.83797 43.5488 6.47099 44.0024 2.71414 47.7655C1.50911 48.9703 0.65142 50.1254 0.0205536 51.2593V51.5924C0.658509 50.3876 1.54456 49.1545 2.82756 47.8718C6.54187 44.1583 9.88759 43.7047 13.1199 43.2795Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M11.9724 42.1319C15.2331 41.6925 18.6001 41.2461 22.3569 37.4829C26.1138 33.7269 26.5674 30.3535 26.9998 27.1007C27.4322 23.8691 27.8788 20.5311 31.6002 16.8034C35.3216 13.0828 38.6673 12.6364 41.8996 12.2041C45.1603 11.7718 48.5273 11.3182 52.2841 7.56217C54.9635 4.88333 55.963 2.39584 56.4734 0.0146484H56.3174C55.807 2.36749 54.8218 4.81246 52.1778 7.45586C48.4564 11.1765 45.1107 11.6229 41.8784 12.0552C38.6177 12.4875 35.2507 12.9411 31.4939 16.7042C27.737 20.4603 27.2834 23.8336 26.851 27.0865C26.4186 30.3181 25.972 33.656 22.2506 37.3837C18.5292 41.1043 15.1835 41.5508 11.9512 41.9831C8.69052 42.4225 5.32353 42.869 1.56669 46.6321C0.964173 47.2345 0.460897 47.8227 0.014328 48.4038V48.6589C0.482162 48.0282 1.02797 47.3904 1.6801 46.7455C5.4015 43.0107 8.74014 42.5642 11.9724 42.1319Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M10.8311 40.9909C14.0918 40.5515 17.4588 40.1051 21.2156 36.3419C24.9725 32.5859 25.4261 29.2126 25.8585 25.9597C26.2909 22.7281 26.7375 19.3902 30.4589 15.6625C34.1803 11.9419 37.526 11.4954 40.7583 11.0631C44.019 10.6308 47.386 10.1772 51.1428 6.42118C53.3969 4.16755 54.4602 2.04858 55.0414 0.0146484H54.8784C54.2971 2.01315 53.241 4.09669 51.0294 6.30779C47.308 10.0284 43.9623 10.4749 40.73 10.9072C37.4693 11.3395 34.1023 11.793 30.3455 15.5562C26.5886 19.3122 26.135 22.6855 25.7026 25.9384C25.2702 29.17 24.8236 32.508 21.1022 36.2356C17.3808 39.9563 14.0351 40.4027 10.8028 40.835C7.54213 41.2744 4.17514 41.7209 0.418298 45.484C0.27653 45.6258 0.141851 45.7675 0.00717163 45.9163V46.1431C0.177293 45.9659 0.340326 45.7817 0.524624 45.5974C4.2602 41.8697 7.59884 41.4232 10.8311 40.9909Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M20.0744 35.201C23.8312 31.4449 24.2849 28.0716 24.7173 24.8187C25.1497 21.5871 25.5963 18.2492 29.3177 14.5215C33.0391 10.8009 36.3848 10.3544 39.6171 9.92209C42.8778 9.4898 46.2447 9.03624 50.0016 5.27311C51.8375 3.43761 52.8795 1.69424 53.5245 0.0146484H53.3544C52.7164 1.66589 51.6886 3.37383 49.8882 5.1668C46.1668 8.88741 42.821 9.33388 39.5887 9.76618C36.3281 10.1985 32.9611 10.652 29.2042 14.4081C25.4474 18.1641 24.9937 21.5375 24.5614 24.7904C24.129 28.022 23.6824 31.3599 19.961 35.0876C16.2396 38.8082 12.8939 39.2547 9.66156 39.687C6.62064 40.0909 3.47339 40.5161 0.00717163 43.6343V43.8469C3.48048 40.672 6.62773 40.2468 9.68282 39.8429C12.9435 39.4106 16.3176 38.957 20.0744 35.201Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M18.9332 34.06C22.6901 30.3039 23.1437 26.9306 23.5761 23.6777C24.0085 20.4461 24.4551 17.1082 28.1765 13.3805C31.8979 9.65988 35.2436 9.21341 38.4759 8.78111C41.7366 8.34881 45.1036 7.89525 48.8604 4.13212C50.2852 2.70766 51.235 1.33989 51.8872 0.0146484H51.71C51.0649 1.30446 50.1363 2.63679 48.747 4.02582C45.0256 7.74642 41.6799 8.1929 38.4476 8.6252C35.1869 9.0575 31.8199 9.51105 28.0631 13.2742C24.3062 17.0302 23.8526 20.4036 23.4202 23.6564C22.9878 26.8881 22.5412 30.226 18.8198 33.9537C15.0984 37.6743 11.7527 38.1208 8.5204 38.5531C5.81263 38.9145 3.03398 39.2901 0.014328 41.565V41.7634C3.04107 39.4531 5.8339 39.0704 8.54166 38.709C11.8023 38.2696 15.1693 37.816 18.9332 34.06Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M17.7849 32.9119C21.5417 29.1559 21.9954 25.7825 22.4277 22.5296C22.8601 19.298 23.3067 15.9601 27.0281 12.2324C30.7495 8.51181 34.0952 8.06533 37.3275 7.63304C40.5882 7.20074 43.9552 6.74718 47.712 2.99113C48.7328 1.97062 49.4983 0.98555 50.1008 0.0146484H49.9165C49.3282 0.950115 48.5839 1.89976 47.5986 2.87774C43.8772 6.59835 40.5315 7.04483 37.2992 7.47712C34.0385 7.90942 30.6715 8.36298 26.9147 12.1261C23.1579 15.8822 22.7042 19.2555 22.2718 22.5084C21.8394 25.74 21.3928 29.0779 17.6714 32.8056C13.95 36.5262 10.6043 36.9727 7.37201 37.405C5.01158 37.7239 2.58735 38.0499 0.00717163 39.6373V39.8216C2.60152 38.2058 5.02575 37.8798 7.39327 37.5609C10.661 37.1215 14.028 36.675 17.7849 32.9119Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M16.6433 31.7702C20.4001 28.0141 20.8538 24.6408 21.2862 21.3879C21.7186 18.1563 22.1652 14.8184 25.8866 11.0907C29.608 7.37008 32.9537 6.92361 36.186 6.49131C39.4467 6.05901 42.8136 5.60545 46.5705 1.84941C47.1943 1.22576 47.7117 0.616293 48.1725 0.0209961H47.974C47.5416 0.587946 47.0454 1.16198 46.4571 1.74311C42.7357 5.46371 39.3899 5.91019 36.1576 6.34249C32.897 6.77478 29.53 7.22834 25.7731 10.9844C22.0163 14.7404 21.5626 18.1138 21.1303 21.3667C20.6979 24.5983 20.2513 27.9362 16.5299 31.6639C12.8085 35.3845 9.46276 35.831 6.23046 36.2633C4.21735 36.5326 2.16881 36.8089 0.0068512 37.8649V38.035C2.1759 36.9649 4.23153 36.6885 6.25172 36.4192C9.51238 35.9798 12.8865 35.5333 16.6433 31.7702Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M10.5468 25.6755C14.3037 21.9194 14.7573 18.5461 15.1897 15.2932C15.6221 12.0616 16.0687 8.72368 19.7901 4.99598C23.5115 1.27537 26.8572 0.828899 30.0895 0.3966C30.8976 0.290297 31.7198 0.176907 32.5492 0.0209961H31.649C31.1173 0.106039 30.5928 0.176907 30.0682 0.247776C26.8076 0.680075 23.4406 1.13364 19.6837 4.89676C15.9269 8.65281 15.4732 12.0262 15.0409 15.279C14.6085 18.5106 14.1619 21.8486 10.4405 25.5763C6.71908 29.2969 3.37336 29.7433 0.141056 30.1756C0.0985259 30.1827 0.0559955 30.1898 0.0205536 30.1898V30.3457C0.0701723 30.3386 0.119791 30.3315 0.162321 30.3245C3.41589 29.8851 6.78288 29.4315 10.5468 25.6755Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M14.0493 14.1459C14.4817 10.9143 14.9283 7.57634 18.6497 3.84865C20.8471 1.64463 22.9169 0.595772 24.9088 0.0146484H24.3842C22.52 0.631206 20.5919 1.69424 18.5363 3.74234C14.7794 7.49838 14.3258 10.8717 13.8934 14.1246C13.461 17.3562 13.0144 20.6941 9.29303 24.4218C5.96149 27.7527 2.93474 28.4613 0.014328 28.8795V29.0354C2.9631 28.6102 6.02528 27.9015 9.39936 24.5281C13.1633 20.7721 13.6099 17.4058 14.0493 14.1459Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M12.901 13.0049C13.3334 9.77327 13.78 6.43535 17.5014 2.70766C18.7064 1.50289 19.876 0.64538 21.0101 0.0146484H20.6983C19.6279 0.638293 18.5292 1.46746 17.3951 2.60136C13.6382 6.3574 13.1846 9.73075 12.7522 12.9836C12.3198 16.2152 11.8732 19.5532 8.1518 23.2809C5.25265 26.1794 2.58033 27.0936 0.014328 27.5542V27.7101C2.61577 27.2424 5.31644 26.3282 8.25813 23.3872C12.015 19.6311 12.4686 16.2578 12.901 13.0049Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M11.7589 11.8634C12.1913 8.6318 12.6379 5.29388 16.3593 1.56618C16.9618 0.963801 17.5501 0.460633 18.1314 0.0141602H17.8762C17.3446 0.432286 16.7988 0.907106 16.253 1.4528C12.4961 5.20884 12.0425 8.58219 11.6101 11.8351C11.1777 15.0667 10.7311 18.4046 7.00971 22.1323C4.53586 24.6056 2.23213 25.6261 0.0205536 26.1647V26.3277C2.26757 25.7891 4.60674 24.7544 7.12312 22.2457C10.8729 18.4825 11.3265 15.1163 11.7589 11.8634Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M10.6186 10.7158C11.051 7.48421 11.4975 4.14629 15.2189 0.4186C15.3607 0.276863 15.5025 0.142212 15.6442 0.0146484H15.4174C15.3111 0.113865 15.2118 0.205994 15.1055 0.312297C11.3487 4.06834 10.895 7.44169 10.4626 10.6946C10.0302 13.9262 9.58365 17.2641 5.86225 20.9918C3.8137 23.0399 1.87857 24.0958 0.014328 24.7053V24.8683C1.91402 24.2588 3.8775 23.1887 5.96857 21.1052C9.73251 17.342 10.1791 13.9758 10.6186 10.7158Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M9.47017 9.57484C9.87421 6.55583 10.2924 3.44469 13.3759 0.0146484H13.1703C10.1436 3.43761 9.71827 6.54166 9.31423 9.55358C8.88184 12.7852 8.43527 16.1231 4.71386 19.8508C3.08353 21.4808 1.517 22.4871 0.00717163 23.132V23.3021C1.55244 22.6501 3.14733 21.6367 4.82019 19.9571C8.58412 16.2011 9.03778 12.8277 9.47017 9.57484Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M8.32838 8.43311C8.6828 5.75427 9.05849 3.00457 11.2984 0.0209961H11.0999C8.90254 2.99748 8.53395 5.74719 8.17244 8.41894C7.74005 11.6506 7.29348 14.9885 3.57207 18.7162C2.34578 19.9422 1.16202 20.8068 0.0137024 21.4375V21.6147C1.19746 20.9769 2.41667 20.091 3.68549 18.8225C7.44234 15.0522 7.89599 11.686 8.32838 8.43311Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M7.18692 7.28529C7.49881 4.95371 7.82487 2.56543 9.37723 0.0141602C9.31343 0.0141602 9.24964 0.021247 9.19293 0.021247C7.66893 2.55835 7.34286 4.93954 7.03806 7.26403C6.60567 10.4956 6.1591 13.8336 2.43769 17.5613C1.61544 18.3833 0.807365 19.0424 0.0205536 19.581V19.7724C0.842807 19.2196 1.68632 18.5392 2.54402 17.6746C6.30087 13.9115 6.74744 10.5453 7.18692 7.28529Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M6.03867 6.14413C6.29385 4.22359 6.56321 2.26052 7.52014 0.198242C7.45634 0.212416 7.39255 0.233676 7.32875 0.24785C6.40726 2.28178 6.14499 4.22358 5.88981 6.12287C5.45742 9.35448 5.01085 12.6924 1.28945 16.4201C0.857054 16.8524 0.438838 17.228 0.0135345 17.5753V17.7808C0.467191 17.4123 0.927937 16.9941 1.39577 16.5264C5.15262 12.7704 5.60627 9.397 6.03867 6.14413Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M4.89743 5.00358C5.08173 3.61455 5.27312 2.21135 5.71969 0.758545C5.65589 0.786892 5.5921 0.822327 5.5283 0.850674C5.11009 2.26096 4.9187 3.62873 4.74149 4.98232C4.3091 8.21393 3.86253 11.5518 0.141126 15.2795C0.0985954 15.3221 0.0560649 15.3575 0.0135345 15.4V15.6126C0.0915068 15.5347 0.169479 15.4638 0.25454 15.3858C4.01139 11.6227 4.46504 8.25645 4.89743 5.00358Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M4.08936 1.65845C4.02556 1.70097 3.96886 1.75058 3.90506 1.7931C3.78456 2.48052 3.69241 3.16086 3.60026 3.83412C3.2104 6.73973 2.79927 9.73748 0.0135345 13.0258V13.2597C2.94104 9.89339 3.35925 6.82478 3.7562 3.85538C3.84835 3.13252 3.95468 2.39548 4.08936 1.65845Z",
    fill: "#3eb8aa"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M2.39523 3.16157C2.08334 5.47189 1.67931 7.8389 0.0135345 10.3689V10.6453C1.85652 7.93812 2.24638 5.41519 2.57953 2.96313C2.51574 3.01983 2.45903 3.0907 2.39523 3.16157Z",
    fill: "#3eb8aa"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M180.476 53.9022C181.214 54.8946 181.958 55.887 182.723 56.8865C182.801 56.8368 182.872 56.7943 182.95 56.7447C182.192 55.7523 181.448 54.7599 180.717 53.7747C180.632 53.8172 180.554 53.8597 180.476 53.9022Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M160.396 18.9442C159.567 16.7544 158.886 14.6708 158.369 12.6936C158.277 12.7078 158.192 12.729 158.099 12.7432C158.61 14.7063 159.276 16.7898 160.113 18.9797C160.205 18.9655 160.304 18.9584 160.396 18.9442Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M160.213 19.2276C160.957 21.1694 161.829 23.1962 162.821 25.3081C162.913 25.2939 163.006 25.2868 163.098 25.2727C162.105 23.175 161.241 21.1481 160.489 19.1921C160.397 19.2063 160.305 19.2134 160.213 19.2276Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M156.993 6.4864C157.142 8.33608 157.489 10.3417 158.035 12.4961C158.127 12.4819 158.212 12.4606 158.304 12.4465C157.758 10.2921 157.404 8.27229 157.255 6.40845C157.163 6.42971 157.078 6.45806 156.993 6.4864Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M162.941 25.5623C163.82 27.4049 164.784 29.3112 165.848 31.2743C165.94 31.2601 166.032 31.246 166.124 31.2318C165.068 29.2829 164.097 27.3765 163.225 25.5269C163.126 25.5339 163.033 25.5481 162.941 25.5623Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M177.883 50.3387C178.677 51.4516 179.485 52.5645 180.307 53.6845C180.385 53.6419 180.463 53.5994 180.541 53.5569C179.719 52.444 178.911 51.3382 178.131 50.2324C178.053 50.2679 177.968 50.3033 177.883 50.3387Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M156.972 6.25105C157.057 6.2227 157.142 6.19435 157.234 6.166C157.092 4.21003 157.184 2.42414 157.517 0.82959C157.411 0.893372 157.312 0.96424 157.213 1.03511C156.915 2.59422 156.837 4.33759 156.972 6.25105Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M185.178 59.6235C184.476 58.7374 183.789 57.8514 183.115 56.9653C183.037 57.015 182.967 57.0575 182.889 57.1071C183.569 58.0002 184.257 58.8863 184.958 59.7865C185.036 59.7298 185.107 59.6731 185.178 59.6235Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M185.127 59.9987C185.758 60.7997 186.396 61.6007 187.041 62.4017C187.105 62.345 187.175 62.2812 187.239 62.2245C186.594 61.4235 185.963 60.6296 185.339 59.8357C185.276 59.8924 185.205 59.942 185.127 59.9987Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M197.136 73.8605C196.725 73.4068 196.321 72.9461 195.917 72.4854C195.874 72.5704 195.831 72.6484 195.789 72.7334C196.2 73.1942 196.604 73.662 197.015 74.1228C197.058 74.0448 197.093 73.9526 197.136 73.8605Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M194.243 70.5793C192.563 68.6446 190.933 66.724 189.352 64.8035C189.288 64.8672 189.225 64.931 189.168 64.9948C190.77 66.9366 192.407 68.8784 194.094 70.8202C194.144 70.7352 194.193 70.6572 194.243 70.5793Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M177.72 50.1111C177.805 50.0757 177.883 50.0403 177.968 50.0048C173.361 43.5345 169.419 37.2981 166.251 31.4727C166.159 31.4868 166.067 31.501 165.974 31.5152C166.542 32.5569 167.13 33.6129 167.747 34.6901C170.624 39.6793 173.984 44.8527 177.72 50.1111Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M197.296 74.4403V74.1355C197.268 74.2064 197.239 74.2702 197.211 74.3411C197.239 74.3765 197.268 74.4119 197.296 74.4403Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M157.595 0.482482C157.63 0.326538 157.666 0.170593 157.708 0.0146484H157.439C157.382 0.2273 157.325 0.44704 157.283 0.673869C157.382 0.610073 157.489 0.546278 157.595 0.482482Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M195.733 72.2803C195.294 71.7841 194.861 71.2809 194.429 70.7847C194.379 70.8626 194.33 70.9406 194.287 71.0186C194.726 71.5219 195.166 72.0251 195.613 72.5284C195.648 72.4434 195.69 72.3654 195.733 72.2803Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M189.174 64.5916C188.586 63.8686 187.998 63.1527 187.416 62.4368C187.346 62.4935 187.282 62.5573 187.211 62.614C187.792 63.337 188.387 64.06 188.983 64.783C189.054 64.7121 189.118 64.6554 189.174 64.5916Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M192.806 72.96C192.394 73.6546 191.976 74.3422 191.572 75.0298C191.643 75.0865 191.707 75.1432 191.778 75.207C192.182 74.5194 192.586 73.8389 192.997 73.1514C192.933 73.0805 192.869 73.0238 192.806 72.96Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M177.14 103.675C179.465 98.317 182.179 92.7041 185.249 86.9C185.164 86.8716 185.086 86.8362 185.001 86.8008C181.953 92.5695 179.217 98.2106 176.863 103.653C176.948 103.66 177.047 103.668 177.14 103.675Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M174.488 109.394C174.19 110.145 173.885 110.903 173.602 111.647C173.155 112.831 172.73 114 172.326 115.141C172.418 115.134 172.51 115.134 172.61 115.134C173.269 113.27 173.985 111.35 174.757 109.394C174.665 109.401 174.58 109.401 174.488 109.394Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M176.741 103.908C175.975 105.68 175.266 107.416 174.586 109.139C174.678 109.139 174.77 109.139 174.862 109.139C175.543 107.431 176.259 105.694 177.024 103.923C176.932 103.916 176.84 103.916 176.741 103.908Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M186.764 83.5046C186.204 84.5254 185.666 85.5461 185.127 86.5597C185.212 86.5881 185.29 86.6235 185.375 86.659C185.907 85.6524 186.459 84.6388 187.012 83.6251C186.927 83.5826 186.842 83.5472 186.764 83.5046Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M172.233 115.41C171.482 117.558 170.816 119.627 170.234 121.619C170.326 121.611 170.419 121.604 170.518 121.597C171.106 119.599 171.772 117.529 172.517 115.396C172.425 115.403 172.332 115.403 172.233 115.41Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M191.428 75.2642C190.981 76.0226 190.549 76.7811 190.109 77.5395C190.18 77.5892 190.251 77.6388 190.329 77.6884C190.761 76.937 191.194 76.1856 191.64 75.4343C191.569 75.3847 191.499 75.328 191.428 75.2642Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M188.424 80.5071C187.906 81.4286 187.396 82.3501 186.892 83.2645C186.978 83.2999 187.055 83.3424 187.133 83.385C187.63 82.4777 188.133 81.5632 188.65 80.6488C188.572 80.5992 188.502 80.5567 188.424 80.5071Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M170.155 121.881C170.091 122.094 170.034 122.306 169.971 122.519H170.247C170.311 122.299 170.368 122.079 170.431 121.86C170.346 121.867 170.254 121.874 170.155 121.881Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M189.975 77.7793C189.501 78.6086 189.018 79.4451 188.551 80.2744C188.629 80.3169 188.707 80.3666 188.777 80.4091C189.238 79.5868 189.713 78.7575 190.188 77.9282C190.124 77.8785 190.053 77.8289 189.975 77.7793Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M194.094 70.8116C193.704 71.4494 193.328 72.0801 192.945 72.7179C193.009 72.7817 193.073 72.8455 193.137 72.9093C193.512 72.2786 193.888 71.6549 194.278 71.0242C194.327 70.9462 194.37 70.8683 194.42 70.7903C195.355 69.2454 196.319 67.7004 197.297 66.1484V65.6665C196.255 67.3107 195.235 68.9477 194.235 70.5848C194.193 70.6557 194.143 70.7336 194.094 70.8116Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M196.971 45.7673C196.787 44.9521 196.603 44.1369 196.426 43.3218C196.603 44.1299 196.787 44.945 196.971 45.7673Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M197.027 46.0303C197.119 46.4343 197.204 46.8383 197.297 47.2424C197.204 46.8383 197.119 46.4414 197.027 46.0303Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M192.357 20.9277C192.123 19.3119 191.917 17.7173 191.719 16.144C191.917 17.7173 192.13 19.3119 192.357 20.9277Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M190.578 4.28172C190.521 3.46656 190.465 2.6443 190.422 1.84331C190.394 1.33295 190.373 0.836763 190.351 0.340576C190.373 0.836763 190.394 1.34004 190.422 1.84331C190.465 2.6443 190.528 3.46656 190.578 4.28172Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M193.096 25.7903C193.301 27.0804 193.521 28.3775 193.748 29.6889C193.521 28.3775 193.301 27.0804 193.096 25.7903Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M192.392 21.1975C192.598 22.6294 192.818 24.0683 193.045 25.5285C192.818 24.0683 192.598 22.6294 192.392 21.1975Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M196.362 43.0526C195.391 38.595 194.54 34.2224 193.789 29.9419C194.54 34.2224 195.398 38.595 196.362 43.0526Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M191.067 10.32C190.875 8.36399 190.726 6.45053 190.599 4.57251C190.726 6.45053 190.875 8.36399 191.067 10.32Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M191.684 15.8691C191.471 14.0903 191.266 12.3256 191.096 10.5964C191.273 12.3256 191.471 14.0903 191.684 15.8691Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M194.305 80.7696C193.681 80.3443 193.057 79.919 192.433 79.4937C193.057 79.919 193.681 80.3443 194.305 80.7696Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M145.887 30.7495C145.334 28.9636 145.022 27.2769 144.951 25.6965C145.015 27.2769 145.334 28.9636 145.887 30.7495Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M168.596 60.7146C169.772 61.792 170.984 62.8695 172.225 63.9469C170.977 62.8695 169.772 61.7849 168.596 60.7146Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M175.996 67.1409C177.01 67.9773 178.037 68.8066 179.087 69.6431C178.045 68.8066 177.01 67.9702 175.996 67.1409Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M148.403 17.0735C147.354 18.094 146.546 19.2704 146.008 20.5957C145.596 21.602 145.348 22.6863 145.242 23.8273C145.341 22.6863 145.596 21.6091 146.008 20.5957C146.546 19.2704 147.354 18.1011 148.403 17.0735Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M148.317 36.4911C148.324 36.4911 148.324 36.4911 148.317 36.4911C147.31 34.5918 146.531 32.7705 145.971 31.0413C146.538 32.7705 147.317 34.5918 148.317 36.4911Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M195.688 81.6989C195.299 81.4366 194.916 81.1815 194.533 80.9192C194.916 81.1815 195.306 81.4437 195.688 81.6989Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M179.307 69.8142C180.235 70.5514 181.185 71.2886 182.142 72.0187C181.185 71.2815 180.235 70.5514 179.307 69.8142Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M175.786 66.9645C174.644 66.0218 173.524 65.0719 172.426 64.1221C173.531 65.0719 174.644 66.0147 175.786 66.9645Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M152.697 14.2869C151.109 14.9674 149.769 15.818 148.678 16.8174C149.769 15.818 151.109 14.9744 152.697 14.2869Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M164.323 56.6531C163.777 56.1145 163.232 55.5689 162.7 55.0303C156.186 48.404 151.401 42.2243 148.445 36.7178C151.401 42.2314 156.186 48.4111 162.7 55.0303C163.232 55.5759 163.77 56.1145 164.323 56.6531Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M196.277 17.427C196.617 17.5262 196.958 17.6326 197.298 17.7389C196.958 17.6326 196.617 17.5262 196.277 17.427Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M168.385 60.5238C167.052 59.2975 165.762 58.0713 164.521 56.8521C165.769 58.0713 167.052 59.2975 168.385 60.5238Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M196.015 17.3492C194.661 16.9523 193.322 16.5766 191.996 16.2222C193.314 16.5766 194.654 16.9452 196.015 17.3492Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M158.098 12.7434C158.19 12.7292 158.275 12.7079 158.367 12.6938C160.543 12.3252 162.968 12.1409 165.64 12.1409C170.467 12.1409 175.911 12.7292 181.823 13.8633C175.911 12.7292 170.467 12.1409 165.64 12.1409C160.48 12.1409 156.227 12.8426 152.959 14.1894C154.462 13.5656 156.184 13.0836 158.098 12.7434Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M191.719 16.1451C190.216 15.7411 188.728 15.3725 187.267 15.0251C188.735 15.3725 190.216 15.7411 191.719 16.1451Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M165.642 11.8774C168.882 11.8774 172.398 12.1468 176.14 12.6643C172.398 12.1468 168.875 11.8774 165.642 11.8774Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M186.992 14.9612C185.326 14.5713 183.696 14.224 182.094 13.9121C183.696 14.224 185.326 14.5784 186.992 14.9612Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M190.196 77.9284C190.862 78.3961 191.536 78.8709 192.216 79.3386C188.799 76.9858 185.51 74.5904 182.363 72.1809C184.823 74.0589 187.36 75.9299 189.983 77.7724C190.054 77.8291 190.125 77.8788 190.196 77.9284Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M149.267 111.547C150.728 112.32 152.401 112.979 154.286 113.511C152.401 112.979 150.728 112.32 149.267 111.547Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M145.197 108.507C146.211 109.606 147.494 110.577 149.018 111.413C147.494 110.577 146.218 109.606 145.197 108.507Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M168.37 67.135C166.945 68.2195 165.57 69.3041 164.252 70.3886C165.57 69.3041 166.945 68.2195 168.37 67.135Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M179.678 59.1621C178.579 59.8851 177.495 60.6081 176.432 61.3312C177.495 60.6081 178.579 59.8851 179.678 59.1621Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M176.202 61.4858C174.997 62.3081 173.813 63.1374 172.658 63.9597C173.813 63.1374 174.99 62.3081 176.202 61.4858Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M143.625 106.345C143.986 107.005 144.433 107.628 144.943 108.224C144.433 107.636 143.993 107.012 143.625 106.345Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M144.461 92.7749C147.169 87.1479 152.35 80.9044 159.481 74.4695C152.35 80.9044 147.169 87.1479 144.461 92.7749Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M195.583 49.6582C194.931 50.0126 194.286 50.3741 193.641 50.7356C194.278 50.3741 194.931 50.0126 195.583 49.6582Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M172.432 64.1221C171.113 65.0648 169.837 66.0147 168.59 66.9645C169.83 66.0147 171.113 65.0719 172.432 64.1221Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M143.625 106.347C143.405 105.95 143.214 105.546 143.051 105.121C143.214 105.546 143.405 105.958 143.625 106.347Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M164.031 70.564C162.514 71.8115 161.068 73.052 159.693 74.2854C161.068 73.0449 162.514 71.8044 164.031 70.564Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M182.887 57.1066C182.965 57.057 183.036 57.0144 183.114 56.9648C186.396 54.9096 189.834 52.8686 193.406 50.863C188.65 53.5277 184.142 56.2561 179.91 59.0129C180.888 58.3751 181.881 57.7373 182.887 57.1066Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M142.584 104.561C142.258 103.533 142.081 102.456 142.053 101.329C142.081 102.456 142.258 103.54 142.584 104.561Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M196.603 112.143C196.837 112.094 197.064 112.044 197.298 111.995C197.071 112.044 196.837 112.094 196.603 112.143Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M196.334 112.2C195.087 112.462 193.853 112.71 192.627 112.944C193.853 112.717 195.087 112.462 196.334 112.2Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M195.818 49.531C196.314 49.2616 196.804 48.9923 197.307 48.7229C196.804 48.9923 196.307 49.2616 195.818 49.531Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M192.358 113C190.976 113.263 189.601 113.504 188.254 113.723C189.601 113.504 190.969 113.255 192.358 113Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M168.794 115.218C163.237 115.218 158.452 114.658 154.547 113.588C158.452 114.658 163.23 115.218 168.794 115.218Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M178.187 115.02C179.811 114.871 181.469 114.687 183.156 114.467C181.469 114.687 179.811 114.871 178.187 115.02Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M177.916 115.049C174.727 115.332 171.679 115.481 168.794 115.481C168.333 115.481 167.872 115.481 167.426 115.467C167.879 115.474 168.333 115.481 168.794 115.481C169.914 115.481 171.062 115.46 172.232 115.41C172.324 115.403 172.416 115.403 172.515 115.403C174.266 115.332 176.066 115.212 177.916 115.049Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M183.441 114.432C184.93 114.233 186.44 114.014 187.971 113.766C186.44 114.014 184.93 114.241 183.441 114.432Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M187.218 119.173C187.02 120.307 186.835 121.42 186.658 122.525C186.835 121.42 187.02 120.3 187.218 119.173Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M196.491 82.2295C196.264 82.9525 196.037 83.6755 195.81 84.3985C196.037 83.6755 196.264 82.9525 196.491 82.2295Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M187.267 118.898C187.565 117.204 187.891 115.482 188.246 113.725C187.898 115.475 187.572 117.204 187.267 118.898Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M190.337 104.299C189.997 105.717 189.671 107.12 189.359 108.509C189.671 107.12 189.99 105.717 190.337 104.299Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M189.304 108.769C188.95 110.349 188.616 111.908 188.305 113.446C188.616 111.915 188.95 110.349 189.304 108.769Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M197.214 79.9683C196.994 80.6346 196.782 81.3009 196.576 81.9672C196.789 81.3009 197.001 80.6346 197.214 79.9683Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M190.394 104.042C191.479 99.5349 192.719 94.8859 194.102 90.1165C192.719 94.8859 191.479 99.5349 190.394 104.042Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M194.938 87.2751C194.676 88.1399 194.428 88.9976 194.18 89.8482C194.428 88.9976 194.683 88.1399 194.938 87.2751Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M195.731 84.6606C195.49 85.4475 195.249 86.2343 195.016 87.0211C195.249 86.2343 195.49 85.4475 195.731 84.6606Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M179.385 0.432863C178.853 0.284007 178.321 0.142239 177.797 0.0146484H176.698C177.584 0.220212 178.499 0.454129 179.42 0.709311C179.413 0.617162 179.399 0.525012 179.385 0.432863Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M195.519 6.39982C193.931 5.68389 192.379 5.0105 190.848 4.38672C190.855 4.47887 190.862 4.57811 190.869 4.67025C192.393 5.29403 193.952 5.96743 195.533 6.68336C195.526 6.59121 195.519 6.49906 195.519 6.39982Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M196.363 76.3895C196.675 76.6872 196.987 76.9849 197.299 77.2755V76.914C197.022 76.6517 196.746 76.3895 196.469 76.1272C196.434 76.2123 196.399 76.3044 196.363 76.3895Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M173.766 52.1871C174.701 53.3426 175.665 54.498 176.643 55.6605C176.721 55.6179 176.806 55.5683 176.884 55.5258C175.899 54.3704 174.942 53.215 174.014 52.0737C173.936 52.1092 173.851 52.1446 173.766 52.1871Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M154.201 20.17C154.293 20.1417 154.378 20.1204 154.463 20.0921C153.755 18.0015 153.244 16.0313 152.954 14.1816C152.868 14.2171 152.776 14.2454 152.691 14.2809C152.989 16.1164 153.492 18.0794 154.201 20.17Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M185.177 2.2325C183.277 1.57328 181.441 0.999117 179.662 0.50293C179.676 0.595079 179.69 0.687228 179.697 0.779377C181.477 1.27556 183.305 1.84972 185.205 2.50894C185.191 2.42388 185.184 2.32465 185.177 2.2325Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M192.804 72.9606C192.868 73.0244 192.932 73.0881 192.995 73.1519C193.506 73.648 194.016 74.1441 194.526 74.6402C194.569 74.5551 194.612 74.4701 194.654 74.3921C194.144 73.8961 193.64 73.4071 193.137 72.911C193.073 72.8472 193.01 72.7834 192.946 72.7196C190.989 70.7991 189.09 68.8785 187.247 66.9651C187.183 67.0289 187.126 67.0926 187.062 67.1564C188.92 69.0911 190.84 71.0259 192.804 72.9606Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M152.796 8.5752C152.697 8.65315 152.605 8.73819 152.506 8.81615C152.328 10.3965 152.385 12.1399 152.662 14.025C152.747 13.9896 152.832 13.9612 152.917 13.9258C152.633 11.9911 152.591 10.1981 152.796 8.5752Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M187.056 66.766C186.355 66.0359 185.667 65.3058 184.987 64.5828C184.916 64.6466 184.852 64.7033 184.781 64.7671C185.469 65.4972 186.163 66.2344 186.872 66.9645C186.936 66.8936 187 66.8298 187.056 66.766Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M156.873 26.6548C157.759 28.5116 158.78 30.4463 159.935 32.4448C160.027 32.4236 160.112 32.4023 160.204 32.381C159.056 30.3896 158.043 28.462 157.142 26.5911C157.057 26.6123 156.965 26.6336 156.873 26.6548Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M154.285 20.4105C154.937 22.3098 155.759 24.3012 156.752 26.3918C156.844 26.3705 156.936 26.3493 157.028 26.328C156.043 24.2445 155.207 22.2389 154.547 20.3325C154.455 20.3609 154.37 20.3892 154.285 20.4105Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M196.269 75.9366C195.794 75.483 195.326 75.0293 194.858 74.5828C194.815 74.6678 194.773 74.7529 194.73 74.8309C195.205 75.2845 195.68 75.7453 196.162 76.1989C196.198 76.1139 196.233 76.0217 196.269 75.9366Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M173.597 51.9685C173.682 51.926 173.767 51.8906 173.845 51.848C168.366 45.0942 163.808 38.6027 160.342 32.6072C160.249 32.6284 160.164 32.6497 160.072 32.671C161.66 35.4207 163.489 38.2908 165.559 41.2815C167.976 44.7895 170.669 48.3613 173.597 51.9685Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M195.796 6.81039C196.228 7.00887 196.654 7.20025 197.093 7.40582C197.072 7.29949 197.036 7.19316 197.008 7.08684C196.597 6.89545 196.193 6.71115 195.789 6.52686C195.789 6.619 195.789 6.71115 195.796 6.81039Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M182.143 61.9057C182.214 61.849 182.285 61.7923 182.363 61.7427C181.534 60.8283 180.718 59.921 179.917 59.0137C179.839 59.0633 179.761 59.1129 179.683 59.1625C180.484 60.0769 181.307 60.9913 182.143 61.9057Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M176.826 55.8737C177.698 56.9015 178.591 57.9293 179.498 58.9571C179.576 58.9075 179.647 58.8579 179.732 58.8083C178.825 57.7805 177.939 56.7597 177.074 55.739C176.989 55.7815 176.904 55.8241 176.826 55.8737Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M182.326 62.1091C183.07 62.9242 183.829 63.7465 184.594 64.5617C184.658 64.4979 184.729 64.4412 184.8 64.3774C184.041 63.5622 183.283 62.747 182.546 61.939C182.468 61.9957 182.397 62.0524 182.326 62.1091Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M157.284 0.673728C155.958 1.51707 154.895 2.59427 154.094 3.90534C153.293 5.2235 152.776 6.76135 152.542 8.48346C152.641 8.4055 152.74 8.33464 152.839 8.26377C153.08 6.69048 153.563 5.27311 154.314 4.03999C155.051 2.83522 156.022 1.83597 157.206 1.03516C157.305 0.964289 157.404 0.893421 157.511 0.829639C158 0.524903 158.524 0.255602 159.077 0.0146484H158.461C158.156 0.163473 157.865 0.312297 157.582 0.482382C157.489 0.546164 157.383 0.609946 157.284 0.673728Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M190.599 4.56536C190.592 4.47321 190.585 4.37398 190.578 4.28183C188.827 3.57299 187.112 2.92086 185.446 2.33252C185.453 2.42467 185.467 2.51682 185.474 2.61605C187.14 3.20439 188.855 3.85652 190.599 4.56536Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M140.257 90.4504C140.236 90.578 140.215 90.7056 140.193 90.8332C141.037 92.0808 142.135 93.2504 143.475 94.3491C143.511 94.264 143.539 94.1789 143.574 94.0939C142.199 92.9597 141.093 91.7405 140.257 90.4504Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M194.103 43.8107C194.132 43.8958 194.153 43.9879 194.181 44.073C194.926 43.8178 195.67 43.5697 196.428 43.3216C196.407 43.2365 196.386 43.1444 196.372 43.0522C195.606 43.3003 194.855 43.5555 194.103 43.8107Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M196.68 43.2367C196.885 43.1658 197.091 43.102 197.303 43.0311V42.7476C197.077 42.8184 196.85 42.8964 196.623 42.9673C196.637 43.0594 196.658 43.1445 196.68 43.2367Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M154.037 63.0247C152.265 64.2793 150.635 65.5269 149.146 66.7815C149.217 66.8453 149.288 66.902 149.359 66.9658C150.855 65.7112 152.485 64.4565 154.25 63.209C154.179 63.1452 154.108 63.0885 154.037 63.0247Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M193.853 43.8958C193.024 44.1793 192.202 44.4699 191.387 44.7535C191.415 44.8385 191.45 44.9236 191.479 45.0086C192.287 44.718 193.109 44.4345 193.931 44.158C193.903 44.0659 193.882 43.9808 193.853 43.8958Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M153.974 99.7844C154.016 99.7064 154.059 99.6355 154.108 99.5575C153.917 99.4937 153.725 99.4299 153.541 99.3662C151.776 98.7424 150.16 98.0619 148.693 97.3318C148.65 97.4098 148.615 97.4877 148.572 97.5586C150.054 98.2958 151.677 98.9834 153.456 99.6072C153.619 99.6709 153.796 99.7277 153.974 99.7844Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M154.236 99.8765C156.008 100.472 157.908 101.004 159.935 101.486C159.978 101.408 160.027 101.33 160.07 101.252C158.043 100.777 156.143 100.238 154.371 99.6497C154.321 99.7205 154.279 99.7985 154.236 99.8765Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M193.747 104.241C193.761 104.156 193.783 104.071 193.797 103.979C192.656 104.007 191.522 104.028 190.402 104.043C190.38 104.128 190.359 104.213 190.338 104.305C191.465 104.291 192.599 104.269 193.747 104.241Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M148.443 97.2122C146.664 96.312 145.112 95.3338 143.8 94.2776C143.765 94.3626 143.729 94.4477 143.701 94.5257C145.012 95.5677 146.565 96.5388 148.323 97.439C148.358 97.361 148.401 97.2831 148.443 97.2122Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M169.121 54.1299C167.561 54.9167 166.045 55.7106 164.57 56.5187C164.634 56.5825 164.705 56.6463 164.769 56.7101C166.236 55.9091 167.746 55.1152 169.312 54.3284C169.241 54.2716 169.178 54.2008 169.121 54.1299Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M186.099 104.036C184.695 104.015 183.32 103.98 181.959 103.93C181.924 104.015 181.895 104.1 181.867 104.185C183.228 104.235 184.61 104.277 186.021 104.299C186.049 104.213 186.078 104.121 186.099 104.036Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M159.249 59.6016C157.477 60.6861 155.825 61.7777 154.266 62.8693C154.336 62.926 154.407 62.9898 154.478 63.0465C156.038 61.9549 157.696 60.8633 159.454 59.7859C159.39 59.7292 159.32 59.6654 159.249 59.6016Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M186.375 104.042C186.346 104.128 186.318 104.213 186.297 104.298C187.027 104.305 187.75 104.312 188.494 104.312C189.012 104.312 189.543 104.305 190.068 104.298C190.089 104.213 190.11 104.128 190.132 104.035C189.586 104.042 189.04 104.05 188.501 104.05C187.778 104.057 187.076 104.05 186.375 104.042Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M138.528 86.0146C137.62 80.0971 141.554 73.5842 149.146 67.1493C149.075 67.0856 149.004 67.0289 148.933 66.9651C141.094 73.6197 137.372 80.175 138.272 86.0571C138.513 87.6162 139.095 89.0974 139.981 90.5006C140.002 90.3801 140.03 90.2596 140.052 90.1392C139.265 88.8281 138.747 87.4532 138.528 86.0146Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M197.106 104.12C197.113 104.035 197.127 103.943 197.134 103.858C196.099 103.9 195.072 103.943 194.058 103.971C194.044 104.056 194.03 104.141 194.016 104.233C195.036 104.205 196.064 104.17 197.106 104.12Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M177.025 103.922C178.514 104.029 180.038 104.114 181.59 104.17C181.618 104.085 181.654 104 181.682 103.915C180.137 103.851 178.613 103.773 177.131 103.667C177.039 103.66 176.947 103.653 176.848 103.646C170.752 103.213 165.194 102.427 160.332 101.3C160.289 101.378 160.24 101.456 160.197 101.533C165.067 102.668 170.631 103.454 176.734 103.894C176.841 103.915 176.933 103.915 177.025 103.922Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M164.523 56.852C164.459 56.7882 164.388 56.7244 164.324 56.6606C163.672 57.0151 163.027 57.3766 162.396 57.7381C161.397 58.3122 160.426 58.8864 159.49 59.4606C159.561 59.5244 159.625 59.5811 159.696 59.6449C161.234 58.7021 162.843 57.7735 164.523 56.852Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M174.02 52.0684C175.281 51.4873 176.572 50.9062 177.89 50.3392C177.975 50.3038 178.06 50.2684 178.138 50.2329C182.264 48.4471 186.637 46.732 191.23 45.1021C191.202 45.017 191.167 44.932 191.138 44.8469C186.559 46.4698 182.15 48.199 177.975 50.0062C177.89 50.0416 177.812 50.077 177.727 50.1125C176.409 50.6865 175.118 51.2676 173.85 51.8558C173.765 51.8913 173.679 51.9338 173.602 51.9763C172.163 52.6425 170.752 53.3228 169.377 54.0102C169.441 54.0811 169.504 54.1449 169.568 54.2158C170.936 53.5354 172.34 52.8551 173.779 52.1889C173.85 52.1464 173.935 52.111 174.02 52.0684Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M189.616 84.8657C189.169 85.8368 188.73 86.8009 188.305 87.7649C188.39 87.7932 188.475 87.8287 188.56 87.857C188.985 86.9001 189.417 85.9432 189.864 84.9791C189.779 84.9366 189.694 84.9012 189.616 84.8657Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M179.754 109.344C179.13 111.187 178.549 112.987 177.996 114.78C178.088 114.773 178.18 114.765 178.272 114.758C178.818 112.987 179.407 111.18 180.037 109.337C179.945 109.337 179.846 109.344 179.754 109.344Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M190.962 81.9873C190.551 82.8663 190.132 83.7452 189.728 84.6171C189.813 84.6525 189.891 84.6951 189.969 84.7305C190.366 83.8657 190.777 82.9939 191.189 82.1149C191.111 82.0724 191.033 82.0298 190.962 81.9873Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M176.133 121.264C176.019 121.69 175.913 122.108 175.807 122.526H176.076C176.189 122.094 176.296 121.661 176.416 121.229C176.317 121.236 176.225 121.25 176.133 121.264Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M193.408 76.9006C193.047 77.6307 192.685 78.3608 192.338 79.091C192.416 79.1406 192.487 79.1973 192.558 79.2469C192.905 78.5239 193.259 77.8009 193.621 77.0708C193.55 77.0141 193.479 76.9573 193.408 76.9006Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M195.603 72.5283C195.284 73.1449 194.972 73.7685 194.66 74.3851C194.618 74.4701 194.575 74.5551 194.533 74.6331C194.192 75.3064 193.866 75.9796 193.533 76.6458C193.604 76.7025 193.675 76.7592 193.746 76.8159C194.072 76.1497 194.405 75.4906 194.738 74.8244C194.781 74.7394 194.823 74.6544 194.866 74.5764C195.171 73.9669 195.482 73.3504 195.794 72.7338C195.837 72.6488 195.879 72.5708 195.922 72.4858C196.376 71.5928 196.836 70.6999 197.304 69.7999V69.24C196.772 70.2534 196.248 71.2668 195.73 72.2732C195.688 72.3653 195.645 72.4433 195.603 72.5283Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M192.442 79.4933C192.364 79.4437 192.293 79.3941 192.215 79.3374C191.825 80.1384 191.45 80.9394 191.074 81.7404C191.152 81.7829 191.23 81.8254 191.301 81.868C191.677 81.0811 192.059 80.2872 192.442 79.4933Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M178.189 115.021C178.097 115.028 178.005 115.035 177.913 115.042C177.672 115.822 177.431 116.602 177.204 117.374C176.849 118.6 176.509 119.805 176.197 120.988C176.289 120.974 176.381 120.96 176.481 120.946C176.998 119.025 177.565 117.048 178.189 115.021Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M181.596 104.179C180.987 105.83 180.398 107.474 179.846 109.09C179.938 109.09 180.037 109.083 180.129 109.076C180.682 107.467 181.263 105.844 181.873 104.186C181.901 104.101 181.937 104.016 181.965 103.931C183.851 98.8563 186.012 93.5554 188.444 88.1056C188.359 88.0772 188.274 88.0418 188.189 88.0134C185.764 93.4491 183.595 98.7642 181.689 103.916C181.66 104.008 181.625 104.094 181.596 104.179Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M189.09 25.3921C189.402 26.7885 189.728 28.1991 190.068 29.6239C190.16 29.6239 190.245 29.6239 190.337 29.6239C189.997 28.2062 189.671 26.8027 189.366 25.4134C189.267 25.4063 189.182 25.3992 189.09 25.3921Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M188.033 20.4243C188.345 21.9763 188.678 23.5425 189.033 25.1229C189.125 25.13 189.217 25.1371 189.302 25.1442C188.955 23.5638 188.621 22.0047 188.31 20.4668C188.217 20.4598 188.125 20.4456 188.033 20.4243Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M195.498 49.397C195.576 49.3544 195.653 49.3119 195.731 49.2694C195.49 48.4826 195.249 47.6957 195.016 46.9089C194.93 46.9444 194.853 46.9798 194.767 47.0153C195.008 47.8092 195.257 48.6031 195.498 49.397Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M197.298 55.073V54.2295C197.228 54.2862 197.157 54.3429 197.086 54.3996C197.157 54.6264 197.228 54.8462 197.298 55.073Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M197.214 53.9594C197.002 53.2931 196.782 52.6268 196.576 51.9604C196.498 52.0101 196.427 52.0597 196.349 52.1093C196.562 52.7827 196.782 53.4561 197.002 54.1295C197.073 54.0728 197.143 54.0161 197.214 53.9594Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M196.264 51.8494C196.342 51.7998 196.42 51.7502 196.498 51.7005C196.271 50.9775 196.045 50.2545 195.818 49.5315C195.74 49.574 195.662 49.6166 195.584 49.6591C195.811 50.3892 196.03 51.1122 196.264 51.8494Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M187.976 20.1554C188.068 20.1695 188.16 20.1837 188.253 20.1979C187.898 18.4403 187.572 16.7182 187.274 15.0245C187.182 15.0032 187.09 14.982 186.998 14.9607C187.289 16.6686 187.622 18.4049 187.976 20.1554Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M186.033 8.97949C186.302 10.8504 186.6 12.7426 186.94 14.6844C187.033 14.7057 187.125 14.7269 187.224 14.7482C186.884 12.8064 186.579 10.9142 186.302 9.05745C186.21 9.03619 186.118 9.00784 186.033 8.97949Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M185.205 2.51606C185.339 3.74918 185.488 5.01064 185.651 6.30045C185.758 7.09418 185.878 7.90209 185.991 8.70999C186.084 8.73834 186.169 8.7596 186.261 8.78794C185.956 6.67606 185.694 4.61378 185.474 2.62237C185.467 2.53024 185.453 2.43811 185.446 2.33889C185.361 1.55934 185.29 0.786867 185.219 0.0214844H184.957C185.02 0.751432 185.091 1.48847 185.169 2.23968C185.183 2.32472 185.19 2.42393 185.205 2.51606Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M193.93 44.1589C194.185 45.0235 194.433 45.8881 194.696 46.7598C194.781 46.7244 194.859 46.6889 194.944 46.6535C194.689 45.7889 194.433 44.9314 194.185 44.081C194.157 43.9959 194.136 43.9038 194.107 43.8188C192.725 39.0493 191.485 34.4003 190.4 29.8931C190.308 29.8931 190.216 29.8931 190.131 29.8931C191.229 34.457 192.47 39.1343 193.859 43.9038C193.881 43.9818 193.902 44.0668 193.93 44.1589Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M196.632 22.0548C196.859 22.1044 197.079 22.1469 197.306 22.1965V21.9343C197.072 21.8846 196.838 21.835 196.611 21.7854C196.611 21.8705 196.625 21.9626 196.632 22.0548Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M193.541 83.4493C194.193 83.8108 194.838 84.1723 195.497 84.5338C195.526 84.4487 195.554 84.3566 195.575 84.2715C194.923 83.9171 194.278 83.5556 193.633 83.1941C193.605 83.2792 193.576 83.3642 193.541 83.4493Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M172.447 70.1469C173.61 70.9834 174.793 71.8127 176.006 72.635C176.069 72.5712 176.133 72.5074 176.204 72.4365C174.999 71.6142 173.815 70.7849 172.66 69.9626C172.589 70.0264 172.518 70.0831 172.447 70.1469Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M159.247 59.6014C159.31 59.6652 159.381 59.729 159.452 59.7857C160.296 60.5369 161.16 61.3023 162.061 62.0605C162.628 62.5425 163.209 63.0314 163.797 63.5134C163.875 63.4637 163.946 63.4071 164.024 63.3574C162.514 62.1102 161.061 60.87 159.686 59.6368C159.615 59.5731 159.551 59.5164 159.48 59.4526C151.704 52.4366 146.261 45.6544 143.794 39.6448C143.716 39.7086 143.645 39.7653 143.574 39.829C146.013 45.7182 151.308 52.4366 159.247 59.6014Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M142.156 34.6265C142.34 36.1998 142.787 37.851 143.482 39.5802C143.553 39.5235 143.623 39.4598 143.701 39.396C143 37.6313 142.553 35.9376 142.39 34.3218C142.305 34.4281 142.227 34.5273 142.156 34.6265Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M176.23 72.7893C177.301 73.5194 178.392 74.2424 179.498 74.9654C179.562 74.8945 179.619 74.8237 179.682 74.7599C178.584 74.0369 177.499 73.3209 176.436 72.5908C176.365 72.6617 176.294 72.7255 176.23 72.7893Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M196.342 21.7291C195.094 21.4669 193.861 21.2188 192.635 20.9849C192.649 21.077 192.663 21.1692 192.677 21.2542C193.896 21.4881 195.123 21.7362 196.37 21.9985C196.356 21.9064 196.349 21.8142 196.342 21.7291Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M172.219 69.984C172.29 69.9202 172.361 69.8635 172.425 69.7997C171.106 68.857 169.83 67.9071 168.583 66.9573C168.512 67.014 168.434 67.0707 168.363 67.1274C169.618 68.0843 170.908 69.0342 172.219 69.984Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M149.018 22.5071C148.997 22.4221 148.982 22.337 148.961 22.252C147.473 23.06 146.218 23.9957 145.197 25.0519C145.197 25.1724 145.197 25.3 145.197 25.4205C146.218 24.3147 147.494 23.3436 149.018 22.5071Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M142.831 29.44C143.263 28.0722 143.979 26.8178 144.95 25.6981C144.943 25.5776 144.936 25.4501 144.936 25.3296C143.845 26.5273 143.058 27.8738 142.583 29.362C142.108 30.8715 141.952 32.4944 142.115 34.2236C142.193 34.1173 142.271 34.011 142.356 33.9047C142.236 32.3314 142.384 30.8361 142.831 29.44Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M164.017 63.6901C165.35 64.7817 166.725 65.8733 168.143 66.9579C168.214 66.9012 168.292 66.8445 168.363 66.7877C166.938 65.7032 165.563 64.6116 164.244 63.5342C164.166 63.5909 164.088 63.6405 164.017 63.6901Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M188.65 80.642C189.415 81.0884 190.181 81.542 190.953 81.9814C191.031 82.0239 191.109 82.0664 191.18 82.109C191.882 82.5129 192.591 82.9098 193.299 83.3066C193.335 83.2216 193.37 83.1365 193.399 83.0515C192.69 82.6546 191.995 82.2578 191.301 81.8609C191.223 81.8184 191.152 81.7759 191.074 81.7333C190.308 81.294 189.543 80.8475 188.784 80.401C188.706 80.3585 188.628 80.3089 188.557 80.2664C185.559 78.4946 182.681 76.7088 179.917 74.9087C179.853 74.9796 179.796 75.0504 179.732 75.1142C182.525 76.9355 185.431 78.7356 188.43 80.5002C188.501 80.5569 188.572 80.5995 188.65 80.642Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M195.816 84.3989C195.788 84.484 195.759 84.5761 195.738 84.6612C196.256 84.9447 196.78 85.2283 197.305 85.5118V85.207C196.801 84.9376 196.305 84.6683 195.816 84.3989Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M154.548 20.3408C156.27 19.8659 158.156 19.4973 160.211 19.228C160.304 19.2138 160.396 19.2067 160.488 19.1925C163.018 18.8735 165.79 18.7105 168.796 18.7105C173.247 18.7105 178.088 19.0578 183.235 19.7242C183.213 19.632 183.185 19.5469 183.164 19.4548C178.053 18.7956 173.233 18.4482 168.803 18.4482C165.769 18.4482 162.962 18.6184 160.403 18.9444C160.311 18.9586 160.219 18.9657 160.126 18.9799C158.085 19.2492 156.192 19.6249 154.477 20.0998C154.385 20.1211 154.3 20.1495 154.215 20.1778C152.35 20.7094 150.678 21.3616 149.224 22.1271C149.246 22.2122 149.267 22.2972 149.288 22.3823C150.748 21.6097 152.421 20.9504 154.307 20.4188C154.371 20.3905 154.456 20.3621 154.548 20.3408Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M188.304 20.475C189.651 20.6948 191.012 20.9358 192.394 21.198C192.38 21.1059 192.366 21.0208 192.358 20.9287C190.976 20.6664 189.608 20.4254 188.254 20.2057C188.162 20.1915 188.07 20.1773 187.978 20.1631C186.44 19.915 184.93 19.6953 183.441 19.4968C183.463 19.589 183.491 19.674 183.512 19.7662C184.994 19.9647 186.503 20.1844 188.035 20.4325C188.127 20.4467 188.219 20.4608 188.304 20.475Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M146.007 113.327C145.461 111.98 145.199 110.514 145.192 108.933C145.1 108.841 145.015 108.749 144.93 108.65C144.901 110.379 145.178 111.973 145.766 113.426C146.354 114.872 147.24 116.14 148.417 117.225C148.41 117.104 148.41 116.977 148.403 116.849C147.354 115.829 146.546 114.652 146.007 113.327Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M191.961 117.984C193.293 117.63 194.633 117.254 195.994 116.85C196.001 116.758 196.008 116.666 196.008 116.574C194.647 116.978 193.315 117.346 191.989 117.701C191.982 117.8 191.968 117.892 191.961 117.984Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M148.699 117.466C149.79 118.423 151.109 119.238 152.661 119.898C152.675 119.813 152.683 119.727 152.697 119.635C151.109 118.948 149.769 118.104 148.678 117.105C148.685 117.225 148.692 117.346 148.699 117.466Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M168.386 73.3994C167.053 74.6257 165.763 75.852 164.516 77.0712C164.593 77.1137 164.679 77.1633 164.757 77.2059C165.99 75.9938 167.28 74.7746 168.62 73.5483C168.549 73.4987 168.464 73.449 168.386 73.3994Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M196.262 116.77C196.382 116.735 196.496 116.699 196.616 116.664C196.659 116.564 196.687 116.465 196.729 116.359C196.581 116.401 196.432 116.451 196.283 116.494C196.269 116.586 196.262 116.678 196.262 116.77Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M179.087 64.2861C178.037 65.1155 177.01 65.9519 175.996 66.7883C176.067 66.845 176.138 66.9088 176.216 66.9655C177.222 66.1362 178.243 65.3069 179.285 64.4775C179.221 64.4137 179.157 64.3499 179.087 64.2861Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M162.698 78.8919C156.184 85.5182 151.399 91.6979 148.443 97.2115C148.401 97.2894 148.358 97.3603 148.323 97.4383C147.316 99.3375 146.536 101.159 145.976 102.888C146.054 102.945 146.132 102.994 146.21 103.051C146.77 101.308 147.564 99.4722 148.571 97.5729C148.613 97.495 148.649 97.4241 148.691 97.3461C151.952 91.2727 157.389 84.4835 164.569 77.4179C164.491 77.3753 164.406 77.3328 164.328 77.2832C163.768 77.8147 163.23 78.3533 162.698 78.8919Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M182.029 120.285C183.631 119.974 185.269 119.626 186.934 119.236C186.949 119.144 186.97 119.052 186.984 118.96C185.318 119.35 183.688 119.697 182.086 120.009C182.072 120.101 182.05 120.193 182.029 120.285Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M170.156 121.881C170.248 121.874 170.347 121.867 170.44 121.86C172.268 121.732 174.168 121.527 176.132 121.257C176.224 121.243 176.316 121.229 176.415 121.215C178.152 120.974 179.931 120.676 181.76 120.329C181.781 120.236 181.802 120.144 181.816 120.059C179.988 120.407 178.216 120.704 176.479 120.945C176.387 120.959 176.295 120.974 176.195 120.988C174.239 121.257 172.339 121.463 170.518 121.59C170.425 121.597 170.333 121.604 170.234 121.612C168.646 121.718 167.108 121.782 165.634 121.782C160.473 121.782 156.22 121.08 152.953 119.733C152.938 119.818 152.924 119.91 152.91 119.995C156.206 121.342 160.466 122.044 165.634 122.044C167.087 122.044 168.604 121.987 170.156 121.881Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M146.113 103.334C146.035 103.284 145.957 103.228 145.879 103.178C145.326 104.964 145.014 106.651 144.943 108.231C145.028 108.323 145.106 108.422 145.191 108.514C145.241 106.891 145.553 105.155 146.113 103.334Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M187.268 118.897C187.254 118.989 187.233 119.081 187.219 119.173C188.686 118.833 190.174 118.457 191.684 118.053C191.698 117.961 191.706 117.869 191.72 117.777C190.217 118.181 188.728 118.549 187.268 118.897Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M182.547 61.9393C183.397 61.2873 184.262 60.6424 185.134 59.9904C185.205 59.9337 185.283 59.8841 185.354 59.8274C188.253 57.673 191.28 55.5328 194.42 53.4067C194.384 53.3217 194.349 53.2367 194.32 53.1516C191.173 55.2777 188.125 57.4392 185.191 59.6148C185.12 59.6715 185.042 59.7211 184.971 59.7778C184.092 60.4298 183.227 61.0818 182.369 61.7409C182.299 61.7976 182.228 61.8543 182.15 61.9039C181.193 62.6409 180.243 63.3709 179.314 64.1079C179.385 64.1717 179.449 64.2355 179.52 64.2993C180.441 63.5693 181.384 62.8323 182.341 62.1023C182.398 62.0527 182.469 61.996 182.547 61.9393Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M196.263 51.8475C195.681 52.2303 195.107 52.6201 194.533 53.01C194.569 53.095 194.604 53.1801 194.632 53.2652C195.199 52.8824 195.774 52.4996 196.348 52.1168C196.426 52.0672 196.497 52.0176 196.575 51.968C196.816 51.805 197.057 51.649 197.298 51.486V51.1599C197.028 51.3371 196.759 51.5143 196.489 51.6915C196.419 51.7482 196.341 51.7979 196.263 51.8475Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M172.657 69.9628C173.742 69.0203 174.862 68.0848 176.003 67.1423C175.932 67.0856 175.861 67.0218 175.79 66.9651C174.649 67.9076 173.529 68.8573 172.43 69.8069C172.36 69.8707 172.289 69.9274 172.225 69.9912C170.984 71.0684 169.772 72.1456 168.596 73.2228C168.674 73.2724 168.752 73.322 168.837 73.3716C170.006 72.3015 171.211 71.2314 172.452 70.1542C172.515 70.0833 172.586 70.0266 172.657 69.9628Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M196.675 90.6924C196.852 89.8914 197.029 89.0834 197.214 88.2682C197.129 88.2327 197.051 88.1973 196.966 88.1619C196.781 88.977 196.597 89.7922 196.42 90.6074C196.512 90.6357 196.597 90.6641 196.675 90.6924Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M193.052 108.401C192.818 109.862 192.599 111.301 192.4 112.732C192.492 112.718 192.577 112.697 192.67 112.683C192.875 111.265 193.088 109.826 193.322 108.38C193.23 108.38 193.145 108.387 193.052 108.401Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M197.276 87.9981C197.283 87.9556 197.29 87.9202 197.304 87.8776V86.6797C197.212 87.0837 197.127 87.4878 197.035 87.8918C197.113 87.9272 197.191 87.9627 197.276 87.9981Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M193.748 104.241C193.521 105.552 193.301 106.849 193.096 108.139C193.188 108.132 193.273 108.118 193.365 108.111C193.571 106.828 193.783 105.538 194.017 104.234C194.031 104.149 194.045 104.064 194.06 103.972C194.797 99.748 195.654 95.3967 196.619 90.9532C196.533 90.9249 196.448 90.8965 196.363 90.8682C195.392 95.3258 194.542 99.6984 193.79 103.979C193.776 104.064 193.762 104.149 193.748 104.241Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M191.987 117.706C192.178 116.14 192.391 114.559 192.625 112.944C192.533 112.958 192.448 112.979 192.356 112.993C192.129 114.602 191.916 116.196 191.718 117.777C191.704 117.869 191.696 117.961 191.682 118.053C191.526 119.35 191.377 120.633 191.25 121.901C191.335 121.866 191.427 121.838 191.519 121.802C191.654 120.548 191.803 119.265 191.959 117.975C191.966 117.89 191.98 117.798 191.987 117.706Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M196.342 21.73C196.349 21.8221 196.356 21.9072 196.363 21.9993C196.469 23.3104 196.59 24.6285 196.717 25.968C196.809 25.9821 196.894 25.9892 196.987 26.0034C196.859 24.6782 196.739 23.36 196.632 22.0631C196.625 21.971 196.618 21.8859 196.611 21.7938C196.49 20.3268 196.384 18.874 196.285 17.4425C196.193 17.4141 196.108 17.3858 196.016 17.3645C196.108 18.796 196.214 20.2489 196.342 21.73Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M197.298 31.4948V30.0701C197.241 30.0701 197.184 30.063 197.135 30.063C197.191 30.5379 197.248 31.0199 197.298 31.4948Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M196.744 26.2219C196.857 27.4057 196.978 28.5965 197.106 29.8016C197.169 29.8016 197.233 29.8087 197.304 29.8087V29.0998C197.205 28.1429 197.106 27.193 197.013 26.2503C196.921 26.2432 196.829 26.2361 196.744 26.2219Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M196.263 17.1512C196.157 15.5283 196.065 13.9267 195.987 12.3534C195.902 12.3179 195.81 12.2896 195.724 12.2542C195.795 13.8416 195.888 15.4432 195.994 17.0732C196.086 17.1016 196.171 17.1299 196.263 17.1512Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M195.526 6.69168C195.562 8.42087 195.633 10.1926 195.71 11.9785C195.803 12.0139 195.888 12.0423 195.98 12.0777C195.895 10.2847 195.838 8.53426 195.796 6.81215C195.796 6.72002 195.788 6.62081 195.788 6.52868C195.774 5.74912 195.76 4.98374 195.746 4.21836C195.668 4.09788 195.576 3.9774 195.491 3.86401C195.498 4.70735 195.498 5.55069 195.519 6.4082C195.519 6.50033 195.526 6.59246 195.526 6.69168Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M173.112 57.9788C173.034 58.0284 172.956 58.0709 172.871 58.1205C173.892 59.1767 174.934 60.2329 176.004 61.289C176.082 61.2394 176.153 61.1827 176.231 61.1331C175.161 60.0769 174.126 59.0278 173.112 57.9788Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M184.778 69.1625C183.956 68.4253 183.141 67.6952 182.347 66.9651C182.283 67.0289 182.212 67.0856 182.148 67.1494C182.949 67.8866 183.764 68.6238 184.594 69.361C184.658 69.2972 184.721 69.2334 184.778 69.1625Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M149.847 12.1134C150.492 10.8306 151.386 9.73926 152.506 8.82506C152.605 8.7471 152.697 8.66206 152.796 8.5841C153.952 7.70533 155.362 7.01082 156.985 6.49348C157.07 6.46513 157.163 6.43678 157.248 6.40844C159.473 5.74227 162.11 5.4021 165.172 5.4021C169.652 5.4021 174.82 6.13205 180.498 7.5069C180.483 7.41477 180.462 7.32264 180.448 7.23051C174.791 5.86983 169.638 5.14697 165.172 5.14697C162.139 5.14697 159.488 5.49423 157.233 6.17457C157.141 6.20292 157.056 6.23126 156.971 6.25961C155.383 6.76278 154.001 7.43603 152.839 8.27228C152.739 8.34315 152.633 8.41402 152.541 8.49198C151.286 9.46288 150.301 10.6322 149.613 12C148.912 13.3961 148.522 14.9694 148.415 16.7057C148.508 16.6206 148.607 16.5427 148.699 16.4647C148.82 14.8702 149.195 13.4103 149.847 12.1134Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M169.121 54.1299C169.184 54.2007 169.248 54.2645 169.312 54.3354C170.404 55.526 171.531 56.7237 172.679 57.9213C172.757 57.8717 172.835 57.8292 172.92 57.7796C171.764 56.5819 170.645 55.3913 169.56 54.2149C169.496 54.144 169.432 54.0803 169.369 54.0094C163.003 47.043 157.907 40.3601 154.37 34.2866C154.277 34.315 154.192 34.3433 154.107 34.3717C156.581 38.6167 159.842 43.2161 163.868 48.0918C165.513 50.0903 167.27 52.103 169.121 54.1299Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M148.962 22.254C148.984 22.339 148.998 22.4241 149.019 22.5091C149.444 24.2879 150.089 26.1801 150.947 28.1715C151.032 28.1361 151.117 28.1007 151.202 28.0723C150.345 26.0738 149.699 24.1745 149.267 22.3815C149.246 22.2965 149.225 22.2115 149.203 22.1264C148.771 20.2342 148.587 18.4625 148.672 16.8254C148.579 16.9105 148.487 16.9955 148.402 17.0806C148.353 18.668 148.537 20.3972 148.962 22.254Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M151.06 28.4254C151.854 30.2467 152.825 32.1531 153.974 34.1374C154.059 34.1091 154.151 34.0807 154.243 34.0453C153.102 32.068 152.117 30.1546 151.316 28.3191C151.231 28.3616 151.145 28.397 151.06 28.4254Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M179.088 64.2848C179.152 64.3486 179.222 64.4124 179.286 64.4762C180.158 65.3053 181.051 66.1345 181.944 66.9637C182.015 66.8999 182.079 66.8432 182.143 66.7794C181.243 65.9573 180.364 65.1282 179.499 64.3061C179.435 64.2423 179.364 64.1785 179.293 64.1147C178.315 63.1864 177.358 62.258 176.415 61.3296C176.337 61.3792 176.259 61.4359 176.182 61.4855C177.146 62.421 178.11 63.3493 179.088 64.2848Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M197.085 79.5231C196.582 79.1191 196.078 78.7222 195.575 78.3181C195.54 78.4032 195.504 78.4882 195.469 78.5804C195.972 78.9844 196.482 79.3956 196.993 79.7996C197.028 79.7004 197.056 79.6153 197.085 79.5231Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M191.642 75.4409C192.231 75.9299 192.819 76.4189 193.407 76.9008C193.478 76.9575 193.549 77.0142 193.613 77.0709C194.159 77.5173 194.704 77.9567 195.25 78.4032C195.286 78.3182 195.321 78.2331 195.356 78.1481C194.811 77.7087 194.272 77.2693 193.733 76.8299C193.662 76.7732 193.591 76.7165 193.521 76.6598C192.932 76.1779 192.351 75.696 191.77 75.2141C191.699 75.1574 191.628 75.1007 191.564 75.0369C189.296 73.1447 187.099 71.2455 184.979 69.3533C184.915 69.4171 184.852 69.4879 184.795 69.5517C186.943 71.4652 189.154 73.3715 191.43 75.2708C191.5 75.3275 191.571 75.3842 191.642 75.4409Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M197.211 79.9688C197.239 79.9901 197.268 80.0113 197.296 80.0397V79.7065C197.268 79.7916 197.239 79.8767 197.211 79.9688Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M186.304 9.06654C187.87 9.53437 189.472 10.0447 191.103 10.6047C191.096 10.5126 191.081 10.4133 191.074 10.3212C189.444 9.76829 187.835 9.25793 186.268 8.783C186.176 8.75465 186.091 8.73338 185.999 8.70503C184.199 8.1734 182.448 7.70557 180.739 7.28735C180.754 7.3795 180.775 7.47165 180.789 7.5638C182.497 7.98202 184.248 8.44985 186.042 8.98857C186.119 9.00983 186.212 9.03819 186.304 9.06654Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M195.71 11.9774C194.236 11.4245 192.783 10.9 191.344 10.4109C191.351 10.503 191.365 10.5952 191.372 10.6944C192.797 11.1835 194.25 11.701 195.717 12.2539C195.802 12.2893 195.894 12.3177 195.979 12.3531C196.412 12.5161 196.858 12.6933 197.291 12.8635V12.587C196.851 12.4169 196.405 12.2397 195.965 12.0767C195.887 12.0412 195.802 12.0129 195.71 11.9774Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M145.885 103.178C145.963 103.228 146.034 103.285 146.119 103.334C147.502 104.234 149.118 105.042 150.946 105.758C150.982 105.673 151.024 105.588 151.06 105.503C149.224 104.787 147.601 103.965 146.211 103.051C146.133 103.001 146.055 102.945 145.978 102.888C144.517 101.903 143.319 100.804 142.391 99.6067C142.377 99.7484 142.362 99.8902 142.355 100.025C143.277 101.166 144.461 102.222 145.885 103.178Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M196.988 107.933C197.094 107.919 197.201 107.905 197.307 107.891V107.628C197.208 107.643 197.109 107.65 197.016 107.664C197.002 107.756 196.995 107.841 196.988 107.933Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M194.938 46.6468C194.853 46.6822 194.775 46.7177 194.689 46.7531C193.952 47.0792 193.222 47.4052 192.492 47.7313C192.52 47.8164 192.556 47.9014 192.591 47.9865C193.314 47.6604 194.044 47.3344 194.775 47.0083C194.86 46.9729 194.938 46.9374 195.023 46.902C195.689 46.6113 196.362 46.3136 197.036 46.0301C197.014 45.9379 196.993 45.8529 196.979 45.7607C196.291 46.0585 195.611 46.3491 194.938 46.6468Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M184.887 109.103C186.248 109.018 187.63 108.918 189.033 108.791C189.055 108.706 189.076 108.614 189.09 108.529C187.694 108.649 186.318 108.755 184.965 108.84C184.929 108.926 184.908 109.018 184.887 109.103Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M151.201 105.858C151.244 105.872 151.286 105.893 151.329 105.907C152.987 106.531 154.795 107.07 156.751 107.531C156.794 107.446 156.836 107.36 156.872 107.268C154.852 106.793 152.987 106.233 151.307 105.595C151.272 105.681 151.236 105.773 151.201 105.858Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M140.328 95.354C139.995 93.9083 139.96 92.3917 140.194 90.8255C140.215 90.6979 140.229 90.5704 140.257 90.4428C141.321 84.5253 146.297 77.8424 154.264 71.046C154.186 70.9964 154.115 70.9397 154.037 70.8901C145.964 77.7715 141.186 84.341 140.045 90.1239C140.024 90.2444 139.995 90.3649 139.974 90.4853C139.676 92.2004 139.705 93.8445 140.073 95.4036C140.435 96.9557 141.115 98.3801 142.108 99.6912C142.122 99.5565 142.136 99.4219 142.157 99.2872C141.271 98.0825 140.654 96.7714 140.328 95.354Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M158.973 66.9651C157.293 68.2268 155.726 69.4815 154.252 70.7219C154.33 70.7786 154.401 70.8283 154.479 70.8779C155.953 69.6303 157.527 68.3828 159.192 67.1281C159.122 67.0714 159.044 67.0218 158.973 66.9651Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M197.275 45.923C197.282 45.9159 197.29 45.9159 197.304 45.9088V45.6182C197.275 45.6323 197.247 45.6394 197.219 45.6536C197.233 45.7458 197.254 45.8379 197.275 45.923Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M174.756 109.401C175.132 109.401 175.5 109.408 175.883 109.408C177.152 109.408 178.442 109.387 179.753 109.345C179.845 109.345 179.945 109.338 180.037 109.33C181.533 109.288 183.057 109.21 184.609 109.118C184.63 109.033 184.658 108.941 184.687 108.856C183.149 108.948 181.625 109.026 180.136 109.068C180.044 109.068 179.945 109.075 179.853 109.082C178.513 109.125 177.187 109.146 175.89 109.146C175.543 109.146 175.21 109.139 174.869 109.139C174.777 109.139 174.685 109.139 174.593 109.139C167.902 109.068 162.047 108.452 157.156 107.332C157.113 107.417 157.078 107.502 157.035 107.587C161.961 108.714 167.802 109.316 174.494 109.394C174.579 109.401 174.664 109.401 174.756 109.401Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M164.245 63.5422C165.642 62.5996 167.095 61.65 168.59 60.7145C168.52 60.6508 168.449 60.587 168.385 60.5232C166.889 61.4587 165.436 62.4083 164.026 63.365C163.948 63.4146 163.87 63.4713 163.799 63.5209C163.175 63.9461 162.558 64.3643 161.956 64.7895C161.006 65.4627 160.084 66.1289 159.191 66.7951C159.262 66.8518 159.34 66.9085 159.411 66.9581C160.871 65.8667 162.409 64.7753 164.018 63.691C164.089 63.6414 164.167 63.5918 164.245 63.5422Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M193.093 108.14C191.838 108.275 190.591 108.402 189.357 108.509C189.336 108.594 189.315 108.686 189.301 108.771C190.541 108.658 191.789 108.537 193.05 108.402C193.143 108.395 193.228 108.381 193.32 108.374C194.44 108.254 195.574 108.112 196.715 107.963C196.722 107.878 196.729 107.786 196.743 107.701C195.609 107.85 194.482 107.984 193.369 108.105C193.27 108.119 193.185 108.126 193.093 108.14Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M173.111 57.9777C174.323 57.269 175.564 56.5674 176.825 55.8658C176.91 55.8233 176.988 55.7737 177.074 55.7312C178.186 55.1146 179.321 54.5052 180.476 53.8957C180.554 53.8532 180.632 53.8107 180.71 53.7681C184.403 51.8334 188.287 49.9341 192.342 48.0916C192.306 48.0065 192.278 47.9215 192.243 47.8364C188.181 49.679 184.275 51.5854 180.54 53.5484C180.462 53.591 180.384 53.6335 180.306 53.676C179.15 54.2855 178.009 54.902 176.882 55.5186C176.797 55.5611 176.719 55.6107 176.641 55.6532C175.372 56.3548 174.132 57.0635 172.913 57.7793C172.835 57.8289 172.757 57.8714 172.672 57.921C171.289 58.7289 169.936 59.551 168.617 60.3731C168.688 60.4369 168.759 60.5007 168.823 60.5644C170.134 59.7495 171.481 58.9345 172.863 58.1266C172.948 58.077 173.026 58.0273 173.111 57.9777Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M192.25 86.084C191.903 86.9984 191.556 87.9199 191.223 88.8272C191.308 88.8555 191.393 88.8839 191.478 88.9193C191.811 88.012 192.151 87.1047 192.491 86.1903C192.413 86.1549 192.335 86.1194 192.25 86.084Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M197.015 74.1293C196.76 74.7317 196.519 75.3341 196.271 75.9365C196.236 76.0215 196.2 76.1136 196.165 76.1987C195.895 76.8436 195.626 77.4956 195.364 78.1405C195.328 78.2255 195.293 78.3106 195.257 78.3956C194.974 79.1043 194.69 79.8059 194.414 80.5075C194.485 80.5571 194.563 80.6067 194.634 80.6563C194.91 79.9618 195.187 79.2673 195.47 78.5657C195.506 78.4806 195.541 78.3956 195.576 78.3035C195.839 77.6657 196.101 77.0207 196.363 76.3758C196.399 76.2908 196.434 76.1987 196.47 76.1136C196.718 75.5183 196.959 74.9301 197.207 74.3348C197.235 74.264 197.263 74.1931 197.292 74.1293V73.4561C197.235 73.5907 197.178 73.7183 197.122 73.8529C197.093 73.9521 197.058 74.0443 197.015 74.1293Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M186.021 104.298C185.553 105.836 185.107 107.352 184.682 108.862C184.653 108.947 184.632 109.039 184.604 109.124C184.122 110.839 183.654 112.533 183.228 114.205C183.321 114.191 183.42 114.177 183.512 114.17C183.944 112.511 184.398 110.825 184.88 109.11C184.908 109.025 184.93 108.933 184.951 108.848C185.376 107.352 185.823 105.836 186.291 104.305C186.319 104.22 186.347 104.135 186.369 104.05C187.836 99.259 189.509 94.284 191.373 89.1815C191.288 89.1531 191.21 89.1177 191.125 89.0894C189.254 94.1919 187.581 99.1882 186.092 104.043C186.078 104.121 186.05 104.213 186.021 104.298Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M193.641 83.1945C193.931 82.4362 194.229 81.6779 194.534 80.9196C194.456 80.87 194.385 80.8204 194.307 80.7708C194.002 81.5361 193.698 82.3015 193.4 83.0598C193.364 83.1449 193.329 83.2299 193.301 83.3149C192.974 84.1583 192.663 84.9874 192.344 85.8237C192.422 85.8591 192.507 85.8946 192.585 85.93C192.897 85.1008 193.215 84.2788 193.534 83.4425C193.577 83.3645 193.605 83.2795 193.641 83.1945Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M182.094 120.009C182.505 118.188 182.952 116.331 183.441 114.432C183.349 114.446 183.25 114.46 183.158 114.467C182.676 116.366 182.236 118.223 181.818 120.059C181.797 120.151 181.775 120.243 181.761 120.328C181.598 121.058 181.428 121.795 181.279 122.511H181.549C181.704 121.774 181.867 121.03 182.038 120.278C182.052 120.193 182.073 120.101 182.094 120.009Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M196.363 57.533C196.1 56.888 195.838 56.25 195.576 55.6121C195.505 55.6688 195.434 55.7255 195.363 55.7822C195.625 56.4272 195.895 57.0794 196.164 57.7244C196.228 57.6606 196.299 57.5968 196.363 57.533Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M194.308 53.1591C194.343 53.2441 194.378 53.3292 194.407 53.4142C194.683 54.1158 194.967 54.8174 195.25 55.5261C195.321 55.4694 195.392 55.4127 195.463 55.3489C195.179 54.6544 194.903 53.9528 194.627 53.2583C194.591 53.1732 194.563 53.0882 194.527 53.0032C194.223 52.2449 193.925 51.4866 193.634 50.7283C193.556 50.7708 193.478 50.8133 193.4 50.8629C193.698 51.6283 194.01 52.3937 194.308 53.1591Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M184.68 25.0659C185.105 26.5687 185.551 28.0927 186.019 29.6308C186.111 29.6308 186.204 29.6308 186.289 29.6308C185.821 28.0997 185.374 26.5828 184.949 25.0872C184.864 25.0801 184.772 25.073 184.68 25.0659Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M183.157 19.4541C183.178 19.5462 183.206 19.6313 183.228 19.7234C183.66 21.3959 184.121 23.0897 184.603 24.8047C184.695 24.8118 184.787 24.8189 184.879 24.8189C184.39 23.1038 183.936 21.4172 183.511 19.7588C183.49 19.6667 183.462 19.5817 183.44 19.4895C182.951 17.5903 182.505 15.7335 182.093 13.9122C182.001 13.898 181.909 13.8767 181.824 13.8555C182.235 15.6981 182.675 17.5548 183.157 19.4541Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M196.269 57.9924C196.61 58.8147 196.95 59.6369 197.304 60.4663V59.7929C197.028 59.1266 196.751 58.4673 196.475 57.801C196.404 57.8648 196.34 57.9286 196.269 57.9924Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M179.421 0.709162C179.691 2.78562 180.038 4.9542 180.449 7.222C180.463 7.31413 180.485 7.40626 180.499 7.49838C180.726 8.71024 180.967 9.95044 181.229 11.2119C181.392 11.9915 181.576 12.7923 181.753 13.586C181.846 13.6002 181.931 13.6214 182.023 13.6356C181.555 11.5521 181.137 9.52523 180.768 7.56217C180.754 7.47004 180.733 7.37791 180.718 7.28578C180.307 5.03924 179.96 2.87066 179.684 0.787117C179.669 0.694988 179.655 0.602859 179.648 0.510729C179.627 0.347731 179.613 0.184733 179.591 0.0146484H179.322C179.343 0.156386 179.357 0.291036 179.379 0.432774C179.4 0.524903 179.414 0.617033 179.421 0.709162Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M191.223 45.102C191.556 46.0162 191.904 46.9304 192.251 47.8446C192.286 47.9297 192.315 48.0147 192.35 48.0997C192.669 48.936 192.981 49.7652 193.307 50.6085C193.385 50.566 193.463 50.5235 193.548 50.4738C193.222 49.6447 192.91 48.8155 192.598 47.9864C192.57 47.9013 192.535 47.8163 192.499 47.7312C192.152 46.817 191.819 45.9099 191.485 45.0028C191.457 44.9177 191.422 44.8327 191.393 44.7477C189.522 39.6451 187.849 34.6701 186.382 29.8794C186.29 29.8794 186.197 29.8794 186.105 29.8794C187.587 34.741 189.267 39.7372 191.138 44.8327C191.166 44.9319 191.195 45.017 191.223 45.102Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M140.327 38.5678C140.653 37.1575 141.27 35.8393 142.156 34.6275C142.227 34.5283 142.305 34.4291 142.383 34.3298C143.311 33.1322 144.509 32.0337 145.969 31.0486C145.934 30.9494 145.913 30.8502 145.877 30.7581C144.452 31.7148 143.276 32.7636 142.347 33.9188C142.262 34.0251 142.184 34.1314 142.106 34.2377C141.114 35.5488 140.433 36.9732 140.072 38.5253C139.71 40.0844 139.682 41.7285 139.973 43.4436C140.043 43.3302 140.114 43.2168 140.192 43.1105C139.958 41.5301 139.994 40.0135 140.327 38.5678Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M168.385 73.3982C168.463 73.4478 168.541 73.4974 168.619 73.547C169.937 74.3691 171.291 75.1911 172.673 75.999C172.737 75.9352 172.801 75.8644 172.865 75.8006C171.482 74.9927 170.135 74.1777 168.824 73.3627C168.746 73.3131 168.668 73.2635 168.583 73.2139C167.087 72.2784 165.634 71.3288 164.238 70.3862C164.167 70.4429 164.096 70.5067 164.025 70.5634C165.443 71.513 166.889 72.4627 168.385 73.3982Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M172.92 76.1421C174.139 76.858 175.379 77.5668 176.648 78.2686C176.712 78.1977 176.769 78.1268 176.826 78.0559C175.564 77.3542 174.323 76.6524 173.111 75.9436C173.047 76.0074 172.984 76.0783 172.92 76.1421Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M154.037 63.0229C154.108 63.0796 154.179 63.1434 154.25 63.2001C155.717 64.4403 157.291 65.6946 158.971 66.9561C159.042 67.0128 159.12 67.0695 159.191 67.1191C160.084 67.7853 161.005 68.4585 161.955 69.1247C162.558 69.5499 163.174 69.9751 163.798 70.3932C163.869 70.3365 163.94 70.2728 164.011 70.2161C162.409 69.1318 160.87 68.0404 159.41 66.949C159.339 66.8923 159.261 66.8356 159.191 66.786C157.525 65.5316 155.951 64.2844 154.477 63.0371C154.406 62.9804 154.335 62.9166 154.264 62.8599C146.29 56.0636 141.321 49.3878 140.25 43.4702C140.187 43.5765 140.109 43.6828 140.045 43.7891C141.193 49.572 145.971 56.1415 154.037 63.0229Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M187.007 83.6261C187.872 84.0442 188.736 84.4552 189.615 84.8663C189.693 84.9017 189.778 84.9442 189.856 84.9797C190.65 85.3482 191.451 85.7167 192.252 86.0852C192.33 86.1206 192.415 86.1561 192.493 86.1915C193.223 86.5175 193.953 86.8506 194.691 87.1695C194.719 87.0845 194.747 86.9923 194.769 86.9073C194.039 86.5813 193.308 86.2624 192.585 85.9293C192.507 85.8939 192.422 85.8584 192.344 85.823C191.543 85.4616 190.75 85.093 189.963 84.7245C189.878 84.6891 189.8 84.6466 189.722 84.6111C188.85 84.2001 187.985 83.7891 187.134 83.378C187.049 83.3355 186.971 83.3001 186.893 83.2575C183.47 81.5992 180.195 79.9055 177.069 78.1833C177.012 78.2542 176.948 78.3251 176.885 78.396C180.039 80.1393 183.342 81.8402 186.759 83.4985C186.844 83.5481 186.929 83.5835 187.007 83.6261Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M197.028 87.8926C196.355 87.602 195.682 87.3114 195.015 87.0137C194.987 87.0987 194.966 87.1909 194.937 87.2759C195.611 87.5737 196.284 87.8643 196.972 88.1549C197.05 88.1903 197.135 88.2258 197.22 88.2612C197.248 88.2754 197.277 88.2896 197.305 88.2967V88.006C197.298 87.999 197.284 87.999 197.277 87.9919C197.191 87.9635 197.114 87.9281 197.028 87.8926Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M196.717 25.9595C195.576 25.8106 194.442 25.6759 193.322 25.5483C193.336 25.6334 193.35 25.7255 193.365 25.8106C194.478 25.9311 195.605 26.0729 196.739 26.2146C196.831 26.2288 196.916 26.2359 197.008 26.2501C197.107 26.2643 197.207 26.2714 197.299 26.2855V26.0233C197.192 26.0091 197.086 25.9949 196.98 25.9807C196.895 25.9807 196.81 25.9736 196.717 25.9595Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M151.316 28.3266C152.996 27.6817 154.853 27.1219 156.881 26.6541C156.973 26.6329 157.058 26.6116 157.15 26.5904C158.95 26.1793 160.886 25.8321 162.941 25.5628C163.033 25.5486 163.126 25.5344 163.218 25.5273C167.031 25.0312 171.263 24.7761 175.885 24.7761C178.713 24.7761 181.655 24.8824 184.681 25.0667C184.773 25.0738 184.866 25.0738 184.958 25.0809C186.319 25.1659 187.694 25.2722 189.09 25.3927C189.182 25.3998 189.275 25.4069 189.367 25.4139C190.6 25.5273 191.841 25.6478 193.102 25.7825C193.088 25.6974 193.074 25.6053 193.06 25.5202C191.798 25.3785 190.543 25.258 189.31 25.1517C189.218 25.1446 189.126 25.1376 189.041 25.1305C187.644 25.01 186.262 24.9037 184.894 24.8186C184.802 24.8116 184.71 24.8045 184.618 24.8045C181.619 24.6202 178.699 24.521 175.899 24.521C171.228 24.521 166.96 24.7761 163.111 25.2722C163.019 25.2864 162.927 25.2935 162.835 25.3076C160.779 25.5769 158.851 25.9242 157.044 26.3352C156.952 26.3565 156.859 26.3778 156.767 26.399C154.811 26.8597 153.003 27.3983 151.345 28.0219C151.302 28.0361 151.26 28.0573 151.217 28.0715C151.132 28.107 151.047 28.1424 150.962 28.1707C149.133 28.8865 147.517 29.6944 146.135 30.5944C146.163 30.6937 146.198 30.7858 146.227 30.885C147.623 29.9708 149.239 29.1487 151.075 28.4329C151.146 28.3975 151.231 28.3621 151.316 28.3266Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M154.101 99.5565C154.059 99.6345 154.016 99.7054 153.966 99.7833C152.818 101.768 151.854 103.674 151.053 105.495C151.018 105.58 150.975 105.665 150.94 105.75C150.082 107.742 149.444 109.634 149.012 111.413C149.097 111.455 149.175 111.505 149.26 111.548C149.685 109.755 150.337 107.848 151.195 105.857C151.23 105.772 151.266 105.68 151.308 105.595C152.109 103.759 153.087 101.846 154.236 99.8754C154.278 99.7975 154.321 99.7195 154.37 99.6487C157.908 93.5752 163.004 86.8923 169.369 79.9259C169.284 79.8834 169.199 79.8409 169.121 79.7983C167.271 81.8252 165.52 83.8379 163.869 85.8364C159.836 90.7121 156.575 95.3044 154.101 99.5565Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M148.7 117.466C148.693 117.346 148.679 117.225 148.672 117.105C148.587 115.489 148.764 113.738 149.189 111.868C149.104 111.825 149.026 111.783 148.948 111.733C148.537 113.561 148.353 115.269 148.402 116.843C148.409 116.97 148.409 117.091 148.416 117.218C148.516 118.954 148.913 120.528 149.614 121.924C149.714 122.129 149.827 122.321 149.948 122.512H150.245C150.104 122.285 149.969 122.051 149.848 121.803C149.196 120.514 148.821 119.061 148.7 117.466Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M197 54.1303C196.489 54.5343 195.979 54.9453 195.469 55.3493C195.398 55.406 195.327 55.4627 195.256 55.5265C192.506 57.7446 189.826 59.977 187.246 62.2235C187.175 62.2802 187.111 62.344 187.048 62.4007C186.289 63.0598 185.538 63.7189 184.801 64.385C184.737 64.4488 184.666 64.5055 184.595 64.5693C183.773 65.3063 182.958 66.0434 182.149 66.7875C182.079 66.8513 182.015 66.908 181.951 66.9718C181.051 67.8009 180.165 68.6301 179.293 69.4522C179.364 69.5089 179.442 69.5656 179.513 69.6222C180.377 68.8002 181.256 67.9781 182.157 67.1489C182.227 67.0851 182.291 67.0285 182.355 66.9647C183.156 66.2347 183.964 65.4977 184.786 64.7677C184.85 64.704 184.921 64.6473 184.992 64.5835C185.729 63.9244 186.466 63.2724 187.225 62.6133C187.296 62.5566 187.359 62.4929 187.43 62.4362C189.975 60.218 192.633 57.9998 195.376 55.7887C195.447 55.732 195.518 55.6753 195.589 55.6186C196.092 55.2146 196.596 54.8107 197.099 54.4138C197.17 54.3571 197.241 54.3004 197.312 54.2437V53.9036C197.283 53.9248 197.255 53.9461 197.226 53.9744C197.141 54.017 197.071 54.0736 197 54.1303Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M173.114 75.9438C174.127 74.8949 175.169 73.8461 176.233 72.7901C176.296 72.7264 176.367 72.6555 176.431 72.5917C177.374 71.6633 178.331 70.7349 179.309 69.8066C179.238 69.7499 179.167 69.6932 179.096 69.6365C178.118 70.5719 177.147 71.5074 176.204 72.4358C176.14 72.4996 176.077 72.5634 176.006 72.6342C174.935 73.6902 173.893 74.7461 172.873 75.8021C172.809 75.8658 172.745 75.9367 172.681 76.0005C171.526 77.1982 170.399 78.3958 169.314 79.5864C169.399 79.629 169.484 79.6715 169.562 79.714C170.647 78.5305 171.767 77.3399 172.922 76.1493C172.986 76.0784 173.05 76.0076 173.114 75.9438Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M197.107 104.121C196.972 105.326 196.859 106.51 196.738 107.7C196.731 107.785 196.724 107.877 196.71 107.962C196.582 109.295 196.462 110.62 196.355 111.931C196.447 111.91 196.533 111.896 196.625 111.874C196.731 110.57 196.852 109.259 196.979 107.934C196.986 107.849 196.993 107.757 197.007 107.672C197.1 106.729 197.199 105.773 197.298 104.816V102.42C197.241 102.902 197.185 103.384 197.135 103.866C197.128 103.951 197.114 104.036 197.107 104.121Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M196.277 116.494C196.377 115.063 196.483 113.61 196.603 112.143C196.511 112.164 196.426 112.179 196.334 112.2C196.214 113.674 196.107 115.134 196.008 116.579C196.001 116.672 195.994 116.764 195.994 116.856C195.966 117.253 195.937 117.65 195.916 118.046C196.015 117.883 196.121 117.713 196.214 117.536C196.228 117.281 196.249 117.033 196.263 116.778C196.263 116.679 196.27 116.587 196.277 116.494Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M190.578 4.28089C190.585 4.37302 190.592 4.47224 190.599 4.56436C190.727 6.44947 190.876 8.35584 191.067 10.3118C191.074 10.4039 191.088 10.5032 191.096 10.5953C191.266 12.3245 191.464 14.082 191.684 15.8679C191.776 15.8892 191.868 15.9175 191.953 15.9388C191.734 14.1529 191.542 12.4095 191.372 10.6874C191.365 10.5953 191.351 10.5032 191.344 10.4039C191.152 8.44797 190.989 6.53452 190.862 4.66358C190.855 4.57145 190.847 4.47224 190.84 4.38011C190.748 3.02651 190.67 1.70127 190.614 0.397285C190.528 0.368937 190.436 0.354764 190.351 0.326416C190.373 0.822497 190.394 1.32566 190.422 1.82883C190.465 2.64382 190.528 3.4659 190.578 4.28089Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M192.357 20.9284C192.371 21.0205 192.385 21.1056 192.392 21.1977C192.598 22.6293 192.817 24.0679 193.044 25.5278C193.058 25.6128 193.073 25.705 193.087 25.79C193.292 27.0798 193.512 28.3767 193.739 29.6878C193.831 29.6878 193.916 29.6949 194.008 29.6949C193.781 28.3909 193.562 27.1011 193.363 25.8183C193.349 25.7333 193.335 25.6412 193.321 25.5561C193.087 24.1033 192.874 22.6718 192.668 21.2544C192.654 21.1623 192.64 21.0772 192.626 20.9851C192.399 19.3764 192.179 17.7889 191.988 16.2227C191.896 16.2015 191.811 16.1731 191.719 16.1519C191.917 17.7181 192.13 19.3126 192.357 20.9284Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M197.213 45.6606C197.028 44.8527 196.851 44.0448 196.674 43.2369C196.653 43.1447 196.638 43.0597 196.617 42.9676C195.653 38.5241 194.795 34.1728 194.058 29.949C193.966 29.949 193.881 29.9419 193.789 29.9419C194.54 34.2224 195.391 38.595 196.362 43.0526C196.383 43.1376 196.405 43.2298 196.419 43.3219C196.596 44.1298 196.78 44.9519 196.965 45.7669C196.986 45.859 197.007 45.9441 197.021 46.0362C197.113 46.4401 197.198 46.8441 197.291 47.248V46.0433C197.284 46.0078 197.276 45.9653 197.262 45.9299C197.255 45.8377 197.234 45.7456 197.213 45.6606Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M164.323 56.6538C164.387 56.7175 164.458 56.7813 164.522 56.8451C165.769 58.0711 167.052 59.2901 168.385 60.5161C168.456 60.5799 168.527 60.6437 168.59 60.7074C169.767 61.7846 170.979 62.8619 172.22 63.9391C172.298 63.8824 172.368 63.8328 172.446 63.7761C171.206 62.6989 170.001 61.6287 168.831 60.5586C168.761 60.4948 168.69 60.4311 168.626 60.3673C167.286 59.1412 166.003 57.9223 164.763 56.7104C164.699 56.6467 164.628 56.5829 164.564 56.5191C157.384 49.4535 151.947 42.6643 148.686 36.5908C148.601 36.6333 148.523 36.6759 148.445 36.7184C151.401 42.232 156.186 48.4117 162.7 55.0309C163.232 55.5766 163.777 56.1151 164.323 56.6538Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M175.786 66.9648C175.856 67.0215 175.927 67.0853 175.998 67.142C177.012 67.9782 178.04 68.8074 179.089 69.6436C179.16 69.7003 179.231 69.757 179.301 69.8137C180.23 70.5507 181.18 71.2878 182.137 72.0177C182.201 71.9469 182.257 71.8831 182.321 71.8122C181.364 71.0823 180.428 70.3452 179.507 69.6153C179.436 69.5586 179.358 69.5019 179.287 69.4452C178.245 68.616 177.217 67.7869 176.218 66.9577C176.147 66.901 176.069 66.8372 175.998 66.7805C174.857 65.838 173.744 64.8954 172.652 63.96C172.575 64.0167 172.504 64.0663 172.426 64.123C173.531 65.0726 174.644 66.0152 175.786 66.9648Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M192.215 79.3391C192.286 79.3887 192.364 79.4454 192.442 79.495C193.059 79.9202 193.683 80.3454 194.313 80.7706C194.391 80.8202 194.462 80.8699 194.54 80.9195C194.923 81.1817 195.306 81.4439 195.696 81.699C195.887 81.8266 196.078 81.9541 196.263 82.0746C196.291 81.9896 196.319 81.8975 196.348 81.8053C195.774 81.4226 195.2 81.0399 194.632 80.6572C194.554 80.6076 194.484 80.558 194.413 80.5084C193.789 80.0832 193.172 79.6651 192.556 79.2399C192.485 79.1903 192.407 79.1407 192.336 79.084C191.662 78.6162 190.996 78.1556 190.33 77.6878C190.259 77.6382 190.188 77.5886 190.11 77.539C187.494 75.6964 184.971 73.8397 182.54 71.9758C182.476 72.0467 182.419 72.1105 182.355 72.1813C185.51 74.5909 188.799 76.9862 192.215 79.3391Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M196.575 81.96C196.547 82.0521 196.518 82.1372 196.49 82.2293C196.759 82.4065 197.029 82.5837 197.298 82.768V82.4491C197.057 82.286 196.816 82.123 196.575 81.96Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M195.994 17.0721C194.633 16.6753 193.286 16.2996 191.961 15.9382C191.868 15.917 191.776 15.8886 191.691 15.8673C190.181 15.4634 188.693 15.0949 187.226 14.7476C187.133 14.7264 187.034 14.7051 186.942 14.6838C185.276 14.2941 183.639 13.9468 182.037 13.635C181.945 13.6208 181.86 13.5996 181.768 13.5854C179.839 13.2169 177.968 12.9121 176.146 12.6641C172.404 12.1467 168.888 11.8774 165.648 11.8774C162.955 11.8774 160.509 12.0688 158.312 12.4373C158.22 12.4515 158.135 12.4727 158.043 12.4869C156.136 12.8271 154.435 13.309 152.925 13.9255C152.84 13.961 152.755 13.9893 152.67 14.0248C151.124 14.6838 149.806 15.4988 148.714 16.4556C148.622 16.5335 148.523 16.6115 148.431 16.6965C147.254 17.7879 146.368 19.0564 145.78 20.4951C145.184 21.9621 144.915 23.5708 144.943 25.3212C144.943 25.4417 144.95 25.5693 144.957 25.6898C145.021 27.2701 145.34 28.9568 145.893 30.7427C145.922 30.8419 145.95 30.934 145.985 31.0333C146.545 32.7625 147.332 34.5838 148.332 36.4831C148.417 36.4405 148.495 36.398 148.58 36.3555C147.573 34.4491 146.786 32.6207 146.219 30.8773C146.191 30.7781 146.155 30.686 146.127 30.5868C145.56 28.7655 145.255 27.0292 145.213 25.4134C145.213 25.2929 145.213 25.1653 145.213 25.0448C145.213 24.6338 145.227 24.2228 145.262 23.8259C145.362 22.6849 145.617 21.6006 146.028 20.5943C146.567 19.269 147.375 18.0926 148.424 17.0721C148.516 16.9871 148.601 16.902 148.693 16.817C149.785 15.8177 151.124 14.9744 152.712 14.287C152.797 14.2515 152.889 14.2232 152.974 14.1878C156.242 12.8342 160.495 12.1397 165.656 12.1397C170.483 12.1397 175.927 12.7279 181.838 13.8618C181.931 13.8759 182.023 13.8972 182.108 13.9185C183.71 14.2303 185.34 14.5775 187.006 14.9673C187.098 14.9886 187.19 15.0098 187.282 15.0311C188.742 15.3713 190.231 15.7469 191.734 16.1508C191.826 16.1721 191.911 16.2004 192.003 16.2217C193.329 16.576 194.668 16.9516 196.022 17.3485C196.114 17.3769 196.199 17.4052 196.292 17.4265C196.632 17.5257 196.972 17.632 197.312 17.7383V17.469C196.965 17.3627 196.618 17.2564 196.27 17.1572C196.171 17.1288 196.086 17.1005 195.994 17.0721Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M148.947 111.738C149.025 111.781 149.11 111.824 149.188 111.873C150.641 112.639 152.307 113.283 154.179 113.801C154.214 113.709 154.249 113.609 154.278 113.51C152.392 112.979 150.719 112.32 149.259 111.547C149.174 111.505 149.089 111.462 149.011 111.413C147.487 110.576 146.204 109.605 145.19 108.507C145.105 108.415 145.02 108.316 144.942 108.223C144.432 107.635 143.985 107.004 143.624 106.345C143.404 105.949 143.213 105.545 143.05 105.119C142.965 104.907 142.894 104.694 142.823 104.482C142.376 103.085 142.228 101.59 142.348 100.017C142.355 99.8751 142.369 99.7404 142.383 99.5987C142.547 97.9829 142.993 96.2891 143.695 94.5245C143.73 94.4394 143.766 94.3544 143.794 94.2764C144 93.7804 144.212 93.2843 144.46 92.774C147.168 87.1471 152.35 80.9035 159.481 74.4686C159.403 74.419 159.325 74.3694 159.247 74.3269C151.308 81.4917 146.006 88.2101 143.574 94.0922C143.539 94.1772 143.511 94.2623 143.475 94.3473C142.78 96.0765 142.341 97.7278 142.15 99.301C142.135 99.4357 142.114 99.5703 142.1 99.705C142.05 100.258 142.029 100.803 142.043 101.335C142.072 102.462 142.249 103.539 142.575 104.567C143.057 106.083 143.844 107.444 144.928 108.656C145.013 108.748 145.105 108.847 145.19 108.939C146.211 109.995 147.466 110.931 148.947 111.738Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M168.796 115.474C171.681 115.474 174.729 115.325 177.919 115.041C178.011 115.034 178.103 115.027 178.195 115.02C179.818 114.871 181.477 114.687 183.164 114.467C183.256 114.453 183.356 114.439 183.448 114.432C184.936 114.233 186.446 114.014 187.977 113.765C187.991 113.673 188.013 113.581 188.034 113.496C186.503 113.744 185 113.964 183.519 114.162C183.426 114.177 183.327 114.191 183.235 114.198C181.548 114.418 179.896 114.602 178.28 114.751C178.188 114.758 178.096 114.765 178.004 114.772C176.161 114.935 174.36 115.056 172.617 115.126C172.524 115.134 172.432 115.134 172.333 115.134C171.128 115.183 169.951 115.204 168.796 115.204C163.239 115.204 158.454 114.644 154.548 113.574C154.513 113.673 154.485 113.765 154.449 113.865C158.043 114.836 162.381 115.375 167.421 115.452C167.875 115.474 168.328 115.474 168.796 115.474Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M195.498 49.3962C194.839 49.7576 194.187 50.1191 193.542 50.4805C193.464 50.523 193.386 50.5656 193.301 50.6152C189.721 52.6207 186.262 54.6688 182.945 56.7524C182.867 56.802 182.796 56.8445 182.718 56.8941C181.704 57.5319 180.705 58.1698 179.727 58.8076C179.649 58.8572 179.571 58.9068 179.493 58.9564C178.387 59.6793 177.295 60.4021 176.225 61.1321C176.147 61.1817 176.076 61.2384 175.998 61.288C174.786 62.1172 173.602 62.9463 172.44 63.7755C172.362 63.8322 172.291 63.8818 172.213 63.9385C170.894 64.8881 169.611 65.8378 168.357 66.7874C168.286 66.8441 168.208 66.9008 168.137 66.9575C166.719 68.0418 165.344 69.1332 164.012 70.2245C163.941 70.2812 163.87 70.345 163.799 70.4017C163.211 70.8836 162.629 71.3726 162.062 71.8545C161.162 72.6199 160.297 73.3782 159.461 74.1294C159.539 74.179 159.617 74.2286 159.695 74.2711C161.07 73.038 162.516 71.7978 164.033 70.5505C164.104 70.4938 164.175 70.4301 164.245 70.3734C165.571 69.2891 166.946 68.2048 168.364 67.1205C168.435 67.0638 168.513 67.0071 168.584 66.9504C169.831 66.0008 171.107 65.0582 172.425 64.1086C172.503 64.0519 172.574 64.0023 172.652 63.9456C173.808 63.1164 174.984 62.2943 176.197 61.4722C176.274 61.4226 176.352 61.3659 176.43 61.3163C177.494 60.5935 178.578 59.8706 179.677 59.1478C179.755 59.0981 179.833 59.0485 179.911 58.9989C184.135 56.2421 188.651 53.5208 193.407 50.849C193.485 50.8065 193.563 50.764 193.641 50.7144C194.286 50.3529 194.931 49.9986 195.583 49.6372C195.661 49.5947 195.739 49.5521 195.817 49.5096C196.313 49.2403 196.802 48.971 197.306 48.7017V48.397C196.781 48.6804 196.257 48.9639 195.739 49.2474C195.661 49.3112 195.576 49.3537 195.498 49.3962Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M196.363 111.931C195.122 112.194 193.889 112.442 192.67 112.676C192.578 112.69 192.486 112.711 192.4 112.725C191.018 112.988 189.657 113.229 188.31 113.448C188.289 113.54 188.275 113.626 188.254 113.718C189.608 113.498 190.976 113.257 192.358 112.995C192.45 112.98 192.535 112.959 192.627 112.945C193.854 112.711 195.087 112.463 196.335 112.201C196.427 112.179 196.512 112.165 196.604 112.144C196.838 112.094 197.065 112.045 197.299 111.995V111.733C197.072 111.783 196.852 111.832 196.625 111.875C196.54 111.896 196.448 111.91 196.363 111.931Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M187.266 118.897C187.563 117.204 187.89 115.481 188.244 113.724C188.265 113.632 188.279 113.547 188.301 113.455C188.613 111.917 188.946 110.358 189.3 108.777C189.321 108.692 189.343 108.6 189.357 108.515C189.669 107.126 189.988 105.723 190.335 104.305C190.356 104.22 190.378 104.135 190.399 104.043C191.483 99.536 192.724 94.887 194.106 90.1175C194.021 90.0892 193.936 90.0608 193.858 90.0325C192.476 94.8019 191.228 99.4793 190.129 104.043C190.108 104.128 190.087 104.213 190.066 104.305C189.725 105.73 189.399 107.133 189.087 108.536C189.066 108.621 189.052 108.713 189.031 108.799C188.683 110.386 188.35 111.952 188.038 113.504C188.017 113.596 188.003 113.681 187.982 113.773C187.627 115.524 187.294 117.26 186.996 118.968C186.982 119.06 186.961 119.152 186.947 119.245C186.755 120.35 186.578 121.441 186.408 122.526H186.67C186.848 121.42 187.032 120.308 187.23 119.174C187.237 119.082 187.252 118.989 187.266 118.897Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M197 79.7919C196.78 80.4652 196.56 81.1384 196.347 81.8117C196.319 81.9038 196.291 81.9889 196.262 82.081C196.028 82.8109 195.809 83.5409 195.582 84.2708C195.554 84.3559 195.525 84.448 195.504 84.533C195.256 85.3268 195.015 86.1205 194.774 86.9142C194.745 86.9993 194.717 87.0914 194.696 87.1764C194.434 88.0481 194.185 88.9056 193.937 89.7702C194.022 89.7986 194.1 89.8269 194.185 89.8553C194.434 88.9978 194.689 88.1403 194.944 87.2827C194.972 87.1977 194.994 87.1056 195.022 87.0205C195.256 86.241 195.497 85.4543 195.738 84.6606C195.766 84.5756 195.795 84.4834 195.816 84.3984C196.036 83.6755 196.262 82.9527 196.496 82.2298C196.525 82.1377 196.553 82.0526 196.581 81.9605C196.794 81.2943 197.007 80.6282 197.219 79.962C197.248 79.877 197.276 79.7848 197.304 79.6998V78.8494C197.233 79.0761 197.163 79.2958 197.092 79.5226C197.056 79.6148 197.028 79.6998 197 79.7919Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M194.016 29.6949C193.924 29.6949 193.839 29.6878 193.747 29.6878C192.598 29.6595 191.464 29.6382 190.337 29.624C190.245 29.624 190.16 29.624 190.068 29.624C189.543 29.617 189.019 29.6099 188.494 29.6099C187.757 29.6099 187.027 29.617 186.297 29.624C186.205 29.624 186.113 29.624 186.027 29.624C178.748 29.7233 172.056 30.2689 166.123 31.2257C166.031 31.2398 165.939 31.254 165.847 31.2682C163.876 31.5942 161.998 31.9627 160.204 32.3737C160.112 32.395 160.027 32.4163 159.935 32.4375C157.915 32.9123 156.008 33.4509 154.236 34.0462C154.144 34.0746 154.059 34.1029 153.967 34.1384C153.797 34.1951 153.612 34.2518 153.442 34.3155C151.663 34.9392 150.04 35.6266 148.558 36.3637C148.473 36.4062 148.395 36.4487 148.31 36.4912C146.552 37.3842 145 38.3551 143.689 39.4039C143.611 39.4606 143.547 39.5244 143.469 39.5882C142.122 40.6866 141.03 41.856 140.187 43.1033C140.109 43.2167 140.038 43.33 139.967 43.4363C139.081 44.8395 138.5 46.3207 138.259 47.8798C137.359 53.7548 141.08 60.3173 148.92 66.9719C148.991 67.0356 149.062 67.0923 149.132 67.1561C150.621 68.4034 152.251 69.6578 154.023 70.9122C154.101 70.9618 154.172 71.0185 154.25 71.0681C155.803 72.1594 157.461 73.2508 159.233 74.3351C159.311 74.3847 159.389 74.4343 159.467 74.4768C160.41 75.0509 161.374 75.6249 162.374 76.199C163.004 76.5604 163.649 76.9218 164.302 77.2762C164.38 77.3187 164.465 77.3612 164.543 77.4108C166.017 78.2187 167.534 79.0195 169.093 79.7991C169.178 79.8416 169.263 79.8841 169.341 79.9267C170.717 80.6141 172.127 81.2944 173.566 81.9606C173.623 81.8897 173.687 81.8118 173.743 81.7409C172.304 81.0747 170.901 80.3944 169.533 79.714C169.448 79.6715 169.363 79.629 169.285 79.5865C167.718 78.7998 166.208 78.0061 164.741 77.2053C164.663 77.1628 164.578 77.1203 164.5 77.0706C162.82 76.1494 161.211 75.2139 159.673 74.2784C159.595 74.2288 159.517 74.1792 159.439 74.1367C157.681 73.0595 156.022 71.9681 154.463 70.8767C154.385 70.8271 154.307 70.7704 154.236 70.7208C152.471 69.4735 150.841 68.2191 149.345 66.9648C149.274 66.901 149.203 66.8443 149.132 66.7805C141.541 60.3385 137.607 53.8257 138.514 47.9082C138.734 46.4695 139.251 45.0947 140.038 43.7907C140.102 43.6844 140.18 43.5781 140.244 43.4718C141.08 42.182 142.186 40.963 143.568 39.8291C143.639 39.7653 143.71 39.7087 143.788 39.6449C145.106 38.5889 146.659 37.6109 148.431 36.7109C148.516 36.6684 148.587 36.6259 148.672 36.5833C150.139 35.8534 151.755 35.1731 153.52 34.5494C153.704 34.4856 153.903 34.4218 154.087 34.3581C154.172 34.3297 154.264 34.3014 154.349 34.273C156.122 33.6848 158.028 33.1462 160.049 32.6714C160.141 32.6501 160.226 32.6289 160.318 32.6076C162.104 32.1966 163.99 31.8281 165.953 31.5091C166.045 31.495 166.137 31.4808 166.23 31.4666C172.141 30.517 178.819 29.9784 186.077 29.8792C186.169 29.8792 186.261 29.8792 186.354 29.8792C187.055 29.8721 187.757 29.865 188.473 29.865C189.012 29.865 189.565 29.8721 190.11 29.8792C190.203 29.8792 190.288 29.8792 190.38 29.8792C191.5 29.8933 192.634 29.9075 193.775 29.9429C193.867 29.9429 193.952 29.9429 194.044 29.95C195.065 29.9784 196.086 30.0138 197.121 30.0634C197.178 30.0634 197.234 30.0705 197.284 30.0705V29.8083C197.22 29.8083 197.156 29.8012 197.085 29.8012C196.072 29.7587 195.037 29.7233 194.016 29.6949Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M196.427 90.6068C195.675 90.3587 194.924 90.1107 194.179 89.8556C194.094 89.8272 194.016 89.7989 193.931 89.7705C193.109 89.487 192.287 89.2036 191.479 88.9201C191.394 88.8918 191.309 88.8634 191.224 88.828C190.323 88.5091 189.437 88.1831 188.551 87.8571C188.466 87.8287 188.381 87.7933 188.296 87.7649C187.311 87.3964 186.333 87.0279 185.369 86.6594C185.284 86.631 185.206 86.5956 185.121 86.5602C181.229 85.0507 177.515 83.4774 174.013 81.8545C173.956 81.9254 173.9 81.9962 173.836 82.0742C177.38 83.7183 181.108 85.2987 184.986 86.8011C185.071 86.8366 185.156 86.8649 185.234 86.9003C186.205 87.2759 187.183 87.6515 188.176 88.013C188.261 88.0413 188.346 88.0768 188.431 88.1051C189.317 88.4311 190.217 88.7571 191.117 89.076C191.202 89.1044 191.287 89.1327 191.365 89.1681C192.181 89.4587 193.003 89.7422 193.832 90.0256C193.917 90.054 193.995 90.0824 194.08 90.1107C194.832 90.3658 195.583 90.6139 196.341 90.869C196.427 90.8973 196.512 90.9257 196.597 90.954C196.823 91.032 197.05 91.1029 197.277 91.1737V90.8902C197.072 90.8194 196.859 90.7556 196.653 90.6847C196.597 90.6635 196.512 90.6351 196.427 90.6068Z",
    fill: "#09F9BF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M196.163 57.723C193.767 60.0049 191.435 62.294 189.181 64.583C189.117 64.6468 189.06 64.7106 188.997 64.7744C188.344 65.4406 187.699 66.0996 187.061 66.7658C186.998 66.8296 186.941 66.8934 186.877 66.9642C186.175 67.7013 185.474 68.4312 184.786 69.1682C184.722 69.232 184.659 69.3029 184.602 69.3667C183.836 70.1817 183.078 71.0037 182.334 71.8187C182.27 71.8896 182.213 71.9534 182.149 72.0243C181.32 72.9385 180.491 73.8527 179.682 74.7669C179.619 74.8377 179.562 74.9086 179.498 74.9724C178.591 76 177.698 77.0276 176.826 78.0552C176.762 78.1261 176.705 78.1969 176.649 78.2678C175.663 79.43 174.706 80.5852 173.771 81.7404C173.714 81.8112 173.65 81.8821 173.594 81.9601C170.666 85.5673 167.98 89.139 165.562 92.64C163.493 95.6306 161.664 98.5008 160.076 101.251C160.033 101.328 159.984 101.406 159.941 101.484C158.793 103.483 157.772 105.418 156.879 107.274C156.837 107.359 156.794 107.444 156.759 107.537C155.766 109.627 154.944 111.626 154.292 113.518C154.256 113.61 154.221 113.709 154.193 113.808C153.491 115.878 153.002 117.827 152.711 119.641C152.697 119.726 152.69 119.811 152.676 119.903C152.541 120.81 152.456 121.689 152.428 122.525H152.697C152.725 121.717 152.803 120.874 152.938 120.002C152.952 119.917 152.966 119.832 152.981 119.74C153.271 117.912 153.767 115.956 154.469 113.879C154.505 113.78 154.533 113.688 154.568 113.589C155.228 111.682 156.057 109.677 157.049 107.593C157.092 107.508 157.127 107.423 157.17 107.338C158.063 105.467 159.084 103.54 160.225 101.548C160.267 101.47 160.317 101.392 160.36 101.314C163.826 95.3259 168.376 88.8343 173.863 82.0805C173.92 82.0097 173.976 81.9388 174.04 81.8608C174.969 80.7198 175.926 79.5647 176.911 78.4095C176.968 78.3387 177.031 78.2678 177.095 78.1969C177.96 77.1764 178.846 76.1559 179.753 75.1283C179.817 75.0574 179.874 74.9866 179.938 74.9228C180.739 74.0157 181.554 73.1085 182.383 72.1943C182.447 72.1235 182.504 72.0597 182.567 71.9888C183.305 71.1809 184.063 70.3659 184.822 69.5509C184.885 69.4872 184.949 69.4163 185.006 69.3525C185.686 68.6226 186.374 67.8926 187.076 67.1627C187.139 67.0989 187.203 67.0351 187.26 66.9713C187.891 66.3122 188.536 65.6532 189.181 64.9941C189.245 64.9303 189.301 64.8665 189.365 64.8027C191.591 62.5349 193.902 60.2671 196.283 57.9923C196.354 57.9285 196.418 57.8647 196.489 57.8009C196.765 57.5387 197.042 57.2765 197.318 57.0143V56.6528C197.007 56.9505 196.695 57.241 196.383 57.5387C196.298 57.5954 196.227 57.6592 196.163 57.723Z",
    fill: "#09F9BF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5742 51.8623V55.9948H77.4466L74.6821 51.841H74.668V55.7325H75.3768V55.8956H73.8882V55.7325H74.512V51.8552H73.8457V51.6921H75.4477L77.4041 54.6338H77.4182V51.8552H76.7236V51.6921H78.2121V51.8552H77.5742V51.8623Z",
    fill: "#6B8299"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3469 54.4927V54.1738C80.3469 53.9115 80.3257 53.7414 80.2831 53.6634C80.2406 53.5854 80.1272 53.5429 79.9358 53.5429C79.5956 53.5429 79.4325 53.6067 79.4325 53.7343C79.4325 53.7697 79.4467 53.8122 79.4751 53.8548C79.5034 53.8973 79.5176 53.954 79.5176 54.0107C79.5176 54.0958 79.4892 54.1596 79.4325 54.2092C79.3758 54.2517 79.312 54.273 79.2411 54.273C79.149 54.273 79.0781 54.2446 79.0285 54.1879C78.9789 54.1312 78.9505 54.0603 78.9505 53.9895C78.9505 53.8193 79.0497 53.6847 79.2411 53.5712C79.4325 53.4578 79.709 53.4011 80.0563 53.4011C80.3327 53.4011 80.5383 53.4366 80.6659 53.5004C80.7935 53.5642 80.8715 53.6421 80.9069 53.7414C80.9353 53.8406 80.9494 53.9753 80.9494 54.1454V55.2937C80.9494 55.4638 80.9636 55.5702 80.9849 55.6127C81.0062 55.6552 81.0487 55.6765 81.0983 55.6765C81.1763 55.6765 81.2472 55.6269 81.318 55.5205H81.396C81.3393 55.8254 81.1621 55.9742 80.8644 55.9742C80.5738 55.9742 80.4036 55.8041 80.3469 55.4709C80.1059 55.8041 79.8153 55.9742 79.4892 55.9742C79.2695 55.9742 79.0994 55.9175 78.9718 55.797C78.8442 55.6765 78.7804 55.5347 78.7804 55.3646C78.7804 54.833 79.3049 54.5424 80.3469 54.4927ZM80.3469 54.9747V54.6345C79.9642 54.6487 79.709 54.7054 79.5814 54.8117C79.4609 54.9109 79.3971 55.0598 79.3971 55.2512C79.3971 55.393 79.4325 55.4993 79.5105 55.5773C79.5814 55.6552 79.6664 55.6907 79.7657 55.6907C79.8862 55.6907 79.9996 55.6481 80.0988 55.5702C80.1981 55.4851 80.2619 55.4071 80.2973 55.3221C80.3328 55.237 80.3469 55.1236 80.3469 54.9747Z",
    fill: "#6B8299"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2672 55.7396V53.5989H81.8278V53.4358H82.1042C82.4303 53.4358 82.6855 53.4217 82.8768 53.3933V53.9958H82.891C83.0541 53.5918 83.3518 53.3933 83.77 53.3933C84.2307 53.3933 84.4859 53.606 84.5355 54.0313H84.5497C84.734 53.606 85.0317 53.3933 85.457 53.3933C85.6413 53.3933 85.8043 53.4429 85.9319 53.5351C86.0595 53.6272 86.1375 53.7406 86.1729 53.8611C86.2013 53.9816 86.2155 54.1872 86.2155 54.4707V55.7325H86.6479V55.8955H85.1947V55.7325H85.6059V54.1872C85.6059 53.9462 85.5917 53.7761 85.5633 53.6839C85.535 53.5918 85.457 53.5493 85.3365 53.5493C85.1664 53.5493 84.9963 53.6414 84.8191 53.8328C84.6419 54.0242 84.5497 54.3857 84.5497 54.9173V55.7325H84.9537V55.8955H83.5361V55.7325H83.9401V54.5204C83.9401 54.0525 83.9259 53.769 83.8905 53.6768C83.855 53.5847 83.7771 53.5422 83.6424 53.5422C83.4652 53.5422 83.3092 53.6201 83.1745 53.7761C83.0399 53.932 82.9619 54.088 82.9265 54.2297C82.891 54.3786 82.8768 54.6125 82.8768 54.9386V55.7254H83.2809V55.8884H81.8278V55.7254H82.2672V55.7396Z",
    fill: "#6B8299"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3284 54.4784H87.7476C87.7335 55.0951 87.7689 55.4778 87.854 55.6196C87.939 55.7614 88.0879 55.8323 88.3005 55.8323C88.74 55.8323 89.0448 55.5771 89.2008 55.0596H89.3354C89.2646 55.3715 89.137 55.5983 88.9456 55.7472C88.7542 55.8961 88.5415 55.9669 88.3076 55.9669C87.9745 55.9669 87.6768 55.8394 87.4287 55.5913C87.1806 55.3432 87.0601 55.0313 87.0601 54.6485C87.0601 54.2799 87.1806 53.9751 87.4216 53.7199C87.6626 53.4718 87.9461 53.3442 88.2651 53.3442C88.5415 53.3442 88.7896 53.4435 88.9952 53.6419C89.2008 53.8546 89.3142 54.131 89.3284 54.4784ZM87.7476 54.3437H88.6549C88.6691 54.1948 88.6833 54.0814 88.6833 54.0035C88.6833 53.6703 88.5345 53.5002 88.2296 53.5002C88.0808 53.5002 87.9603 53.5427 87.8752 53.6207C87.7902 53.6987 87.7476 53.8121 87.7476 53.9468V54.3437Z",
    fill: "#6B8299"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1172 59.3962H74.8827L76.187 61.7496L76.6194 62.6427H76.6477C76.6123 62.2103 76.5485 61.6858 76.5485 61.218V59.3962H77.2573V63.5855H76.4918L75.1875 61.2321L74.7551 60.339H74.7268C74.7622 60.7785 74.826 61.2888 74.826 61.7567V63.5855H74.1172V59.3962Z",
    fill: "#11302D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2685 62.4513H78.858L78.5319 63.5855H77.7734L79.1344 59.3962H80.0063L81.3673 63.5855H80.5875L80.2685 62.4513ZM80.0984 61.8701L79.9496 61.3597C79.8149 60.9202 79.6944 60.4382 79.5739 59.9775H79.5455C79.4321 60.4453 79.3116 60.9202 79.1769 61.3597L79.0281 61.8701H80.0984Z",
    fill: "#11302D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8906 59.3962H82.7129L83.4713 61.459L83.7478 62.2529H83.7761L84.0455 61.459L84.7898 59.3962H85.612V63.5855H84.9174V61.6716C84.9174 61.2818 84.9741 60.7218 85.0166 60.339H84.9882L84.648 61.2959L83.925 63.1956H83.5777L82.8546 61.2959L82.5215 60.339H82.4931C82.5286 60.7218 82.5924 61.2818 82.5924 61.6716V63.5855H81.9048V59.3962H81.8906Z",
    fill: "#11302D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6699 59.3962H89.1934V60.0271H87.4142V61.0975H88.9169V61.7212H87.4142V62.9546H89.2572V63.5855H86.6699V59.3962Z",
    fill: "#11302D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5764 62.5362C91.8741 62.8198 92.2782 63.0112 92.668 63.0112C93.143 63.0112 93.3981 62.7985 93.3981 62.4725C93.3981 62.1251 93.1288 62.0188 92.7531 61.8558L92.1789 61.6077C91.7678 61.4375 91.3354 61.1115 91.3354 60.4948C91.3354 59.8285 91.9238 59.3181 92.746 59.3181C93.2351 59.3181 93.71 59.5237 94.0361 59.8497L93.6604 60.3247C93.391 60.0978 93.1075 59.9632 92.7531 59.9632C92.3561 59.9632 92.0939 60.1475 92.0939 60.4593C92.0939 60.7854 92.4129 60.9059 92.7602 61.0477L93.3273 61.2816C93.8234 61.4943 94.1708 61.8061 94.1708 62.4157C94.1708 63.0962 93.6108 63.6562 92.668 63.6562C92.1081 63.6562 91.5552 63.4294 91.1582 63.0395L91.5764 62.5362Z",
    fill: "#11302D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8984 59.3962H95.6427V61.8063C95.6427 62.7136 95.983 63.0184 96.4862 63.0184C96.9966 63.0184 97.3581 62.7207 97.3581 61.8063V59.3962H98.0669V61.7425C98.0669 63.1176 97.4574 63.6564 96.4862 63.6564C95.5222 63.6564 94.8984 63.1176 94.8984 61.7425V59.3962Z",
    fill: "#11302D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M101.4 63.5855L100.499 61.9481H99.8615V63.5855H99.1172V59.3962H100.535C101.407 59.3962 102.073 59.701 102.073 60.6367C102.073 61.2747 101.74 61.6645 101.244 61.8346L102.243 63.5855H101.4ZM99.8544 61.3526H100.45C101.017 61.3526 101.336 61.1116 101.336 60.6367C101.336 60.1547 101.024 59.9917 100.45 59.9917H99.8544V61.3526Z",
    fill: "#11302D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M102.953 59.3962H103.712L105.016 61.7496L105.441 62.6427H105.47C105.441 62.2103 105.37 61.6858 105.37 61.218V59.3962H106.079V63.5855H105.321L104.016 61.2321L103.591 60.339H103.563C103.591 60.7785 103.662 61.2888 103.662 61.7567V63.5855H102.953V59.3962Z",
    fill: "#11302D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M109.099 62.4513H107.688L107.362 63.5855H106.604L107.964 59.3962H108.836L110.197 63.5855H109.418L109.099 62.4513ZM108.936 61.8701L108.787 61.3597C108.652 60.9202 108.532 60.4382 108.411 59.9775H108.383C108.269 60.4453 108.149 60.9202 108.014 61.3597L107.865 61.8701H108.936Z",
    fill: "#11302D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M110.727 59.3962H111.549L112.307 61.459L112.584 62.2529H112.612L112.881 61.459L113.626 59.3962H114.448V63.5855H113.753V61.6716C113.753 61.2818 113.81 60.7218 113.853 60.339H113.824L113.484 61.2959L112.761 63.1956H112.414L111.691 61.2959L111.357 60.339H111.329C111.365 60.7218 111.428 61.2818 111.428 61.6716V63.5855H110.741V59.3962H110.727Z",
    fill: "#11302D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M115.498 59.3962H118.022V60.0271H116.242V61.0975H117.745V61.7212H116.242V62.9546H118.085V63.5855H115.498V59.3962Z",
    fill: "#11302D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2698 74.1019H74.9372L74.5119 75.2502H75.2845V75.4132H73.7676V75.2502H74.3488L75.8799 71.1177H75.9792L77.4464 75.2502H78.0064V75.4132H76.0075V75.2502H76.688L76.2698 74.1019ZM74.9939 73.9389H76.2131L75.6247 72.2589H75.6106L74.9939 73.9389Z",
    fill: "#6B8299"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9474 71.1672V75.2502H81.3728V75.4132H81.0254C80.8057 75.4132 80.5718 75.4274 80.3237 75.4486V74.9383H80.3095C80.1394 75.3069 79.8771 75.4912 79.5085 75.4912C79.2179 75.4912 78.9556 75.3636 78.7288 75.1013C78.502 74.839 78.3956 74.5413 78.3956 74.2082C78.3956 73.8537 78.5161 73.5418 78.75 73.2796C78.984 73.0102 79.2675 72.8826 79.5865 72.8826C79.9125 72.8826 80.1536 73.0315 80.3095 73.3221H80.3237V71.3799H79.7566V71.2169H80.3237C80.5292 71.2098 80.7348 71.1956 80.9474 71.1672ZM79.6007 73.0102C79.3738 73.0102 79.2321 73.0953 79.1754 73.2654C79.1186 73.4355 79.0903 73.7829 79.0903 74.3003C79.0903 74.7469 79.1257 75.0304 79.1966 75.1509C79.2675 75.2643 79.388 75.3281 79.551 75.3281C79.7282 75.3281 79.8771 75.2714 80.0118 75.1509C80.1465 75.0304 80.2315 74.8957 80.2741 74.7469C80.3166 74.598 80.3378 74.3499 80.3378 74.0026C80.3378 73.6765 80.2741 73.4284 80.1394 73.2654C80.0118 73.0953 79.8275 73.0102 79.6007 73.0102Z",
    fill: "#6B8299"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3448 71.1672V75.2502H84.7701V75.4132H84.4227C84.203 75.4132 83.9691 75.4274 83.721 75.4486V74.9383H83.7068C83.5367 75.3069 83.2744 75.4912 82.9058 75.4912C82.6152 75.4912 82.3529 75.3636 82.1261 75.1013C81.8993 74.839 81.7929 74.5413 81.7929 74.2082C81.7929 73.8537 81.9134 73.5418 82.1474 73.2796C82.3813 73.0102 82.6648 72.8826 82.9838 72.8826C83.3098 72.8826 83.5509 73.0315 83.7068 73.3221H83.721V71.3799H83.1539V71.2169H83.721C83.9265 71.2098 84.1392 71.1956 84.3448 71.1672ZM83.005 73.0102C82.7782 73.0102 82.6365 73.0953 82.5797 73.2654C82.523 73.4355 82.4947 73.7829 82.4947 74.3003C82.4947 74.7469 82.5301 75.0304 82.601 75.1509C82.6719 75.2643 82.7924 75.3281 82.9554 75.3281C83.1326 75.3281 83.2815 75.2714 83.4162 75.1509C83.5509 75.0304 83.6359 74.8957 83.6785 74.7469C83.721 74.598 83.7422 74.3499 83.7422 74.0026C83.7422 73.6765 83.6785 73.4284 83.5438 73.2654C83.4091 73.0953 83.2319 73.0102 83.005 73.0102Z",
    fill: "#6B8299"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5485 75.243V73.1023H85.0453V72.9393H85.5556C85.8179 72.9393 86.0164 72.9251 86.1581 72.8967V73.4851H86.1723C86.3212 73.0881 86.5338 72.8967 86.8174 72.8967C86.9449 72.8967 87.0442 72.9322 87.1222 73.0101C87.2001 73.0881 87.2356 73.1803 87.2356 73.2866C87.2356 73.3858 87.2072 73.4709 87.1434 73.5276C87.0796 73.5914 87.0016 73.6197 86.9024 73.6197C86.7252 73.6197 86.6331 73.5276 86.6331 73.3504L86.6472 73.2157C86.6472 73.1661 86.626 73.1448 86.5834 73.1448C86.5126 73.1448 86.4275 73.237 86.3212 73.4213C86.2148 73.6056 86.1581 73.8891 86.1581 74.2719V75.2288H86.6756V75.3918H85.0453V75.2288H85.5485V75.243Z",
    fill: "#6B8299"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8446 73.9889H88.2639C88.2497 74.6056 88.2852 74.9883 88.3702 75.1301C88.4553 75.2719 88.6041 75.3428 88.8168 75.3428C89.2563 75.3428 89.5611 75.0876 89.717 74.5701H89.8517C89.7808 74.882 89.6532 75.1088 89.4618 75.2577C89.2704 75.4066 89.0578 75.4774 88.8239 75.4774C88.4907 75.4774 88.193 75.3499 87.9449 75.1018C87.6968 74.8537 87.5763 74.5418 87.5763 74.159C87.5763 73.7904 87.6968 73.4856 87.9378 73.2304C88.1788 72.9823 88.4624 72.8547 88.7813 72.8547C89.0578 72.8547 89.3059 72.954 89.5115 73.1525C89.7241 73.3651 89.8304 73.6416 89.8446 73.9889ZM88.2639 73.8471H89.1712C89.1854 73.6983 89.1996 73.5848 89.1996 73.5069C89.1996 73.1737 89.0507 73.0036 88.7459 73.0036C88.597 73.0036 88.4765 73.0461 88.3915 73.1241C88.3064 73.2021 88.2639 73.3155 88.2639 73.4502V73.8471Z",
    fill: "#6B8299"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0129 72.9183V73.62H91.8853C91.7861 73.216 91.5593 73.0104 91.1836 73.0104C91.0206 73.0104 90.8859 73.053 90.7796 73.138C90.6732 73.2231 90.6165 73.3223 90.6165 73.4286C90.6165 73.5208 90.652 73.5917 90.7299 73.6484C90.8079 73.7051 90.9851 73.7476 91.2687 73.7831C91.8924 73.861 92.2043 74.1446 92.2043 74.6337C92.2043 74.8747 92.1264 75.0802 91.9633 75.2433C91.8003 75.4063 91.6018 75.4843 91.3608 75.4843C91.1269 75.4843 90.9001 75.385 90.6732 75.1937L90.4535 75.378H90.3472V74.4565H90.4535C90.6307 75.0448 90.9355 75.3425 91.3537 75.3425C91.5168 75.3425 91.6585 75.2929 91.7932 75.1866C91.9279 75.0873 91.9917 74.9668 91.9917 74.8251C91.9917 74.7116 91.9492 74.6266 91.8712 74.5628C91.7932 74.5061 91.5806 74.4494 91.2403 74.3998C90.652 74.3147 90.3613 74.0524 90.3613 73.62C90.3613 73.4074 90.4393 73.2231 90.5953 73.0813C90.7512 72.9395 90.9426 72.8616 91.1694 72.8616C91.4104 72.8616 91.6089 72.9395 91.7719 73.1026C91.8145 73.06 91.857 72.9963 91.8995 72.9183H92.0129Z",
    fill: "#6B8299"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4164 72.9183V73.62H94.2888C94.1896 73.216 93.9627 73.0104 93.587 73.0104C93.424 73.0104 93.2893 73.053 93.183 73.138C93.0767 73.2231 93.02 73.3223 93.02 73.4286C93.02 73.5208 93.0554 73.5917 93.1334 73.6484C93.2114 73.7051 93.3886 73.7476 93.6721 73.7831C94.2959 73.861 94.6078 74.1446 94.6078 74.6337C94.6078 74.8747 94.5298 75.0802 94.3668 75.2433C94.2037 75.4063 94.0053 75.4843 93.7643 75.4843C93.5303 75.4843 93.3035 75.385 93.0767 75.1937L92.8569 75.378H92.7506V74.4565H92.8569C93.0342 75.0448 93.339 75.3425 93.7572 75.3425C93.9202 75.3425 94.062 75.2929 94.1966 75.1866C94.3313 75.0873 94.3951 74.9668 94.3951 74.8251C94.3951 74.7116 94.3526 74.6266 94.2746 74.5628C94.1966 74.5061 93.984 74.4494 93.6438 74.3998C93.0554 74.3147 92.7648 74.0524 92.7648 73.62C92.7648 73.4074 92.8428 73.2231 92.9987 73.0813C93.1547 72.9395 93.346 72.8616 93.5729 72.8616C93.8139 72.8616 94.0124 72.9395 94.1754 73.1026C94.2179 73.06 94.2604 72.9963 94.303 72.9183H94.4164Z",
    fill: "#6B8299"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0586 82.4863H74.9659V79.8068H74.2145V79.3461C74.6186 79.2681 74.9021 79.1689 75.1573 79.0129H75.7102V82.4863H76.5112V83.0888H74.0586V82.4863Z",
    fill: "#11302D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1136 82.664C78.2477 81.5724 78.9565 80.8494 78.9565 80.2327C78.9565 79.8003 78.7226 79.531 78.2831 79.531C77.9713 79.531 77.709 79.7436 77.4893 79.9846L77.0781 79.5735C77.4467 79.1765 77.8224 78.9426 78.3753 78.9426C79.155 78.9426 79.6654 79.4388 79.6654 80.1902C79.6654 80.9132 78.992 81.6575 78.1839 82.5081C78.3966 82.4868 78.6659 82.4656 78.8644 82.4656H79.8639V83.0964H77.1136V82.664V82.664Z",
    fill: "#11302D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6657 82.1175C80.9067 82.3656 81.2257 82.5641 81.6297 82.5641C82.0692 82.5641 82.3811 82.3302 82.3811 81.9474C82.3811 81.5221 82.1117 81.2527 81.1831 81.2527V80.714C81.9841 80.714 82.2464 80.4376 82.2464 80.0619C82.2464 79.7216 82.0125 79.5161 81.6439 79.5161C81.3249 79.5161 81.0768 79.672 80.8216 79.8988L80.4459 79.4452C80.7933 79.1404 81.1831 78.9348 81.6722 78.9348C82.452 78.9348 82.9907 79.3176 82.9907 80.0123C82.9907 80.4659 82.7213 80.7778 82.2818 80.9479V80.9763C82.7639 81.1039 83.1254 81.4512 83.1254 81.9899C83.1254 82.7342 82.4803 83.1666 81.7006 83.1666C81.0414 83.1666 80.609 82.9114 80.3184 82.5924L80.6657 82.1175Z",
    fill: "#11302D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2368 81.9635H85.8262L85.5001 83.0977H84.7417L86.1026 78.9084H86.9745L88.3355 83.0977H87.5558L87.2368 81.9635ZM87.0667 81.3752L86.9178 80.8648C86.7831 80.4254 86.6626 79.9434 86.5421 79.4826H86.5138C86.4004 79.9504 86.2798 80.4254 86.1452 80.8648L85.9963 81.3752H87.0667Z",
    fill: "#11302D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8654 78.9084H89.6239L90.9281 81.2618L91.3534 82.1549H91.3818C91.3534 81.7296 91.2825 81.198 91.2825 80.7302V78.9084H91.9914V83.0977H91.2329L89.9286 80.7443L89.4963 79.8512H89.4679C89.4963 80.2907 89.5671 80.801 89.5671 81.2689V83.0977H88.8583V78.9084H88.8654Z",
    fill: "#11302D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7636 81.5382L92.5089 78.9084H93.3028L93.7565 79.9788C93.877 80.2907 93.9904 80.5813 94.1251 80.9003H94.1534C94.2881 80.5813 94.4157 80.2907 94.5362 79.9788L94.9898 78.9084H95.7625L94.5007 81.5382V83.0977H93.7565V81.5382H93.7636Z",
    fill: "#11302D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M95.856 78.9084H96.6145L96.983 81.0208C97.0539 81.4674 97.1248 81.9139 97.1886 82.3605H97.217C97.3091 81.921 97.3942 81.4674 97.4934 81.0208L98.0038 78.9084H98.6488L99.1592 81.0208C99.2584 81.4532 99.3435 81.9139 99.4427 82.3605H99.4711C99.5349 81.9139 99.6057 81.4674 99.6695 81.0208L100.038 78.9084H100.747L99.946 83.0977H99.0245L98.507 80.8932C98.4362 80.5671 98.3724 80.2482 98.3227 79.9292H98.2944C98.2377 80.2482 98.1739 80.5671 98.103 80.8932L97.5997 83.0977H96.6995L95.856 78.9084Z",
    fill: "#11302D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M101.398 78.9084H103.921V79.5393H102.142V80.6097H103.645V81.2334H102.142V82.4668H103.985V83.0977H101.398V78.9084Z",
    fill: "#11302D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M106.494 81.0842C106.487 80.751 106.345 80.4675 105.927 80.4675C105.615 80.4675 105.318 80.6093 105.041 80.7723L104.772 80.2761C105.119 80.0564 105.559 79.865 106.062 79.865C106.849 79.865 107.231 80.347 107.231 81.226V83.0902H106.629L106.572 82.7429H106.551C106.267 82.9768 105.948 83.1682 105.58 83.1682C105.027 83.1682 104.644 82.7996 104.644 82.2467C104.644 81.5733 105.211 81.226 106.494 81.0842ZM105.814 82.594C106.069 82.594 106.267 82.4664 106.501 82.2467V81.5449C105.651 81.6513 105.367 81.8781 105.367 82.19C105.36 82.4735 105.544 82.594 105.814 82.594Z",
    fill: "#11302D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M109.655 82.0482C109.952 82.3317 110.356 82.5231 110.746 82.5231C111.221 82.5231 111.476 82.3105 111.476 81.9844C111.476 81.6371 111.207 81.5308 110.831 81.3677L110.257 81.1196C109.846 80.9495 109.414 80.6234 109.414 80.0068C109.414 79.3404 110.002 78.8301 110.824 78.8301C111.313 78.8301 111.781 79.0356 112.114 79.3617L111.739 79.8366C111.469 79.6098 111.186 79.4751 110.831 79.4751C110.434 79.4751 110.172 79.6594 110.172 79.9713C110.172 80.2974 110.491 80.4179 110.838 80.5596L111.405 80.7936C111.902 81.0062 112.249 81.3181 112.249 81.9277C112.249 82.6082 111.689 83.1682 110.746 83.1682C110.186 83.1682 109.633 82.9413 109.236 82.5515L109.655 82.0482Z",
    fill: "#11302D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M113.718 79.5305H112.506V78.8997H115.667V79.5305H114.455V83.0889H113.711V79.5305H113.718Z",
    fill: "#11302D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M118.652 83.0889L117.751 81.4515H117.113V83.0889H116.369V78.8997H117.787C118.659 78.8997 119.325 79.2045 119.325 80.1401C119.325 80.7781 118.992 81.1679 118.496 81.3381L119.495 83.0889H118.652ZM117.113 80.8631H117.709C118.276 80.8631 118.595 80.6221 118.595 80.1472C118.595 79.6652 118.283 79.5022 117.709 79.5022H117.113V80.8631Z",
    fill: "#11302D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M120.204 78.9084H122.727V79.5393H120.948V80.6097H122.451V81.2334H120.948V82.4668H122.791V83.0977H120.204V78.9084Z",
    fill: "#11302D"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M123.648 78.9084H126.171V79.5393H124.392V80.6097H125.895V81.2334H124.392V82.4668H126.235V83.0977H123.648V78.9084Z",
    fill: "#11302D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M127.946 79.5305H126.734V78.8997H129.896V79.5305H128.684V83.0889H127.939V79.5305H127.946Z",
    fill: "#11302D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8371 86.5112C76.3404 86.5112 76.7657 86.7593 77.028 87.0429L76.6098 87.5036C76.3971 87.291 76.1632 87.1563 75.8442 87.1563C75.1496 87.1563 74.6676 87.7304 74.6676 88.6732C74.6676 89.6301 75.1141 90.2043 75.823 90.2043C76.1916 90.2043 76.4609 90.0483 76.7019 89.7861L77.1201 90.2397C76.7799 90.6296 76.3404 90.8493 75.8159 90.8493C74.7455 90.8493 73.9162 90.0838 73.9162 88.6945C73.902 87.3264 74.7597 86.5112 75.8371 86.5112Z",
    fill: "#11302D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8086 86.5894H78.5529V90.7786H77.8086V86.5894Z",
    fill: "#11302D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4582 87.2202H79.2461V86.5894H82.4075V87.2202H81.1954V90.7786H80.4511V87.2202H80.4582Z",
    fill: "#11302D"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7058 89.2191L82.4512 86.5894H83.2451L83.6987 87.6597C83.8192 87.9716 83.9326 88.2622 84.0673 88.5812H84.0957C84.2304 88.2622 84.3579 87.9716 84.4785 87.6597L84.9321 86.5894H85.7048L84.443 89.2191V90.7786H83.6987V89.2191H83.7058Z",
    fill: "#11302D"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3359 91.5361C85.7471 91.3731 85.981 91.0896 85.981 90.7635C85.9597 90.7635 85.9455 90.7635 85.9243 90.7635C85.6762 90.7635 85.4494 90.6005 85.4494 90.3099C85.4494 90.0334 85.6762 89.8562 85.9455 89.8562C86.2929 89.8562 86.4984 90.1397 86.4984 90.6147C86.4984 91.2455 86.1369 91.7275 85.499 91.9473L85.3359 91.5361Z",
    fill: "#11302D"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M88.611 89.7994C88.852 90.0475 89.171 90.246 89.575 90.246C90.0145 90.246 90.3264 90.012 90.3264 89.6293C90.3264 89.204 90.057 88.9346 89.1284 88.9346V88.3959C89.9294 88.3959 90.1917 88.1194 90.1917 87.7438C90.1917 87.4035 89.9578 87.1979 89.5892 87.1979C89.2702 87.1979 89.0221 87.3539 88.7669 87.5807L88.3913 87.1271C88.7386 86.8223 89.1284 86.6167 89.6175 86.6167C90.3973 86.6167 90.936 86.9995 90.936 87.6941C90.936 88.1478 90.6666 88.4597 90.2271 88.6298V88.6582C90.7092 88.7857 91.0707 89.1331 91.0707 89.6718C91.0707 90.4161 90.4256 90.8485 89.6459 90.8485C88.9867 90.8485 88.5543 90.5933 88.2637 90.2743L88.611 89.7994Z",
    fill: "#11302D"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5094 89.7281H93.999V90.7772H93.3044V89.7281H91.5039V89.232L93.1201 86.7085H93.999V89.1611H94.5094V89.7281V89.7281ZM93.3114 89.154V88.2325C93.3114 87.9986 93.3327 87.6229 93.3398 87.389H93.3114C93.2122 87.6016 93.0917 87.8072 92.9783 88.0198L92.234 89.154H93.3114Z",
    fill: "#11302D"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1762 89.8137C95.4172 90.0476 95.722 90.2461 96.1331 90.2461C96.5868 90.2461 96.9199 89.9555 96.9199 89.4664C96.9199 88.9773 96.6222 88.7008 96.1686 88.7008C95.9063 88.7008 95.7574 88.7717 95.5164 88.9348L95.162 88.7079L95.2825 86.6948H97.4586V87.3186H95.9205L95.8354 88.3039C96.0055 88.2188 96.1615 88.1692 96.3741 88.1692C97.0688 88.1692 97.6571 88.5662 97.6571 89.4451C97.6571 90.3383 96.9695 90.8486 96.2253 90.8486C95.566 90.8486 95.1336 90.5864 94.8359 90.2886L95.1762 89.8137Z",
    fill: "#11302D"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M100.54 87.5396C100.391 87.3624 100.136 87.2348 99.8945 87.2348C99.3841 87.2348 98.9659 87.6105 98.9376 88.7376C99.1715 88.4399 99.5259 88.2556 99.8236 88.2556C100.525 88.2556 101.014 88.6667 101.014 89.5173C101.014 90.3325 100.433 90.857 99.7315 90.857C98.9305 90.857 98.25 90.2332 98.25 88.8652C98.25 87.2845 99.0155 86.6323 99.852 86.6323C100.348 86.6323 100.695 86.8379 100.944 87.0931L100.54 87.5396ZM100.32 89.5173C100.32 89.0353 100.086 88.7943 99.6818 88.7943C99.4479 88.7943 99.1857 88.9219 98.9517 89.2621C99.0297 89.9851 99.3203 90.2899 99.7102 90.2899C100.05 90.2899 100.32 90.0135 100.32 89.5173Z",
    fill: "#11302D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M103.461 87.3264H101.533V86.7026H104.269V87.1492C103.312 88.333 103.149 89.1836 103.078 90.7714H102.327C102.398 89.3324 102.674 88.418 103.461 87.3264Z",
    fill: "#11302D"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M104.807 88.8916H106.331V89.4303H104.807V88.8916Z",
    fill: "#11302D"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M107.6 88.6865V88.6582C107.289 88.4313 107.04 88.1336 107.04 87.7012C107.04 87.042 107.565 86.6167 108.267 86.6167C108.997 86.6167 109.465 87.0562 109.465 87.7154C109.465 88.1194 109.181 88.4597 108.919 88.6511V88.6794C109.295 88.8921 109.621 89.1898 109.621 89.7356C109.621 90.3594 109.068 90.8414 108.246 90.8414C107.452 90.8414 106.863 90.3806 106.863 89.7214C106.863 89.2252 107.211 88.8921 107.6 88.6865ZM108.26 90.331C108.65 90.331 108.933 90.0971 108.933 89.7214C108.933 89.2819 108.501 89.1189 107.955 88.8921C107.7 89.0764 107.515 89.3386 107.515 89.6505C107.508 90.0617 107.841 90.331 108.26 90.331ZM108.855 87.7721C108.855 87.4106 108.628 87.1483 108.253 87.1483C107.941 87.1483 107.693 87.3539 107.693 87.7083C107.693 88.1194 108.054 88.2966 108.515 88.4739C108.735 88.2612 108.855 88.0273 108.855 87.7721Z",
    fill: "#11302D"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M110.584 89.9419C110.74 90.1191 110.988 90.2467 111.236 90.2467C111.746 90.2467 112.164 89.871 112.2 88.7439C111.966 89.0417 111.605 89.2189 111.307 89.2189C110.612 89.2189 110.123 88.8077 110.123 87.9571C110.123 87.142 110.704 86.6245 111.406 86.6245C112.2 86.6245 112.88 87.2412 112.88 88.6093C112.88 90.19 112.122 90.8492 111.278 90.8492C110.789 90.8492 110.435 90.6436 110.187 90.3885L110.584 89.9419ZM112.179 88.2123C112.101 87.4964 111.81 87.1845 111.413 87.1845C111.08 87.1845 110.804 87.4609 110.804 87.95C110.804 88.4321 111.045 88.6801 111.449 88.6801C111.675 88.6872 111.952 88.5526 112.179 88.2123Z",
    fill: "#11302D"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M113.426 88.7234C113.426 87.3482 113.964 86.6323 114.808 86.6323C115.652 86.6323 116.19 87.3553 116.19 88.7234C116.19 90.0985 115.652 90.857 114.808 90.857C113.964 90.857 113.426 90.0985 113.426 88.7234ZM115.488 88.7234C115.488 87.568 115.205 87.2065 114.808 87.2065C114.418 87.2065 114.128 87.5751 114.128 88.7234C114.128 89.8788 114.418 90.2758 114.808 90.2758C115.205 90.2758 115.488 89.8717 115.488 88.7234Z",
    fill: "#11302D"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M151.257 75.2445V71.3671H150.605V71.2041H152.582C153.022 71.2041 153.398 71.2679 153.709 71.3884C154.021 71.5089 154.284 71.757 154.489 72.1185C154.695 72.48 154.801 72.8699 154.801 73.2952C154.801 73.7417 154.688 74.1458 154.454 74.4931C154.227 74.8475 153.958 75.0814 153.66 75.209C153.362 75.3366 152.994 75.3933 152.568 75.3933H150.598V75.2303H151.257V75.2445ZM152.001 71.3742V75.2516H152.547C152.83 75.2516 153.064 75.2232 153.249 75.1736C153.426 75.124 153.575 75.0106 153.695 74.8334C153.816 74.6561 153.894 74.4364 153.936 74.167C153.979 73.8977 154 73.5433 154 73.1109C154 72.5863 153.936 72.2036 153.802 71.9413C153.667 71.6861 153.504 71.5231 153.313 71.4664C153.121 71.4026 152.873 71.3742 152.561 71.3742H152.001Z",
    fill: "#6B8299"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M157.078 74.0025V73.6835C157.078 73.4213 157.057 73.2511 157.014 73.1732C156.972 73.0952 156.858 73.0527 156.667 73.0527C156.327 73.0527 156.164 73.1165 156.164 73.244C156.164 73.2795 156.178 73.322 156.206 73.3645C156.234 73.4071 156.249 73.4638 156.249 73.5205C156.249 73.6056 156.22 73.6693 156.164 73.719C156.107 73.7615 156.043 73.7828 155.972 73.7828C155.88 73.7828 155.809 73.7544 155.76 73.6977C155.71 73.641 155.682 73.5701 155.682 73.4992C155.682 73.3291 155.781 73.1944 155.972 73.081C156.171 72.9676 156.44 72.9109 156.787 72.9109C157.064 72.9109 157.269 72.9463 157.404 73.0101C157.532 73.0739 157.61 73.1519 157.645 73.2511C157.673 73.3504 157.688 73.4851 157.688 73.6552V74.8035C157.688 74.9736 157.702 75.0799 157.723 75.1225C157.744 75.165 157.787 75.1863 157.836 75.1863C157.914 75.1863 157.985 75.1366 158.056 75.0303H158.134C158.077 75.3351 157.9 75.484 157.603 75.484C157.312 75.484 157.142 75.3139 157.085 74.9807C156.844 75.3139 156.553 75.484 156.227 75.484C156.008 75.484 155.838 75.4273 155.71 75.3068C155.582 75.1863 155.519 75.0445 155.519 74.8744C155.511 74.3427 156.036 74.0521 157.078 74.0025ZM157.078 74.4845V74.1443C156.695 74.1584 156.44 74.2152 156.312 74.3215C156.192 74.4207 156.128 74.5696 156.128 74.761C156.128 74.9027 156.164 75.0091 156.242 75.087C156.312 75.165 156.397 75.2004 156.497 75.2004C156.617 75.2004 156.731 75.1579 156.83 75.0799C156.929 74.9949 156.993 74.9169 157.028 74.8318C157.064 74.7468 157.078 74.6263 157.078 74.4845Z",
    fill: "#6B8299"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M159.58 72.2371V72.953H160.324V73.116H159.58V74.6613C159.58 74.8881 159.594 75.0441 159.623 75.1291C159.651 75.2142 159.736 75.2567 159.864 75.2567C159.963 75.2567 160.062 75.2213 160.154 75.1575C160.246 75.0937 160.317 74.9874 160.367 74.8456H160.502C160.402 75.2496 160.112 75.4552 159.63 75.4552C159.424 75.4552 159.275 75.4197 159.176 75.3418C159.084 75.2709 159.02 75.1787 158.999 75.0653C158.978 74.959 158.963 74.8101 158.963 74.6258V73.116H158.403V72.953H158.963V72.2938C159.176 72.2867 159.382 72.2725 159.58 72.2371Z",
    fill: "#6B8299"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M163.189 73.9882H161.608C161.594 74.6048 161.629 74.9876 161.714 75.1294C161.799 75.2711 161.948 75.342 162.161 75.342C162.6 75.342 162.905 75.0869 163.061 74.5694H163.196C163.125 74.8813 162.997 75.1081 162.806 75.257C162.614 75.4058 162.402 75.4767 162.168 75.4767C161.835 75.4767 161.544 75.3491 161.289 75.101C161.041 74.8529 160.913 74.541 160.913 74.1583C160.913 73.7897 161.034 73.4849 161.275 73.2297C161.516 72.9816 161.799 72.854 162.118 72.854C162.395 72.854 162.643 72.9532 162.848 73.1517C163.061 73.3644 163.174 73.6408 163.189 73.9882ZM161.608 73.8464H162.515C162.529 73.6975 162.544 73.5841 162.544 73.5061C162.544 73.173 162.395 73.0029 162.09 73.0029C161.941 73.0029 161.82 73.0454 161.735 73.1234C161.65 73.2013 161.608 73.3148 161.608 73.4494V73.8464Z",
    fill: "#6B8299"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M165.25 74.1722C165.25 73.8107 165.371 73.5059 165.619 73.2507C165.867 72.9955 166.172 72.8679 166.54 72.8679C166.902 72.8679 167.2 72.9884 167.455 73.2294C167.703 73.4704 167.83 73.7752 167.83 74.1438C167.83 74.5195 167.703 74.8314 167.441 75.0937C167.178 75.3559 166.873 75.4835 166.526 75.4835C166.179 75.4835 165.881 75.3559 165.626 75.1008C165.378 74.8527 165.25 74.5408 165.25 74.1722ZM167.129 74.1722C167.129 73.7894 167.114 73.5342 167.086 73.4137C167.058 73.2932 167.001 73.194 166.909 73.1231C166.817 73.0522 166.696 73.0168 166.533 73.0168C166.384 73.0168 166.257 73.0522 166.165 73.1302C166.065 73.2011 166.009 73.3003 165.987 73.4279C165.966 73.5484 165.952 73.8036 165.952 74.1864C165.952 74.5691 165.966 74.8243 165.995 74.9519C166.023 75.0795 166.087 75.1716 166.179 75.2425C166.271 75.3134 166.391 75.3489 166.533 75.3489C166.682 75.3489 166.803 75.3134 166.895 75.2425C166.994 75.1716 167.051 75.0724 167.079 74.9448C167.114 74.8101 167.129 74.555 167.129 74.1722Z",
    fill: "#6B8299"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M168.788 75.2426V73.1019H168.271V72.9389H168.788C168.774 72.386 168.887 71.9536 169.128 71.6346C169.376 71.3156 169.667 71.1597 170 71.1597C170.163 71.1597 170.305 71.2093 170.425 71.3014C170.546 71.3936 170.603 71.507 170.603 71.6417C170.603 71.7338 170.574 71.8118 170.518 71.8756C170.461 71.9394 170.39 71.9677 170.298 71.9677C170.22 71.9677 170.156 71.9394 170.106 71.8898C170.05 71.8402 170.021 71.7693 170.021 71.6913C170.021 71.5708 170.092 71.4645 170.227 71.3865C170.163 71.3298 170.071 71.3014 169.95 71.3014C169.837 71.3014 169.724 71.3369 169.617 71.4078C169.511 71.4786 169.447 71.585 169.426 71.7267C169.405 71.8685 169.39 72.1024 169.39 72.4143V72.9389H169.972V73.1019H169.39V75.2426H169.915V75.4056H168.306V75.2426H168.788V75.2426Z",
    fill: "#6B8299"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M173.962 71.1667V73.3641H173.976C174.132 73.0381 174.387 72.868 174.748 72.868C175.053 72.868 175.322 72.9956 175.549 73.2578C175.776 73.5201 175.89 73.8178 175.89 74.1651C175.89 74.5054 175.776 74.8102 175.556 75.0795C175.337 75.3489 175.074 75.4836 174.784 75.4836C174.429 75.4836 174.16 75.2922 173.983 74.9094H173.969V75.441C173.827 75.4127 173.628 75.4056 173.38 75.4056H172.927V75.2426H173.366V71.3652H172.927V71.2022H173.366C173.614 71.2093 173.813 71.1951 173.962 71.1667ZM174.734 75.3205C174.94 75.3205 175.067 75.2355 175.117 75.0725C175.159 74.9094 175.181 74.5975 175.181 74.1439C175.181 73.6831 175.159 73.3783 175.11 73.2295C175.06 73.0806 174.933 73.0097 174.72 73.0097C174.557 73.0097 174.408 73.0593 174.288 73.1586C174.16 73.2578 174.075 73.3783 174.025 73.513C173.976 73.6477 173.954 73.8887 173.954 74.236C173.954 74.5692 174.032 74.8385 174.195 75.0299C174.351 75.2213 174.536 75.3205 174.734 75.3205Z",
    fill: "#6B8299"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M177.414 72.9037V75.2499H177.825V75.413H176.372V75.2499H176.812V73.1092H176.372V72.9462H176.819C177.024 72.9462 177.23 72.932 177.414 72.9037ZM176.783 71.6986C176.783 71.6065 176.819 71.5285 176.883 71.4576C176.954 71.3938 177.031 71.3584 177.124 71.3584C177.216 71.3584 177.294 71.3938 177.365 71.4576C177.428 71.5214 177.464 71.6065 177.464 71.6986C177.464 71.7979 177.428 71.8759 177.365 71.9396C177.301 72.0034 177.216 72.0389 177.124 72.0389C177.031 72.0389 176.946 72.0034 176.883 71.9396C176.819 71.8759 176.783 71.7908 176.783 71.6986Z",
    fill: "#6B8299"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M178.564 75.2427V73.102H178.06V72.939H178.571C178.833 72.939 179.031 72.9248 179.173 72.8965V73.4848H179.187C179.336 73.0879 179.549 72.8965 179.832 72.8965C179.96 72.8965 180.059 72.9319 180.137 73.0099C180.215 73.0879 180.251 73.18 180.251 73.2863C180.251 73.3856 180.222 73.4706 180.158 73.5274C180.095 73.5911 180.017 73.6195 179.917 73.6195C179.74 73.6195 179.648 73.5274 179.648 73.3501L179.662 73.2155C179.662 73.1658 179.641 73.1446 179.598 73.1446C179.528 73.1446 179.443 73.2367 179.336 73.421C179.23 73.6053 179.18 73.8889 179.18 74.2716V75.2286H179.698V75.3916H178.06V75.2286H178.564V75.2427Z",
    fill: "#6B8299"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M181.83 72.2371V72.953H182.574V73.116H181.83V74.6613C181.83 74.8881 181.844 75.0441 181.872 75.1291C181.901 75.2142 181.986 75.2567 182.113 75.2567C182.213 75.2567 182.312 75.2213 182.404 75.1575C182.496 75.0937 182.567 74.9874 182.617 74.8456H182.751C182.652 75.2496 182.362 75.4552 181.88 75.4552C181.674 75.4552 181.525 75.4197 181.426 75.3418C181.334 75.2709 181.27 75.1787 181.249 75.0653C181.227 74.959 181.213 74.8101 181.213 74.6258V73.116H180.653V72.953H181.213V72.2938C181.426 72.2867 181.631 72.2725 181.83 72.2371Z",
    fill: "#6B8299"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M183.59 75.2428V71.3655H183.101V71.2025H183.569C183.853 71.2025 184.058 71.1883 184.2 71.1528V73.4849H184.214C184.42 73.088 184.717 72.8966 185.093 72.8966C185.242 72.8966 185.391 72.9391 185.54 73.0171C185.681 73.095 185.774 73.2085 185.816 73.3502C185.859 73.4991 185.88 73.733 185.88 74.052V75.2357H186.284V75.3988H184.873V75.2357H185.277V73.9882C185.277 73.6479 185.27 73.4069 185.249 73.2652C185.228 73.1234 185.136 73.0525 184.965 73.0525C184.781 73.0525 184.632 73.1305 184.505 73.2864C184.384 73.4424 184.299 73.5983 184.264 73.7614C184.228 73.9244 184.207 74.1867 184.207 74.5553V75.2357H184.611V75.3988H183.158V75.2357H183.59V75.2428Z",
    fill: "#6B8299"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M150.578 81.0344C150.578 79.6593 151.117 78.9434 151.96 78.9434C152.804 78.9434 153.343 79.6664 153.343 81.0344C153.343 82.4096 152.804 83.168 151.96 83.168C151.117 83.168 150.578 82.4167 150.578 81.0344ZM152.634 81.0344C152.634 79.879 152.35 79.5175 151.953 79.5175C151.563 79.5175 151.273 79.8861 151.273 81.0344C151.273 82.1898 151.563 82.5868 151.953 82.5868C152.357 82.5939 152.634 82.1898 152.634 81.0344Z",
    fill: "#11302D"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M153.847 82.6648C154.981 81.5732 155.69 80.8501 155.69 80.2334C155.69 79.8011 155.449 79.5317 155.016 79.5317C154.704 79.5317 154.442 79.7443 154.222 79.9854L153.811 79.5742C154.18 79.1773 154.555 78.9434 155.108 78.9434C155.888 78.9434 156.398 79.4395 156.398 80.1909C156.398 80.9139 155.725 81.6582 154.917 82.5088C155.13 82.4876 155.399 82.4663 155.597 82.4663H156.597V83.0972H153.847V82.6648Z",
    fill: "#11302D"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M158.459 78.5442H158.963L157.474 84.1145H156.971L158.459 78.5442Z",
    fill: "#11302D"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M159.355 81.0344C159.355 79.6593 159.893 78.9434 160.737 78.9434C161.58 78.9434 162.119 79.6664 162.119 81.0344C162.119 82.4096 161.58 83.168 160.737 83.168C159.893 83.168 159.355 82.4167 159.355 81.0344ZM161.41 81.0344C161.41 79.879 161.127 79.5175 160.73 79.5175C160.34 79.5175 160.049 79.8861 160.049 81.0344C160.049 82.1898 160.34 82.5868 160.73 82.5868C161.134 82.5939 161.41 82.1898 161.41 81.0344Z",
    fill: "#11302D"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M162.621 82.6648C163.755 81.5732 164.464 80.8501 164.464 80.2334C164.464 79.8011 164.23 79.5317 163.791 79.5317C163.479 79.5317 163.217 79.7443 162.997 79.9854L162.586 79.5742C162.954 79.1773 163.33 78.9434 163.883 78.9434C164.663 78.9434 165.173 79.4395 165.173 80.1909C165.173 80.9139 164.5 81.6582 163.692 82.5088C163.904 82.4876 164.174 82.4663 164.372 82.4663H165.371V83.0972H162.621V82.6648Z",
    fill: "#11302D"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M167.237 78.5442H167.74L166.244 84.1145H165.748L167.237 78.5442Z",
    fill: "#11302D"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M168.342 82.4863H169.249V79.8068H168.498V79.3461C168.902 79.2681 169.185 79.1689 169.44 79.0129H169.993V82.4863H170.794V83.0888H168.342V82.4863Z",
    fill: "#11302D"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M171.85 82.2607C172.006 82.4379 172.254 82.5655 172.502 82.5655C173.013 82.5655 173.431 82.1898 173.459 81.0628C173.225 81.3605 172.864 81.5377 172.573 81.5377C171.871 81.5377 171.389 81.1266 171.389 80.276C171.389 79.4608 171.971 78.9434 172.672 78.9434C173.466 78.9434 174.147 79.56 174.147 80.9281C174.147 82.5088 173.381 83.168 172.545 83.168C172.056 83.168 171.701 82.9625 171.453 82.7073L171.85 82.2607ZM173.445 80.5312C173.367 79.8152 173.076 79.5033 172.679 79.5033C172.346 79.5033 172.07 79.7798 172.07 80.2689C172.07 80.7509 172.304 80.999 172.715 80.999C172.949 81.0061 173.225 80.8714 173.445 80.5312Z",
    fill: "#11302D"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M175.436 81.0046V80.9763C175.125 80.7494 174.876 80.4517 174.876 80.0193C174.876 79.3601 175.401 78.9348 176.103 78.9348C176.833 78.9348 177.301 79.3743 177.301 80.0335C177.301 80.4376 177.017 80.7778 176.755 80.9692V80.9975C177.131 81.2102 177.457 81.5079 177.457 82.0537C177.457 82.6775 176.904 83.1595 176.081 83.1595C175.288 83.1595 174.699 82.6987 174.699 82.0395C174.706 81.5433 175.054 81.2102 175.436 81.0046ZM176.103 82.642C176.493 82.642 176.776 82.4081 176.776 82.0324C176.776 81.593 176.344 81.4299 175.798 81.2031C175.543 81.3874 175.358 81.6497 175.358 81.9616C175.351 82.3727 175.684 82.642 176.103 82.642ZM176.698 80.0902C176.698 79.7287 176.471 79.4664 176.096 79.4664C175.784 79.4664 175.536 79.672 175.536 80.0264C175.536 80.4376 175.897 80.6148 176.358 80.792C176.571 80.5722 176.698 80.3454 176.698 80.0902Z",
    fill: "#11302D"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M178.223 82.1318C178.464 82.3657 178.769 82.5642 179.18 82.5642C179.634 82.5642 179.967 82.2736 179.967 81.7845C179.967 81.2954 179.669 81.019 179.215 81.019C178.953 81.019 178.804 81.0898 178.563 81.2529L178.209 81.026L178.329 79.0129H180.506V79.6367H178.967L178.882 80.622C179.052 80.5369 179.208 80.4873 179.421 80.4873C180.123 80.4873 180.704 80.8843 180.704 81.7632C180.704 82.6564 180.016 83.1667 179.272 83.1667C178.613 83.1667 178.181 82.9045 177.883 82.6068L178.223 82.1318Z",
    fill: "#11302D"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1863 99.7762L76.2004 100.754H76.0657C75.8815 100.166 75.5483 99.8754 75.0734 99.8754C74.8111 99.8754 74.6055 99.9463 74.4638 100.095C74.3149 100.244 74.244 100.393 74.244 100.549C74.244 100.691 74.3078 100.818 74.4283 100.917C74.5488 101.017 74.7686 101.095 75.0876 101.151C75.4065 101.208 75.6546 101.272 75.8177 101.357C75.9878 101.435 76.1295 101.57 76.243 101.754C76.3564 101.938 76.4131 102.151 76.4131 102.392C76.4131 102.76 76.2926 103.072 76.0516 103.313C75.8106 103.561 75.5129 103.682 75.1513 103.682C74.8607 103.682 74.5701 103.576 74.2795 103.356L74.0172 103.59H73.918V102.534H74.0385C74.1519 102.867 74.3007 103.115 74.5063 103.285C74.7048 103.455 74.9245 103.533 75.1584 103.533C75.3924 103.533 75.605 103.455 75.8035 103.299C76.002 103.143 76.0941 102.952 76.0941 102.711C76.0941 102.512 76.0232 102.342 75.8885 102.207C75.7539 102.073 75.5341 101.981 75.2293 101.924C74.9245 101.874 74.6906 101.811 74.5276 101.747C74.3645 101.676 74.2228 101.562 74.1094 101.392C73.9959 101.222 73.9321 101.038 73.9321 100.825C73.9321 100.542 74.0314 100.287 74.2369 100.06C74.4425 99.8329 74.7119 99.7266 75.0592 99.7266C75.3498 99.7266 75.6192 99.8187 75.8744 100.003C75.9452 99.9392 76.002 99.8612 76.0516 99.7691H76.1863V99.7762Z",
    fill: "#0049B1"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9843 102.314H77.5595C77.5454 102.867 77.5737 103.214 77.6517 103.342C77.7297 103.469 77.8643 103.533 78.0557 103.533C78.4527 103.533 78.722 103.299 78.8638 102.838H78.9843C78.9205 103.115 78.8071 103.328 78.6299 103.455C78.4598 103.59 78.2613 103.654 78.0557 103.654C77.7509 103.654 77.4887 103.54 77.2689 103.32C77.0421 103.094 76.9358 102.817 76.9358 102.477C76.9358 102.144 77.0421 101.867 77.2618 101.641C77.4816 101.414 77.7368 101.3 78.0203 101.3C78.2684 101.3 78.4952 101.392 78.6795 101.57C78.8709 101.754 78.9701 102.002 78.9843 102.314ZM77.5595 102.193H78.3818C78.396 102.059 78.4031 101.96 78.4031 101.889C78.4031 101.591 78.2684 101.435 77.9919 101.435C77.8573 101.435 77.7509 101.47 77.673 101.541C77.595 101.612 77.5595 101.711 77.5595 101.832V102.193Z",
    fill: "#0049B1"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9986 102.307L81.9626 103.448H82.2319V103.59H80.9135V103.448H81.2821L80.6512 102.697L79.9636 103.448H80.4102V103.59H79.3682V103.448H79.7935L80.5662 102.597L79.6659 101.52H79.347V101.378H80.715V101.52H80.3393L80.9064 102.208L81.5302 101.52H81.0978V101.378H82.1185V101.52H81.7003L80.9986 102.307Z",
    fill: "#0049B1"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7772 101.662C82.7772 101.562 82.8126 101.484 82.8764 101.413C82.9473 101.343 83.0253 101.307 83.1245 101.307C83.2237 101.307 83.3088 101.343 83.3797 101.413C83.4506 101.484 83.486 101.562 83.486 101.662C83.486 101.761 83.4506 101.846 83.3797 101.917C83.3088 101.988 83.2237 102.023 83.1245 102.023C83.0253 102.023 82.9473 101.988 82.8764 101.917C82.8126 101.839 82.7772 101.761 82.7772 101.662ZM82.7772 103.306C82.7772 103.214 82.8126 103.129 82.8764 103.058C82.9473 102.987 83.0253 102.952 83.1245 102.952C83.2237 102.952 83.3088 102.987 83.3797 103.058C83.4506 103.129 83.486 103.207 83.486 103.306C83.486 103.405 83.4506 103.49 83.3797 103.561C83.3088 103.632 83.2237 103.668 83.1245 103.668C83.0253 103.668 82.9473 103.632 82.8764 103.561C82.8126 103.483 82.7772 103.405 82.7772 103.306Z",
    fill: "#0049B1"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8045 99.8186H86.5417L87.2222 101.676L87.4703 102.392H87.4915L87.7326 101.676L88.3989 99.8186H89.1361V103.59H88.5052V101.867C88.5052 101.513 88.5548 101.017 88.5903 100.669H88.569L88.2642 101.527L87.6121 103.242H87.3002L86.648 101.527L86.3503 100.669H86.3291C86.3645 101.017 86.4141 101.52 86.4141 101.867V103.59H85.7974V99.8186H85.8045Z",
    fill: "#11302D"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0033 99.9609V101.577H96.3436C96.4641 101.577 96.5633 101.563 96.6484 101.542C96.7334 101.52 96.8043 101.457 96.8752 101.35C96.939 101.244 96.9815 101.088 96.9886 100.868H97.1375V102.47H96.9886C96.9744 102.165 96.9177 101.967 96.8114 101.868C96.7122 101.768 96.5562 101.726 96.3436 101.726H96.0033V103.448H96.7689C97.2013 103.448 97.5061 103.356 97.6762 103.172C97.8463 102.988 97.9455 102.704 97.9739 102.328H98.1157L98.0802 103.59H94.7345V103.448H95.337V99.9609H94.7345V99.8191H97.9455L98.0093 100.826H97.8676C97.8179 100.521 97.7187 100.301 97.5699 100.166C97.421 100.032 97.1658 99.9609 96.8114 99.9609H96.0033V99.9609Z",
    fill: "#0049B1"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4988 101.52L100.286 103.058L100.973 101.52H100.484V101.378H101.484V101.52H101.108L99.9737 104.093C99.8107 104.462 99.6689 104.717 99.5555 104.866C99.4421 105.015 99.3003 105.085 99.1373 105.085C99.0381 105.085 98.9601 105.05 98.9034 104.986C98.8467 104.922 98.8183 104.851 98.8183 104.766C98.8183 104.688 98.8396 104.632 98.8892 104.582C98.9388 104.533 98.9955 104.511 99.0593 104.511C99.1515 104.511 99.2224 104.554 99.272 104.639C99.3216 104.724 99.3641 104.766 99.3996 104.766C99.4492 104.766 99.5059 104.724 99.5626 104.632C99.6193 104.54 99.7115 104.362 99.8249 104.093L100.009 103.682L98.8963 101.527H98.5631V101.385H99.917V101.527H99.4988V101.52Z",
    fill: "#0049B1"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M103.688 102.314H102.263C102.249 102.867 102.277 103.214 102.355 103.342C102.433 103.469 102.568 103.533 102.759 103.533C103.156 103.533 103.426 103.299 103.568 102.838H103.688C103.624 103.115 103.511 103.328 103.334 103.455C103.163 103.59 102.965 103.654 102.759 103.654C102.455 103.654 102.192 103.54 101.973 103.32C101.753 103.094 101.639 102.817 101.639 102.477C101.639 102.144 101.746 101.867 101.966 101.641C102.185 101.414 102.44 101.3 102.724 101.3C102.972 101.3 103.192 101.392 103.383 101.57C103.575 101.747 103.674 102.002 103.688 102.314ZM102.263 102.193H103.085C103.1 102.059 103.107 101.96 103.107 101.889C103.107 101.591 102.972 101.435 102.696 101.435C102.561 101.435 102.455 101.47 102.377 101.541C102.299 101.612 102.263 101.711 102.263 101.832V102.193Z",
    fill: "#0049B1"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M105.635 101.356V101.987H105.522C105.437 101.618 105.224 101.441 104.891 101.441C104.749 101.441 104.629 101.476 104.529 101.554C104.43 101.632 104.388 101.717 104.388 101.817C104.388 101.902 104.423 101.965 104.494 102.015C104.565 102.065 104.721 102.107 104.976 102.135C105.536 102.206 105.819 102.462 105.819 102.901C105.819 103.121 105.749 103.305 105.6 103.447C105.451 103.596 105.274 103.667 105.061 103.667C104.848 103.667 104.643 103.582 104.444 103.404L104.246 103.574H104.147V102.745H104.246C104.409 103.277 104.678 103.539 105.061 103.539C105.203 103.539 105.337 103.496 105.458 103.404C105.578 103.312 105.635 103.206 105.635 103.078C105.635 102.972 105.6 102.894 105.529 102.844C105.458 102.795 105.267 102.745 104.962 102.695C104.437 102.617 104.168 102.384 104.168 101.994C104.168 101.802 104.239 101.639 104.381 101.512C104.522 101.384 104.692 101.313 104.898 101.313C105.111 101.313 105.295 101.384 105.444 101.526C105.479 101.483 105.522 101.434 105.557 101.356H105.635V101.356Z",
    fill: "#0049B1"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M106.466 101.662C106.466 101.562 106.501 101.484 106.565 101.413C106.636 101.343 106.714 101.307 106.813 101.307C106.912 101.307 106.997 101.343 107.068 101.413C107.139 101.484 107.175 101.562 107.175 101.662C107.175 101.761 107.139 101.846 107.068 101.917C106.997 101.988 106.912 102.023 106.813 102.023C106.721 102.023 106.636 101.988 106.565 101.917C106.501 101.839 106.466 101.761 106.466 101.662ZM106.466 103.306C106.466 103.214 106.501 103.129 106.565 103.058C106.636 102.987 106.714 102.952 106.813 102.952C106.912 102.952 106.997 102.987 107.068 103.058C107.139 103.129 107.175 103.207 107.175 103.306C107.175 103.405 107.139 103.49 107.068 103.561C106.997 103.632 106.912 103.668 106.813 103.668C106.721 103.668 106.636 103.632 106.565 103.561C106.501 103.483 106.466 103.405 106.466 103.306Z",
    fill: "#0049B1"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M109.494 99.8186H110.699C111.478 99.8186 112.046 100.053 112.046 100.747C112.046 101.102 111.84 101.449 111.401 101.569V101.591C111.939 101.683 112.244 101.973 112.244 102.484C112.244 103.242 111.627 103.59 110.798 103.59H109.494V99.8186ZM110.642 101.385C111.167 101.385 111.393 101.187 111.393 100.832C111.393 100.485 111.145 100.343 110.656 100.343H110.167V101.385H110.642ZM110.727 103.072C111.28 103.072 111.592 102.867 111.592 102.441C111.592 102.051 111.294 101.867 110.727 101.867H110.16V103.079H110.727V103.072Z",
    fill: "#11302D"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M114.993 103.59L114.178 102.115H113.604V103.59H112.937V99.8186H114.213C115 99.8186 115.596 100.095 115.596 100.939C115.596 101.513 115.298 101.86 114.844 102.016L115.744 103.59H114.993V103.59ZM113.604 101.584H114.142C114.653 101.584 114.936 101.364 114.936 100.939C114.936 100.506 114.653 100.357 114.142 100.357H113.604V101.584Z",
    fill: "#11302D"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M116.192 101.69C116.192 100.471 116.872 99.7549 117.85 99.7549C118.836 99.7549 119.516 100.478 119.516 101.69C119.516 102.909 118.836 103.661 117.85 103.661C116.872 103.661 116.192 102.909 116.192 101.69ZM118.821 101.69C118.821 100.846 118.439 100.336 117.85 100.336C117.255 100.336 116.872 100.846 116.872 101.69C116.872 102.541 117.255 103.079 117.85 103.079C118.446 103.079 118.821 102.534 118.821 101.69Z",
    fill: "#11302D"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M123.684 103.448V99.9604H123.089V99.8186H124.953V99.9604H124.35V101.577H125.981V99.9604H125.392V99.8186H127.243V99.9604H126.647V103.448H127.243V103.59H125.392V103.448H125.981V101.718H124.35V103.448H124.953V103.59H123.089V103.448H123.684Z",
    fill: "#0049B1"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M128.697 100.74V101.385H129.363V101.527H128.697V102.923C128.697 103.129 128.711 103.27 128.739 103.341C128.768 103.419 128.839 103.455 128.959 103.455C129.051 103.455 129.136 103.426 129.221 103.362C129.306 103.306 129.37 103.207 129.413 103.086H129.533C129.448 103.448 129.186 103.632 128.746 103.632C128.562 103.632 128.427 103.596 128.342 103.533C128.257 103.469 128.201 103.384 128.186 103.284C128.165 103.185 128.158 103.058 128.158 102.888V101.527H127.655V101.385H128.158V100.789C128.335 100.782 128.52 100.768 128.697 100.74Z",
    fill: "#0049B1"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M130.101 101.661C130.101 101.562 130.136 101.484 130.207 101.413C130.278 101.342 130.356 101.307 130.455 101.307C130.554 101.307 130.639 101.342 130.71 101.413C130.781 101.484 130.817 101.562 130.817 101.661C130.817 101.761 130.781 101.846 130.71 101.916C130.639 101.987 130.554 102.023 130.455 102.023C130.363 102.023 130.278 101.987 130.207 101.916C130.136 101.839 130.101 101.761 130.101 101.661ZM130.101 103.306C130.101 103.214 130.136 103.129 130.207 103.058C130.278 102.987 130.356 102.951 130.455 102.951C130.554 102.951 130.639 102.987 130.71 103.058C130.781 103.129 130.817 103.207 130.817 103.306C130.817 103.405 130.781 103.49 130.71 103.561C130.639 103.632 130.554 103.667 130.455 103.667C130.363 103.667 130.278 103.632 130.207 103.561C130.136 103.483 130.101 103.398 130.101 103.306Z",
    fill: "#0049B1"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M134.963 100.676C134.828 100.513 134.601 100.4 134.381 100.4C133.921 100.4 133.545 100.74 133.517 101.753C133.729 101.484 134.048 101.321 134.311 101.321C134.941 101.321 135.381 101.69 135.381 102.455C135.381 103.185 134.856 103.66 134.225 103.66C133.502 103.66 132.893 103.1 132.893 101.867C132.893 100.442 133.588 99.8538 134.332 99.8538C134.778 99.8538 135.09 100.038 135.31 100.272L134.963 100.676ZM134.771 102.455C134.771 102.023 134.559 101.803 134.197 101.803C133.992 101.803 133.751 101.916 133.538 102.221C133.609 102.873 133.864 103.15 134.225 103.15C134.53 103.15 134.771 102.902 134.771 102.455Z",
    fill: "#11302D"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M135.849 101.895H137.224V102.377H135.849V101.895Z",
    fill: "#11302D"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M137.692 101.739C137.692 100.499 138.174 99.8538 138.94 99.8538C139.698 99.8538 140.187 100.506 140.187 101.739C140.187 102.98 139.705 103.66 138.94 103.66C138.181 103.66 137.692 102.98 137.692 101.739ZM139.549 101.739C139.549 100.704 139.294 100.371 138.94 100.371C138.585 100.371 138.33 100.697 138.33 101.739C138.33 102.774 138.592 103.143 138.94 103.143C139.294 103.143 139.549 102.781 139.549 101.739Z",
    fill: "#11302D"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M140.647 101.739C140.647 100.499 141.129 99.8538 141.894 99.8538C142.653 99.8538 143.142 100.506 143.142 101.739C143.142 102.98 142.66 103.66 141.894 103.66C141.136 103.66 140.647 102.98 140.647 101.739ZM142.504 101.739C142.504 100.704 142.249 100.371 141.894 100.371C141.54 100.371 141.285 100.697 141.285 101.739C141.285 102.774 141.547 103.143 141.894 103.143C142.249 103.143 142.504 102.781 142.504 101.739Z",
    fill: "#11302D"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.66
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M187.934 0.0148926H9.38495C4.21043 0.0148926 0.0140991 4.21032 0.0140991 9.38374V23.9685H197.298V9.38374C197.298 4.21032 193.109 0.0148926 187.934 0.0148926Z",
    fill: "url(#paint1_linear)"
  }))), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M197.298 22.2607H0.0136719V24.3873H197.298V22.2607Z",
    fill: "url(#paint2_linear)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M156.476 39.2132V40.9566H156.285C156.08 39.9006 155.555 39.3691 154.697 39.3691C154.237 39.3691 153.903 39.5463 153.698 39.9077C153.485 40.2691 153.379 41.0204 153.379 42.1755C153.379 43.1252 153.421 43.7701 153.514 44.1102C153.606 44.4504 153.762 44.6984 153.981 44.8402C154.208 44.989 154.449 45.0599 154.719 45.0599C155.066 45.0599 155.399 44.9252 155.704 44.663C156.009 44.4008 156.25 43.9756 156.42 43.3945H156.625L156.554 45.1874H156.377C156.313 45.0032 156.207 44.8402 156.058 44.7126C155.598 45.0953 155.123 45.2867 154.634 45.2867C154.017 45.2867 153.45 44.9961 152.939 44.4079C152.429 43.8197 152.174 43.1039 152.174 42.2535C152.174 41.3889 152.422 40.6518 152.925 40.0495C153.428 39.4471 154.01 39.1423 154.669 39.1423C155.179 39.1423 155.626 39.3266 156.016 39.688C156.129 39.5038 156.214 39.3479 156.271 39.2132H156.476Z",
    fill: "#0049B1"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M159.46 39.5039V44.9253H160.779C161.034 44.9253 161.233 44.9041 161.381 44.8686C161.53 44.8332 161.672 44.7411 161.814 44.5922C161.956 44.4434 162.062 44.2733 162.14 44.0749C162.218 43.8765 162.303 43.593 162.388 43.2316H162.594L162.431 45.1521H157.497V44.9253H158.418V39.5039H157.497V39.2842H160.439V39.5039H159.46V39.5039Z",
    fill: "#0049B1"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M166.605 43.3163H164.741L164.139 44.925H165.223V45.1447H163.097V44.925H163.905L166.045 39.1421H166.18L168.236 44.925H169.023V45.1447H166.223V44.925H167.173L166.605 43.3163ZM164.826 43.0966H166.527L165.698 40.7437H165.684L164.826 43.0966Z",
    fill: "#0049B1"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M173.232 39.213L173.26 40.7366H173.055C172.764 39.8224 172.247 39.3689 171.509 39.3689C171.098 39.3689 170.786 39.4823 170.56 39.709C170.333 39.9358 170.219 40.1697 170.219 40.4106C170.219 40.6374 170.311 40.8288 170.503 40.9847C170.694 41.1406 171.034 41.2611 171.531 41.3532C172.034 41.4382 172.41 41.5445 172.672 41.665C172.934 41.7926 173.154 41.9981 173.331 42.2816C173.508 42.5721 173.6 42.9052 173.6 43.2737C173.6 43.8478 173.416 44.3297 173.04 44.7124C172.665 45.0951 172.197 45.2864 171.644 45.2864C171.19 45.2864 170.744 45.1163 170.29 44.7832L169.879 45.1518H169.723V43.5076H169.914C170.085 44.0249 170.326 44.4147 170.638 44.6698C170.949 44.9321 171.283 45.0596 171.651 45.0596C172.013 45.0596 172.353 44.9392 172.658 44.6982C172.963 44.4572 173.118 44.1525 173.118 43.784C173.118 43.4722 173.012 43.217 172.799 43.0044C172.587 42.7918 172.247 42.6501 171.772 42.565C171.297 42.4871 170.935 42.395 170.68 42.2887C170.425 42.1824 170.205 41.9981 170.028 41.7359C169.844 41.4737 169.759 41.176 169.759 40.8571C169.759 40.4106 169.915 40.0209 170.233 39.6665C170.552 39.3193 170.978 39.1421 171.516 39.1421C171.97 39.1421 172.388 39.2838 172.785 39.5744C172.892 39.4752 172.984 39.3547 173.069 39.213H173.232V39.213Z",
    fill: "#0049B1"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M178.095 39.213L178.123 40.7366H177.918C177.627 39.8224 177.11 39.3689 176.372 39.3689C175.961 39.3689 175.649 39.4823 175.423 39.709C175.196 39.9358 175.082 40.1697 175.082 40.4106C175.082 40.6374 175.174 40.8288 175.366 40.9847C175.557 41.1406 175.897 41.2611 176.394 41.3532C176.897 41.4382 177.273 41.5445 177.535 41.665C177.797 41.7926 178.017 41.9981 178.194 42.2816C178.371 42.5721 178.463 42.9052 178.463 43.2737C178.463 43.8478 178.279 44.3297 177.903 44.7124C177.528 45.0951 177.06 45.2864 176.507 45.2864C176.053 45.2864 175.607 45.1163 175.153 44.7832L174.742 45.1518H174.586V43.5076H174.777C174.948 44.0249 175.189 44.4147 175.501 44.6698C175.812 44.9321 176.146 45.0596 176.514 45.0596C176.876 45.0596 177.216 44.9392 177.521 44.6982C177.826 44.4572 177.981 44.1525 177.981 43.784C177.981 43.4722 177.875 43.217 177.662 43.0044C177.45 42.7918 177.11 42.6501 176.635 42.565C176.16 42.4871 175.798 42.395 175.543 42.2887C175.288 42.1824 175.068 41.9981 174.891 41.7359C174.707 41.4737 174.622 41.176 174.622 40.8571C174.622 40.4106 174.778 40.0209 175.096 39.6665C175.415 39.3193 175.841 39.1421 176.379 39.1421C176.833 39.1421 177.251 39.2838 177.648 39.5744C177.755 39.4752 177.847 39.3547 177.932 39.213H178.095V39.213Z",
    fill: "#0049B1"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M185.865 39.213V40.9563H185.674C185.468 39.9004 184.944 39.3689 184.086 39.3689C183.625 39.3689 183.292 39.546 183.087 39.9075C182.874 40.2689 182.768 41.0201 182.768 42.1753C182.768 43.1249 182.81 43.7698 182.902 44.11C182.994 44.4502 183.15 44.6982 183.37 44.8399C183.597 44.9888 183.838 45.0596 184.107 45.0596C184.455 45.0596 184.788 44.925 185.093 44.6628C185.397 44.4005 185.638 43.9753 185.808 43.3942H186.014L185.943 45.1872H185.766C185.702 45.0029 185.596 44.8399 185.447 44.7124C184.986 45.0951 184.511 45.2864 184.022 45.2864C183.406 45.2864 182.838 44.9958 182.328 44.4076C181.818 43.8194 181.563 43.1037 181.563 42.2532C181.563 41.3886 181.811 40.6516 182.314 40.0492C182.817 39.4468 183.398 39.1421 184.058 39.1421C184.568 39.1421 185.015 39.3263 185.404 39.6878C185.518 39.5035 185.603 39.3476 185.66 39.213H185.865Z",
    fill: "#0049B1"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2267 38.4459V44.3138H77.1057V44.6256H73.7812V44.3138H74.6319V38.4459H73.7812V38.134H77.1057V38.4459H76.2267V38.4459Z",
    fill: "#11302D"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3109 44.3138V38.4459H77.4957V38.134H80.7918C81.7416 38.134 82.5001 38.4388 83.053 39.0412C83.6059 39.6435 83.8894 40.4089 83.8894 41.3302C83.8894 41.805 83.8044 42.2586 83.6342 42.6767C83.4641 43.0948 83.2019 43.4775 82.8545 43.8248C82.5001 44.172 82.1386 44.3917 81.77 44.491C81.4014 44.5902 80.9477 44.6398 80.409 44.6398H77.5028V44.328H78.3109V44.3138ZM79.8987 38.4459V44.3138H80.409C81.1958 44.3138 81.6708 44.087 81.8338 43.6193C81.9968 43.1586 82.0819 42.372 82.0819 41.2593C82.0819 40.3877 82.0323 39.7569 81.933 39.3813C81.8338 38.9986 81.6778 38.7506 81.4794 38.6301C81.2738 38.5096 81.0186 38.4529 80.7067 38.4529H79.8987V38.4459Z",
    fill: "#11302D"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7324 41.4634C84.7324 41.2295 84.8175 41.031 84.9876 40.868C85.1577 40.7049 85.3562 40.6199 85.5759 40.6199C85.8099 40.6199 86.0083 40.7049 86.1714 40.868C86.3344 41.031 86.4195 41.2295 86.4195 41.4634C86.4195 41.6973 86.3344 41.8958 86.1714 42.0588C86.0083 42.2218 85.8028 42.3069 85.5689 42.3069C85.342 42.3069 85.1436 42.2218 84.9805 42.0588C84.8175 41.8958 84.7324 41.6973 84.7324 41.4634ZM84.7324 43.916C84.7324 43.6821 84.8175 43.4836 84.9876 43.3205C85.1577 43.1575 85.3562 43.0725 85.5759 43.0725C85.8099 43.0725 86.0083 43.1575 86.1714 43.3205C86.3344 43.4836 86.4195 43.6891 86.4195 43.916C86.4195 44.1499 86.3344 44.3484 86.1714 44.5114C86.0083 44.6744 85.8028 44.7595 85.5689 44.7595C85.342 44.7595 85.1436 44.6744 84.9805 44.5114C84.8175 44.3413 84.7324 44.1428 84.7324 43.916Z",
    fill: "#11302D"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7987 38.1621C92.4083 38.1621 92.9257 38.4739 93.351 39.0976C93.7834 39.7212 93.9961 40.5149 93.9961 41.4859C93.9961 41.9607 93.8968 42.478 93.6913 43.045C93.4857 43.6119 93.2092 44.0371 92.8477 44.3206C92.4933 44.6112 92.1318 44.7529 91.7774 44.7529C91.1891 44.7529 90.6716 44.4269 90.2321 43.782C89.7927 43.1371 89.5729 42.3575 89.5729 41.4504C89.5729 40.5504 89.7856 39.7779 90.218 39.133C90.6503 38.481 91.182 38.1621 91.7987 38.1621ZM91.7632 44.4269C91.9546 44.4269 92.1035 44.3135 92.2098 44.0938C92.309 43.8741 92.3728 43.1584 92.3941 41.9536L92.4224 40.6142C92.4224 39.8842 92.3728 39.3456 92.2736 38.9984C92.1743 38.644 92.0184 38.4668 91.7987 38.4668C91.5435 38.4668 91.3734 38.7007 91.2954 39.1614C91.2174 39.622 91.1749 40.4583 91.1749 41.663C91.1749 42.5914 91.2032 43.2363 91.2599 43.6119C91.3167 43.9804 91.3804 44.2143 91.4584 44.2923C91.5222 44.3844 91.6285 44.4269 91.7632 44.4269Z",
    fill: "#11302D"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4144 38.2119V44.3137H98.5839V44.6255H94.6641V44.3137H95.9116V38.6442H94.6641V38.3324H95.4013C95.7273 38.3324 96.1384 38.3111 96.6275 38.2686L97.2371 38.2119H97.4144Z",
    fill: "#11302D"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M103.538 42.5276L103.39 44.6324H99.3704V43.7678C99.5618 43.5836 99.7461 43.4206 99.9304 43.2717C100.824 42.5276 101.398 41.9819 101.653 41.6347C101.908 41.2874 102.043 40.7772 102.043 40.1181C102.043 39.0976 101.724 38.5802 101.093 38.5802C100.838 38.5802 100.618 38.644 100.42 38.7645C100.221 38.885 100.122 39.0338 100.122 39.1968C100.122 39.3031 100.207 39.3669 100.37 39.3669C100.533 39.374 100.696 39.4307 100.859 39.537C101.015 39.6433 101.093 39.8275 101.093 40.0897C101.093 40.3094 101.015 40.4795 100.866 40.6142C100.717 40.7488 100.554 40.8126 100.377 40.8126C100.171 40.8126 99.98 40.7276 99.8028 40.5575C99.6256 40.3874 99.5405 40.1464 99.5405 39.8346C99.5405 39.374 99.7178 38.9771 100.079 38.6511C100.441 38.3251 100.902 38.1621 101.469 38.1621C102.078 38.1621 102.589 38.3393 103.014 38.6795C103.432 39.0267 103.645 39.4448 103.645 39.9338C103.645 40.6638 103.163 41.3583 102.206 42.0174L100.264 43.3568V43.378H102.695C102.893 43.378 103.035 43.3355 103.106 43.2434C103.184 43.1513 103.219 42.9174 103.234 42.5205H103.538V42.5276Z",
    fill: "#11302D"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M108.649 41.1814V41.2026C109.436 41.2168 110.01 41.394 110.385 41.7271C110.761 42.0601 110.945 42.4641 110.945 42.9318C110.945 43.4563 110.733 43.8956 110.307 44.2358C109.882 44.576 109.315 44.7461 108.606 44.7461C107.997 44.7461 107.522 44.6114 107.188 44.335C106.855 44.0586 106.685 43.7539 106.685 43.3996C106.685 43.1657 106.763 42.9814 106.912 42.8397C107.061 42.698 107.245 42.6271 107.451 42.6271C107.649 42.6271 107.819 42.6909 107.954 42.8114C108.096 42.9389 108.167 43.1019 108.167 43.3003C108.167 43.5697 108.004 43.7964 107.678 43.9807C107.614 44.0161 107.578 44.0586 107.578 44.1012C107.578 44.1862 107.671 44.2571 107.855 44.3209C108.039 44.3846 108.223 44.413 108.415 44.413C109.039 44.413 109.358 43.8956 109.358 42.868C109.358 41.8475 108.982 41.3373 108.23 41.3373L107.607 41.3656C107.479 41.3656 107.415 41.316 107.415 41.2097C107.415 41.0892 107.479 41.0325 107.614 41.0325L108.067 41.0538C108.535 41.0538 108.847 40.9404 109.003 40.7066C109.159 40.4727 109.237 40.1467 109.237 39.7215C109.237 39.2821 109.18 38.9561 109.06 38.7506C108.939 38.5451 108.734 38.4388 108.443 38.4388C108.287 38.4388 108.138 38.4671 107.997 38.5309C107.855 38.5876 107.791 38.6514 107.791 38.7081C107.791 38.7648 107.834 38.8214 107.926 38.8781C108.167 39.0482 108.287 39.2325 108.287 39.438C108.287 39.6364 108.216 39.7923 108.089 39.9057C107.954 40.0191 107.805 40.0829 107.635 40.0829C107.444 40.0829 107.266 40.0191 107.118 39.8845C106.969 39.7498 106.891 39.5868 106.891 39.3884C106.891 39.0553 107.061 38.7648 107.394 38.5167C107.734 38.2687 108.167 38.1482 108.698 38.1482C109.28 38.1482 109.776 38.2828 110.18 38.5592C110.584 38.8356 110.782 39.19 110.782 39.6223C110.782 40.4939 110.066 41.0042 108.649 41.1814Z",
    fill: "#11302D"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M114.887 38.1609V42.5973H115.589V41.9595H115.894V43.554H115.589V42.9091H114.887V44.3123H115.589V44.6241H112.69V44.3123H113.484V42.9091H111.393V42.5831L114.192 38.1538H114.887V38.1609ZM113.462 39.8476L111.747 42.5973H113.484V39.8476H113.462Z",
    fill: "#11302D"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M117.247 39.5794L117.19 40.9684C117.651 40.8196 118.048 40.7487 118.395 40.7487C118.991 40.7487 119.522 40.9259 119.976 41.2732C120.43 41.6204 120.656 42.0952 120.656 42.6905C120.656 43.2717 120.423 43.7677 119.962 44.1575C119.501 44.5544 118.92 44.7528 118.225 44.7528C117.637 44.7528 117.176 44.6111 116.85 44.3347C116.524 44.0583 116.361 43.7465 116.361 43.3992C116.361 43.2008 116.432 43.0307 116.574 42.8819C116.715 42.7331 116.9 42.6551 117.126 42.6551C117.346 42.6551 117.523 42.726 117.644 42.8606C117.764 43.0024 117.828 43.1654 117.828 43.3496C117.828 43.4984 117.779 43.6331 117.679 43.7465C117.58 43.8599 117.474 43.9378 117.346 43.9591C117.226 43.9874 117.162 44.03 117.162 44.0937C117.162 44.1788 117.261 44.2567 117.453 44.3205C117.644 44.3843 117.849 44.4197 118.055 44.4197C118.707 44.4197 119.04 43.9024 119.04 42.8677C119.04 41.6984 118.686 41.1102 117.977 41.1102C117.757 41.1102 117.559 41.1456 117.389 41.2094L116.971 41.3724C116.921 41.3724 116.885 41.3582 116.878 41.3228C116.871 41.2873 116.864 41.2165 116.871 41.1102L116.956 38.6014C116.963 38.4526 116.978 38.3675 116.992 38.3321C117.013 38.2967 117.063 38.2825 117.155 38.2825H119.721C119.806 38.2825 119.863 38.2754 119.898 38.2542C119.933 38.24 119.969 38.1479 120.011 37.9919H120.295C120.238 38.7148 120.139 39.1613 120.004 39.3314C119.87 39.5014 119.593 39.5865 119.182 39.5865H117.247V39.5794Z",
    fill: "#11302D"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M125.356 40.9256L125.378 40.9468C125.569 40.6775 125.852 40.5429 126.242 40.5429C126.753 40.5429 127.178 40.7484 127.525 41.1665C127.873 41.5847 128.043 42.0524 128.043 42.5768C128.043 43.1579 127.83 43.6611 127.412 44.1005C126.994 44.5399 126.498 44.7525 125.923 44.7525C125.278 44.7525 124.747 44.4974 124.321 43.9942C123.896 43.491 123.683 42.7823 123.683 41.8823C123.683 41.0461 123.882 40.3374 124.279 39.7633C124.676 39.1822 125.193 38.7641 125.824 38.4877C126.462 38.2184 126.987 38.0837 127.405 38.0837C127.518 38.0837 127.575 38.1404 127.575 38.2467C127.575 38.346 127.525 38.3956 127.433 38.3956C126.916 38.431 126.455 38.6649 126.065 39.083C125.675 39.5011 125.434 40.1177 125.356 40.9256ZM125.973 40.9256C125.682 40.9256 125.498 41.0461 125.413 41.287C125.328 41.528 125.285 41.9744 125.285 42.6193C125.285 43.3635 125.328 43.8525 125.406 44.1005C125.484 44.3414 125.64 44.469 125.874 44.469C126.094 44.469 126.257 44.3769 126.349 44.1997C126.441 44.0225 126.49 43.7036 126.49 43.243C126.49 42.1374 126.455 41.4784 126.384 41.2516C126.306 41.039 126.171 40.9256 125.973 40.9256Z",
    fill: "#11302D"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M129.113 38.2751H132.962V38.6011C131.721 40.4437 131.098 41.7123 131.098 42.4068C131.098 42.6832 131.154 42.9667 131.275 43.2572C131.395 43.5478 131.452 43.7675 131.452 43.9163C131.452 44.1785 131.36 44.384 131.183 44.5258C131.005 44.6675 130.786 44.7384 130.531 44.7384C130.268 44.7384 130.063 44.6604 129.9 44.5116C129.744 44.3557 129.666 44.1502 129.666 43.8809C129.666 43.6257 129.786 43.2501 130.034 42.7611C130.275 42.2721 130.651 41.6343 131.154 40.8619C131.658 40.0894 131.955 39.6287 132.062 39.487H129.446C129.297 39.487 129.198 39.5012 129.155 39.5366C129.113 39.572 129.063 39.6571 129.021 39.7988L128.829 40.387H128.517L129.113 38.2751Z",
    fill: "#11302D"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M136.01 41.3216V41.3429C136.619 41.4279 137.066 41.6335 137.349 41.9524C137.64 42.2784 137.782 42.6398 137.782 43.0367C137.782 43.5327 137.59 43.9438 137.215 44.2627C136.839 44.5816 136.3 44.7446 135.599 44.7446C134.868 44.7446 134.316 44.5745 133.926 44.2343C133.543 43.8942 133.352 43.4831 133.352 42.9941C133.352 42.1437 133.912 41.5909 135.032 41.3358V41.3146C134.075 41.024 133.593 40.5067 133.593 39.7696C133.593 39.3161 133.784 38.9334 134.16 38.6215C134.535 38.3097 135.017 38.1538 135.606 38.1538C136.201 38.1538 136.683 38.3239 137.045 38.657C137.406 38.9901 137.583 39.3728 137.583 39.7909C137.59 40.5421 137.066 41.0523 136.01 41.3216ZM135.584 44.4257C135.804 44.4257 135.967 44.3336 136.074 44.1564C136.187 43.9721 136.237 43.554 136.237 42.902C136.237 42.3209 136.18 41.9453 136.066 41.7681C135.953 41.5909 135.783 41.4988 135.556 41.4988C135.28 41.4988 135.102 41.6193 135.024 41.8532C134.946 42.087 134.911 42.4839 134.911 43.0367C134.911 43.5965 134.968 43.9721 135.074 44.1564C135.18 44.3336 135.35 44.4257 135.584 44.4257ZM135.577 41.2012C135.818 41.2012 135.96 41.0878 136.017 40.8539C136.074 40.62 136.095 40.2303 136.095 39.6633C136.095 39.1176 136.052 38.7845 135.967 38.6499C135.882 38.5152 135.755 38.4515 135.584 38.4515C135.421 38.4515 135.287 38.5223 135.195 38.6641C135.102 38.8058 135.053 39.1885 135.053 39.8121C135.053 40.3153 135.088 40.6696 135.166 40.8823C135.23 41.0949 135.372 41.2012 135.577 41.2012Z",
    fill: "#11302D"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M177.827 2.74316C173.12 2.74316 169.3 6.5559 169.3 11.2687C169.3 15.9744 173.113 19.7942 177.827 19.7942C182.534 19.7942 186.354 15.9814 186.354 11.2687C186.347 6.56299 182.534 2.74316 177.827 2.74316ZM181.428 16.8106L177.827 14.9184L174.226 16.8106L174.914 12.7994L172 9.9576L176.027 9.36939L177.827 5.71965L179.627 9.36939L183.654 9.9576L180.74 12.7994L181.428 16.8106Z",
    fill: "url(#paint3_linear)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M1.19693 23.3307L0.0273438 24.0537V22.6077L1.19693 23.3307Z",
    fill: "url(#paint4_linear)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M3.54374 23.3278L2.38125 24.0508L1.21875 23.3278L2.38125 22.5977L3.54374 23.3278Z",
    fill: "url(#paint5_linear)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M5.89849 23.3278L4.73599 24.0508L3.56641 23.3278L4.73599 22.5977L5.89849 23.3278Z",
    fill: "url(#paint6_linear)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24296 23.3278L7.08047 24.0508L5.91797 23.3278L7.08047 22.5977L8.24296 23.3278Z",
    fill: "url(#paint7_linear)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5958 23.3207L9.43326 24.0508L8.26367 23.3278L9.43326 22.5977L10.5958 23.3207Z",
    fill: "url(#paint8_linear)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9422 23.3207L11.7797 24.0508L10.6172 23.3207L11.7797 22.5977L12.9422 23.3207Z",
    fill: "url(#paint9_linear)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2969 23.3207L14.1344 24.0508L12.9648 23.3207L14.1344 22.5977L15.2969 23.3207Z",
    fill: "url(#paint10_linear)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6504 23.3207L16.4809 24.0508L15.3184 23.3207L16.4809 22.5977L17.6504 23.3207Z",
    fill: "url(#paint11_linear)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9961 23.3207L18.8336 24.0437L17.6641 23.3207L18.8336 22.5977L19.9961 23.3207Z",
    fill: "url(#paint12_linear)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3477 23.3207L21.1781 24.0437L20.0156 23.3207L21.1781 22.5977L22.3477 23.3207Z",
    fill: "url(#paint13_linear)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6954 23.3207L23.5329 24.0437L22.3633 23.3207L23.5329 22.5977L24.6954 23.3207Z",
    fill: "url(#paint14_linear)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0489 23.3207L25.8793 24.0437L24.7168 23.3207L25.8793 22.5977L27.0489 23.3207Z",
    fill: "url(#paint15_linear)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3946 23.3207L28.2321 24.0437L27.0625 23.3207L28.2321 22.5977L29.3946 23.3207Z",
    fill: "url(#paint16_linear)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M31.75 23.3207L30.5805 24.0437L29.418 23.3207L30.5805 22.5977L31.75 23.3207Z",
    fill: "url(#paint17_linear)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0945 23.3207L32.932 24.0437L31.7695 23.3207L32.932 22.5977L34.0945 23.3207Z",
    fill: "url(#paint18_linear)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4493 23.3207L35.2797 24.0437L34.1172 23.3207L35.2868 22.5977L36.4493 23.3207Z",
    fill: "url(#paint19_linear)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7937 23.3207L37.6312 24.0437L36.4688 23.3207L37.6312 22.5977L38.7937 23.3207Z",
    fill: "url(#paint20_linear)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1471 23.3229L39.9775 24.0459L38.815 23.3229L39.9846 22.5928L41.1471 23.3229Z",
    fill: "url(#paint21_linear)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4931 23.3229L42.3306 24.0459L41.1682 23.3229L42.3306 22.5928L43.4931 23.3229Z",
    fill: "url(#paint22_linear)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8476 23.3229L44.6851 24.0459L43.5155 23.3229L44.6851 22.5928L45.8476 23.3229Z",
    fill: "url(#paint23_linear)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1937 23.3229L47.0312 24.0459L45.8687 23.3229L47.0312 22.5928L48.1937 23.3229Z",
    fill: "url(#paint24_linear)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5463 23.3158L49.3838 24.0459L48.2142 23.3229L49.3838 22.5928L50.5463 23.3158Z",
    fill: "url(#paint25_linear)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8504 23.3207L51.6879 24.0508L50.5254 23.3207L51.6879 22.5977L52.8504 23.3207Z",
    fill: "url(#paint26_linear)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2051 23.3207L54.0426 24.0508L52.873 23.3207L54.0426 22.5977L55.2051 23.3207Z",
    fill: "url(#paint27_linear)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5547 23.3207L56.3852 24.0508L55.2227 23.3207L56.3852 22.5977L57.5547 23.3207Z",
    fill: "url(#paint28_linear)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9024 23.3207L58.7399 24.0437L57.5703 23.3207L58.7399 22.5977L59.9024 23.3207Z",
    fill: "url(#paint29_linear)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2488 23.3207L61.0863 24.0437L59.9238 23.3207L61.0863 22.5977L62.2488 23.3207Z",
    fill: "url(#paint30_linear)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6036 23.3207L63.4411 24.0437L62.2715 23.3207L63.4411 22.5977L64.6036 23.3207Z",
    fill: "url(#paint31_linear)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9571 23.3207L65.7875 24.0437L64.625 23.3207L65.7875 22.5977L66.9571 23.3207Z",
    fill: "url(#paint32_linear)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3028 23.3207L68.1403 24.0437L66.9707 23.3207L68.1403 22.5977L69.3028 23.3207Z",
    fill: "url(#paint33_linear)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6543 23.3207L70.4848 24.0437L69.3223 23.3207L70.4848 22.5977L71.6543 23.3207Z",
    fill: "url(#paint34_linear)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M74.002 23.3207L72.8395 24.0437L71.6699 23.3207L72.8395 22.5977L74.002 23.3207Z",
    fill: "url(#paint35_linear)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3555 23.3207L75.1859 24.0437L74.0234 23.3207L75.1859 22.5977L76.3555 23.3207Z",
    fill: "url(#paint36_linear)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7019 23.3207L77.5394 24.0437L76.377 23.3207L77.5394 22.5977L78.7019 23.3207Z",
    fill: "url(#paint37_linear)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0547 23.3207L79.8852 24.0437L78.7227 23.3207L79.8852 22.5977L81.0547 23.3207Z",
    fill: "url(#paint38_linear)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4012 23.3207L82.2387 24.0437L81.0762 23.3207L82.2387 22.5977L83.4012 23.3207Z",
    fill: "url(#paint39_linear)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M85.755 23.3229L84.5926 24.0459L83.423 23.3229L84.5855 22.5928L85.755 23.3229Z",
    fill: "url(#paint40_linear)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1011 23.3229L86.9386 24.0459L85.7762 23.3229L86.9386 22.5928L88.1011 23.3229Z",
    fill: "url(#paint41_linear)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4537 23.3158L89.2912 24.0459L88.1216 23.3229L89.2912 22.5928L90.4537 23.3158Z",
    fill: "url(#paint42_linear)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7998 23.3158L91.6373 24.0459L90.4748 23.3158L91.6373 22.5928L92.7998 23.3158Z",
    fill: "url(#paint43_linear)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1542 23.3158L93.9918 24.0459L92.8222 23.3158L93.9918 22.5928L95.1542 23.3158Z",
    fill: "url(#paint44_linear)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5003 23.3158L96.3378 24.0388L95.1754 23.3158L96.3378 22.5928L97.5003 23.3158Z",
    fill: "url(#paint45_linear)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8529 23.3158L98.6904 24.0388L97.5208 23.3158L98.6904 22.5928L99.8529 23.3158Z",
    fill: "url(#paint46_linear)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M102.206 23.3158L101.036 24.0388L99.874 23.3158L101.036 22.5928L102.206 23.3158Z",
    fill: "url(#paint47_linear)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M104.546 23.337L103.376 24.06L102.214 23.337L103.376 22.614L104.546 23.337Z",
    fill: "url(#paint48_linear)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M106.893 23.337L105.731 24.06L104.561 23.337L105.731 22.614L106.893 23.337Z",
    fill: "url(#paint49_linear)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M109.244 23.3356L108.075 24.0586L106.912 23.3356L108.075 22.6055L109.244 23.3356Z",
    fill: "url(#paint50_linear)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M111.593 23.3285L110.43 24.0586L109.268 23.3356L110.43 22.6055L111.593 23.3285Z",
    fill: "url(#paint51_linear)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M113.945 23.3285L112.776 24.0586L111.613 23.3285L112.776 22.6055L113.945 23.3285Z",
    fill: "url(#paint52_linear)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M116.292 23.3285L115.129 24.0586L113.967 23.3285L115.129 22.6055L116.292 23.3285Z",
    fill: "url(#paint53_linear)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M118.645 23.3285L117.482 24.0586L116.312 23.3285L117.482 22.6055L118.645 23.3285Z",
    fill: "url(#paint54_linear)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M120.989 23.3285L119.827 24.0586L118.664 23.3285L119.827 22.6055L120.989 23.3285Z",
    fill: "url(#paint55_linear)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M123.344 23.3285L122.174 24.0515L121.012 23.3285L122.174 22.6055L123.344 23.3285Z",
    fill: "url(#paint56_linear)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M125.69 23.3285L124.528 24.0515L123.365 23.3285L124.528 22.6055L125.69 23.3285Z",
    fill: "url(#paint57_linear)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M128.045 23.3285L126.875 24.0515L125.713 23.3285L126.875 22.6055L128.045 23.3285Z",
    fill: "url(#paint58_linear)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M130.391 23.3285L129.229 24.0515L128.066 23.3285L129.229 22.6055L130.391 23.3285Z",
    fill: "url(#paint59_linear)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M132.744 23.3285L131.582 24.0515L130.412 23.3285L131.582 22.6055L132.744 23.3285Z",
    fill: "url(#paint60_linear)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M135.096 23.3285L133.926 24.0515L132.764 23.3285L133.926 22.6055L135.096 23.3285Z",
    fill: "url(#paint61_linear)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M137.443 23.3285L136.281 24.0515L135.111 23.3285L136.281 22.6055L137.443 23.3285Z",
    fill: "url(#paint62_linear)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M139.797 23.3285L138.627 24.0515L137.465 23.3285L138.627 22.6055L139.797 23.3285Z",
    fill: "url(#paint63_linear)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M142.143 23.3285L140.98 24.0515L139.811 23.3285L140.98 22.6055L142.143 23.3285Z",
    fill: "url(#paint64_linear)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M144.496 23.3278L143.327 24.0508L142.164 23.3278L143.327 22.5977L144.496 23.3278Z",
    fill: "url(#paint65_linear)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M146.843 23.3278L145.68 24.0508L144.518 23.3278L145.68 22.5977L146.843 23.3278Z",
    fill: "url(#paint66_linear)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M149.195 23.3278L148.026 24.0508L146.863 23.3278L148.026 22.5977L149.195 23.3278Z",
    fill: "url(#paint67_linear)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M151.542 23.3278L150.379 24.0508L149.217 23.3278L150.379 22.5977L151.542 23.3278Z",
    fill: "url(#paint68_linear)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M153.895 23.3207L152.725 24.0508L151.562 23.3278L152.725 22.5977L153.895 23.3207Z",
    fill: "url(#paint69_linear)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M156.197 23.3285L155.035 24.0586L153.865 23.3285L155.035 22.6055L156.197 23.3285Z",
    fill: "url(#paint70_linear)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M158.553 23.3285L157.383 24.0586L156.221 23.3285L157.383 22.6055L158.553 23.3285Z",
    fill: "url(#paint71_linear)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M160.898 23.3285L159.736 24.0586L158.566 23.3285L159.736 22.6055L160.898 23.3285Z",
    fill: "url(#paint72_linear)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M163.252 23.3285L162.082 24.0515L160.92 23.3285L162.082 22.6055L163.252 23.3285Z",
    fill: "url(#paint73_linear)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M165.6 23.3285L164.438 24.0515L163.275 23.3285L164.438 22.6055L165.6 23.3285Z",
    fill: "url(#paint74_linear)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M167.951 23.3285L166.782 24.0515L165.619 23.3285L166.782 22.6055L167.951 23.3285Z",
    fill: "url(#paint75_linear)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M170.298 23.3285L169.135 24.0515L167.973 23.3285L169.135 22.6055L170.298 23.3285Z",
    fill: "url(#paint76_linear)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M172.65 23.3285L171.488 24.0515L170.318 23.3285L171.488 22.6055L172.65 23.3285Z",
    fill: "url(#paint77_linear)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M175.006 23.3285L173.836 24.0515L172.674 23.3285L173.836 22.6055L175.006 23.3285Z",
    fill: "url(#paint78_linear)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M177.35 23.3285L176.187 24.0515L175.018 23.3285L176.187 22.6055L177.35 23.3285Z",
    fill: "url(#paint79_linear)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M179.705 23.3285L178.536 24.0515L177.373 23.3285L178.536 22.6055L179.705 23.3285Z",
    fill: "url(#paint80_linear)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M182.051 23.3285L180.888 24.0515L179.719 23.3285L180.888 22.6055L182.051 23.3285Z",
    fill: "url(#paint81_linear)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M184.402 23.3285L183.233 24.0515L182.07 23.3285L183.233 22.6055L184.402 23.3285Z",
    fill: "url(#paint82_linear)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M186.75 23.3278L185.588 24.0508L184.418 23.3278L185.588 22.5977L186.75 23.3278Z",
    fill: "url(#paint83_linear)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M189.104 23.3278L187.934 24.0508L186.771 23.3278L187.934 22.5977L189.104 23.3278Z",
    fill: "url(#paint84_linear)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M191.45 23.3207L190.288 24.0508L189.125 23.3278L190.288 22.5977L191.45 23.3207Z",
    fill: "url(#paint85_linear)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M193.803 23.3207L192.633 24.0508L191.471 23.3207L192.633 22.5977L193.803 23.3207Z",
    fill: "url(#paint86_linear)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M196.151 23.3207L194.989 24.0508L193.826 23.3207L194.989 22.5977L196.151 23.3207Z",
    fill: "url(#paint87_linear)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M197.291 24.073L196.072 23.3216L197.291 22.627V24.073Z",
    fill: "url(#paint88_linear)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M2.34575 23.3287L1.17617 24.0517L0.0136719 23.3287L1.17617 22.6057L2.34575 23.3287Z",
    fill: "url(#paint89_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M4.69218 23.3287L3.52968 24.0517L2.36719 23.3287L3.52968 22.6057L4.69218 23.3287Z",
    fill: "url(#paint90_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M7.04692 23.328L5.88443 24.051L4.71484 23.328L5.88443 22.5979L7.04692 23.328Z",
    fill: "url(#paint91_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M9.38944 23.328L8.22695 24.051L7.06445 23.328L8.22695 22.5979L9.38944 23.328Z",
    fill: "url(#paint92_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M11.7442 23.328L10.5817 24.051L9.41211 23.328L10.5817 22.5979L11.7442 23.328Z",
    fill: "url(#paint93_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M14.0906 23.3209L12.9281 24.051L11.7656 23.328L12.9281 22.5979L14.0906 23.3209Z",
    fill: "url(#paint94_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M16.4454 23.3209L15.2829 24.051L14.1133 23.328L15.2829 22.5979L16.4454 23.3209Z",
    fill: "url(#paint95_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M18.7989 23.3209L17.6293 24.051L16.4668 23.3209L17.6293 22.5979L18.7989 23.3209Z",
    fill: "url(#paint96_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M21.1446 23.3209L19.9821 24.051L18.8125 23.3209L19.9821 22.5979L21.1446 23.3209Z",
    fill: "url(#paint97_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M23.4981 23.3209L22.3285 24.0439L21.166 23.3209L22.3285 22.5979L23.4981 23.3209Z",
    fill: "url(#paint98_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M25.8438 23.3209L24.6813 24.0439L23.5117 23.3209L24.6813 22.5979L25.8438 23.3209Z",
    fill: "url(#paint99_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M28.1973 23.3209L27.0277 24.0439L25.8652 23.3209L27.0277 22.5979L28.1973 23.3209Z",
    fill: "url(#paint100_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M30.543 23.3209L29.3805 24.0439L28.2109 23.3209L29.3805 22.5979L30.543 23.3209Z",
    fill: "url(#paint101_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M32.8965 23.3209L31.727 24.0439L30.5645 23.3209L31.727 22.5979L32.8965 23.3209Z",
    fill: "url(#paint102_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M35.243 23.3209L34.0805 24.0439L32.918 23.3209L34.0805 22.5979L35.243 23.3209Z",
    fill: "url(#paint103_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M37.5977 23.3209L36.4281 24.0439L35.2656 23.3209L36.4352 22.5979L37.5977 23.3209Z",
    fill: "url(#paint104_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M39.9422 23.3209L38.7797 24.0439L37.6172 23.3209L38.7797 22.5979L39.9422 23.3209Z",
    fill: "url(#paint105_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M42.295 23.3209L41.1254 24.0439L39.9629 23.3209L41.1325 22.5979L42.295 23.3209Z",
    fill: "url(#paint106_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M44.6414 23.3221L43.4789 24.0452L42.3164 23.3221L43.4789 22.592L44.6414 23.3221Z",
    fill: "url(#paint107_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M46.9961 23.3221L45.8336 24.0452L44.6641 23.3221L45.8336 22.592L46.9961 23.3221Z",
    fill: "url(#paint108_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M49.3426 23.3221L48.1801 24.0452L47.0176 23.3221L48.1801 22.592L49.3426 23.3221Z",
    fill: "url(#paint109_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M51.6954 23.3221L50.5329 24.0452L49.3633 23.3221L50.5329 22.592L51.6954 23.3221Z",
    fill: "url(#paint110_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M54.0008 23.3229L52.8383 24.053L51.6758 23.33L52.8383 22.5999L54.0008 23.3229Z",
    fill: "url(#paint111_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M56.3536 23.3209L55.1911 24.051L54.0215 23.3209L55.1911 22.5979L56.3536 23.3209Z",
    fill: "url(#paint112_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M58.7051 23.3209L57.5355 24.051L56.373 23.3209L57.5355 22.5979L58.7051 23.3209Z",
    fill: "url(#paint113_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M61.0508 23.3209L59.8883 24.051L58.7188 23.3209L59.8883 22.5979L61.0508 23.3209Z",
    fill: "url(#paint114_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M63.4063 23.3209L62.2367 24.051L61.0742 23.3209L62.2367 22.5979L63.4063 23.3209Z",
    fill: "url(#paint115_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M65.752 23.3209L64.5895 24.0439L63.4199 23.3209L64.5895 22.5979L65.752 23.3209Z",
    fill: "url(#paint116_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M68.1055 23.3209L66.9359 24.0439L65.7734 23.3209L66.9359 22.5979L68.1055 23.3209Z",
    fill: "url(#paint117_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M70.4512 23.3209L69.2887 24.0439L68.1191 23.3209L69.2887 22.5979L70.4512 23.3209Z",
    fill: "url(#paint118_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M72.8047 23.3209L71.6352 24.0439L70.4727 23.3209L71.6352 22.5979L72.8047 23.3209Z",
    fill: "url(#paint119_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M75.1512 23.3209L73.9887 24.0439L72.8262 23.3209L73.9887 22.5979L75.1512 23.3209Z",
    fill: "url(#paint120_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M77.504 23.3209L76.3344 24.0439L75.1719 23.3209L76.3344 22.5979L77.504 23.3209Z",
    fill: "url(#paint121_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M79.8523 23.3209L78.6898 24.0439L77.5273 23.3209L78.6898 22.5979L79.8523 23.3209Z",
    fill: "url(#paint122_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M82.2032 23.3209L81.0407 24.0439L79.8711 23.3209L81.0407 22.5979L82.2032 23.3209Z",
    fill: "url(#paint123_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M84.5516 23.3209L83.3891 24.0439L82.2266 23.3209L83.3891 22.5979L84.5516 23.3209Z",
    fill: "url(#paint124_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M86.9043 23.3209L85.7418 24.0439L84.5723 23.3209L85.7348 22.5979L86.9043 23.3209Z",
    fill: "url(#paint125_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M89.2497 23.3231L88.0872 24.0461L86.9247 23.3231L88.0872 22.593L89.2497 23.3231Z",
    fill: "url(#paint126_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M91.6022 23.3231L90.4397 24.0461L89.2701 23.3231L90.4397 22.593L91.6022 23.3231Z",
    fill: "url(#paint127_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M93.9574 23.316L92.7878 24.0461L91.6253 23.3231L92.7878 22.593L93.9574 23.316Z",
    fill: "url(#paint128_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M96.3028 23.316L95.1403 24.0461L93.9707 23.316L95.1403 22.593L96.3028 23.316Z",
    fill: "url(#paint129_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M98.656 23.316L97.4864 24.0461L96.3239 23.316L97.4864 22.593L98.656 23.316Z",
    fill: "url(#paint130_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M101.003 23.316L99.8409 24.039L98.6713 23.316L99.8409 22.593L101.003 23.316Z",
    fill: "url(#paint131_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M103.355 23.316L102.185 24.039L101.023 23.316L102.185 22.593L103.355 23.316Z",
    fill: "url(#paint132_linear)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M105.693 23.3363L104.524 24.0593L103.361 23.3363L104.524 22.6133L105.693 23.3363Z",
    fill: "url(#paint133_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M108.041 23.3363L106.879 24.0593L105.709 23.3363L106.879 22.6133L108.041 23.3363Z",
    fill: "url(#paint134_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M110.395 23.3356L109.225 24.0586L108.062 23.3356L109.225 22.6055L110.395 23.3356Z",
    fill: "url(#paint135_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M112.74 23.3356L111.578 24.0586L110.408 23.3356L111.578 22.6055L112.74 23.3356Z",
    fill: "url(#paint136_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M115.094 23.3285L113.924 24.0586L112.762 23.3356L113.924 22.6055L115.094 23.3285Z",
    fill: "url(#paint137_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M117.442 23.3285L116.28 24.0586L115.117 23.3285L116.28 22.6055L117.442 23.3285Z",
    fill: "url(#paint138_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M119.795 23.3285L118.625 24.0586L117.463 23.3285L118.632 22.6055L119.795 23.3285Z",
    fill: "url(#paint139_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M122.139 23.3285L120.977 24.0586L119.814 23.3285L120.977 22.6055L122.139 23.3285Z",
    fill: "url(#paint140_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M124.492 23.3285L123.33 24.0586L122.16 23.3285L123.33 22.6055L124.492 23.3285Z",
    fill: "url(#paint141_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M126.841 23.3285L125.678 24.0586L124.516 23.3285L125.678 22.6055L126.841 23.3285Z",
    fill: "url(#paint142_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M129.193 23.3285L128.031 24.0515L126.861 23.3285L128.031 22.6055L129.193 23.3285Z",
    fill: "url(#paint143_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M131.547 23.3285L130.377 24.0515L129.215 23.3285L130.377 22.6055L131.547 23.3285Z",
    fill: "url(#paint144_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M133.893 23.3285L132.73 24.0515L131.561 23.3285L132.73 22.6055L133.893 23.3285Z",
    fill: "url(#paint145_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M136.244 23.3285L135.075 24.0515L133.912 23.3285L135.075 22.6055L136.244 23.3285Z",
    fill: "url(#paint146_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M138.592 23.3285L137.429 24.0515L136.26 23.3285L137.429 22.6055L138.592 23.3285Z",
    fill: "url(#paint147_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M140.945 23.3285L139.776 24.0515L138.613 23.3285L139.776 22.6055L140.945 23.3285Z",
    fill: "url(#paint148_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M143.291 23.3285L142.129 24.0515L140.959 23.3285L142.129 22.6055L143.291 23.3285Z",
    fill: "url(#paint149_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M145.645 23.3285L144.475 24.0515L143.312 23.3285L144.475 22.6055L145.645 23.3285Z",
    fill: "url(#paint150_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M147.993 23.3285L146.83 24.0515L145.668 23.3285L146.83 22.6055L147.993 23.3285Z",
    fill: "url(#paint151_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M150.345 23.3307L149.175 24.0537L148.013 23.3307L149.175 22.6006L150.345 23.3307Z",
    fill: "url(#paint152_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M152.691 23.3307L151.528 24.0537L150.366 23.3307L151.528 22.6006L152.691 23.3307Z",
    fill: "url(#paint153_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M155.043 23.3236L153.874 24.0537L152.711 23.3307L153.874 22.6006L155.043 23.3236Z",
    fill: "url(#paint154_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M157.349 23.3307L156.186 24.0608L155.024 23.3378L156.186 22.6077L157.349 23.3307Z",
    fill: "url(#paint155_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M159.704 23.3285L158.534 24.0586L157.372 23.3285L158.534 22.6055L159.704 23.3285Z",
    fill: "url(#paint156_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M162.049 23.3285L160.887 24.0586L159.717 23.3285L160.887 22.6055L162.049 23.3285Z",
    fill: "url(#paint157_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M164.403 23.3285L163.233 24.0586L162.071 23.3285L163.233 22.6055L164.403 23.3285Z",
    fill: "url(#paint158_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M166.749 23.3285L165.587 24.0586L164.424 23.3285L165.587 22.6055L166.749 23.3285Z",
    fill: "url(#paint159_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M169.104 23.3285L167.934 24.0515L166.772 23.3285L167.934 22.6055L169.104 23.3285Z",
    fill: "url(#paint160_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M171.449 23.3285L170.286 24.0515L169.124 23.3285L170.286 22.6055L171.449 23.3285Z",
    fill: "url(#paint161_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M173.801 23.3285L172.639 24.0515L171.469 23.3285L172.639 22.6055L173.801 23.3285Z",
    fill: "url(#paint162_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M176.155 23.3285L174.985 24.0515L173.823 23.3285L174.985 22.6055L176.155 23.3285Z",
    fill: "url(#paint163_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M178.501 23.3285L177.338 24.0515L176.168 23.3285L177.338 22.6055L178.501 23.3285Z",
    fill: "url(#paint164_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M180.856 23.3285L179.686 24.0515L178.524 23.3285L179.686 22.6055L180.856 23.3285Z",
    fill: "url(#paint165_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M183.202 23.3285L182.039 24.0515L180.87 23.3285L182.039 22.6055L183.202 23.3285Z",
    fill: "url(#paint166_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M185.553 23.3285L184.384 24.0515L183.221 23.3285L184.384 22.6055L185.553 23.3285Z",
    fill: "url(#paint167_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M187.899 23.3285L186.737 24.0515L185.567 23.3285L186.737 22.6055L187.899 23.3285Z",
    fill: "url(#paint168_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M190.255 23.3307L189.085 24.0537L187.923 23.3307L189.085 22.6006L190.255 23.3307Z",
    fill: "url(#paint169_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M192.601 23.3307L191.438 24.0537L190.276 23.3307L191.438 22.6006L192.601 23.3307Z",
    fill: "url(#paint170_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M194.953 23.3307L193.784 24.0537L192.621 23.3307L193.784 22.6006L194.953 23.3307Z",
    fill: "url(#paint171_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.81,
    d: "M197.299 23.3236L196.137 24.0537L194.974 23.3307L196.137 22.6006L197.299 23.3236Z",
    fill: "url(#paint172_linear)"
  })))), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2635 15.5911V9.16334H50.179V8.90112H53.468C54.1981 8.90112 54.8148 9.00743 55.3322 9.21295C55.8497 9.41847 56.2821 9.82242 56.6294 10.4248C56.9767 11.0272 57.1468 11.6792 57.1468 12.3808C57.1468 13.1249 56.9555 13.7911 56.5727 14.3722C56.1899 14.9604 55.7504 15.3502 55.2542 15.5557C54.7581 15.7612 54.1556 15.8675 53.4396 15.8675H50.1719V15.6053H51.2635V15.5911ZM52.4969 9.16334V15.5911H53.3971C53.872 15.5911 54.2548 15.5486 54.5596 15.4636C54.8573 15.3785 55.1054 15.1872 55.3039 14.8966C55.5023 14.6061 55.6299 14.2375 55.7008 13.7911C55.7717 13.3446 55.8071 12.7635 55.8071 12.0406C55.8071 11.176 55.6937 10.5311 55.4811 10.1059C55.2613 9.68068 54.992 9.41846 54.673 9.31216C54.354 9.21295 53.9358 9.15625 53.4254 9.15625H52.4969V9.16334Z",
    fill: "#0049B1"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5792 15.5911V9.16334H58.4805V8.90112H62.2941C62.7903 8.90112 63.2014 8.94364 63.5204 9.02869C63.8394 9.11373 64.1158 9.29799 64.3497 9.56729C64.5836 9.83659 64.697 10.1484 64.697 10.5028C64.697 10.9421 64.5269 11.2965 64.1867 11.5729C63.8464 11.8493 63.2723 12.0548 62.4642 12.1894V12.2178C63.0454 12.3312 63.5204 12.5509 63.8961 12.8839C64.2647 13.2099 64.456 13.7698 64.456 14.5564C64.456 15.0029 64.5057 15.2935 64.612 15.421C64.7183 15.5486 64.8672 15.6124 65.0515 15.6124C65.172 15.6124 65.3208 15.5911 65.4909 15.5415V15.7966C65.1932 15.903 64.9026 15.9526 64.6191 15.9526C64.0449 15.9526 63.648 15.7966 63.407 15.4777C63.173 15.1588 63.0596 14.847 63.0667 14.5423L63.088 13.6564C63.088 13.3517 62.9887 13.0469 62.7974 12.7422C62.5989 12.4446 62.1594 12.2957 61.4647 12.2957H60.8126V15.6053H61.9113V15.8675H58.4805V15.6053H59.5792V15.5911ZM60.8126 9.16334V12.0406H61.7483C62.1523 12.0406 62.4571 12.0123 62.6698 11.9627C62.8824 11.906 63.0525 11.7713 63.173 11.5445C63.3006 11.3177 63.3644 10.9563 63.3644 10.4602C63.3644 10.0563 63.3006 9.75864 63.173 9.57438C63.0454 9.39012 62.8895 9.26964 62.7052 9.22712C62.5209 9.1846 62.287 9.16334 61.9893 9.16334H60.8126Z",
    fill: "#0049B1"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5018 15.5911V9.16334H66.3676V8.90112H69.8906V9.16334H68.7423V15.5911H69.8906V15.8533H66.3676V15.5911H67.5018Z",
    fill: "#0049B1"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6286 8.89453H73.9531V9.15675H72.8473L74.6548 14.0679H74.6761L76.349 9.15675H75.2219V8.89453H77.6887V9.15675H76.6254L74.2862 16.0168H74.1445L71.5572 9.15675H70.6216V8.89453H70.6286Z",
    fill: "#0049B1"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5674 15.5911V9.16334H78.4333V8.90112H81.9562V9.16334H80.8079V15.5911H81.9562V15.8533H78.4333V15.5911H79.5674Z",
    fill: "#0049B1"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0726 9.16357V16.0237H88.8599L84.2737 9.13523H84.2525V15.5985H85.4291V15.8607H82.9553V15.5985H83.9902V9.17066H82.8844V8.90845H85.5425L88.789 13.7842H88.8103V9.17066H87.6549V8.90845H90.1287V9.17066H89.0726V9.16357Z",
    fill: "#0049B1"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4525 13.529H94.2758V13.2668H97.8767V13.529H96.8702C96.8702 14.4149 96.5866 15.0527 96.0125 15.4425C95.4383 15.8252 94.8429 16.0236 94.2191 16.0236C93.3118 16.0236 92.5534 15.6622 91.9438 14.9322C91.3412 14.2023 91.0364 13.3589 91.0364 12.3809C91.0364 11.3959 91.3483 10.5383 91.965 9.82257C92.5817 9.09971 93.3543 8.73828 94.2829 8.73828C94.7578 8.73828 95.2186 8.88002 95.651 9.15641C95.7857 9.24145 95.8778 9.28397 95.9274 9.28397C96.0408 9.28397 96.1472 9.18475 96.2606 8.98632H96.4945L96.5654 10.8785H96.3031C96.0125 9.63123 95.3391 9.00758 94.2617 9.00758C93.7017 9.00758 93.2976 9.13515 93.0425 9.38319C92.7873 9.63123 92.6313 9.95014 92.5746 10.3328C92.5179 10.7155 92.4896 11.2612 92.4896 11.9699C92.4896 13.2455 92.5321 14.096 92.6172 14.507C92.7022 14.9251 92.8794 15.2369 93.1417 15.4425C93.404 15.6551 93.73 15.7543 94.1057 15.7543C94.4105 15.7543 94.6799 15.6905 94.9209 15.57C95.1548 15.4425 95.3036 15.2582 95.3674 15.0102C95.4242 14.7621 95.4596 14.3936 95.4596 13.9046V13.529H95.4525Z",
    fill: "#0049B1"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M103.527 9.16334V15.5911H105.086C105.384 15.5911 105.625 15.5699 105.795 15.5203C105.965 15.4777 106.136 15.3643 106.306 15.1943C106.476 15.0242 106.603 14.8187 106.695 14.5777C106.788 14.3368 106.887 14.0037 106.986 13.5785H107.227L107.036 15.8533H101.188V15.5911H102.287V9.16334H101.188V8.90112H104.675V9.16334H103.527V9.16334Z",
    fill: "#0049B1"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M109.19 15.5911V9.16334H108.056V8.90112H111.572V9.16334H110.423V15.5911H111.572V15.8533H108.056V15.5911H109.19Z",
    fill: "#0049B1"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M117.711 8.81599V10.8854H117.484C117.243 9.63098 116.619 9.00024 115.605 9.00024C115.06 9.00024 114.663 9.21285 114.415 9.63806C114.166 10.0633 114.039 10.9633 114.039 12.324C114.039 13.4508 114.096 14.2162 114.202 14.6201C114.308 15.0241 114.492 15.3146 114.762 15.4918C115.024 15.669 115.315 15.754 115.634 15.754C116.052 15.754 116.442 15.5981 116.803 15.2863C117.165 14.9745 117.448 14.4713 117.654 13.7768H117.895L117.81 15.9029H117.597C117.519 15.6832 117.392 15.4918 117.222 15.343C116.676 15.7966 116.109 16.0233 115.534 16.0233C114.797 16.0233 114.131 15.6761 113.528 14.9816C112.926 14.287 112.621 13.4366 112.621 12.4303C112.621 11.4027 112.919 10.531 113.514 9.81523C114.11 9.09946 114.797 8.74512 115.584 8.74512C116.187 8.74512 116.718 8.96481 117.179 9.39711C117.314 9.1845 117.413 8.99316 117.484 8.83016H117.711V8.81599Z",
    fill: "#0049B1"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M121.312 9.16381V12.1474H121.943C122.163 12.1474 122.354 12.1261 122.503 12.0836C122.659 12.0411 122.794 11.9206 122.921 11.7363C123.042 11.545 123.113 11.2474 123.134 10.8434H123.403V13.7915H123.134C123.106 13.2317 122.999 12.8632 122.808 12.686C122.616 12.5088 122.333 12.4167 121.943 12.4167H121.312V15.5987H122.73C123.531 15.5987 124.091 15.4286 124.396 15.0955C124.708 14.7554 124.892 14.238 124.949 13.5364H125.211L125.147 15.868H118.973V15.6058H120.079V9.17799H118.973V8.91577H124.892L125.012 10.7725H124.75C124.658 10.2056 124.474 9.80163 124.197 9.55359C123.914 9.30555 123.453 9.17799 122.794 9.17799H121.312V9.16381Z",
    fill: "#0049B1"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M132.439 9.16357V16.0237H132.227L127.64 9.13523H127.619V15.5985H128.796V15.8607H126.322V15.5985H127.357V9.17066H126.251V8.90845H128.909L132.156 13.7842H132.177V9.17066H131.022V8.90845H133.495V9.17066H132.439V9.16357Z",
    fill: "#0049B1"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M138.684 8.81624L138.713 10.6234H138.472C138.125 9.5391 137.515 9.0005 136.636 9.0005C136.154 9.0005 135.778 9.13515 135.509 9.40445C135.24 9.67375 135.105 9.95014 135.105 10.2407C135.105 10.51 135.218 10.7368 135.438 10.921C135.665 11.1053 136.069 11.2541 136.664 11.3533C137.253 11.4526 137.706 11.5801 138.018 11.7289C138.33 11.8778 138.592 12.1187 138.805 12.466C139.018 12.8061 139.124 13.203 139.124 13.6424C139.124 14.3227 138.904 14.8897 138.458 15.3432C138.011 15.7968 137.458 16.0236 136.806 16.0236C136.267 16.0236 135.736 15.8252 135.204 15.4283L134.715 15.8677H134.531V13.9188H134.75C134.956 14.5283 135.24 14.9889 135.608 15.3007C135.977 15.6055 136.374 15.7614 136.813 15.7614C137.246 15.7614 137.643 15.6196 138.004 15.3362C138.366 15.0527 138.543 14.6913 138.543 14.2519C138.543 13.8834 138.415 13.5786 138.167 13.3235C137.919 13.0754 137.508 12.8983 136.948 12.8061C136.388 12.714 135.955 12.6006 135.651 12.4731C135.353 12.3455 135.091 12.1258 134.878 11.814C134.665 11.5022 134.552 11.1549 134.552 10.7722C134.552 10.2478 134.736 9.78005 135.112 9.36193C135.488 8.95089 135.991 8.73828 136.636 8.73828C137.175 8.73828 137.671 8.90837 138.139 9.24854C138.266 9.12806 138.38 8.98632 138.472 8.82332H138.684V8.81624Z",
    fill: "#0049B1"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M142.576 9.16381V12.1474H143.207C143.427 12.1474 143.618 12.1261 143.767 12.0836C143.923 12.0411 144.057 11.9206 144.185 11.7363C144.305 11.545 144.376 11.2474 144.398 10.8434H144.667V13.7915H144.398C144.369 13.2317 144.263 12.8632 144.072 12.686C143.88 12.5088 143.597 12.4167 143.207 12.4167H142.576V15.5987H143.994C144.795 15.5987 145.355 15.4286 145.659 15.0955C145.971 14.7554 146.156 14.238 146.212 13.5364H146.475L146.411 15.868H140.237V15.6058H141.343V9.17799H140.237V8.91577H146.156L146.276 10.7725H146.014C145.922 10.2056 145.737 9.80163 145.461 9.55359C145.177 9.30555 144.717 9.17799 144.057 9.17799H142.576V9.16381Z",
    fill: "#0049B1"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6591 104.765C64.6591 105.07 64.3756 105.318 64.0283 105.318H14.0977C13.7503 105.318 13.4668 105.07 13.4668 104.765V38.7652C13.4668 38.4604 13.7503 38.2124 14.0977 38.2124H64.0283C64.3756 38.2124 64.6591 38.4604 64.6591 38.7652V104.765Z",
    fill: "white"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3992 88.4609L58.9036 90.8352C61.0899 91.3786 63.0465 92.4215 64.6639 93.8237V105.594H13.4668V95.0635C15.2808 93.0362 17.6955 91.5307 20.4839 90.8377L29.9857 88.4634L30.534 86.275C27.0145 85.8083 23.602 84.7384 20.4466 83.1127C20.3088 83.03 20.1883 82.9213 20.092 82.7927C19.6817 82.2446 19.7938 81.468 20.3424 81.0581C20.3746 81.0334 24.8081 77.3753 24.8081 64.7011C24.8081 50.7953 35.032 46.1137 39.6937 46.1137C42.1935 45.833 44.6785 46.7524 46.3922 48.5919H47.1365C52.076 48.5919 54.5792 54.0121 54.5792 64.7011C54.5792 77.3753 59.0127 81.0334 59.0574 81.0631C59.3793 81.3182 59.5561 81.7142 59.5313 82.1239C59.5075 82.5331 59.2828 82.9043 58.9308 83.1152C55.7726 84.7258 52.3647 85.7916 48.8508 86.2676L49.3992 88.4609Z",
    fill: "#11302D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 33.6555,
    y1: -17.0632,
    x2: 178.693,
    y2: 157.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00597934,
    stopColor: "#96CDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0889,
    stopColor: "#B5DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1753,
    stopColor: "#CEEDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2656,
    stopColor: "#DFF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3623,
    stopColor: "#EAFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4766,
    stopColor: "#EDFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5487,
    stopColor: "#E4FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    stopColor: "#CDF0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8101,
    stopColor: "#A6DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9455,
    stopColor: "#7CCAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 98.6581,
    y1: 29.0238,
    x2: 98.6581,
    y2: -71.2347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0424,
    stopColor: "#41D9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.198,
    stopColor: "#85E7DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4606,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5716,
    stopColor: "#F8FCF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7691,
    stopColor: "#E4F4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9E8AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 0.0142389,
    y1: 23.3246,
    x2: 197.3,
    y2: 23.3246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78E4C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2033,
    stopColor: "#7987AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2458,
    stopColor: "#818DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#959CBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#B3B3CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4725,
    stopColor: "#CCD6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5576,
    stopColor: "#95D5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7033,
    stopColor: "#9AC8E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8681,
    stopColor: "#AEA3BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9337,
    stopColor: "#9EA2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92A1C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 193.913,
    y1: -7.92329,
    x2: 168.279,
    y2: 22.6645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAD8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D6D1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2418,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2725,
    stopColor: "#DAD8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3022,
    stopColor: "#ACABB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3094,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#C9CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3782,
    stopColor: "#DADDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#EEF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4898,
    stopColor: "#FBFBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6194,
    stopColor: "#DBEBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6516,
    stopColor: "#DEE6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7385,
    stopColor: "#F6F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9FB1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: -1.05167,
    y1: 21.3243,
    x2: 32.2719,
    y2: 68.6984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 0.197925,
    y1: 20.2209,
    x2: 35.5951,
    y2: 70.5429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 1.77298,
    y1: 19.1168,
    x2: 37.1517,
    y2: 69.4127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 3.34327,
    y1: 18.01,
    x2: 38.7296,
    y2: 68.3167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 4.91318,
    y1: 16.9005,
    x2: 40.3182,
    y2: 67.2338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 6.48759,
    y1: 15.7973,
    x2: 41.8772,
    y2: 66.1087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 8.06435,
    y1: 14.6955,
    x2: 43.4376,
    y2: 64.9836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 9.63669,
    y1: 13.5883,
    x2: 45.0154,
    y2: 63.8841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 11.2044,
    y1: 12.4764,
    x2: 46.6038,
    y2: 62.8017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 12.7777,
    y1: 11.3745,
    x2: 48.1641,
    y2: 61.6813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 14.3527,
    y1: 10.2696,
    x2: 49.736,
    y2: 60.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 15.9179,
    y1: 9.15305,
    x2: 51.3281,
    y2: 59.4936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 17.4924,
    y1: 8.05084,
    x2: 52.8928,
    y2: 58.3775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 19.0663,
    y1: 6.94349,
    x2: 54.4687,
    y2: 57.2731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 20.6405,
    y1: 5.84218,
    x2: 56.0322,
    y2: 56.1566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 22.2145,
    y1: 4.73623,
    x2: 57.6062,
    y2: 55.0506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 23.783,
    y1: 3.62708,
    x2: 59.18,
    y2: 53.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 25.3507,
    y1: 2.51665,
    x2: 60.7588,
    y2: 52.8542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 26.9313,
    y1: 1.42219,
    x2: 62.3201,
    y2: 51.7325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 28.5088,
    y1: 0.321731,
    x2: 63.8886,
    y2: 50.6191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 30.0747,
    y1: -0.7935,
    x2: 65.4687,
    y2: 49.5241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 31.6512,
    y1: -1.89242,
    x2: 67.0354,
    y2: 48.4111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 33.1945,
    y1: -2.97381,
    x2: 68.5733,
    y2: 47.3221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 34.7643,
    y1: -4.08544,
    x2: 70.1507,
    y2: 46.2214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 36.3272,
    y1: -5.19981,
    x2: 71.7243,
    y2: 45.1222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 37.9038,
    y1: -6.30249,
    x2: 73.2965,
    y2: 44.0133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: 39.4746,
    y1: -7.41029,
    x2: 74.8695,
    y2: 42.9088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear",
    x1: 41.0435,
    y1: -8.52444,
    x2: 76.447,
    y2: 41.8067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear",
    x1: 42.6224,
    y1: -9.6212,
    x2: 78.0157,
    y2: 40.6954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear",
    x1: 44.1955,
    y1: -10.7257,
    x2: 79.5872,
    y2: 39.5887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear",
    x1: 45.7676,
    y1: -11.8298,
    x2: 81.1571,
    y2: 38.4814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear",
    x1: 47.3396,
    y1: -12.9388,
    x2: 82.7323,
    y2: 37.3768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear",
    x1: 48.9027,
    y1: -14.0579,
    x2: 84.3074,
    y2: 36.2749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear",
    x1: 50.479,
    y1: -15.1596,
    x2: 85.8793,
    y2: 35.1671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear",
    x1: 52.0554,
    y1: -16.259,
    x2: 87.4496,
    y2: 34.0589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear",
    x1: 53.6213,
    y1: -17.3737,
    x2: 89.0232,
    y2: 32.9553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear",
    x1: 55.2093,
    y1: -18.4569,
    x2: 90.5934,
    y2: 31.8465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear",
    x1: 56.7677,
    y1: -19.5828,
    x2: 92.1682,
    y2: 30.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear",
    x1: 58.346,
    y1: -20.6796,
    x2: 93.7387,
    y2: 29.6363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear",
    x1: 59.929,
    y1: -21.7709,
    x2: 95.31,
    y2: 28.5282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear",
    x1: 61.4982,
    y1: -22.8835,
    x2: 96.8846,
    y2: 27.4232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear",
    x1: 63.07,
    y1: -23.9893,
    x2: 98.4564,
    y2: 26.3175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear",
    x1: 64.635,
    y1: -25.1056,
    x2: 100.029,
    y2: 25.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear",
    x1: 66.2035,
    y1: -26.2174,
    x2: 101.602,
    y2: 24.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear",
    x1: 101.972,
    y1: 21.3361,
    x2: 137.369,
    y2: 71.6581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear",
    x1: 103.547,
    y1: 20.2305,
    x2: 138.936,
    y2: 70.5418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear",
    x1: 105.115,
    y1: 19.1213,
    x2: 140.52,
    y2: 69.4542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear",
    x1: 106.693,
    y1: 18.0206,
    x2: 142.061,
    y2: 68.3011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear",
    x1: 108.262,
    y1: 16.9094,
    x2: 143.66,
    y2: 67.2329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear",
    x1: 109.835,
    y1: 15.8044,
    x2: 145.228,
    y2: 66.1205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear",
    x1: 111.405,
    y1: 14.6957,
    x2: 146.81,
    y2: 65.0286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear",
    x1: 112.984,
    y1: 13.6011,
    x2: 148.346,
    y2: 63.8729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear",
    x1: 114.555,
    y1: 12.4916,
    x2: 149.931,
    y2: 62.7828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear",
    x1: 116.123,
    y1: 11.3785,
    x2: 151.52,
    y2: 61.7008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear",
    x1: 117.698,
    y1: 10.2725,
    x2: 153.095,
    y2: 60.5945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear",
    x1: 119.276,
    y1: 9.17493,
    x2: 154.652,
    y2: 59.4666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear",
    x1: 120.848,
    y1: 8.06889,
    x2: 156.224,
    y2: 58.3617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear",
    x1: 122.411,
    y1: 6.95235,
    x2: 157.811,
    y2: 57.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear",
    x1: 123.99,
    y1: 5.85361,
    x2: 159.375,
    y2: 56.1575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear",
    x1: 125.558,
    y1: 4.74139,
    x2: 160.956,
    y2: 55.0635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear",
    x1: 127.141,
    y1: 3.65053,
    x2: 162.51,
    y2: 53.9325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear",
    x1: 128.699,
    y1: 2.52292,
    x2: 164.105,
    y2: 52.8572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear",
    x1: 130.281,
    y1: 1.42927,
    x2: 165.666,
    y2: 51.7346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear",
    x1: 131.847,
    y1: 0.315706,
    x2: 167.245,
    y2: 50.6376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear",
    x1: 133.43,
    y1: -0.775736,
    x2: 168.806,
    y2: 49.5157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear",
    x1: 135.009,
    y1: -1.87173,
    x2: 170.371,
    y2: 48.4003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear",
    x1: 136.536,
    y1: -2.97168,
    x2: 171.922,
    y2: 47.3351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear",
    x1: 138.099,
    y1: -4.09412,
    x2: 173.507,
    y2: 46.2431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear",
    x1: 139.68,
    y1: -5.18709,
    x2: 175.071,
    y2: 45.1262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear",
    x1: 141.25,
    y1: -6.29649,
    x2: 176.645,
    y2: 44.0223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear",
    x1: 142.818,
    y1: -7.41218,
    x2: 178.224,
    y2: 42.9224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear",
    x1: 144.383,
    y1: -8.52547,
    x2: 179.797,
    y2: 41.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear",
    x1: 145.985,
    y1: -9.58952,
    x2: 181.353,
    y2: 40.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear",
    x1: 147.543,
    y1: -10.7158,
    x2: 182.932,
    y2: 39.5953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear",
    x1: 149.111,
    y1: -11.8311,
    x2: 184.51,
    y2: 38.4932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear",
    x1: 150.677,
    y1: -12.9433,
    x2: 186.082,
    y2: 37.3896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear",
    x1: 152.256,
    y1: -14.0432,
    x2: 187.654,
    y2: 36.2804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear",
    x1: 153.842,
    y1: -15.1295,
    x2: 189.222,
    y2: 35.1679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear",
    x1: 155.386,
    y1: -16.2728,
    x2: 190.8,
    y2: 34.0724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear",
    x1: 156.966,
    y1: -17.3713,
    x2: 192.372,
    y2: 32.9632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear",
    x1: 158.537,
    y1: -18.4789,
    x2: 193.944,
    y2: 31.8567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear",
    x1: 160.132,
    y1: -19.5544,
    x2: 195.513,
    y2: 30.7453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear",
    x1: 161.692,
    y1: -20.6775,
    x2: 197.087,
    y2: 29.6413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear",
    x1: 163.274,
    y1: -21.7726,
    x2: 198.661,
    y2: 28.5341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear",
    x1: 165.967,
    y1: -20.6992,
    x2: 200.618,
    y2: 28.5627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0495,
    stopColor: "#D5DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1273,
    stopColor: "#E7E4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1333,
    stopColor: "#D6D4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2485,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3175,
    stopColor: "#E7EFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3758,
    stopColor: "#EDE8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4303,
    stopColor: "#D2F1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4911,
    stopColor: "#D0F5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5436,
    stopColor: "#CCFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5818,
    stopColor: "#D9FFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6145,
    stopColor: "#DBF8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6456,
    stopColor: "#DCF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#CEFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9FFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear",
    x1: -0.225827,
    y1: 21.3295,
    x2: 35.1529,
    y2: 71.6254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear",
    x1: 1.34692,
    y1: 20.2231,
    x2: 36.7365,
    y2: 70.5342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear",
    x1: 2.92085,
    y1: 19.1167,
    x2: 38.3072,
    y2: 69.4233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear",
    x1: 4.48991,
    y1: 18.0109,
    x2: 39.8763,
    y2: 68.3177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear",
    x1: 6.0619,
    y1: 16.9017,
    x2: 41.4654,
    y2: 67.2328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear",
    x1: 7.63586,
    y1: 15.7979,
    x2: 43.027,
    y2: 66.1115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear",
    x1: 9.21244,
    y1: 14.6957,
    x2: 44.5884,
    y2: 64.9877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear",
    x1: 10.7852,
    y1: 13.5892,
    x2: 46.1639,
    y2: 63.8851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear",
    x1: 12.3529,
    y1: 12.4773,
    x2: 47.7523,
    y2: 62.8027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear",
    x1: 13.9298,
    y1: 11.3775,
    x2: 49.3095,
    y2: 61.6749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear",
    x1: 15.4996,
    y1: 10.2681,
    x2: 50.8891,
    y2: 60.5792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear",
    x1: 17.0664,
    y1: 9.15392,
    x2: 52.4766,
    y2: 59.4945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear",
    x1: 18.6409,
    y1: 8.05171,
    x2: 54.0413,
    y2: 58.3784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear",
    x1: 20.212,
    y1: 6.94319,
    x2: 55.617,
    y2: 57.2765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear",
    x1: 21.789,
    y1: 5.8431,
    x2: 57.1808,
    y2: 56.1574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear",
    x1: 23.3659,
    y1: 4.74107,
    x2: 58.7499,
    y2: 55.0444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear",
    x1: 24.9281,
    y1: 3.623,
    x2: 60.3338,
    y2: 53.9573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear",
    x1: 26.4987,
    y1: 2.51538,
    x2: 61.9067,
    y2: 52.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear",
    x1: 28.0803,
    y1: 1.42308,
    x2: 63.4677,
    y2: 51.7312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear",
    x1: 29.6572,
    y1: 0.321359,
    x2: 65.0375,
    y2: 50.6194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear",
    x1: 31.2236,
    y1: -0.793513,
    x2: 66.6176,
    y2: 49.5241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear",
    x1: 32.8004,
    y1: -1.89244,
    x2: 68.1845,
    y2: 48.4111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear",
    x1: 34.3445,
    y1: -2.97206,
    x2: 69.7248,
    y2: 47.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear",
    x1: 35.9159,
    y1: -4.08028,
    x2: 71.297,
    y2: 46.2188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear",
    x1: 37.4809,
    y1: -5.19457,
    x2: 72.8727,
    y2: 45.1199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear",
    x1: 39.0556,
    y1: -6.29705,
    x2: 74.443,
    y2: 44.0111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear",
    x1: 40.6285,
    y1: -7.40471,
    x2: 76.0182,
    y2: 42.9067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear",
    x1: 42.1956,
    y1: -8.51861,
    x2: 77.5937,
    y2: 41.8048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear",
    x1: 43.7719,
    y1: -9.61888,
    x2: 79.1636,
    y2: 40.6955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear",
    x1: 45.344,
    y1: -10.7248,
    x2: 80.7358,
    y2: 39.5896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear",
    x1: 46.9173,
    y1: -11.8303,
    x2: 82.3083,
    y2: 38.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear",
    x1: 48.4891,
    y1: -12.9379,
    x2: 83.8819,
    y2: 37.3779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear",
    x1: 50.0572,
    y1: -14.049,
    x2: 85.4542,
    y2: 36.2729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear",
    x1: 51.6255,
    y1: -15.1648,
    x2: 87.0313,
    y2: 35.1695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear",
    x1: 53.1993,
    y1: -16.2651,
    x2: 88.5997,
    y2: 34.0616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear",
    x1: 54.7778,
    y1: -17.3648,
    x2: 90.1728,
    y2: 32.9542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear",
    x1: 56.353,
    y1: -18.4663,
    x2: 91.744,
    y2: 31.8469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear",
    x1: 57.9167,
    y1: -19.5817,
    x2: 93.317,
    y2: 30.7451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear",
    x1: 59.495,
    y1: -20.6787,
    x2: 94.8878,
    y2: 29.6371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear",
    x1: 61.0747,
    y1: -21.7769,
    x2: 96.4612,
    y2: 28.5301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear",
    x1: 62.6419,
    y1: -22.8896,
    x2: 98.0337,
    y2: 27.4249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear",
    x1: 64.2301,
    y1: -23.9724,
    x2: 99.6046,
    y2: 26.3172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear",
    x1: 65.7806,
    y1: -25.1121,
    x2: 101.18,
    y2: 25.2132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear",
    x1: 67.356,
    y1: -26.211,
    x2: 102.75,
    y2: 24.1067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear",
    x1: 103.12,
    y1: 21.336,
    x2: 138.517,
    y2: 71.6582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear",
    x1: 104.694,
    y1: 20.2295,
    x2: 140.094,
    y2: 70.5567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear",
    x1: 106.266,
    y1: 19.1234,
    x2: 141.66,
    y2: 69.4409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear",
    x1: 107.84,
    y1: 18.0206,
    x2: 143.211,
    y2: 68.3057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear",
    x1: 109.408,
    y1: 16.9068,
    x2: 144.823,
    y2: 67.2548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear",
    x1: 110.984,
    y1: 15.803,
    x2: 146.387,
    y2: 66.1329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear",
    x1: 112.557,
    y1: 14.6991,
    x2: 147.951,
    y2: 65.0168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear",
    x1: 114.132,
    y1: 13.5992,
    x2: 149.504,
    y2: 63.8843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear",
    x1: 115.703,
    y1: 12.4918,
    x2: 151.08,
    y2: 62.7851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear",
    x1: 117.276,
    y1: 11.3829,
    x2: 152.662,
    y2: 61.6898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear",
    x1: 118.848,
    y1: 10.2762,
    x2: 154.236,
    y2: 60.5858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear",
    x1: 120.419,
    y1: 9.16817,
    x2: 155.813,
    y2: 59.4859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear",
    x1: 121.996,
    y1: 8.06957,
    x2: 157.373,
    y2: 58.3625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear",
    x1: 123.56,
    y1: 6.95375,
    x2: 158.958,
    y2: 57.2771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear",
    x1: 125.135,
    y1: 5.84955,
    x2: 160.529,
    y2: 56.1672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear",
    x1: 126.71,
    y1: 4.74693,
    x2: 162.098,
    y2: 55.0558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear",
    x1: 128.288,
    y1: 3.64932,
    x2: 163.66,
    y2: 53.9356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear",
    x1: 129.855,
    y1: 2.53498,
    x2: 165.243,
    y2: 52.8432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear",
    x1: 131.432,
    y1: 1.43097,
    x2: 166.816,
    y2: 51.7347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear",
    x1: 132.993,
    y1: 0.314132,
    x2: 168.398,
    y2: 50.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear",
    x1: 134.574,
    y1: -0.780195,
    x2: 169.961,
    y2: 49.5282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear",
    x1: 136.158,
    y1: -1.86799,
    x2: 171.52,
    y2: 48.4037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear",
    x1: 137.688,
    y1: -2.96885,
    x2: 173.074,
    y2: 47.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear",
    x1: 139.255,
    y1: -4.08506,
    x2: 174.653,
    y2: 46.2371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear",
    x1: 140.838,
    y1: -5.17651,
    x2: 176.216,
    y2: 45.1195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear",
    x1: 142.407,
    y1: -6.28805,
    x2: 177.793,
    y2: 44.0175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear",
    x1: 143.967,
    y1: -7.41143,
    x2: 179.373,
    y2: 42.9231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear",
    x1: 145.548,
    y1: -8.50808,
    x2: 180.943,
    y2: 41.8105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear",
    x1: 147.13,
    y1: -9.59624,
    x2: 182.506,
    y2: 40.6955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear",
    x1: 148.701,
    y1: -10.7048,
    x2: 184.08,
    y2: 39.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear",
    x1: 150.255,
    y1: -11.8384,
    x2: 185.661,
    y2: 38.4973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear",
    x1: 151.835,
    y1: -12.9329,
    x2: 187.231,
    y2: 37.3864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear",
    x1: 153.414,
    y1: -14.0327,
    x2: 188.803,
    y2: 36.2777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear",
    x1: 155.001,
    y1: -15.1171,
    x2: 190.37,
    y2: 35.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear",
    x1: 156.552,
    y1: -16.2517,
    x2: 191.947,
    y2: 34.0674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear",
    x1: 158.123,
    y1: -17.3578,
    x2: 193.518,
    y2: 32.9613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear",
    x1: 159.673,
    y1: -18.4972,
    x2: 195.099,
    y2: 31.8649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear",
    x1: 161.278,
    y1: -19.5584,
    x2: 196.665,
    y2: 30.7497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear",
    x1: 162.852,
    y1: -20.6605,
    x2: 198.236,
    y2: 29.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear",
    x1: 164.411,
    y1: -21.7847,
    x2: 199.81,
    y2: 28.5398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A770C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0291,
    stopColor: "#AD76CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2664,
    stopColor: "#D7A6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4481,
    stopColor: "#F1C3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    stopColor: "#FBCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6258,
    stopColor: "#F3C3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#DEA4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#BB73C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC5EB7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicensecard);
export default __webpack_public_path__ + "static/media/licensecard.103700f9b373a7b8dabe648b377befe3.svg";
export { ForwardRef as ReactComponent };